import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import DOMPurify from "dompurify";
import {
  FormControlLabel,
  Checkbox,
  FormControl,
  FormHelperText,
  Button,
  Box,
  Grid,
  CircularProgress,
  Typography,
  Snackbar,
  Alert,
  RadioGroup,
  Switch,
  useTheme,
  useMediaQuery,
  Tooltip,
  IconButton as IconButtonMui,
} from "@mui/material";
import { Skeleton } from "@mui/material";
import OfferCheckLoader from "../OfferCheckLoader";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector, useStore } from "react-redux";
import type { AppDispatch, RootState } from "../../../services/redux/store";
import { RadioButton } from "../RadioButton";
import { IconButton } from "../Button";
import EntranceExamDetailsSection from "./EntranceExamDetailsSection";
import {
  nextVerticalStep,
  prevVerticalStep,
  updateFormData,
  setSelectedProduct,
  setIsMobileVerified,
  setIsEmailVerified,
  setTrackingId,
  setCollateralId,
  setApplicationId,
  setApplicantId,
  setAadhaarApplicationNo,
  setHasPan,
  setIsPanVerified,
  setPanNumber,
  setAadhaarMandatory,
  setShowAadhaar,
  setLastPanNumber,
  setLastVerifiedPhoneNumber,
  setLastVerifiedEmail,
  setIsDocumentVerified,
  setAadhaarVerifiedDetails,
  setCoApplicantVerification,
  setCurrentCoApplicantIdx,
  setCgpaMode,
  setActiveHorizontalIndex,
  setBreData,
  setBreStatus,
  setIsEligible,
  setIsDocumentVerifiedCoApplicant,
  setAadhaarApplicationNoCoApplicant,
  setAadhaarVerifiedDetailsCoApplicant,
  setActiveVerticalIndex,
  setCoApplicantZipCodeData,
  setCheckIsLeadApiInvoked,
  setLeadSequenceId,
  setAssignedSMIdValue,
  setAadhaarSeedingStatus,
  setVerificationMessage,
  setApplicationSource,
  setEncryptionKey,
  setIsCoAppAlreadyExist,
  setGoogleCampKeys,
  setSavedEmploymentForCoApplicant,
  setreferenceOneId,
  setreferenceTwoId,
  setIsRefColBtnEnable,
  setIsPreLogin,
  setFetchUserApplicationData,
} from "../../../services/redux/slices/stepperDynamicFormSlice";
import { setStatusPopup } from "../../../services/redux/slices/statusPopupSlice";
import { setAdditionalSummaryActiveTab } from "../../../services/redux/slices/tabsSlice";
import eligibilityCheckServices from "../../../services/api/service/eligibilityCheckService";
import applicantDetailsServices from "../../../services/api/service/applicantDetailsService";
import losServices from "../../../services/api/service/losService";
import { SectionHeader } from "../SectionHeader";
import idIcon from "./../../../assets/svgIcons/id.svg";
import booksIcon from "./../../../assets/svgIcons/book line.svg";
import loanIcon from "./../../../assets/svgIcons/Loan.svg";
import locationIcon from "./../../../assets/svgIcons/live-view.svg";
import academicIcon from "./../../../assets/svgIcons/academic-cap-green.svg";
import VerifiedIcon from "./../../../assets/svgIcons/check-circle.svg";
import newVerifiedIcon from "./../../../assets/svgIcons/verified-btn.svg";
import newVerifyIcon from "./../../../assets/svgIcons/verify-btn.svg";
import greenCheckVerified from "./../../../assets/svgIcons/green-check-verified.svg";
import arrowRightVerify from "./../../../assets/svgIcons/arrow-right-verify.svg";
import workExperienceIcon from "./../../../assets/svgIcons/work-experience.svg";
import RightBlackArrow from "./../../../assets/svgIcons/right-black-arrow.svg";
import ArrowNarrowRight from "./../../../assets/images/icons/arrow-narrow-right.png";
import { CustomRadioGroup } from "../CustomRadioGroup";
import { InputField } from "../Inputs";
import AutoCompleteOptions from "../AutoComplete";
import ModalPopup from "../ModalPopup";
import OtpInputForm from "../../../pages/common-features/OtpInputForm";
import SelectOptions from "../SelectOptions";
import { PrimaryButton } from "../Button";
import postsServices from "../../../services/api/service/postsService";
import dropdownService from "../../../services/api/service/dropdownService";
import { getValidationSchema } from "../../../utils/validationSchemas";
import { isValidJourneyEmail } from "../../../utils/emailValidation";
import EligibilityConfirmation from "../../../pages/eligibility-check/EligibilityConfirmation";
import StaticEligibilitySuccess from "../../../pages/eligibility-check/StaticEligibilitySuccess";
import { FormGrid } from "../FormGrid";
import { authStatusSelector } from "../../../services/redux/slices/authSlice";
import type { FormikProps } from "formik";
import { decrypt, encryptData } from "../../../utils/crypto";
import CourseDetailsSection from "./CourseDetailsSection";
import CoApplicantDetailsSection from "./CoApplicantDetailsSection";
import LoaderBackdrop from "../LoaderBackdrop";
import { AnyCnameRecord } from "node:dns";
import { fetchUserApplicationsFormData } from "../../../services/api/service/userApplicationService";
import { setSalesUserId } from "../../../services/redux/slices/chatSlice";
import { letterSpacing } from "@mui/system";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { getCollateralSaveErrorMessage, formatDateToDDMMYYYY, removeSalutation, debounce, mapGender, handleOwnershipStatusValue, handleUnwanted, splitAddressByWords, mapCollateral,numberToWord, buildCollateralFormDataEntries, getCollateralFormValue, getCompleteCollateralNumbers, isFirstCollateralWithData, hasDuplicateCoOwnerNamesForCollateral, buildCoOwnerOwnershipDetailsList, buildSaveCollateralPayload, resolveCoOwnerApplicantIdMap, getMergedCollateralFieldDefinitions, isCoOwnerCollateralNameField, getCoOwnerNameAutocompleteOptions, handleCoOwnerNameSelection, resolveCollateralNumbersToSave, isCollateralSectionComplete, normalizeBirthCityOption, applyCollateralAddressFromPincode, FUND_EXPENSE_CURRENCY_FIELDS, FUND_EXPENSE_CONDITIONAL_FIELDS, FUND_EXPENSE_LOAN_AMOUNT_FIELD, isAdmissionStatusConfirmed, getFundExpenseValidationState,hasDataForPrefixes, getCollateralNumberFromFieldName, fieldBelongsToCollateralNumber, getReferenceCollateralValidationErrors, isCollateralStepAlreadySaved, isCollateralContinueGenuinelySaved, extractFetchedCollateralVals, buildCollateralGroupValueSnapshot, isCoApplicantFieldLockedByCoOwner, extractFetchedApplicationVals, mergeSavedCoOwnersIntoFetchedData

} from "../../../utils/helpers";
import { getSanitizedPublicKeyFromResponse } from "../../../utils/piiKey";
import { useLocation, useNavigate } from "react-router-dom";
import { topCountry } from "../../../data/stepsData";
import { persistor } from "../../../services/redux/store";
import BasicDatePicker from "../BasicDatePicker";
import dayjs from "dayjs";
import {
  setDisplayHorizontalSteps,
} from "../../../services/redux/slices/stepperDynamicFormSlice";
import {
  autoCompleteOffFields,
  callCreateApi,
  callSaveCoApplicantApi,
  fetchAppData,
  getCombinedApplicationSteps,
  getFields,
  getGAEligibilityStatements,
  getGAExtendedJourneyPrefix,
  getGAProvisionalOfferStatements,
  getReferenceData,
  setZeroForFundAndExpenses,
} from "../../../components/ui/StepperDyanmicForm/helper";
import {
  FUND_EXPENSE_AMOUNT_FIELDS,
  getAdditionalDetailsBlockReason,
  isNavigationDisabled,
  computeEmploymentFillStatusForCoApplicants
} from "../../../components/ui/StepperDyanmicForm/helperDynamic"
import { OutlinedPrimaryButton } from "../../../components/ui/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { trackCustomerJourneyEvent,trackCustomerJourneyEventAndWait,trackGooglePixelEvent } from "../../../utils/ga";
import ApplicantAdditionalDetails from "./AdditionalDetailsDocuments/ApplicantAdditionalDetails";
import CoApplicantAdditionalDetails from "./AdditionalDetailsDocuments/CoApplicantAdditionalDetails";
import FundExpenseDetails from "./AdditionalDetailsDocuments/FundExpenseDetails";
import ReferenceCollateralDetails from "./AdditionalDetailsDocuments/ReferenceCollateralDetails";
import AdditionalSummaryDetail from "../../../pages/summary/AdditionalSummaryDetail";
import LoanApplicationOverview from"../../../pages/summary/LoanApplicationOverview";
import { ROUTES } from "../../../routes/routerConfig";
import { current } from "@reduxjs/toolkit";
import {
  anchorModalContentOne
} from "../../../data/constant";
import {
  handleCourseCategoryValue,
  normalizeValue,
  hasAddressData
} from "../../../data/dynamicFormConst";
import { ContinueOption, SkipCoApplicantOption } from "../SkipCoApplicantOption";
import { buildApplicantIdDtosBySection,APPLICANT_SECTION_BY_VERTICAL_INDEX } from "./helperDto";
import { mapFormDataToAPI,updateLeadPayloadData,getMasterOptionName } from "./formDataHelper";
import {
  buildApplicantAdditionalFormData,
  buildAdditionalBasicDetailsPayload,
  buildSaveLoanRequirementPayload,
  getFundExpenseTotals,
  isAdmissionStatusUndecided,
  buildFundExpenseFormData,
  buildSaveExpensePayload,
} from "./formDataHelperAppAdd";

const getAutocompleteOptionValue = (value: any): string => {
  if (value && typeof value === "object") {
    return String(value?.value ?? value?.label ?? "").trim();
  }

  return String(value ?? "").trim();
};

const DynamicForm = ({ fields }: { fields: any[] }) => {
  const dispatch = useDispatch<AppDispatch>();
  const store = useStore<RootState>();
  const formikRef = useRef<FormikProps<any>>(null);
  const isAuthenticated = useSelector(authStatusSelector);
  const coAppAddOption = useSelector(
      (state: RootState) => state?.stepper?.coAppAddOption
  );
  const googleCampKeys = useSelector(
      (state: RootState) => state?.stepper?.googleCampKeys
  );
  const isCoAppAlreadyExist = useSelector(
      (state: RootState) => state?.stepper?.isCoAppAlreadyExist
  );
  const isRefColBtnEnable =  useSelector(
      (state: RootState) => state?.stepper?.isRefColBtnEnable
  );
  const reduxHorizontalSteps = useSelector(
      (state: RootState) => state?.stepper?.horizontalSteps,
  );
  const location = useLocation();
  const navigate = useNavigate();
  // Load testing flag - if true, auto-verify PAN and Aadhaar
  const isLoadTesting = process.env.REACT_APP_LOAD_TESTING == "true";

  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [isSubmittingToAPI, setIsSubmittingToAPI] = useState(false);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  // Loader for BRE checkOffer API
  const [isCheckingOffer, setIsCheckingOffer] = useState(false);
  const [openEmailOtp, setOpenEmailOtp] = useState(false);
  const [openCoApplicantModal, setOpenCoApplicantModal] = useState(false);
  const [openAnchorModal, setOpenAnchorModal] = useState(false);
  const [enableContinue, setenableContinue] = useState(isRefColBtnEnable ?? false);
  useEffect(() => {
    setenableContinue(Boolean(isRefColBtnEnable));
  }, [isRefColBtnEnable]);
  const [isSkipCoAppModal, setIsSkipCoAppModal] = useState<boolean>(false);
  const [selectedVal, setSelectedVal] = useState<ContinueOption | null>(null);


  const [anchorModalContent, setAnchorModalContent] = useState(anchorModalContentOne);
  const purposeItems = useMemo(() => {
    return anchorModalContent
      .split(/\n\s*\n/) // split on blank lines
      .map((item) => item.replace(/;+$/, "").trim()) // remove trailing semicolons
      .filter(Boolean);
  }, [anchorModalContent]);
  // State for dropdown data
  const [dropdownData, setDropdownData] = useState<{
    countries: Array<{ value: string; label: string }>;
    institutes: Array<{ value: string; label: string; code: string }>;
    universities: Array<{ value: string; label: string; code: string }>;
    courses: Array<{ value: string; label: string; code: string }>;
    courseCategory?: Array<{ value: string; label: string }>;
    admissionStatus?: Array<{ value: string; label: string }>;
    courseType?: Array<{ value: string; label: string }>;
    salutations?: Array<{ value: string; label: string }>;
    maritalStatuses?: Array<{ value: string; label: string }>;
    languageExamTypes?: Array<{ value: string; label: string; id: string }>;
    entranceExamTypes?: Array<{ value: string; label: string; id: string }>;
    designations?: Array<{ value: string; label: string }>;
    loanTenureVal?: Array<{ value: string; label: string; id: string }>;
  }>({
    countries: [],
    institutes: [],
    universities: [],
    courses: [],
    courseCategory: [],
    admissionStatus: [],
    courseType: [],
    maritalStatuses: [],
    languageExamTypes: [],
    entranceExamTypes: [],
    designations: [],
    loanTenureVal:[],

  });
  const [loadingDropdowns, setLoadingDropdowns] = useState({
    countries: false,
    institutes: false,
    universities: false,
    courses: false,
  });
  // State to track form values for dependent dropdowns
  const [formValues, setFormValues] = useState<{
    countryId?: string;
    universityId?: string;
    instituteId?: string;
    instituteName?: string;
    universityName?: string;
    courseName?: string;
  }>({});
  const [productOptions, setProductOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [zipCodeLoading, setZipCodeLoading] = useState(false);
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity?: "error" | "success";
  }>({
    open: false,
    message: "",
    severity: "error",
  });
  const [tabIndex, setTabIndex] = React.useState<Record<string, number>>(
    {}
  );
  const [otpEmailFieldName, setOtpEmailFieldName] = useState("email");
  const [otpMobileFieldName, setOtpMobileFieldName] = useState("phone_number");
  const [errorMsg, setErrorMsg] = useState("");
  // For Mobile Verification Step 1
  const [otpMobileNumber, setOtpMobileNumber] = useState("");
  const [otpKey, setOtpKey] = useState("");
  const [otpTime, setOtpTime] = useState("");
  // For Email Verification Step 1
  const [otpEmail, setOtpEmail] = useState("");
  const [otpEmailKey, setOtpEmailKey] = useState("");
  const [otpEmailTime, setOtpEmailTime] = useState("");
  const [cityList, setCityList] = useState<any[]>([]);
  const [birthCityList, setBirthCityList] = useState<any[]>([]);
  const [birthCityLoading, setBirthCityLoading] = useState(false);
  const lastBirthCityCountryRef = useRef<string>("");
  const birthCityInFlightCountryRef = useRef<string>("");
  const birthCityRequestIdRef = useRef<number>(0);
  // Flag to prevent API calls during form initialization
  const [isFormInitialized, setIsFormInitialized] = useState(false);
  // For Co-applicant Pan Verification API Loading State
  const [coApplicantPanLoading, setCoApplicantPanLoading] = useState<{
    [key: string]: boolean;
  }>({});
  // Inline PAN verify error per co-applicant PAN field; shown in place of the schema error
  const [coApplicantPanVerifyError, setCoApplicantPanVerifyError] = useState<{
    [key: string]: string;
  }>({});
  // Store entrance exam master data
  const [entranceExamMaster, setEntranceExamMaster] = useState([]);
  // Loading state for API calls in useEffect
  const [isApiLoading, setIsApiLoading] = useState(false);
  // Track pushed documents to prevent duplicates
  const pushedDocumentsRef = useRef<Set<string>>(new Set());
  // Track ongoing Aadhaar verification calls to prevent concurrent processing
  const processingAadhaarVerificationRef = useRef<Set<string>>(new Set());

  // Function to check for specific purposes anchor tag
  const hasSpecificPurposesAnchor = (htmlString: string): boolean => {
    return htmlString.includes("<a>purposes</a>");
  };

  const isPreviousButton = process.env.REACT_APP_ENABLE_PREVIOUS_BUTTON == "true";
  // Function to handle purposes anchor clicks
  const handlePurposesClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement;
    if (target.tagName === "A" && target.textContent?.trim() === "purposes") {
      event.preventDefault();
      setAnchorModalContent(anchorModalContent);
      setOpenAnchorModal(true);
    }
  };
  // Get all form data from Redux
  const formData = useSelector((state: RootState) => state.stepper.formData);
  const tabsState = useSelector((state: RootState) => state.tabs);


  const {
    horizontalSteps,
    activeHorizontalIndex,
    templateId,
    trackingId,
    collateralId,
    referenceOneId,
    referenceTwoId,
    isMobileVerified,
    isEmailVerified,
    lastVerifiedPhoneNumber,
    lastVerifiedEmail,
    hasPan,
    panNumber,
    isPanVerified,
    adharMandatory,
    showAadhaar,
    isDocumentVerified,
    aadhaarApplicationNo,
    aadhaarVerifiedDetails,
    aadhaarVerifiedDetailsCoApplicant,
    coApplicantVerification,
    breData,
    aadhaarApplicationNoCoApplicant,
    isDocumentVerifiedCoApplicant,
    loanDetailCoApplicantCollapseValue,
    checkIsLeadApiInvoked,
    leadSequenceId,
    assignedSMIdValue,
    coApplicantZipCodeData,
    aadhaarSeedingStatus,
    verificationMessage,
    applicationSource,
    partnerCode,
    partnerName,
    encryptionKey,
    customerConsentTime,
    savedBasicCoApplicants,
    savedEmploymentCoApplicants,
    fetchUserApplicationData,
    isPartnerPreEligibilityFlow,
    partnerSkipEligibilityTrackingId,
  } = useSelector((state: RootState) => state.stepper);
  const isDIYJourney = !fetchUserApplicationData?.partnerStartedJourney;
  useEffect(() => {
    (async () => {  
      if(activeHorizontalIndex!==0){
        let bothReferencesFilled= await getReferenceData(trackingId);
        if (bothReferencesFilled==2) {
          setActiveTab(1);
        }
      }
    })();
  }, []);
  const saveNoCollateralAnswer = useCallback(async (): Promise<boolean> => {
    setIsSubmittingToAPI(true);
    try {
      const currentValues = formikRef?.current?.values || {};
      const horizontalStepLabel = horizontalSteps?.[activeHorizontalIndex]?.stepLabel;
      const mergedFields = getMergedCollateralFieldDefinitions(
        horizontalSteps,
        fields,
        horizontalStepLabel,
      );
      const collateralData = buildCollateralFormDataEntries(mergedFields, currentValues, 1, true);
      const collateralPayload = {
        formData: collateralData,
        trackingId,
        collateralSequenceType: `COLLATERAL_${numberToWord[1]}`,
      };
      const collateralResp: any = await losServices.createCollateral(collateralPayload);
      if (collateralResp?.data?.status !== "success") {
        throw new Error(
          collateralResp?.data?.message || "Unable to save Collateral details.",
        );
      }
      if (collateralResp?.data?.data?.trackingId) {
        dispatch(setTrackingId(collateralResp.data.data.trackingId));
      }
      dispatch(updateFormData(currentValues));
      setenableContinue(true);
      dispatch(setIsRefColBtnEnable(true));
      return true;
    } catch (error: any) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: getCollateralSaveErrorMessage(error),
        }),
      );
      return false;
    } finally {
      setIsSubmittingToAPI(false);
    }
  }, [trackingId, horizontalSteps, activeHorizontalIndex, fields, formikRef, dispatch]);

  const fetchSanitizedPiiPublicKey = useCallback(async () => {
    if (encryptionKey) {
      return getSanitizedPublicKeyFromResponse(encryptionKey);
    }
    const piiKeyResponse: any = await losServices.getPiiKey();
    if (piiKeyResponse?.status !== 200) return "";

    const rawKey = piiKeyResponse?.data?.p_k;
    const rawKeyStr = typeof rawKey === "string" ? rawKey : "";
    dispatch(setEncryptionKey(rawKeyStr));

    return getSanitizedPublicKeyFromResponse(rawKey);
  }, [encryptionKey, dispatch]);

  const activeVerticalIndex = useSelector(
    (state: RootState) =>
      state.stepper.activeVerticalIndex[activeHorizontalIndex] || 0
  );
  const previousStepRef = useRef({
    horizontal: activeHorizontalIndex,
    vertical: activeVerticalIndex,
  });
  const [activeCollateralStatusByGroup, setActiveCollateralStatusByGroup] = useState<
    Record<string, boolean>
  >({});

  useEffect(() => {
    if (!(activeHorizontalIndex === 3 && activeVerticalIndex === 3)) return;
    if (!trackingId) return;
    let isCancelled = false;
    (async () => {
      try {
        const res: any = await eligibilityCheckServices.getCollateralIds(trackingId);
        const records = Array.isArray(res?.data?.data)
          ? res.data.data
          : res?.data?.data
            ? [res.data.data]
            : [];
        const statusByGroup: Record<string, boolean> = {};
        records.forEach((record: any) => {
          const word = String(record?.collateralSequenceType || "")
            .match(/^COLLATERAL_(.+)$/i)?.[1]
            ?.toUpperCase();
          const groupNum = word
            ? Object.entries(numberToWord).find(([, w]) => w === word)?.[0]
            : undefined;
          if (groupNum) {
            statusByGroup[groupNum] =
              String(record?.status || "").toUpperCase() === "ACTIVE";
          }
        });
        if (!isCancelled) setActiveCollateralStatusByGroup(statusByGroup);
      } catch (error) {
        // Fail-open: a failed status check here must not newly block Continue
        // for applicants who could already get through before this existed.
        if (!isCancelled) setActiveCollateralStatusByGroup({});
      }
    })();
    return () => {
      isCancelled = true;
    };
  }, [activeHorizontalIndex, activeVerticalIndex, trackingId]);
  const lastSavedCollateralSnapshotByGroupRef = useRef<Record<number, string>>({});
  const mergedCollateralVals = useCallback((): Record<string, any> => {
    const vals = formikRef?.current?.values || formData || {};
    return { ...extractFetchedCollateralVals(fetchUserApplicationData), ...vals };
  }, [formikRef, formData, fetchUserApplicationData]);
  // Saved (fetched) values used to lock co-applicant First/Last Name & Mobile
  // once that co-applicant is a collateral co-owner.
  const fetchedApplicationVals = useMemo(
    () => extractFetchedApplicationVals(fetchUserApplicationData),
    [fetchUserApplicationData],
  );
  const buildCollateralGroupSnapshot = useCallback(
    (groupNumber: number): string =>
      buildCollateralGroupValueSnapshot(mergedCollateralVals(), groupNumber),
    [mergedCollateralVals],
  );
    const getPresentCollateralGroupNumbers = useCallback((): number[] => {
    const vals = mergedCollateralVals();
    const numbers = new Set<number>();
    Object.keys(vals).forEach((key) => {
      const match = key.match(/^collateral(\d*)type$/i);
      if (match) numbers.add(Number(match[1] || 1));
    });
    return Array.from(numbers).sort((a, b) => a - b);
  }, [mergedCollateralVals]);

  useEffect(() => {
    if (!(activeHorizontalIndex === 3 && activeVerticalIndex === 3)) return;
    const rawAnswer = formData?.hasCollateral ?? formikRef?.current?.values?.hasCollateral;
    const answer = String(
      rawAnswer && typeof rawAnswer === "object"
        ? (rawAnswer as any).value ?? (rawAnswer as any).label
        : rawAnswer ?? "",
    ).trim().toLowerCase();
    if (answer !== "yes") return;
    
    if (isCollateralStepAlreadySaved(fetchUserApplicationData, answer, activeCollateralStatusByGroup)) {
      console.log(getPresentCollateralGroupNumbers(),"getPresentCollateralGroupNumbers()")
      getPresentCollateralGroupNumbers().forEach((n) => {
        if (lastSavedCollateralSnapshotByGroupRef.current[n] !== undefined) return;
        const snapshot = buildCollateralGroupSnapshot(n);
        if (snapshot !== "{}") {
          lastSavedCollateralSnapshotByGroupRef.current[n] = snapshot;
        }
      });
    }
    const vals = formikRef?.current?.values || formData || {};
    const isGenuinelySaved = isCollateralContinueGenuinelySaved(
      vals,
      lastSavedCollateralSnapshotByGroupRef.current,
      fetchUserApplicationData,
      horizontalSteps,
    );
    console.log(isGenuinelySaved,enableContinue,"isGenuinelySaved")
    if (isGenuinelySaved && !enableContinue) {
      setenableContinue(true);
      dispatch(setIsRefColBtnEnable(true));
    } else if (!isGenuinelySaved && enableContinue) {
      setenableContinue(false);
      dispatch(setIsRefColBtnEnable(false));
    }
  }, [
    activeHorizontalIndex,
    activeVerticalIndex,
    formData,
    fields,
    horizontalSteps,
    enableContinue,
    fetchUserApplicationData,
    activeCollateralStatusByGroup,
    getPresentCollateralGroupNumbers,
    buildCollateralGroupSnapshot,
    dispatch,
  ]);
  const employmentFirstSightRef = useRef<Record<string, boolean>>({});

  const coApplicantEvaluationFieldsForEmploymentCheck = useMemo(() => {
    return activeHorizontalIndex === 3 && activeVerticalIndex === 1
      ? [
          ...(horizontalSteps?.[1]?.verticalSteps?.[5]?.fields || []),
          ...(horizontalSteps?.[3]?.verticalSteps?.[1]?.fields || []),
        ].filter(
          (field: any, index: number, arr: any[]) =>
            arr.findIndex(
              (candidate: any) =>
                candidate?.id === field?.id ||
                String(candidate?.name || "") === String(field?.name || ""),
            ) === index,
        )
      : fields;
  }, [activeHorizontalIndex, activeVerticalIndex, horizontalSteps, fields]);

  const coApplicantNumsForEmploymentCheck = useMemo(() => {
    return new Set(
      coApplicantEvaluationFieldsForEmploymentCheck
        .map(
          (f: any) =>
            String(f?.name || "").match(
              /^(?:basic|address|employment)CoApplicant(\d+)/,
            )?.[1],
        )
        .filter(Boolean),
    ) as Set<string>;
  }, [coApplicantEvaluationFieldsForEmploymentCheck]);

  useEffect(() => {
    if (!(activeHorizontalIndex === 3 && activeVerticalIndex === 1)) return;

    const employmentFillStatus = computeEmploymentFillStatusForCoApplicants(
      formikRef.current?.values || {},
      coApplicantEvaluationFieldsForEmploymentCheck,
      coApplicantNumsForEmploymentCheck,
    );

    employmentFillStatus.forEach(({ coAppKey, isEmploymentFilled }) => {
      if (employmentFirstSightRef.current[coAppKey]) return;
      employmentFirstSightRef.current[coAppKey] = true;
      if (isEmploymentFilled && savedEmploymentCoApplicants?.[coAppKey] !== true) {
        dispatch(setSavedEmploymentForCoApplicant({ coAppKey, value: true }));
      }
    });
  }, [
    activeHorizontalIndex,
    activeVerticalIndex,
    coApplicantEvaluationFieldsForEmploymentCheck,
    coApplicantNumsForEmploymentCheck,
    savedEmploymentCoApplicants,
    dispatch,
  ]);
  const reduxLastPanNumber = useSelector(
    (state: RootState) => state.stepper.lastPanNumber
  );
  const isEligibilityCheckSubmitted = useSelector(
    (state: RootState) => state.stepper.isEligibilityCheckSubmitted
  );
  const userProfile = useSelector(
    (state: RootState) => state?.auth?.userProfile
  );
  const notInList = useSelector(
    (state: RootState) => state?.stepper?.notInList
  );
  const applicationIdApp = useSelector(
    (state: RootState) => state?.stepper?.applicationId
  );
  const applicantIdApp = useSelector(
    (state: RootState) => state?.stepper?.applicantId
  );
  const validationSchema = getValidationSchema(
    coApplicantEvaluationFieldsForEmploymentCheck,
    activeHorizontalIndex,
    activeVerticalIndex,
    notInList
  );
  // For Step 2
  const isPanStep = activeHorizontalIndex === 1 && activeVerticalIndex === 0;
  const [isAadharLoading, setIsAadharLoading] = useState(false);
  const [isAadharCoApplicantLoading, setIsAadharCoApplicantLoading] = useState<
    Record<string, boolean>
  >({});
  const [isCurrentSameAsPermanent, setIsCurrentSameAsPermanent] =
    useState(false);
  // To prevent eaadhaar API call on verify now button click
  const [isEaadhaarOnVerifyNow, setIsEaadhaarOnVerifyNow] = useState(false);


  const MobileNumberTooltipContent = (
    <Typography variant="caption">
      Mobile number should be the one which is linked with Aadhaar.
    </Typography>
  );

  // Configure DOMPurify once (can be at top of your component file)
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank"); // opens in new tab
      node.setAttribute("rel", "noopener noreferrer"); // security best practice
    }
  });
  useEffect(() => {
    if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
      setIsCurrentSameAsPermanent(formikRef?.current?.values?.currentsameAsPermanent);
    }
  }, [formikRef?.current?.values?.currentsameAsPermanent, activeHorizontalIndex, activeVerticalIndex])
  const totalReferenceCountRef = useRef<number | null>(null);

  const reevaluateCollateralAlreadySaved = useCallback(() => {
    if (totalReferenceCountRef.current === null || totalReferenceCountRef.current < 2) {
      return;
    }
    const rawCollateralAnswer =
      formData?.collateral ?? formikRef?.current?.values?.hasCollateral;
    const collateralAnswer = String(
      rawCollateralAnswer && typeof rawCollateralAnswer === "object"
        ? (rawCollateralAnswer as any).value ?? (rawCollateralAnswer as any).label
        : rawCollateralAnswer ?? "",
    ).trim().toLowerCase();
    
    if (
      isCollateralStepAlreadySaved(
        fetchUserApplicationData,
        collateralAnswer,
        activeCollateralStatusByGroup,
      )
    ) {
      // Seed the reconcile check's per-group snapshots from the current
      // (presumably matching-what's-saved) live values first.
      for (const n of getPresentCollateralGroupNumbers()) {
        const snapshot = buildCollateralGroupSnapshot(n);
        if (snapshot !== "{}") {
          lastSavedCollateralSnapshotByGroupRef.current[n] = snapshot;
        }
      }
      const vals = formikRef?.current?.values || formData || {};
      const isGenuinelySaved = isCollateralContinueGenuinelySaved(
        vals,
        lastSavedCollateralSnapshotByGroupRef.current,
        fetchUserApplicationData,
        horizontalSteps,
      );
      setenableContinue(isGenuinelySaved);
      dispatch(setIsRefColBtnEnable(isGenuinelySaved));
    }
  }, [
    formData,
    formikRef,
    getPresentCollateralGroupNumbers,
    fetchUserApplicationData,
    activeCollateralStatusByGroup,
    buildCollateralGroupSnapshot,
    horizontalSteps,
    dispatch,
  ]);

  useEffect(() => {
    if (isAuthenticated && trackingId && activeHorizontalIndex === 3 && activeVerticalIndex === 3) {
      (async () => {
        totalReferenceCountRef.current = await getReferenceData(trackingId);
        reevaluateCollateralAlreadySaved();
      })()
    }
  }, [trackingId, activeHorizontalIndex, activeVerticalIndex]);

  useEffect(() => {
    if (!(activeHorizontalIndex === 3 && activeVerticalIndex === 3)) return;
    reevaluateCollateralAlreadySaved();
  }, [activeHorizontalIndex, activeVerticalIndex, fetchUserApplicationData, activeCollateralStatusByGroup, reevaluateCollateralAlreadySaved]);

  useEffect(() => {
    const previousStep = previousStepRef.current;
    const isHorizontalStepChanged =
      activeHorizontalIndex !== previousStep.horizontal;
    const isVerticalStepIncreased =
      activeVerticalIndex > previousStep.vertical;

    if (isHorizontalStepChanged || isVerticalStepIncreased) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    previousStepRef.current = {
      horizontal: activeHorizontalIndex,
      vertical: activeVerticalIndex,
    };
  }, [activeHorizontalIndex, activeVerticalIndex]);

  useEffect(() => {
    if (formikRef.current) {
      // For Applicant Step 0 Form 0 - Personal Details
      formikRef.current.setFieldValue(
        "isMobileVerified",
        isMobileVerified ? true : false
      );
      formikRef.current.setFieldValue(
        "isEmailVerified",
        isEmailVerified ? true : false
      );
      // For Student Loan - Applicant
      formikRef.current.setFieldValue(
        "isPanVerified",
        isPanVerified ? true : false
      );
      formikRef.current.setFieldValue(
        "isAadhaarVerified",
        isDocumentVerified ? true : false
      );

      // Dynamic for all co-applicants
      Object.keys(coApplicantVerification).forEach((idx) => {
        const num = Number(idx) + 1;
        // Only set if Redux value is not undefined, else preserve Formik value
        if (typeof coApplicantVerification[idx]?.panVerified !== "undefined") {
          formikRef?.current?.setFieldValue(
            `basicCoApplicant${num}IsPanVerified`,
            coApplicantVerification[idx]?.panVerified
          );
        }
        if (
          typeof coApplicantVerification[idx]?.emailVerified !== "undefined"
        ) {
          formikRef?.current?.setFieldValue(
            `basicCoApplicant${num}IsEmailVerified`,
            coApplicantVerification[idx]?.emailVerified
          );
        }
        if (
          typeof coApplicantVerification[idx]?.mobileVerified !== "undefined"
        ) {
          formikRef?.current?.setFieldValue(
            `basicCoApplicant${num}IsMobileVerified`,
            coApplicantVerification[idx]?.mobileVerified
          );
        }
      });

      // Set AadhaarVerified field for all co-applicants from isDocumentVerifiedCoApplicant
      if (
        typeof isDocumentVerifiedCoApplicant === "object" &&
        isDocumentVerifiedCoApplicant !== null
      ) {
        Object.keys(isDocumentVerifiedCoApplicant).forEach((coAppKey) => {
          // coAppKey is like 'CoApplicant1', extract number
          const match = coAppKey.match(/CoApplicant(\d+)/);
          if (match) {
            const num = match[1];
            if (formikRef.current) {
              formikRef.current.setFieldValue(
                `basicCoApplicant${num}AadhaarVerified`,
                isDocumentVerifiedCoApplicant[coAppKey] ? true : ""
              );
            }
          }
        });
      }
    }
  }, [
    isMobileVerified,
    isEmailVerified,
    isPanVerified,
    isDocumentVerified,
    coApplicantVerification,
    isDocumentVerifiedCoApplicant,
  ]);
  // Safely hydrate Formik from Redux formData (especially after refresh fetch flow)
  // without overriding actively entered values.
  useEffect(() => {
    if (!formikRef.current || !formData) return;

    const currentValues = formikRef.current.values || {};
    let hasChanges = false;
    const nextValues: Record<string, any> = { ...currentValues };

    Object.entries(formData).forEach(([key, reduxValue]) => {
      const currentValue = currentValues[key];
      const isCurrentBlank =
        currentValue === undefined || currentValue === null || currentValue === "";

      const hasReduxValue =
        reduxValue !== undefined && reduxValue !== null && reduxValue !== "";

      if (isCurrentBlank && hasReduxValue) {
        nextValues[key] = reduxValue;
        hasChanges = true;
      }
    });

    if (hasChanges) {
      formikRef.current.setValues(nextValues, false);
    }
  }, [formData]);
  const [relationshipOptions, setRelationshipOptions] = useState<any>([]);
  const [applicantNationalityOptions, setApplicantNationalityOptions] = useState<
    Array<{ value: string; label: string }>
  >([]);

  useEffect(() => {
    let isMounted = true;
    if(isAuthenticated) {
      dropdownService
        .getNationalityList()
        .then((fetched) => {
          if (isMounted) {
            setApplicantNationalityOptions(Array.isArray(fetched) ? fetched : []);
          }
        })
        .catch((error) => {
          console.error("Error fetching applicant nationality list:", error);
        });
    }
    return () => {
      isMounted = false;
    };
  }, []);

  const resolveApplicantNationalityOption = useCallback(
    (rawValue: any) => {
      const searchValue = String(
        rawValue && typeof rawValue === "object"
          ? rawValue?.value ?? rawValue?.label ?? ""
          : rawValue ?? "",
      )
        .trim()
        .toLowerCase();

      if (!searchValue) {
        return null;
      }

      return (
        applicantNationalityOptions.find(
          (opt) =>
            String(opt?.value ?? "").trim().toLowerCase() === searchValue ||
            String(opt?.label ?? "").trim().toLowerCase() === searchValue,
        ) || null
      );
    },
    [applicantNationalityOptions],
  );

  const handleRelationMasterApi = async () => {
    setIsApiLoading(true);
    try {
      const data = await losServices.relationMaster();
      if (data.status == 200) {
        const optionsData = data?.data?.data?.map((item: any) => ({
          label: item.descInPennant,
          value: item.codeInPennant,
        }));
        setRelationshipOptions(optionsData);
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsApiLoading(false);
    }
  };

  useEffect(() => {
    const profileEmail = (decrypt(userProfile?.email) || "").toLowerCase();
    const existingEmail =
      formikRef?.current?.values?.studentDetailEmail ||
      formikRef?.current?.values?.email ||
      formData?.studentDetailEmail ||
      formData?.email ||
      "";
    const resolvedEmail = existingEmail || profileEmail;
    const shouldAutoVerifyPrefilledEmail =
      activeHorizontalIndex === 0 &&
      activeVerticalIndex === 0 &&
      !!profileEmail &&
      String(resolvedEmail || "").trim().toLowerCase() ===
      String(profileEmail || "").trim().toLowerCase();

    if (
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 0 &&
      (userProfile?.email || userProfile?.phoneNumber)
    ) {
      let fullname = userProfile?.fullName?.split(" ");
      formikRef?.current?.setFieldValue("email", resolvedEmail);
      formikRef?.current?.setFieldValue("studentDetailEmail", resolvedEmail);
      //dispatch(setIsEmailVerified(true));
      if (!lastVerifiedEmail && resolvedEmail) {
        dispatch(setLastVerifiedEmail(resolvedEmail));
      }
      formikRef?.current?.setFieldValue(
        "phone_number",
        decrypt(userProfile?.phoneNumber)
      );

      const finalFirstName = formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0];
      const finalLastName = formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1];

      formikRef?.current?.setFieldValue("firstName", finalFirstName);
      formikRef?.current?.setFieldValue("lastName", finalLastName);
      //dispatch(setIsMobileVerified(true));
      dispatch(setLastVerifiedPhoneNumber(decrypt(userProfile?.phoneNumber)));
      dispatch(updateFormData({
        email: resolvedEmail,
        studentDetailEmail: resolvedEmail,
        firstName: formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0],
        lastName: formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1],
        phone_number: decrypt(userProfile?.phoneNumber)
      }));
    } else {
      if (!(userProfile?.email || userProfile?.phoneNumber)) return;
      if (!formikRef?.current) return;

      const fullname = userProfile?.fullName?.split(" ") ?? [];
      const decryptedPhone = decrypt(userProfile?.phoneNumber);
      const firstName = fullname[0] || "";
      const lastName = fullname[1] || "";
      formikRef.current.setFieldValue("email", resolvedEmail);
      formikRef.current.setFieldValue("studentDetailEmail", resolvedEmail);
      if (shouldAutoVerifyPrefilledEmail) {
        dispatch(setIsEmailVerified(true));
        dispatch(setIsMobileVerified(true));
      }
      if (!lastVerifiedEmail && resolvedEmail) {
        dispatch(setLastVerifiedEmail(resolvedEmail));
      }

      formikRef.current.setFieldValue("phone_number", decryptedPhone);
      dispatch(setLastVerifiedPhoneNumber(decryptedPhone));

      // Also prefill studentDetails fields (used on student details page)
      // Only set if not already populated — preserves any user edits
      if (!formikRef.current.values?.studentDetailsFirstName) {
        formikRef.current.setFieldValue("studentDetailsFirstName", firstName);
      }
      if (!formikRef.current.values?.studentDetailsLastName) {
        formikRef.current.setFieldValue("studentDetailsLastName", lastName);
      }
      if (!formikRef.current.values?.studentDetailsPhone_number) {
        formikRef.current.setFieldValue("studentDetailsPhone_number", decryptedPhone);
      }
      if (!formikRef.current.values?.studentDetailEmail) {
        formikRef.current.setFieldValue("studentDetailEmail", resolvedEmail);
      }
      let finalFirstName = formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0];
      let finalLastName = formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1];

      formikRef?.current?.setFieldValue("firstName", finalFirstName);
      formikRef?.current?.setFieldValue("lastName", finalLastName);
      // Persist to Redux formData so initialValues mapping also picks them up on re-render
      dispatch(updateFormData({
        email: resolvedEmail,
        studentDetailEmail: resolvedEmail,
        firstName: formikRef.current?.values?.studentDetailsFirstName || formikRef.current?.values?.firstName || fullname[0],
        lastName: formikRef.current?.values?.studentDetailsLastName || formikRef.current?.values?.lastName || fullname[1],
        phone_number: decryptedPhone,
      }));
    }
    const fullname = userProfile?.fullName?.split(" ") ?? [];
    const finalFirstName = formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0];
    const finalLastName = formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1];
  }, [activeHorizontalIndex, activeVerticalIndex, userProfile, formData?.email, formData?.studentDetailEmail, lastVerifiedEmail]);
  // Dropdown / master-data fetchers shared by the step-load effect below and
  // handleLeadCreationFlow — each caller decides which ones to run for its step.
  const fetchProducts = async () => {
    setLoadingProducts(true);
    try {
      const res = await dropdownService.getProducts();
      setProductOptions(
        res.data.map((prod) => ({
          value: prod.code,
          label: prod.name,
        }))
      );
    } catch (error) {
      setProductOptions([]);
    } finally {
      setLoadingProducts(false);
    }
  };
  // Fetch master data for dropdowns like courseCategory, admissionStatus, courseType
  const fetchMasterData = async () => {
    try {
      const res = await eligibilityCheckServices.getMasters();
      if (res.data?.status === "success") {
        setDropdownData((prev) => ({
          ...prev,
          courseCategory: (res.data.data.categories || []).map(
            (cat: any) => ({
              value: cat.categoryCode,
              label: cat.categoryName,
            })
          ),
          admissionStatus: (res.data.data.statusesOfAdmission || []).map(
            (stat: any) => ({
              value: stat.statusName,
              label: stat.statusName,
            })
          ),
          courseType: (res.data.data.courseTypes || []).map((type: any) => ({
            value: type.typeCode,
            label: type.typeName,
          })),
        }));
      }
    } catch (error) {
      // Optionally handle error or fallback to static data
      console.error("Failed to fetch master data", error);
    }
  };

  // Fetch Countries on component mount
  const fetchCountries = async () => {
    setLoadingDropdowns((prev) => ({ ...prev, countries: true }));
    try {
      const countriesResponse = await dropdownService.getCountries();
      const allCountries = countriesResponse.data
        // .filter((country) => country.active)
        .map((country) => ({
          value: country.countryId,
          label: country.countryDesc,
        }));
      // Separate top countries and rest
      const topCountries: any[] = [];
      const restCountries: any[] = [];

      allCountries.forEach((country) => {
        const countryLabel = country.label.toUpperCase();
        const isTopCountry = topCountry.some((topName: any) =>
          countryLabel.includes(topName)
        );

        if (isTopCountry) {
          topCountries.push(country);
        } else {
          restCountries.push(country);
        }
      });

      // Sort top countries by the order in topCountryNames array
      topCountries.sort((a, b) => {
        const aIndex = topCountry.findIndex((name: any) =>
          a.label.toUpperCase().includes(name)
        );
        const bIndex = topCountry.findIndex((name: any) =>
          b.label.toUpperCase().includes(name)
        );
        return aIndex - bIndex;
      });

      // Sort rest of countries alphabetically
      restCountries.sort((a, b) => a.label.localeCompare(b.label));

      // Combine: top countries first, then rest
      const countriesOptions = [...topCountries, ...restCountries];
      setDropdownData((prev) => ({
        ...prev,
        countries: countriesOptions,
      }));
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
      setLoadingDropdowns((prev) => ({ ...prev, countries: false }));
    }
  };
  // Fetch Salutations on component mount
  const fetchSalutations = async () => {
    setLoadingDropdowns((prev) => ({ ...prev, salutations: true }));
    try {
      const salutationResponse = await dropdownService.getSalutations();
      const salutationsOptions = salutationResponse.data
        // .filter((sal) => sal.active)
        .map((sal) => ({
          value: sal.salutationCode,
          label: sal.salutationDesc,
        }));

      setDropdownData((prev) => ({
        ...prev,
        salutations: salutationsOptions,
      }));
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
      //setLoadingDropdowns((prev) => ({ ...prev, countries: false }));
    }
  };

  const fetchMaritalStatuses = async () => {
    try {
      const response = await dropdownService.getMaritalStatusMaster();
      const maritalStatusOptions = (response?.data || []).map((item: any) => ({
        value: String(
          item?.maritalStatusCode ??
            item?.code ??
            item?.statusId ??
            item?.id ??
            item?.value ??
            item?.label ??
            item?.name ??
            "",
        ),
        label: String(
          item?.maritalStatusName ??
            item?.desc ??
            item?.label ??
            item?.value ??
            item?.name ??
            item?.maritalStatusCode ??
            item?.code ??
            "",
        ),
      }));

      setDropdownData((prev) => ({
        ...prev,
        maritalStatuses: maritalStatusOptions.filter(
          (opt: any) => opt.value && opt.label,
        ),
      }));
    } catch (error) {
      console.error("Error fetching marital status master:", error);
    }
  };

  // Fetch System Values after Salutations
  const fetchSystemValues = async () => {
    try {
      const systemValuesResponse =
        await eligibilityCheckServices.getSystemValues();

      if (systemValuesResponse.data?.status === "success") {
        const systemValues = systemValuesResponse.data.data;

        // Filter and process Language Exam Types
        const languageExamTypes = systemValues
          .filter(
            (item: any) => item.name === "LANGUAGE_EXAM_TYPE" && item.active
          )
          .map((item: any) => ({
            value: item.code,
            label: item.value,
            id: item.serialId,
          }));

        // Filter and process Entrance Exam Types
        const entranceExamTypes = systemValues
          .filter(
            (item: any) => item.name === "ENTRANCE_EXAM_TYPE" && item.active
          )
          .map((item: any) => ({
            value: item.code,
            label: item.value,
            id: item.serialId,
          }));
        // Filter and process loan tenure Exam Types
        const loanTenureVal = systemValues
          .filter(
            (item: any) => item.name === "LOAN_TENURE_INMONTH" && item.active
          )
          .map((item: any) => ({
            value: item.code,
            label: item.value,
            id: item.serialId,
          }));

        // Update dropdown data with system values
        setDropdownData((prev) => ({
          ...prev,
          languageExamTypes,
          entranceExamTypes,
          loanTenureVal
        }));
      }
    } catch (error) {
      console.error("Error fetching system values:", error);
    }
  };

  // Get Entrance Exam Master
  const getEntranceExamMaster = async () => {
    try {
      const response = await eligibilityCheckServices.getEntranceExamMaster();
      if (response?.data?.data) {
        setEntranceExamMaster(response.data.data);
      }
    } catch (error: any) {
      console.log(error, "error");
      setEntranceExamMaster([]);
    }
  };

  // Fetch Designations
  const fetchDesignations = async () => {
    try {
      const designationResponse =
        await eligibilityCheckServices.getDesignations();
      const designationList = Array.isArray(designationResponse?.data?.data)
        ? designationResponse.data.data
        : [];
      if (designationList.length > 0) {
        const designationsOptions = designationList.map(
          (designation: any) => ({
            value: designation.genDesignation,
            label: designation.genDesgDesc,
          })
        );

        setDropdownData((prev) => ({
          ...prev,
          designations: designationsOptions,
        }));
      }
    } catch (error) {
      console.error("Error fetching designations:", error);
    }
  };
  useEffect(() => {
    // Fetch Products on component mount
    
    if (
     ( activeHorizontalIndex === 1 &&
      (activeVerticalIndex === 0 || activeVerticalIndex === 5))||
      (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
    ) {
      handleRelationMasterApi();
    }

    // Execute API calls based on step conditions
    const executeApiCalls = async () => {
      const promises: Promise<void>[] = [];
      const hasLoanTenureField = (fields || []).some((field: any) =>
        /loan\s*tenure|loantenure/i.test(
          String(field?.name || "") + String(field?.label || ""),
        ),
      );

      if (activeHorizontalIndex === 0 && activeVerticalIndex === 0) {
        promises.push(fetchProducts());
      }

      if (
        activeHorizontalIndex === 0 &&
        (activeVerticalIndex === 1 || activeVerticalIndex === 5)
      ) {
        promises.push(fetchMasterData());
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
        debouncedZipCodeCall(formData.permanentPincode, undefined, "permanent");
        debouncedZipCodeCall(formData.currentPincode, undefined, "current");
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 5 && tabIndex[loanDetailCoApplicantCollapseValue] === 1) {
        const coAppNum = loanDetailCoApplicantCollapseValue.split("CoApplicant")[1];
        debouncedZipCodeCall(formData[`addressCoApplicant${coAppNum}permanentPincode`], coAppNum, "permanent");
        debouncedZipCodeCall(formData[`addressCoApplicant${coAppNum}currentPincode`], coAppNum, "current");
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 2) {
        debouncedCompanyZipCodeCall(formData.employmentCompanyPincode);
      }

        if (
          (activeHorizontalIndex === 0 && activeVerticalIndex === 1) ||
          (activeHorizontalIndex === 1 &&
            (activeVerticalIndex === 1 ||
              activeVerticalIndex === 2 ||
              activeVerticalIndex === 5)) ||
          (activeHorizontalIndex === 3 && activeVerticalIndex === 0) ||
          (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
        ) {
          promises.push(fetchCountries());
        }

      if (
        (activeHorizontalIndex === 1 &&
        (activeVerticalIndex === 0 || activeVerticalIndex === 5))
        ||  (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
        ||  (activeHorizontalIndex === 3 && activeVerticalIndex === 0)
      ) {
        promises.push(fetchSalutations());
      }

      if (
        (activeHorizontalIndex === 3 && activeVerticalIndex === 0) ||
        (activeHorizontalIndex === 1 && activeVerticalIndex === 5)
      ) {
        promises.push(fetchMaritalStatuses());
      }

      if ((activeHorizontalIndex === 1 && activeVerticalIndex === 2)||  (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
      ){
        promises.push(fetchDesignations());
        handleInvokCompanyZipCode(String(formData.employmentCompanyPincode));
      }

      if (
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 5 &&
        tabIndex[loanDetailCoApplicantCollapseValue] === 2
      ) {
        promises.push(fetchDesignations());
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 4) {
        promises.push(getEntranceExamMaster());
        promises.push(fetchSystemValues());
      }
      if (
        (activeHorizontalIndex === 3 && activeVerticalIndex === 0) ||
        hasLoanTenureField
      ) {
        promises.push(fetchSystemValues());
      }
      // Set loading state at the start
      if (promises.length > 0) {
        setIsApiLoading(true);
        try {
          // Wait for all API calls to complete
          await Promise.all(promises);
        } finally {
          setIsApiLoading(false);
        }
      }
    };

    executeApiCalls();
  }, [activeHorizontalIndex, activeVerticalIndex, tabIndex, loanDetailCoApplicantCollapseValue]);

  // Initialize courseXTypeId fields and default courseXType values on academic details page load
  useEffect(() => {
    if (
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 3 &&
      formikRef.current
    ) {
      const currentFormData = { ...formData };
      let hasChanges = false;

      // Define default course type values
      const defaultCourseTypes: { [key: string]: string } = {
        course1Type: "10th",
        course2Type: "12th",
        course3Type: "Graduation",
      };

      // Set default values for course types if not already set
      Object.entries(defaultCourseTypes).forEach(
        ([fieldName, defaultValue]) => {
          if (
            !formData?.[fieldName] &&
            !formikRef.current?.values?.[fieldName]
          ) {
            formikRef.current?.setFieldValue(fieldName, defaultValue, false);
            currentFormData[fieldName] = defaultValue;
            hasChanges = true;
          }
        }
      );

      // Iterate through formData to find courseXType fields and calculate TypeId
      Object.keys(currentFormData).forEach((key) => {
        const courseTypeMatch = key.match(/^course(\d+)Type$/);
        if (courseTypeMatch && currentFormData[key]) {
          const courseNumber = courseTypeMatch[1];
          const courseTypeIdField = `course${courseNumber}TypeID`;
          const courseTypeValue = currentFormData[key];

          // Calculate examTypeIdValue based on course type
          let examTypeIdValue: number = 0;
          if (courseTypeValue === "10th") {
            examTypeIdValue = 283;
          } else if (courseTypeValue === "12th") {
            examTypeIdValue = 284;
          } else if (courseTypeValue === "Diploma") {
            examTypeIdValue = 285;
          } else if (courseTypeValue === "Graduation") {
            examTypeIdValue = 286;
          }

          // Set the TypeId field in form values and Redux if not already set
          if (examTypeIdValue !== 0 && !currentFormData[courseTypeIdField]) {
            formikRef.current?.setFieldValue(
              courseTypeIdField,
              examTypeIdValue,
              false
            );
            currentFormData[courseTypeIdField] = examTypeIdValue;
            hasChanges = true;
          }
        }
      });

      // Update Redux only if there are changes
      if (hasChanges) {
        dispatch(updateFormData(currentFormData));
      }
    }
  }, [activeHorizontalIndex, activeVerticalIndex, dispatch]);

  const handleExamDropdownChange = (
    field: string,
    value: string,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    // Support dynamic field names with suffixes, e.g., languageExamName_6
    setFieldValue(field, value, true);
    let examType = field.startsWith("coreExamName")
      ? "CORE_EXAM"
      : "LANGUAGE_EXAM";
    const found: any = entranceExamMaster.find(
      (exam: any) => exam.examTypeName === examType && exam.examName === value
    );
    // Determine suffix (e.g., _6)
    const suffixMatch = field.match(/_(\d+)$/);
    const suffix = suffixMatch ? `_${suffixMatch[1]}` : "";
    const marksField = field.startsWith("coreExamName")
      ? `coreTotalMarks${suffix}`
      : `languageTotalMarks${suffix}`;
    if (found && found.totalMarks) {
      setFieldValue(marksField, found.totalMarks, true);
    } else {
      setFieldValue(marksField, "", true);
    }

    // Store exam ID in Redux and form values
    const isCoreExam = field.startsWith("coreExamName");
    const examIdField = isCoreExam
      ? `coreExamID${suffix}`
      : `languageExamID${suffix}`;
    const examIdFieldLowercase = isCoreExam
      ? `coreExamId${suffix}`
      : `languageExamId${suffix}`;

    // Find the exam ID from dropdownData
    const examTypes = isCoreExam
      ? dropdownData?.entranceExamTypes
      : dropdownData?.languageExamTypes;

    const selectedExam = examTypes?.find((exam: any) => exam.label === value);
    const examId = selectedExam?.id || "";

    // Set the exam ID in form values (both uppercase and lowercase versions)
    setFieldValue(examIdField, examId, true);
    setFieldValue(examIdFieldLowercase, examId, true);

    // Store exam name and ID in Redux
    const currentFormData = { ...formData };
    currentFormData[field] = value; // Store exam name (e.g., coreExamName, coreExamName_7)
    currentFormData[examIdField] = examId; // Store exam ID uppercase (e.g., coreExamID, coreExamID_7)
    currentFormData[examIdFieldLowercase] = examId; // Store exam ID lowercase (e.g., coreExamId, coreExamId_7)

    dispatch(updateFormData(currentFormData));
  };

  // Retry wrapper function for API calls
  const retryApiCall = async (
    apiCall: () => Promise<any>,
    maxRetries: number = 3,
    delay: number = 1000
  ): Promise<any> => {
    let lastError: any;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response = await apiCall();
        return response;
      } catch (error) {
        lastError = error;

        // If this is not the last attempt, wait before retrying
        if (attempt < maxRetries) {
          await new Promise((resolve) => setTimeout(resolve, delay));
          // Optional: Increase delay for next retry (exponential backoff)
          delay *= 1.5;
        }
      }
    }

    // If all retries failed, throw the last error
    throw lastError;
  };

  useEffect(() => {
    if (isLoadTesting) {
      // dispatch(setIsDocumentVerified(true));
      const formikInstance = formikRef?.current;
      if (!formikInstance) {
        return;
      }
      // Only set AadhaarVerified flags (avoid touching other Formik fields)
      formikInstance.setFieldValue("isAadhaarVerified", true, false);
      const aadhaarVerifiedKeys = Object.keys(formikInstance.values).filter(
        (key) => /^basicCoApplicant(\d+)AadhaarVerified$/.test(key)
      );
      aadhaarVerifiedKeys.forEach((key) => {
        formikInstance.setFieldValue(key, true, false);
      });
    }
  }, [isLoadTesting, formikRef?.current?.values]);

  const handleInvokAadharApi = (
    applicationNo: string,
    payload: any,
    coAppKey?: string
  ): Promise<any> => {
    // Create unique verification key to track this specific verification call
    const verificationKey = `${payload?.typeOfApplicant}-${applicationNo}-${trackingId}`;

    // Check if this verification is already being processed
    if (processingAadhaarVerificationRef.current.has(verificationKey)) {
      return Promise.resolve(); // Skip duplicate call
    }

    // Mark this verification as being processed
    processingAadhaarVerificationRef.current.add(verificationKey);

    // Co-applicant Aadhaar verification is triggered from two steps: the
    // Loan Details step (1,5) and the Additional Details step (3,1).
    const isCoApplicantVerificationStep =
      (activeHorizontalIndex === 1 && activeVerticalIndex === 5) ||
      (activeHorizontalIndex === 3 && activeVerticalIndex === 1);

    if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
      setIsAadharLoading(true);
    }

    if (isCoApplicantVerificationStep) {
      setIsAadharCoApplicantLoading((prev) => ({
        ...prev,
        [String(coAppKey)]: true,
      }));
    }
    // Use retry wrapper for the API call
    return payload?.documentId ? retryApiCall(
      () => applicantDetailsServices.verifyAadhaarApplication(payload),
      3,
      1000
    )
      .then((res) => {
        const detailsObject = {
          ...res.data.data.proofOfAddress,
          ...res.data.data.proofOfIdentity,
        };
        
        if (Number(applicationIdApp) != 0 && (activeVerticalIndex !== 1 || (activeHorizontalIndex === 3 &&  activeVerticalIndex === 1))) {
          const uploadedDocuments = res?.data?.data?.uploadedDocuments || [];
          // Loop through each uploaded document and call push document API sequentially
          let coApp = `1`;
          if (coAppKey) {
            coApp = coAppKey.replace("CoApplicant", "");
          }

          // Sequential processing of documents using async/await
          (async () => {
            for (const document of uploadedDocuments) {
              const docNamed = document?.docName?.replace(/\s+/g, "").toUpperCase();
              if (document?.docName) {
                // Create unique key for this document to prevent duplicate pushes
                const documentKey = `${payload?.typeOfApplicant}-${document?.docType}-${document?.key}-${trackingId}`;

                // Check if this document has already been pushed
                if (pushedDocumentsRef.current.has(documentKey)) {
                  continue; // Skip this document
                }

                let pushPayload: any = {
                  eventName:
                    payload?.typeOfApplicant === "Applicant"
                      ? `APPLICANT_${docNamed}_PUSH_DOCUMENT`
                      : `COAPPLICANT${coApp}_${docNamed}_PUSH_DOCUMENT`,
                  trackingId: trackingId,
                  docType: document?.docNameDms || "",
                  applicantId:
                    payload?.typeOfApplicant === "Applicant"
                      ? Number(applicantIdApp)
                      : 0,
                  applicationId: applicationIdApp ? Number(applicationIdApp) : 0,
                  documentFilePath: document?.key || "",
                  userApplicantType: payload?.typeOfApplicant,
                };

                if (document?.docType === "PANCR") {
                  pushPayload.applicantHasPanCardFlag = true;
                }

                // Call push document API for each document sequentially
                if (pushPayload.docType && ((payload?.typeOfApplicant === "Applicant" && pushPayload.applicantId > 0 && pushPayload.applicationId > 0) || (payload?.typeOfApplicant !== "Applicant" && pushPayload.applicationId > 0))) {
                  // Mark this document as pushed before making the API call
                  pushedDocumentsRef.current.add(documentKey);

                  try {
                    await eligibilityCheckServices.pushDocument(pushPayload);
                  } catch (pushError: any) {
                    console.error(
                      "Push document failed for document:",
                      document,
                      pushError
                    );
                    // Remove from set if push failed so it can be retried
                    pushedDocumentsRef.current.delete(documentKey);
                  }
                }
              }
            }
          })();


        }
        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          setIsAadharLoading(false);
        }
        if (isCoApplicantVerificationStep) {
          setIsAadharCoApplicantLoading((prev) => ({
            ...prev,
            [String(coAppKey)]: false,
          }));
          let coApp = `1`;
          if (coAppKey) {
            coApp = coAppKey.replace("CoApplicant", "");
          }
          const fieldData = getFields(fields, coApp ?? 1, reduxHorizontalSteps);
          
          callSaveCoApplicantApi(formData, fieldData, coAppKey, trackingId, res?.data?.data?.isAadhaarConsent || false, "ADHAAR", res.data.data.proofOfAddress)
        }

        // Remove from processing set after successful completion
        processingAadhaarVerificationRef.current.delete(verificationKey);

        if (!res?.data?.data?.isAadhaarConsent) {
          dispatch(
            setVerificationMessage({
              index:
                isCoApplicantVerificationStep && coAppKey
                  ? coAppKey
                  : `CoApplicant1`,
              applicantType:
                activeHorizontalIndex === 1 && activeVerticalIndex === 0
                  ? "applicant"
                  : "coapplicant",
              field: "aadhar",
              status: "error",
              message:
                "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
            })
          );
          return;
        }

        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          const applicantInfo: any = {}
          applicantInfo.fatherName = removeSalutation(detailsObject?.careOf) || "";
          applicantInfo.gender = detailsObject?.gender === "M" ? "male" : "female";
          applicantInfo.adhaar = payload?.documentId || res?.data?.data?.documentId;
          callCreateApi(formData, fields, trackingId, templateId, res?.data?.data?.isAadhaarConsent || false, applicantInfo, "ADHAAR")
          dispatch(
            setVerificationMessage({
              // index: "",
              applicantType: "applicant",
              field: "aadhar",
              status: "success",
              message: "Yay! Your Aadhaar has been verified successfully.",
            })
          );
        } else if (isCoApplicantVerificationStep) {
          dispatch(
            setVerificationMessage({
              index: coAppKey ? coAppKey : `CoApplicant1`,
              applicantType: "coapplicant",
              field: "aadhar",
              status: "success",
              message:
                "Yay! The co-applicant’s Aadhaar has been successfully verified.",
            })
          );
        }

        // Clear document_verified param from URL
        if ((activeHorizontalIndex === 1 && activeVerticalIndex !== 0) || isCoApplicantVerificationStep) {
          const url = new URL(window.location.href);
          if (url.searchParams.has("document_verified")) {
            url.searchParams.delete("document_verified");
            window.history.replaceState({}, document.title, url.toString());
          }
        }

        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          detailsObject.careOf = removeSalutation(detailsObject.careOf)
          dispatch(setAadhaarVerifiedDetails(detailsObject));
          dispatch(setIsDocumentVerified(true));
          dispatch(setAadhaarApplicationNo(applicationNo));
          formikRef?.current?.setFieldValue("aadhaar", applicationNo);
          localStorage.removeItem("aadhaarApplicationNo");
        }

        if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
          detailsObject.careOf = removeSalutation(detailsObject.careOf)
          dispatch(setAadhaarVerifiedDetails(detailsObject));

          // Check if user has manually entered any permanent address data
          const hasManualPermanentAddress = (
            (formikRef?.current?.values?.permanentAddressLine1 && formikRef?.current?.values?.permanentAddressLine1.trim() !== "") ||
            (formikRef?.current?.values?.permanentAddressLine2 && formikRef?.current?.values?.permanentAddressLine2.trim() !== "") ||
            (formikRef?.current?.values?.permanentAddressLine3 && formikRef?.current?.values?.permanentAddressLine3.trim() !== "")
          );

          // Only prefill if user hasn't manually entered data
          if (!hasManualPermanentAddress) {
            // Prefill address fields from Aadhaar data on address page
            const conCatPermanentAddress: string = [
              handleUnwanted(detailsObject.house),
              handleUnwanted(detailsObject.street),
              handleUnwanted(detailsObject.landmark),
              handleUnwanted(detailsObject.locality),
              //detailsObject.vtc,
            ]
              .filter(Boolean)
              .join(" ")
              .trim();

            let chunkSize: boolean = conCatPermanentAddress.length > 50;

            if (chunkSize) {
              const addressLines = splitAddressByWords(conCatPermanentAddress);
              const permanentAddr1: string = addressLines[0] || "";
              const permanentAddr2: string = addressLines[1] || "";
              const permanentAddr3: string = addressLines[2] || "";
              formikRef?.current?.setFieldValue(
                "permanentAddressLine1",
                permanentAddr1 || ""
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine2",
                permanentAddr2 || ""
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine3",
                permanentAddr3 || ""
              );
            } else {
              formikRef?.current?.setFieldValue(
                "permanentAddressLine1",
                detailsObject.house || ""
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine2",
                `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim()
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine3",
                `${detailsObject.locality || ""}`.trim()
              );
            }
          }

          // Set pincode, city, state, country (only if not manually entered)
          if (detailsObject.pincode && !formikRef?.current?.values?.permanentPincode) {
            formikRef?.current?.setFieldValue(
              "permanentPincode",
              detailsObject.pincode || ""
            );
            // Trigger pincode API to fetch city, state data
            handleInvokZipCode(detailsObject.pincode, undefined, "permanent");
          }

          if (!formikRef?.current?.values?.permanentCity) {
            formikRef?.current?.setFieldValue(
              "permanentCity",
              detailsObject.vtc || detailsObject.district || ""
            );
          }

          if (!formikRef?.current?.values?.permanentState) {
            formikRef?.current?.setFieldValue(
              "permanentState",
              detailsObject.state || ""
            );
          }

          if (!formikRef?.current?.values?.permanentCountry) {
            formikRef?.current?.setFieldValue(
              "permanentCountry",
              detailsObject.country || "India"
            );
          }

          // Update filled fields count for all address fields (only if they were prefilled)
          if (!hasManualPermanentAddress) {
            handleFilledFieldsCount("permanentAddressLine1", detailsObject.house || "");
            handleFilledFieldsCount("permanentAddressLine2", `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim());
            handleFilledFieldsCount("permanentAddressLine3", `${detailsObject.locality || ""}`.trim());
            handleFilledFieldsCount("permanentPincode", detailsObject.pincode || "");
            handleFilledFieldsCount("permanentCity", detailsObject.vtc || detailsObject.district || "");
            handleFilledFieldsCount("permanentState", detailsObject.state || "");
            handleFilledFieldsCount("permanentCountry", detailsObject.country || "India");
          }

          // Handle current address - check if manually entered
          const hasManualCurrentAddress = (
            (formikRef?.current?.values?.currentAddressLine1 && formikRef?.current?.values?.currentAddressLine1.trim() !== "") ||
            (formikRef?.current?.values?.currentAddressLine2 && formikRef?.current?.values?.currentAddressLine2.trim() !== "") ||
            (formikRef?.current?.values?.currentAddressLine3 && formikRef?.current?.values?.currentAddressLine3.trim() !== "")
          );

          // Only prefill current address if user hasn't manually entered data
          if (!hasManualCurrentAddress) {
            const conCatCurrentAddress: string = [
              handleUnwanted(detailsObject.house),
              handleUnwanted(detailsObject.street),
              handleUnwanted(detailsObject.landmark),
              handleUnwanted(detailsObject.locality),
              //detailsObject.vtc,
            ]
              .filter(Boolean)
              .join(" ")
              .trim();

            let currentChunkSize: boolean = conCatCurrentAddress.length > 50;

            if (currentChunkSize) {
              const currentAddr1: string = conCatCurrentAddress.slice(0, 50);
              const currentAddr2: string = conCatCurrentAddress.slice(50, 100);
              const currentAddr3: string = conCatCurrentAddress.slice(100, 150);

              formikRef?.current?.setFieldValue(
                "currentAddressLine1",
                currentAddr1 || ""
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine2",
                currentAddr2 || ""
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine3",
                currentAddr3 || ""
              );
            } else {
              formikRef?.current?.setFieldValue(
                "currentAddressLine1",
                detailsObject.house || ""
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine2",
                `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim()
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine3",
                `${detailsObject.locality || ""}`.trim()
              );
            }
          }

          // Set current address pincode, city, state, country (only if not manually entered)
          if (detailsObject.pincode && !formikRef?.current?.values?.currentPincode) {
            formikRef?.current?.setFieldValue(
              "currentPincode",
              detailsObject.pincode || ""
            );
            handleInvokZipCode(detailsObject.pincode, undefined, "current");
          }

          if (!formikRef?.current?.values?.currentCity) {
            formikRef?.current?.setFieldValue(
              "currentCity",
              detailsObject.vtc || detailsObject.district || ""
            );
          }

          if (!formikRef?.current?.values?.currentState) {
            formikRef?.current?.setFieldValue(
              "currentState",
              detailsObject.state || ""
            );
          }

          if (!formikRef?.current?.values?.currentCountry) {
            formikRef?.current?.setFieldValue(
              "currentCountry",
              detailsObject.country || "India"
            );
          }

          // Update filled fields count for current address fields (only if they were prefilled)
          if (!hasManualCurrentAddress) {
            handleFilledFieldsCount("currentAddressLine1", detailsObject.house || "");
            handleFilledFieldsCount("currentAddressLine2", `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim());
            handleFilledFieldsCount("currentAddressLine3", `${detailsObject.locality || ""}`.trim());
            handleFilledFieldsCount("currentPincode", detailsObject.pincode || "");
            handleFilledFieldsCount("currentCity", detailsObject.vtc || detailsObject.district || "");
            handleFilledFieldsCount("currentState", detailsObject.state || "");
            handleFilledFieldsCount("currentCountry", detailsObject.country || "India");
          }
        }

        if (isCoApplicantVerificationStep) {
          detailsObject.careOf = removeSalutation(detailsObject.careOf)
          dispatch(
            setAadhaarVerifiedDetailsCoApplicant({
              coAppKey,
              details: detailsObject,
            })
          );
          dispatch(
            setIsDocumentVerifiedCoApplicant({
              coAppKey,
              value: true,
            })
          );
          dispatch(
            setAadhaarApplicationNoCoApplicant({
              coAppKey,
              applicationNo,
            })
          );
          // Set Aadhaar number in the correct co-applicant field
          formikRef?.current?.setFieldValue(
            `basic${coAppKey}AadhaarNumber`,
            applicationNo
          );
          const coAppNum = coAppKey ? coAppKey.replace("CoApplicant", "") : "";

          const conCatPermanentAddress: string = [
            handleUnwanted(detailsObject.house),
            handleUnwanted(detailsObject.street),
            handleUnwanted(detailsObject.landmark),
            handleUnwanted(detailsObject.locality),
            //detailsObject.vtc,
          ]
            .filter(Boolean)
            .join(" ")
            .trim();

          let chunkSize: boolean = conCatPermanentAddress.length > 50; // Condition applied here

          if (chunkSize) {
            const addressLines = splitAddressByWords(conCatPermanentAddress);
            const permanentAddr1: string = addressLines[0] || "";
            const permanentAddr2: string = addressLines[1] || "";
            const permanentAddr3: string = addressLines[2] || "";
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine1`,
              permanentAddr1 || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine2`,
              permanentAddr2 || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine3`,
              permanentAddr3 || ""
            );
          } else {
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine1`,
              detailsObject.house || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine2`,
              `${detailsObject.street} ${detailsObject.landmark}` || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine3`,
              `${detailsObject.locality}` || ""
            );
          }

          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentPincode`,
            detailsObject.pincode || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentCity`,
            detailsObject.vtc || detailsObject.district || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentState`,
            detailsObject.state || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentCountry`,
            detailsObject.country || ""
          );
          localStorage.removeItem("aadhaarApplicationNoCoApplicant");
        }
      })
      .catch((err) => {
        // Remove from processing set on error to allow retry
        processingAadhaarVerificationRef.current.delete(verificationKey);
        dispatch(
          setStatusPopup({
            status: "error",
            message: "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
            // message: err?.response?.data?.message || "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
          })
        );
        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          setIsAadharLoading(false);
          dispatch(setIsDocumentVerified(isLoadTesting ? true : false));
        }
        if (isCoApplicantVerificationStep) {
          setIsAadharCoApplicantLoading((prev) => ({
            ...prev,
            [String(coAppKey)]: false,
          }));
          dispatch(
            setIsDocumentVerifiedCoApplicant({
              coAppKey,
              value: isLoadTesting ? true : false,
            })
          );
        }
      }) : Promise.resolve();
  };

  // check if productName is present in the url and set it in the redux store
  useEffect(() => {
    if (location.pathname === "/apply-now") {
      const urlParams = new URLSearchParams(window.location.search);
      const productName = urlParams.get("productName");
      formikRef?.current?.setFieldValue(
        "product",
        productName?.toUpperCase() || ""
      );
    }
  }, [location, formikRef]);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const documentVerified = urlParams.get("document_verified");
    // Retrieve co-applicant key from localStorage or another source
    const coAppKey = localStorage.getItem("aadhaarCoAppKey"); // e.g., "CoApplicant1"
    // Get per-coapplicant applicationNo if coAppKey exists, else use applicant's
    const applicationNo =
      coAppKey &&
        aadhaarApplicationNoCoApplicant &&
        aadhaarApplicationNoCoApplicant[coAppKey]
        ? aadhaarApplicationNoCoApplicant[coAppKey]
        : aadhaarApplicationNo;

    const isCoApplicantVerificationStep =
      (activeHorizontalIndex === 1 && activeVerticalIndex === 5) ||
      (activeHorizontalIndex === 3 && activeVerticalIndex === 1);
    let typeOfApplicant = "Applicant";
    let coAppNum = "";
    if (
      documentVerified === "true" &&
      isCoApplicantVerificationStep &&
      coAppKey
    ) {
      // Extract co-applicant number from coAppKey, e.g., "CoApplicant1" -> "1"
      coAppNum = coAppKey.replace("CoApplicant", "");
      typeOfApplicant = `Co-Applicant ${coAppNum}`;
    }

    const payload = {
      documentId: applicationNo,
      employmentCategory: formData?.applicantType ?? formikRef?.current?.values?.applicantType ?? "student",
      typeOfApplicant,
      formSubmissionTrackingId: trackingId,
    };

    if (
      documentVerified === "true" &&
      applicationNo &&
      (activeHorizontalIndex === 1 && activeVerticalIndex === 0)
      //  || (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
        &&
      isEaadhaarOnVerifyNow !== true
    ) {
      setIsApiLoading(true);
      handleInvokAadharApi(aadhaarApplicationNo, payload).finally(() => {
        setIsApiLoading(false);
      });
    }
    if (
      activeVerticalIndex === 1 &&
      activeHorizontalIndex === 1 &&
      formData?.aadhaar !== null &&
      formData?.aadhaar !== "undefined" &&
      formData?.aadhaar !== undefined
    ) {
      const payloadAddress = {
        documentId: formData?.aadhaar,
        employmentCategory: formData?.applicantType ?? formikRef?.current?.values?.applicantType ?? "student",
        typeOfApplicant,
        formSubmissionTrackingId: trackingId,
      };

      setIsApiLoading(true);
      handleInvokAadharApi(aadhaarApplicationNo, payloadAddress).finally(() => {
        setIsApiLoading(false);
      });
    }

    if (
      documentVerified === "true" &&
      isCoApplicantVerificationStep &&
      applicationNo &&
      coAppKey // Make sure you have the key
    ) {
      // coAppNum already set above
      // Set the Aadhaar number for the correct co-applicant field
      if (formikRef.current) {
        formikRef.current.setFieldValue(
          `basicCoApplicant${coAppNum}AadhaarNumber`,
          applicationNo
        );
      }

      setIsApiLoading(true);
      handleInvokAadharApi(applicationNo, payload, coAppKey).finally(() => {
        setIsApiLoading(false);
      });
    }
  }, [
    aadhaarApplicationNo,
    aadhaarApplicationNoCoApplicant,
    trackingId,
    activeHorizontalIndex,
    activeVerticalIndex
  ]);

  const shouldDisableFields = useMemo(() => {
    return isEligibilityCheckSubmitted && activeHorizontalIndex === 0;
  }, [isEligibilityCheckSubmitted, activeHorizontalIndex]);

  useEffect(() => {
    if (activeHorizontalIndex == 1 && activeVerticalIndex == 1) {
      // Use formData value if present, otherwise default to true
      let value = formData?.currentsameAsPermanent;
      if (value === undefined || value === null || value === "") {
        value = true;
      }
      // Convert string "true"/"false" to boolean
      if (typeof value === "string") {
        value = value === "true";
      }
      formikRef?.current?.setFieldValue("currentsameAsPermanent", value);
    }
  }, [activeHorizontalIndex, activeVerticalIndex, formikRef, formData]);
  
  const handleCurrentAddressFilledInPermanent = (
    value: any,
    fieldName: any
  ): void => {
    // Only main applicant: copy single permanent field to current field
    if (fieldName.includes("permanent")) {
      formikRef?.current?.setFieldValue(
        fieldName?.replace(/^[a-z]+/, "current"),
        value
      );
    }

    // Co-applicant
    const coAppMatch = fieldName.match(
      /^addressCoApplicant(\d+)permanent(.+)$/
    );
    if (coAppMatch) {
      const coAppNum = coAppMatch[1];
      const fieldSuffix = coAppMatch[2];
      const currentField = `addressCoApplicant${coAppNum}current${fieldSuffix}`;
      formikRef?.current?.setFieldValue(currentField, value);
    }
  };
  const handleFilledFieldsCount = (fieldName: string, value: any) => {
    // Main applicant only: copy single permanent field to current field if sameAsPermanent is true (strict boolean)
    if (
      fieldName.includes("permanent") &&
      formikRef?.current?.values?.currentsameAsPermanent === true
    ) {
      handleCurrentAddressFilledInPermanent(value, fieldName);
    }
    // Co-applicant
    const coAppMatch = fieldName.match(
      /^addressCoApplicant(\d+)permanent(.+)$/
    );
    if (coAppMatch) {
      const coAppNum = coAppMatch[1];
      const sameAsKey = `addressCoApplicant${coAppNum}currentsameAsPermanent`;
      if (formikRef?.current?.values?.[sameAsKey] === true) {
        handleCurrentAddressFilledInPermanent(value, fieldName);
      }
    }
  };

  // Function to copy all permanent address fields to current address fields for a given co-applicant
  const copyCoApplicantPermanentToCurrent = (coAppNum: string) => {
    if (!formikRef?.current) return;
    const values = formikRef?.current?.values;
    // Dynamically copy all permanent address fields for this co-applicant
    Object.keys(values)
      .filter(
        (key) =>
          key.startsWith(`addressCoApplicant${coAppNum}permanent`) &&
          !key.includes("currentsameAsPermanent")
      )
      .forEach((permKey) => {
        const fieldSuffix = permKey.replace(
          `addressCoApplicant${coAppNum}permanent`,
          ""
        );
        const currKey = `addressCoApplicant${coAppNum}current${fieldSuffix}`;
        formikRef?.current?.setFieldValue(currKey, values[permKey] ?? "");
      });
  };

  // Effect: Only copy permanent to current address when checkbox transitions from unchecked to checked
  const prevSameAsPermanentRef = useRef<{ [key: string]: boolean }>({});
  useEffect(() => {
    if (!formikRef.current) return;
    const values = formikRef.current.values;
    Object.keys(values)
      .filter(
        (key) =>
          key.startsWith("addressCoApplicant") &&
          key.match(/^addressCoApplicant\d+currentsameAsPermanent$/)
      )
      .forEach((key) => {
        const coAppNum = key.match(
          /^addressCoApplicant(\d+)currentsameAsPermanent$/
        )?.[1];
        const prev = prevSameAsPermanentRef.current[key];
        const curr = values[key];
        if (coAppNum && curr && !prev) {
          copyCoApplicantPermanentToCurrent(coAppNum);
        }
        prevSameAsPermanentRef.current[key] = curr;
      });
  }, [formikRef.current?.values]);

  const fetchUniversities = async (value: any) => {
    if (formValues.countryId || formData?.country?.value) {
      setLoadingDropdowns((prev) => ({ ...prev, universities: true }));
      try {
        const universitiesResponse = await dropdownService.getUniversities({
          universityName: value,
          countryId: formValues.countryId || formData?.country?.value,
        });

        const universitiesOptions = universitiesResponse.data
          .filter((university) => university.active)
          .map((university) => ({
            value: university.universityId.toString(),
            label: university.universityName,
            code: university.universityCode.toString(),
          }));

        setDropdownData((prev) => ({
          ...prev,
          universities: universitiesOptions,
        }));
      } catch (error) {
        console.error("Error fetching universities:", error);
      } finally {
        setLoadingDropdowns((prev) => ({ ...prev, universities: false }));
      }
    } else {
      // Clear universities if country not selected
      setDropdownData((prev) => ({
        ...prev,
        universities: [],
      }));
    }
  };
  // Fetch institutes when university changes
  const fetchInstitutes = async (value: any) => {
    if (
      (formValues.countryId || formData?.country?.value) &&
      formValues.universityId
    ) {
      setLoadingDropdowns((prev) => ({ ...prev, institutes: true }));
      try {
        const institutesResponse = await dropdownService.getInstitutes({
          instituteName: value, // Default search term
          universityId: formValues.universityId,
          countryId: formValues.countryId || formData?.country?.value,
        });

        const institutesOptions = institutesResponse.data
          .filter((institute) => institute.active)
          .map((institute) => ({
            value: institute.instituteId.toString(),
            label: institute.instituteName,
            code: institute.instituteCode.toString(),
          }));

        setDropdownData((prev) => ({
          ...prev,
          institutes: institutesOptions,
        }));
      } catch (error) {
        console.error("Error fetching institutes:", error);
      } finally {
        setLoadingDropdowns((prev) => ({ ...prev, institutes: false }));
      }
    } else {
      // Clear institutes if dependencies are not met
      setDropdownData((prev) => ({
        ...prev,
        institutes: [],
      }));
    }
  };
  // Fetch courses when institute changes
  const fetchCourses = async (value: any) => {
    if (formValues?.instituteId) {
      setLoadingDropdowns((prev) => ({ ...prev, courses: true }));
      try {
        const coursesResponse = await dropdownService.getCourses({
          courseName: value,
          instituteId: formValues.instituteId || "316",
          // instituteId: "316",
        });

        const coursesOptions = coursesResponse.data
          .filter((course) => course.recordStatus === "Approved")
          .map((course) => ({
            value: course.courseId.toString(),
            label: course.courseName,
            code: course.courseCode.toString(),
          }));

        setDropdownData((prev) => ({
          ...prev,
          courses: coursesOptions,
        }));
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoadingDropdowns((prev) => ({ ...prev, courses: false }));
      }
    } else {
      // Clear courses if institute not selected
      setDropdownData((prev) => ({
        ...prev,
        courses: [],
      }));
    }
  };
  const revalidateTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const scheduleFormRevalidate = useCallback(() => {
    if (revalidateTimerRef.current) {
      clearTimeout(revalidateTimerRef.current);
    }
    revalidateTimerRef.current = setTimeout(() => {
      revalidateTimerRef.current = null;
      const formik = formikRef.current;
      if (formik) {
        formik.validateForm(formik.values);
      }
    }, 0);
  }, []);

  useEffect(
    () => () => {
      if (revalidateTimerRef.current) {
        clearTimeout(revalidateTimerRef.current);
      }
    },
    []
  );

  // Handle dropdown changes to update form values for dependent dropdowns
  const handleDropdownChange = (
    fieldName: string,
    value: any,
    form: any,
    changeReason?: string,
  ) => {
    // Safe to schedule up front: the pass runs on a later macrotask, so it still
    // sees every write this handler makes, whichever branch returns first.
    scheduleFormRevalidate();

    const isApplicantCityCountryField =
      String(fieldName || "").toLowerCase() === "applicantcitycountry";
    const isApplicantCityCountryCityMode =
      isApplicantCityCountryField &&
      Array.isArray(birthCityList) &&
      birthCityList.length > 0;
    const isBirthCountryField =
      /birth.*country|country.*birth/i.test(fieldName) ||
      (isApplicantCityCountryField && !isApplicantCityCountryCityMode);
    const isBirthCityField =
      /birth.*city|city.*birth/i.test(fieldName) ||
      isApplicantCityCountryCityMode ||
      String(fieldName || "").toLowerCase() === "applicantcitybirth";

    // Selecting an option can be followed by a blur event from MUI Autocomplete.
    // Ignore blur reason for birth-country to avoid duplicate city API calls.
    if (isBirthCountryField && changeReason === "blur") {
      return;
    }

    // Keep applicantCityCountry stable on outside-click/transient events.
    if (
      isApplicantCityCountryField &&
      (value === null || value === undefined || value === "")
    ) {
      return;
    }

    if (
      isApplicantCityCountryField &&
      changeReason &&
      changeReason !== "selectOption" &&
      changeReason !== "clear"
    ) {
      return;
    }

    if (isBirthCityField && changeReason === "blur") {
      return;
    }

    // MUI Autocomplete can emit a transient null-like change on blur/outside click.
    // Ignore that for birth-country fields unless it is an explicit clear action.
    if (
      isBirthCountryField &&
      (value === null || value === undefined || value === "") &&
      changeReason !== "clear"
    ) {
      return;
    }

    if (
      isBirthCityField &&
      (value === null || value === undefined || value === "") &&
      changeReason !== "clear"
    ) {
      return;
    }

    const normalizedValue =
      isBirthCityField && value && typeof value === "object"
        ? normalizeBirthCityOption(value, birthCityList)
        : isApplicantCityCountryField && value && typeof value === "object"
          ? isApplicantCityCountryCityMode
            ? normalizeBirthCityOption(value, birthCityList)
            : String((value as any)?.label || (value as any)?.value || "")
          : value;

    // Birth-city fields are often dynamic and missing from Yup schema;
    // validating them throws "schema does not contain the path".
    form.setFieldValue(fieldName, normalizedValue, !isBirthCityField);
    if (isBirthCityField) {
      form.setFieldError?.(fieldName, undefined);
    }

    // Re-populate total marks when coreScoreReceived changes to "Yes"
    const coreScoreReceivedMatch = fieldName.match(/^coreScoreReceived(_\d+)?$/);
    if (coreScoreReceivedMatch) {
      const suffix = coreScoreReceivedMatch[1] || "";
      const examNameField = `coreExamName${suffix}`;
      const marksField = `coreTotalMarks${suffix}`;
      const examScoreField = `coreExamScore${suffix}`;
      const expectedOnField = `coreScoreExpectedOn${suffix}`;

      if (value === "Yes") {
        // Re-populate total marks from master
        const examNameValue = formikRef?.current?.values?.[examNameField];
        if (examNameValue) {
          const found: any = entranceExamMaster.find(
            (exam: any) => exam.examTypeName === "CORE_EXAM" && exam.examName === examNameValue
          );
          if (found && found.totalMarks) {
            form.setFieldValue(marksField, found.totalMarks, true);
            dispatch(updateFormData({ [marksField]: found.totalMarks }));
          }
        }
        // Clear expected date
        form.setFieldValue(expectedOnField, "", false);
        dispatch(updateFormData({ [expectedOnField]: "" }));
      }

      if (value === "No") {
        // Clear marks obtained and total marks
        form.setFieldValue(examScoreField, "", false);
        form.setFieldValue(marksField, "", false);
        dispatch(updateFormData({ [examScoreField]: "", [marksField]: "" }));
        // Clear expected date in case switching back keeps stale value
        form.setFieldValue(expectedOnField, "", false);
        dispatch(updateFormData({ [expectedOnField]: "" }));
      }
    }

    // Re-populate total marks when languageScoreReceived changes to "Yes"
    const langScoreReceivedMatch = fieldName.match(/^languageScoreReceived(_\d+)?$/);
    if (langScoreReceivedMatch) {
      const suffix = langScoreReceivedMatch[1] || "";
      const examNameField = `languageExamName${suffix}`;
      const marksField = `languageTotalMarks${suffix}`;
      const examScoreField = `languageExamScore${suffix}`;
      const expectedOnField = `languageScoreExpectedOn${suffix}`;

      if (value === "Yes") {
        // Re-populate total marks from master
        const examNameValue = formikRef?.current?.values?.[examNameField];
        if (examNameValue) {
          const found: any = entranceExamMaster.find(
            (exam: any) => exam.examTypeName === "LANGUAGE_EXAM" && exam.examName === examNameValue
          );
          if (found && found.totalMarks) {
            form.setFieldValue(marksField, found.totalMarks, true);
            dispatch(updateFormData({ [marksField]: found.totalMarks }));
          }
        }
        // Clear expected date
        form.setFieldValue(expectedOnField, "", false);
        dispatch(updateFormData({ [expectedOnField]: "" }));
      }

      if (value === "No") {
        // Clear marks obtained and total marks
        form.setFieldValue(examScoreField, "", false);
        form.setFieldValue(marksField, "", false);
        dispatch(updateFormData({ [examScoreField]: "", [marksField]: "" }));
        // Clear expected date in case switching back keeps stale value
        form.setFieldValue(expectedOnField, "", false);
        dispatch(updateFormData({ [expectedOnField]: "" }));
      }
    }

    // Handle course type fields - set corresponding TypeId field
    const courseTypeMatch = fieldName.match(/^course(\d+)Type$/);
    if (courseTypeMatch) {
      const courseNumber = courseTypeMatch[1];
      const courseTypeIdField = `course${courseNumber}TypeID`;

      let examTypeIdValue: number = 0;
      if (value === "10th") {
        examTypeIdValue = 283;
      } else if (value === "12th") {
        examTypeIdValue = 284;
      } else if (value === "Diploma") {
        examTypeIdValue = 285;
      } else if (value === "Graduation") {
        examTypeIdValue = 286;
      }
      // Set the TypeId field in form values
      form.setFieldValue(courseTypeIdField, examTypeIdValue, true);

      // Store both course type and TypeId in Redux immediately
      const currentFormData = { ...formData };
      currentFormData[fieldName] = value; // Store course type (e.g., course1Type: "10th")
      currentFormData[courseTypeIdField] = examTypeIdValue; // Store TypeId (e.g., course1TypeId: 283)
      dispatch(updateFormData(currentFormData));
    }

    // Don't set field value here as it's already set in the onChange handler
    if (fieldName === "permanentCity" && value) {
      // Only update current city if "same as permanent" is checked
      const isSameAs = formikRef?.current?.values?.currentsameAsPermanent;
      if (isSameAs) {
        form.setFieldValue("currentCity", value?.value || value);
      }
    }

    if (fieldName?.toLowerCase()?.includes("coursename")) {
      const courseValue = value?.value || value;
      const courseCode = value?.code || value;
      setFormValues((prev) => ({ ...prev, courseCode: courseCode }));
      formikRef?.current?.setFieldValue("courseCode", courseCode);
      // Force form validation/update after courseName is set
      setTimeout(() => {
        if (formikRef?.current) {
          formikRef?.current.validateForm();
        }
      }, 10);
    }

    // Update form values state for dependent dropdowns
    if (fieldName?.toLowerCase()?.includes("study")) {
      // Only clear if the value is being cleared/emptied
      const actualValue = value?.value || value;
      if (!actualValue || actualValue === "" || actualValue === null) {
        // Clear all course-related dependent dropdowns when course category/study/admission status is cleared
        form.setFieldValue("country", "");
        form.setFieldValue("university", "");
        form.setFieldValue("institute", "");
        form.setFieldValue("course", "");
        form.setFieldValue("courseName", "");
        setDropdownData((prev) => ({
          ...prev,
          countries: [],
          universities: [],
          institutes: [],
          courses: [],
        }));
      }
    } else if (isBirthCountryField) {
      const countryName = value?.label || value?.value || value || "";

      if (!countryName) {
        if (changeReason === "clear") {
          setBirthCityList([]);
          const birthCityField = fields.find((f: any) =>
            /birth.*city|city.*birth/i.test(String(f?.name || "")) ||
            /birth.*city|city.*birth/i.test(String(f?.label || "")) ||
            String(f?.name || "").toLowerCase() === "applicantcitybirth",
          )?.name;
          if (birthCityField) {
            form.setFieldValue(birthCityField, "");
          }
        }
        return;
      }
      if (
        String(fieldName || "").toLowerCase() === "applicantbirthcountry" ||
        /country.*birth|birth.*country/i.test(String(fieldName || ""))
      ) {
        handleInvokStatesByCountryApi(String(countryName));
      }
      const birthCityField = fields.find((f: any) =>
        /birth.*city|city.*birth/i.test(String(f?.name || "")) ||
        /birth.*city|city.*birth/i.test(String(f?.label || "")) ||
        String(f?.name || "").toLowerCase() === "applicantcitybirth"
      )?.name;
      if (birthCityField) {
        form.setFieldValue(birthCityField, "");
      }
    } else if (fieldName?.toLowerCase()?.includes("country")) {
      const countryValue = value?.value || value;

      setFormValues((prev) => ({
        ...prev,
        countryId: countryValue,
        universityCountryId: countryValue,
      }));
      // formikRef.current?.setFieldValue("universityCountryId", countryValue);
      formikRef.current?.setFieldValue("universityCountryId", value?.value);

      // Only clear if the value is being cleared/emptied
      if (!countryValue || countryValue === "" || countryValue === null) {
        // Clear dependent dropdowns
        form.setFieldValue("university", "");
        form.setFieldValue("institute", "");
        form.setFieldValue("course", "");
        form.setFieldValue("courseName", "");
        setDropdownData((prev) => ({
          ...prev,
          institutes: [],
          universities: [],
          courses: [],
        }));
      }
    } else if (fieldName?.toLowerCase()?.includes("university")) {
      const universityValue = value?.value || value;
      const universityCode = value?.code || value;
      setFormValues((prev) => ({
        ...prev,
        universityId: universityValue,
        universityCampusId: universityCode,
      }));
      formikRef.current?.setFieldValue("universityCampusId", universityCode);

      // Only clear if the value is being cleared/emptied
      if (
        !universityValue ||
        universityValue === "" ||
        universityValue === null
      ) {
        // Clear dependent dropdowns
        form.setFieldValue("institute", "");
        form.setFieldValue("course", "");
        form.setFieldValue("courseName", "");
        setDropdownData((prev) => ({
          ...prev,
          institutes: [],
          courses: [],
        }));
      }
    } else if (fieldName?.toLowerCase()?.includes("institute")) {
      const instituteValue = value?.value || value;
      const instituteCode = value?.code || value;
      setFormValues((prev) => ({
        ...prev,
        instituteId: instituteValue,
        institute_code: instituteCode,
      }));
      formikRef.current?.setFieldValue("institute_code", instituteCode);

      // Only clear if the value is being cleared/emptied
      if (!instituteValue || instituteValue === "" || instituteValue === null) {
        // Clear dependent dropdown
        form.setFieldValue("course", "");
        form.setFieldValue("courseName", "");
        setDropdownData((prev) => ({
          ...prev,
          courses: [],
        }));
      }
    } else if (
      fieldName?.toLowerCase()?.includes("course") &&
      !fieldName?.toLowerCase()?.includes("coursename")
    ) {
      // You can add search functionality here if needed for generic "course" fields
      const searchTerm = value?.value || value; // or extract from input
      setFormValues((prev) => ({ ...prev, courseName: searchTerm }));
    } else if (fieldName?.toLowerCase() == "salutation") {
      const salutationValue = value?.value || value;
      const salutationLabel = value?.label || value;

      setFormValues((prev) => ({
        ...prev,
        salutation: salutationValue,
        salutationName: salutationLabel,
      }));
      // Set both the main salutation field and salutationName field
      formikRef.current?.setFieldValue(fieldName, salutationValue);
      formikRef.current?.setFieldValue("salutationName", salutationLabel);
    } else if (/coapplicant.*salutation/i.test(fieldName)) {
      const salutationValue = value?.value || value;
      const salutationLabel = value?.label || value;

      setFormValues((prev) => ({
        ...prev,
        [fieldName]: salutationValue,
        [`${fieldName}Name`]: salutationLabel,
      }));
      // Set both the main salutation field and salutationName field
      formikRef.current?.setFieldValue(fieldName, salutationValue);
      formikRef.current?.setFieldValue(`${fieldName}Name`, salutationLabel);
    } 
    // Handle Language Exam ID and Name storage in Redux
    else if (
      fieldName?.toLowerCase()?.includes("languageexamname") ||
      fieldName?.toLowerCase()?.includes("languageexam")
    ) {
      if (value && typeof value === "object" && value.value && value.label) {
        // Store exam ID in formData instead of separate Redux state
        const currentFormData = { ...formData };
        currentFormData.languageExamId = value.value; // Store the ID
        dispatch(updateFormData(currentFormData));
      }
    }
    // Handle Core Exam ID and Name storage in Redux
    else if (
      fieldName?.toLowerCase()?.includes("coreexamname") ||
      fieldName?.toLowerCase()?.includes("coreexam") ||
      /core.*exam.*name/i.test(fieldName) ||
      /entrance.*exam/i.test(fieldName)
    ) {
      if (value && typeof value === "object" && value.value && value.label) {
        // Store exam ID in formData instead of separate Redux state
        const currentFormData = { ...formData };
        currentFormData.coreExamId = value.value; // Store the ID
        dispatch(updateFormData(currentFormData));
      }
    }
    // Handle direct coreExamID/languageExamID field storage in Redux
    else if (
      /^coreExamID(_\d+)?$/i.test(fieldName) ||
      /^languageExamID(_\d+)?$/i.test(fieldName)
    ) {
      const currentFormData = { ...formData };
      currentFormData[fieldName] = value;
      dispatch(updateFormData(currentFormData));
    }
    // Handle RelationWithStudent field - similar to salutation handling
    else if (/basicCoApplicant\d+RelationWithStudent/i.test(fieldName)) {
      const relationValue = value?.value || value;
      const relationLabel = value?.label || value;
      const relationValueFields = [
        fieldName.replace(
          /RelationWithStudent$/,
          "OtherRelationWithStudent"
        ),
        fieldName.replace(/RelationWithStudent$/, "RelationValue"),
      ];

      setFormValues((prev) => ({
        ...prev,
        [fieldName]: relationValue,
        [`${fieldName}Name`]: relationLabel,
      }));
      // Set both the main relation field and relationName field
      formikRef.current?.setFieldValue(fieldName, relationValue);
      formikRef.current?.setFieldValue(`${fieldName}Name`, relationLabel);
      if (relationValue !== "OTHERS") {
        relationValueFields.forEach((relationValueField) => {
          formikRef.current?.setFieldValue(relationValueField, "");
        });
      }

      // Update Redux with RelationWithStudent value
      const currentFormData = { ...formData };
      currentFormData[fieldName] = relationValue;
      currentFormData[`${fieldName}Name`] = relationLabel;
      if (relationValue !== "OTHERS") {
        relationValueFields.forEach((relationValueField) => {
          currentFormData[relationValueField] = "";
        });
      }
      dispatch(updateFormData(currentFormData));
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const eligilibity_camp = urlParams.get("eligilibity_campaign") || "";
    const provisional_camp = urlParams.get("provisional_campaign") || "";
    const consent_camp = urlParams.get("consent_campaign") || "";


    if(eligilibity_camp && provisional_camp && consent_camp) {
      dispatch(setGoogleCampKeys({ ...googleCampKeys, eligilibity_camp, provisional_camp, consent_camp }));
    } else if(eligilibity_camp) {
      dispatch(setGoogleCampKeys({ ...googleCampKeys, eligilibity_camp }));
    } else if(provisional_camp) {
      dispatch(setGoogleCampKeys({ ...googleCampKeys, provisional_camp }));
    } else if(consent_camp) {
      dispatch(setGoogleCampKeys({ ...googleCampKeys, consent_camp }));
    }
  }, [location])

  // Helper function to get dropdown options based on field
  const getDropdownOptions = (field: any) => {
    const normalizedFieldName = String(field?.name || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
    const isLoanTenureField = /loan\s*tenure|loantenure/i.test(
      String(field?.name || "") + String(field?.label || ""),
    );

    // Use helper-backed options for collateral type fields.
    if (/^collateral\d*type$/.test(normalizedFieldName)) {
      return (mapCollateral() || []).map((opt: any) => ({
        value: String(opt?.value ?? ""),
        label: String(opt?.label ?? ""),
      }));
        }
    if (field.name.toLowerCase().includes("designation")) {
     
      return [
        // { value: "", label: `Select ${field.label || "Designation"}` },
        ...(dropdownData?.designations || []),
      ];
    }
    const isBirthCityField =
      /birth.*city|city.*birth/i.test(String(field?.name || "")) ||
      /birth.*city|city.*birth/i.test(String(field?.label || "")) ||
      String(field?.name || "").toLowerCase() === "applicantcitybirth";

    if (field.options && Array.isArray(field.options.options) && !isLoanTenureField) {
      const objectOptions = field.options.options.filter(
        (opt: any) =>
          opt &&
          typeof opt === "object" &&
          ("value" in opt || "label" in opt),
      );

      if (objectOptions.length > 0) {
        return objectOptions.map((opt: any) => ({
          value: String(opt?.value ?? opt?.label ?? ""),
          label: String(opt?.label ?? opt?.value ?? ""),
        }));
      }
    }

    // Show years from 2000 to current year for "cour" fields in activeHorizontalIndex 1, form 3
    if (
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 3 && // form 3 (0-based index)
      field.name.toLowerCase().includes("year")
    ) {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = currentYear - 30; year <= currentYear; year++) {
        years.push({ value: year.toString(), label: year.toString() });
      }

      // Filter based on chronological order of courses
      const formValues = formikRef?.current?.values || {};

      // Extract course number from field name (e.g., "course1Year", "course1PassingYear" -> 1)
      const currentCourseMatch = field.name.match(/course(\d+)(Year|PassingYear|YearOfPassing|PassYear)/i);
      if (!currentCourseMatch) {
        return [
          { value: "", label: `Select ${field.label || "Year"}` },
          ...years,
        ];
      }

      const currentCourseNum = parseInt(currentCourseMatch[1]);

      // Get current course type (e.g., "10th", "Diploma", etc.)
      const currentCourseType = formValues[`course${currentCourseNum}Type`] || "";

      // Special handling for Diploma: show same options as 10th, but exclude 10th's selected year
      if (currentCourseType === "Diploma") {
        // Find the course that is "10th" and get its selected year
        let tenthSelectedYear: number | null = null;
        Object.keys(formValues).forEach((key) => {
          const typeMatch = key.match(/course(\d+)Type/);
          if (typeMatch && formValues[key] === "10th") {
            const tenthCourseNum = parseInt(typeMatch[1]);
            // Check multiple possible year field name patterns
            const yearFieldPatterns = [
              `course${tenthCourseNum}Year`,
              `course${tenthCourseNum}PassingYear`,
              `course${tenthCourseNum}YearOfPassing`,
              `course${tenthCourseNum}PassYear`,
            ];

            for (const yearKey of yearFieldPatterns) {
              const tenthYear = formValues[yearKey];
              if (tenthYear) {
                const tenthYearValue = parseInt(tenthYear);
                if (!isNaN(tenthYearValue)) {
                  tenthSelectedYear = tenthYearValue;
                  break; // Found the year, no need to check other patterns
                }
              }
            }
          }
        });

        // Filter years: show only years AFTER the year selected in 10th
        const filteredYears = years.filter((yearOption) => {
          const yearValue = parseInt(yearOption.value);
          // If no 10th year selected, show all years. Otherwise, show only years after the selected 10th year
          if (tenthSelectedYear === null) {
            return true;
          }
          return yearValue > tenthSelectedYear;
        });

        return [
          { value: "", label: `Select ${field.label || "Year"}` },
          ...filteredYears,
        ];
      }

      // Get all course year fields and their values
      const courseYearData: { courseNum: number; year: number }[] = [];
      Object.keys(formValues).forEach((key) => {
        const match = key.match(/course(\d+)(Year|PassingYear|YearOfPassing|PassYear)/i);
        if (match && formValues[key]) {
          const courseNum = parseInt(match[1]);
          const year = parseInt(formValues[key]);
          if (!isNaN(year)) {
            courseYearData.push({ courseNum, year });
          }
        }
      });

      // Find the maximum year from all previous courses
      let minAllowedYear = 1965; // Default minimum
      courseYearData.forEach(({ courseNum, year }) => {
        if (courseNum < currentCourseNum && year >= minAllowedYear) {
          minAllowedYear = year;
        }
      });

      // Collect all already selected years (to exclude duplicates)
      const selectedYears = courseYearData
        .filter(({ courseNum }) => courseNum !== currentCourseNum)
        .map(({ year }) => year);

      // Filter years: show only years after the previous course and exclude duplicates
      const filteredYears = years.filter((yearOption) => {
        const yearValue = parseInt(yearOption.value);
        return yearValue > minAllowedYear && !selectedYears.includes(yearValue);
      });

      return [
        { value: "", label: `Select ${field.label || "Year"}` },
        ...filteredYears,
      ];
    }

    // 1. If options are provided directly in the field JSON, use them
    // Exclude fields that should use system values instead
    const isSystemValueField =
      field.name.toLowerCase().includes("salutation") ||
      field.name.toLowerCase().includes("marital") ||
      field.name.toLowerCase().includes("country") ||
      String(field.label || "").toLowerCase().includes("country") ||
      isLoanTenureField ||
      /birth.*city|city.*birth/i.test(String(field.name || "")) ||
      /birth.*city|city.*birth/i.test(String(field.label || "")) ||
      field.name.toLowerCase().includes("coreexamname") ||
      field.name.toLowerCase().includes("coreexam") ||
      field.name.toLowerCase().includes("languageexamname") ||
      field.name.toLowerCase().includes("languageexam") ||
      /core.*exam/i.test(field.name) ||
      /language.*exam/i.test(field.name);

    if (
      field.options &&
      Array.isArray(field.options.options) &&
      !isSystemValueField
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Option"}` },
        ...field.options.options
          .filter((opt: any) => opt != null && opt !== undefined)
          .map((opt: string) => ({
            value: opt || "",
            label: opt || "",
          })),
      ];
    }

    // 2. Existing logic for other dropdowns
    if (
      field.name.toLowerCase().includes("coursecategory") ||
      field.label.toLowerCase().includes("coursecategory")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Course Category"}` },
        ...(dropdownData?.courseCategory ?? []),
      ];
    }
    if (
      field.name.toLowerCase().includes("coursetype") ||
      field.label.toLowerCase().includes("coursetype")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Course Type"}` },
        ...(dropdownData?.courseType ?? []),
      ];
    }

    if (isBirthCityField) {
      return [...(birthCityList || [])];
    }

    if (
      field.name.toLowerCase().includes("country") ||
      field.label.toLowerCase().includes("country")
    ) {
      const countryOptions = [...(dropdownData?.countries || [])];
      const isStudyDestinationStep =
        activeHorizontalIndex === 0 &&
        activeVerticalIndex === 1 &&
        (
          field.name.toLowerCase().includes("study") ||
          field.name.toLowerCase().includes("destination") ||
          field.label.toLowerCase().includes("study") ||
          field.label.toLowerCase().includes("destination")
        );

      if (isStudyDestinationStep) {
        return countryOptions.filter(
          (country: any) =>
            String(country?.label || "").trim().toLowerCase() !== "india"
        );
      }

      return [
        // { value: "", label: `Select ${field.label || "Country"}` },
        ...countryOptions,
      ];
    }
    if (
      field.name.toLowerCase().includes("university") ||
      field.label.toLowerCase().includes("university")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "University"}` },
        ...(dropdownData?.universities || []),
      ];
    }
    if (
      field.name.toLowerCase().includes("institute") ||
      field.label.toLowerCase().includes("institute")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Institute"}` },
        ...(dropdownData?.institutes || []),
      ];
    }
    if (
      field.name.toLowerCase().includes("course") ||
      field.label.toLowerCase().includes("course")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Course"}` },
        ...(dropdownData?.courses || []),
      ];
    }
    if (field.name.toLowerCase().includes("salutation")) {
      return [
        // { value: "", label: `Select ${field.name || "Salutation"}` },
        ...(dropdownData?.salutations || []),
      ];
    }
    
    if (
      field.name.toLowerCase().includes("marital") ||
      field.label.toLowerCase().includes("marital")
    ) {
      return [...(dropdownData?.maritalStatuses || [])];
    }
    if (isLoanTenureField) {
      return [...(dropdownData?.loanTenureVal || [])];
    }
    if (
      field.name.toLowerCase().includes("admissionstatus") ||
      field.label.toLowerCase().includes("admissionstatus")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Admission Status"}` },
        ...(dropdownData?.admissionStatus || []),
      ];
    }

    if (
      field.name.toLowerCase().includes("permanentcity") ||
      field.name.toLowerCase().includes("currentcity")
    ) {
      return [
        { value: "", label: `Select ${field.label || "City"}` },
        ...(cityList || []),
      ];
    }
    // Handle Language Exam Type fields
    if (
      field.name.toLowerCase().includes("languageexamname") ||
      field.name.toLowerCase().includes("languageexam") ||
      /language.*exam/i.test(field.name)
    ) {
      const options = [
        // { value: "", label: `Select ${field.label || "Language Exam"}` },
        ...(dropdownData?.languageExamTypes || []),
      ];
      return options;
    }

    // Handle Entrance/Core Exam Type fields
    if (
      field.name.toLowerCase().includes("coreexamname") ||
      field.name.toLowerCase().includes("coreexam") ||
      /core.*exam.*name/i.test(field.name) ||
      /entrance.*exam/i.test(field.name)
    ) {
      const options = [
        // { value: "", label: `Select ${field.label || "Core Exam"}` },
        ...(dropdownData?.entranceExamTypes || []),
      ];
      return options;
    }

    // Nationality should come from get-data JSON field options.
    if (field.name.toLowerCase().includes("naionality")) {
  
      if (field.options && Array.isArray(field.options)) {
        return field.options
          .filter((opt: any) => opt != null && opt !== undefined)
          .map((opt: any) =>
            typeof opt === "object"
              ? {
                  value: String(opt?.value ?? opt?.label ?? ""),
                  label: String(opt?.label ?? opt?.value ?? ""),
                }
              : { value: String(opt), label: String(opt) },
          )
          .filter((opt: any) => opt.value && opt.label);
      }
      return [];
    }

    return [];
  };

  // Check if dropdown is loading
  const isDropdownLoading = (field: any) => {
    if (field.name.toLowerCase().includes("country")) {
      return loadingDropdowns.countries;
    }
    if (field.name.toLowerCase().includes("university")) {
      return loadingDropdowns.universities;
    }
    if (field.name.toLowerCase().includes("institute")) {
      return loadingDropdowns.institutes;
    }
    if (field.name.toLowerCase().includes("course")) {
      return loadingDropdowns.courses;
    }
    return false;
  };

  const urlParams = new URLSearchParams(window.location.search);
  const isRedirectVerified = urlParams.get("document_verified") === "true";

  // Fix initial values - set proper defaults for different field types
  const initialValues = (() => {
    // Use mergedFields for vertical step 3, fields for others
    const fieldsToUse = fields;
    const values: Record<string, any> = {};

    // Define enableReinitialize based on your logic or set to false by default
    const enableReinitialize =
      activeHorizontalIndex === 1 &&
      (activeVerticalIndex === 0 ||
        activeVerticalIndex === 1 ||
        activeVerticalIndex === 5);

    fieldsToUse.forEach((field: any) => {
      // Special case for employmentType dropdown to default to 'Student'
      if (field.type === "dropdown" && field.name === "employmentType") {
        if (
          formData &&
          enableReinitialize &&
          (
            /^(basicCoApplicant\d+|addressCoApplicant\d+|employmentCoApplicant\d+)/.test(
              field.name,
            ) ||
            field.name === "dob"
          )
        ) {
          return;
        }
      }

      // Special case for employmentisEmployed radio button to default to "null"
      if (field.type === "radio" && field.name === "employmentisEmployed") {
        if (
          formData &&
          formData[field.name] !== undefined &&
          formData[field.name] !== ""
        ) {
          values[field.name] = formData[field.name];
        } else {
          // values[field.name] = "Yes";
          values[field.name] = "";
        }
        return;
      }
      // Prefill from existing formData in Redux if available
      if (formData && formData[field.name] !== undefined) {
        values[field.name] = formData[field.name];
        return;
      }
      // Prefill co-applicant fields from coApplicantVerification
      // Co-applicant strict mapping (new field names)
      const coApplicantMatch = field.name.match(
        /^basicCoApplicant(\d+)(Email|PhoneNumber|PanNumber|MaritalStatus)$/
      );
      if (coApplicantMatch) {
        const idx = coApplicantMatch[1]; // '1' for basicCoApplicant1, '2' for basicCoApplicant2
        const reduxIdx = String(Number(idx) - 1); // '0' for basicCoApplicant1, '1' for basicCoApplicant2
        const type = coApplicantMatch[2];
        
        // Prefer formData if present
        if (formData[field.name] !== undefined && formData[field.name] !== "") {
          values[field.name] = formData[field.name];
          return;
        }

        // Strictly match field name and reduxIdx
        if (
          type === "PhoneNumber" &&
          coApplicantVerification[reduxIdx]?.lastVerifiedMobileNumber &&
          field.name === `basicCoApplicant${idx}PhoneNumber`
        ) {
          values[field.name] =
            coApplicantVerification[reduxIdx].lastVerifiedMobileNumber;
          return;
        }
        if (
          type === "Email" &&
          coApplicantVerification[reduxIdx]?.lastVerifiedEmail &&
          field.name === `basicCoApplicant${idx}Email`
        ) {
          values[field.name] =
            coApplicantVerification[reduxIdx].lastVerifiedEmail;
          return;
        }
        if (
          type === "PanNumber" &&
          coApplicantVerification[reduxIdx]?.lastPanNumber &&
          field.name === `basicCoApplicant${idx}PanNumber`
        ) {
          values[field.name] = coApplicantVerification[reduxIdx].lastPanNumber;
          return;
        }
      }
      // For indexed exam fields (core/language), prefill all matching keys from formData
      if (
        (field.name.startsWith("core") || field.name.startsWith("language")) &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 4 &&
        formData
      ) {
        Object.keys(formData).forEach((key) => {
          if (key.startsWith(field.name)) {
            values[key] = formData[key];
          }
        });
        if (values[field.name] === undefined) {
          switch (field.type) {
            case "checkbox":
              values[field.name] = false;
              break;
            case "number":
              values[field.name] = "";
              break;
            default:
              values[field.name] = "";
              break;
          }
        }
        return;
      }
      // For indexed course fields (course13Type, etc.), prefill all matching keys from formData
      if (
        field.name.startsWith("course") &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 3 &&
        formData
      ) {
        Object.keys(formData).forEach((key) => {
          if (key.startsWith(field.name)) {
            values[key] = formData[key];
          }
        });
        if (values[field.name] === undefined) {
          switch (field.type) {
            case "checkbox":
              values[field.name] = false;
              break;
            case "number":
              values[field.name] = "";
              break;
            default:
              values[field.name] = "";
              break;
          }
        }
        return;
      }
      // Special redirect prefill for phone/email
      if (
        isRedirectVerified &&
        field.name === "phone_number" &&
        lastVerifiedPhoneNumber
      ) {
        values[field.name] = lastVerifiedPhoneNumber;
        return;
      }
      if (isRedirectVerified && field.name === "email" && lastVerifiedEmail) {
        values[field.name] = lastVerifiedEmail;
        return;
      }

      // Default values for all other fields
      switch (field.type) {
        case "checkbox":
          values[field.name] = false;
          break;
        case "number":
          values[field.name] = "";
          break;
        default:
          values[field.name] = "";
          break;
      }
    });

    // Also prefill any indexed keys in formData not present in fieldsToUse
    if (formData) {
      Object.keys(formData).forEach((key) => {
        if (values[key] === undefined) {
          values[key] = formData[key];
        }
      });
      // Map studentDetails fields from main applicant fields if not already set
      if (
        (values["studentDetailEmail"] === undefined ||
          values["studentDetailEmail"] === "") &&
        formData["email"] !== undefined
      ) {
        values["studentDetailEmail"] = formData["email"];
      }
      if (
        (values["studentDetailsFirstName"] === undefined ||
          values["studentDetailsFirstName"] === "") &&
        formData["firstName"] !== undefined
      ) {
        values["studentDetailsFirstName"] = formData["firstName"];
      }
      if (
        (values["studentDetailsLastName"] === undefined ||
          values["studentDetailsLastName"] === "") &&
        formData["lastName"] !== undefined
      ) {
        values["studentDetailsLastName"] = formData["lastName"];
      }
      if (
        (values["studentDetailsPhone_number"] === undefined ||
          values["studentDetailsPhone_number"] === "") &&
        formData["phone_number"] !== undefined
      ) {
        values["studentDetailsPhone_number"] = formData["phone_number"];
      }
      if (
        (values["LoanDetailsLoanAmount"] === undefined ||
          values["LoanDetailsLoanAmount"] === "") &&
        formData["loanAmount"] !== undefined
      ) {
        values["LoanDetailsLoanAmount"] = formData["loanAmount"];
      }
    }
    // console.log(values, "<--- initial form values");
    return values;
  })();

  const handleRadioChange = (fieldName: string, value: string, form: any) => {
    // Check if this is an applicant type field and value is co-applicant
    if (
      fieldName === "applicantType" &&
      value.toLowerCase().includes("co-applicant")
    ) {
      setOpenCoApplicantModal(true);
    }
    // Employment: clear other fields if "No" is selected
    if (fieldName === "employmentisEmployed" && value === "No") {
      fields
        .filter((f) => f.name !== "employmentisEmployed")
        .forEach((field) => {
          form.setFieldValue(field.name, "");
        });
    }
    // Co-applicant Employment: if "No" is selected, clear that co-applicant's employment type
    const coAppEmploymentMatch = fieldName.match(/^employmentCoApplicant(\d+)isEmployed$/);
    if (coAppEmploymentMatch && value === "No") {
      const idx = coAppEmploymentMatch[1];
      const employmentTypeField = `employmentCoApplicant${idx}employmentType`;
      form.setFieldValue(employmentTypeField, "");
    }
    // Exam: clear other fields if "No" is selected
    if (fieldName === "coreExamApplied" && value === "No") {
      coreFields
        .filter((f: any) => f.name !== "coreExamApplied")
        .forEach((field: any) => {
          // For dynamic exam fields, clear all matching keys
          Object.keys(form.values).forEach((key) => {
            if (key.startsWith(field.name)) {
              form.setFieldValue(key, "");
            }
          });
        });
    }
    if (fieldName === "languageExamApplied" && value === "No") {
      languageFields
        .filter((f: any) => f.name !== "languageExamApplied")
        .forEach((field: any) => {
          Object.keys(form.values).forEach((key) => {
            if (key.startsWith(field.name)) {
              form.setFieldValue(key, "");
            }
          });
        });
    }

    form.setFieldValue(fieldName, value);
  };


  const handleGAEligibilityStatments = useMemo(
    () => getGAEligibilityStatements(applicationSource),
    [applicationSource]
  );

  const handleGAProvisionalOfferStatments = useMemo(
    () => getGAProvisionalOfferStatements(applicationSource),
    [applicationSource]
  );

  const extendedJourneyPrefix = useMemo(
    () => getGAExtendedJourneyPrefix(applicationSource),
    [applicationSource]
  );

  const handleInvokCreateApi = async (payload: any, values: any) => {
    try {
      let resp = null;
      if (isAuthenticated) {
        resp = await postsServices.addPost(
          "api/v1/user-lead/create-verified",
          payload
        );
      } else {
        resp = await postsServices.addPost("api/v1/user-lead/create", payload);
      }

      if (resp.status == 201) {
        trackCustomerJourneyEvent(
          `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
          decrypt(userProfile?.id) ?? "",
          resp.data.data.trackingId,
          {
            label: `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
            category: `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
            action: `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
            page: "EligibiityCheck_Verify Yourself and Provide Consent_Verify",
          }
        );

        if(activeHorizontalIndex === 0 && activeVerticalIndex === 0) {
           if(googleCampKeys && Object.keys(googleCampKeys).length && googleCampKeys?.consent_camp) {
            trackGooglePixelEvent(googleCampKeys.consent_camp) 
          }
        }

        // window.scrollTo({ top: 0, behavior: "smooth" });
        dispatch(setTrackingId(resp.data.data.trackingId));
        setIsSubmittingToAPI(false);
        dispatch(updateFormData(values));
        dispatch(nextVerticalStep());
      }
    } catch (error: any) {
      setIsSubmittingToAPI(false);
      dispatch(
        setStatusPopup({
          status: "error",
          message:
            error?.response?.data?.message ||
            error?.message ||
            "API call failed",
        })
      );
    }
  };
  const buildCreateLeadPayloadForCurrentStep = (values: any) => {
    const resolveFieldValue = (key: string, rawValue: any): any => {
      switch (key) {
        case "institute_code":
          return values?.institute?.value
            ? dropdownData.institutes?.find(
                (item: any) => item.value === values.institute?.value,
              )?.code
            : rawValue;
        case "courseCode":
          return values?.courseName?.value
            ? dropdownData.courses?.find(
                (item: any) => item.value === values.courseName?.value,
              )?.code
            : rawValue;
        case "universityCampusId":
          return values?.university?.code
            ? values.university.code
            : values?.university?.value
              ? dropdownData.universities?.find(
                  (item: any) => item.value == values.university?.value,
                )?.code
              : typeof values?.university === "string"
                ? rawValue
                : rawValue;
        case "universityCountryId":
          return values?.country?.value || rawValue;
        default:
          if (rawValue && typeof rawValue === "object") {
            if (key === "university") {
              return `${rawValue.label}-${rawValue.value}`;
            }
            if ("label" in rawValue) return rawValue.label;
            if ("value" in rawValue) return rawValue.value;
          }
          return rawValue;
      }
    };

    const data: any[] = [];
    Object.entries(values).forEach(([key, value]: any) => {
      const fieldDef = fields.find((f) => f.name === key);
      if (fieldDef?.id) {
        data.push({
          formFieldId: fieldDef.id,
          formFieldKey: key,
          formFieldValue: String(resolveFieldValue(key, value) ?? ""),
        });
      }
    });

    const payloadObject: any = {
      data,
      templateId: templateId,
      formName: horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
      mobileNumber: values?.phone_number ?? formData?.phone_number,
      isAadhaarSeeded:
        aadhaarSeedingStatus === undefined ||
        aadhaarSeedingStatus === null ||
        aadhaarSeedingStatus === ""
          ? false
          : aadhaarSeedingStatus,
    };
    if (trackingId) {
      payloadObject.trackingId = trackingId;
    }
    if (partnerCode) {
      payloadObject.partnerCode = partnerCode;
    }
    if (partnerName) {
      payloadObject.partnerName = partnerName;
    }
    return payloadObject;
  };

  // Add debug logging to form submission
  const handleSubmitForm1 = (values: any, { setSubmitting }: any) => {
    // Build the data array as per required payload
    const data: any[] = [];
    const formDataEntries = Object.entries(values);

    formDataEntries.forEach(([key, value]: any) => {
      const fieldDef = fields.find((f) => f.name === key);
      if (fieldDef?.id) {
        let formFieldValue: any = value;
        // Force applicantType to always be "student"
        if (key === "applicantType") {
          formFieldValue = "student";
        }

        data.push({
          formFieldId: fieldDef.id, // Use field.id from API response
          formFieldKey: key,
          formFieldValue: String(formFieldValue),
        });
      }
    });

    // Build the payload object as per required structure
    const payloadObject: any = {
      templateId: templateId,
      formName: horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
      mobileNumber: values?.phone_number,
      data,
    };

    // Extract source values from URL query parameters only when not authenticated
    if (!isAuthenticated) {
      const urlParams = new URLSearchParams(window.location.search);
      const leadOriginSource = urlParams.get("leadoriginsource") || "";
      const subSource = urlParams.get("source") || "";
      const subSubSource = urlParams.get("subsubsource") || "";
      const utmSource = urlParams.get("utm_source") || "";
      const utmCampaign = urlParams.get("utm_campaign") || "";
      const utmPartnerLeadId = urlParams.get("utm_partner_lead_id") || "";
      const adgroup = urlParams.get("adgroup") || "";
      const keywords = urlParams.get("keywords") || "";
      const gclid = urlParams.get("gclid") || "";

      if(leadOriginSource) payloadObject.leadOriginSource = leadOriginSource;
      if(subSource) payloadObject.subSource = subSource;
      if(subSubSource) payloadObject.subSubSource = subSubSource;
      if(utmSource) payloadObject.utm_source = utmSource;
      if(utmCampaign) payloadObject.utm_campaign = utmCampaign;
      if(utmPartnerLeadId) payloadObject.utmPartnerLeadId = utmPartnerLeadId;
      if(adgroup) payloadObject.adgroup = adgroup;
      if(keywords) payloadObject.keywords = keywords;
      if(gclid) payloadObject.gclid = gclid;
    }
    if (partnerCode) {
      payloadObject.partnerCode = partnerCode;
    }
    if (partnerName) {
      payloadObject.partnerName = partnerName;
    }
    // If trackingId is available, add it to the payload
    if (trackingId) {
      payloadObject.trackingId = trackingId;
    }

    handleInvokCreateApi(payloadObject, values);
  };

  useEffect(() => {
    if (
      fields
        ?.find((f) => f.name === "university")
        ?.name?.toLowerCase()
        .includes("university")
    ) {
      setFormValues((prev) => ({
        ...prev,
        universityNotInList: notInList?.includes(
          fields?.find((f) => f.name === "university")?.label
        )
          ? true
          : false,
      }));
      formikRef.current?.setFieldValue(
        "universityNotInList",
        notInList?.includes(fields?.find((f) => f.name === "university")?.label)
          ? true
          : false
      );
    }
    if (
      fields
        ?.find((f) => f.name === "institute")
        ?.name?.toLowerCase()
        .includes("institute")
    ) {
      setFormValues((prev) => ({
        ...prev,
        instituteNotInList: notInList?.includes(
          fields?.find((f) => f.name === "institute")?.label
        )
          ? true
          : false,
      }));
      formikRef.current?.setFieldValue(
        "instituteNotInList",
        notInList?.includes(fields?.find((f) => f.name === "institute")?.label)
          ? true
          : false
      );
    }
    if (
      fields
        ?.find((f) => f.name === "courseName")
        ?.name?.toLowerCase()
        .includes("coursename")
    ) {
      setFormValues((prev) => ({
        ...prev,
        courseNameNotInList: notInList?.includes(
          fields?.find((f) => f.name === "courseName")?.label
        )
          ? true
          : false,
      }));
      formikRef.current?.setFieldValue(
        "courseNameNotInList",
        notInList?.includes(fields?.find((f) => f.name === "courseName")?.label)
          ? true
          : false
      );
    }
  }, [notInList, setFormValues, formikRef, fields]);

  const shouldAutoInvokeLeadFlow: boolean =
    checkIsLeadApiInvoked.ASSIGN_SM == false ||
    checkIsLeadApiInvoked.CREATE_LEAD == false ||
    checkIsLeadApiInvoked.LEAD_TO_APPLICATION == false;
  const getLeadPayload: any = useMemo(() => {
    if (activeHorizontalIndex == 1 || activeHorizontalIndex == 3) {
      const extractId = (field: any) => {
        const match = field?.match(/^\s*([^-\s]+)\s*(?:-|$)/);
        return match ? match[1] : field?.trim();
      };
      const extractValue = (field: any) =>
        field && typeof field === "object" && "value" in field
          ? field?.value
          : field;
      const extractValueCode = (field: any) =>
        field && typeof field === "object" && "code" in field
          ? field?.code
          : extractId(field)
      // console.log(formData, "formData")
      const partnerLeadPayload: {
        applicationId: any;
        leadFirstName: any;
        leadLastName: any;
        leadMobileNo: any;
        leadEmailAddr: any;
        amountRequested: any;
        admissionStatus: any;
        countryOfStudyId: any;
        universityId: string;
        universityNotInList: any;
        otherUniversityName: any;
        instituteId: string;
        instituteNotInList: any;
        otherInstituteName: any;
        courseId: string;
        courseNotInList: any;
        leadCourseTypeName: any;
        stemFlag: boolean;
        otherCourseName: string;
        assignedSMId?: string;
        pincode?: string;
      } = {
        pincode: formData?.pincode || "",
        applicationId: trackingId || "",
        leadFirstName: formData?.firstName || "",
        leadLastName: formData?.lastName || "",
        leadMobileNo: formData?.phone_number,
        leadEmailAddr: formData?.email || "",
        amountRequested: formData?.loanAmount || "",
        admissionStatus: formData?.admissionStatus || "",
        countryOfStudyId: extractValue(formData?.universityCountryId) || "US",
        universityId: notInList?.includes("University Name")
          ? ""
          : formData.university != null && formData.university != "" ? String(extractValueCode(formData.university)) : "",
        universityNotInList: notInList?.includes("University Name") || false,
        otherUniversityName: notInList?.includes("University Name")
          ? formData.university
          : "",
        instituteId: notInList?.includes("Institute Name")
          ? ""
          : formData.institute != null && formData.institute != "" ? String(extractValueCode(formData.institute)) : "",
        instituteNotInList: notInList?.includes("Institute Name") || false,
        otherInstituteName: notInList?.includes("Institute Name")
          ? formData.institute
          : "",
        courseId: notInList?.includes("Course Name")
          ? ""
          : formData.courseName != null && formData.courseName != "" ? String(extractValueCode(formData.courseName)) : "",
        courseNotInList: notInList?.includes("Course Name") || false,
        leadCourseTypeName: formData.leadCourseTypeName || "Post Graduate",
        stemFlag: formData.courseType == "STEM" ? true : false,
        otherCourseName: notInList?.includes("Course Name")
          ? String(extractValue(formData.courseName))
          : "",
      };

      return partnerLeadPayload;
      
    }
  }, [checkIsLeadApiInvoked, formData, activeHorizontalIndex]);

  const callUpdateLeadApi = async (trackingId: string) => {
    try {
      let leadData:any=  await losServices.getDataByLeadId(trackingId ?? "");
      let dataval=leadData?.data?.data?.configs;
        
      const updateLeadPayload = updateLeadPayloadData(trackingId,dataval);
      
      const updateLeadResp: any = await losServices.updateLead(updateLeadPayload);
      if (updateLeadResp?.status === 200) {
            dispatch(
              setCheckIsLeadApiInvoked({
                key: "CREATE_LEAD",
                value: true,
              })
            );
          }
        } catch (error: any) {
          console.error("Update Lead Error:", error);
          return;
      }
  }

  const handleLeadCreationFlow = async (partnerLeadPayload: any, leadSequenceId: string, isThirdParty?: boolean | null) => {
    //source
    if (checkIsLeadApiInvoked?.ASSIGN_SM == false && applicationSource == "" || isThirdParty === true) {
      let payload: any = {
        pinCode: formData?.pincode, //this static pincode need to be change later for now we are passing it static
        applicationId: trackingId,
      };
      if(partnerCode){
        payload.partnerCode = partnerCode;
      }
      try {
        await eligibilityCheckServices
          .leadAllocation(payload)
          .then((res: any) => {
            partnerLeadPayload.assignedSMId =
              String(res?.data?.data?.assignedSMId) || "";
            dispatch(
              setAssignedSMIdValue(String(res?.data?.data?.assignedSMId))
            );
            // setting assigned sales person id, which is application specific, will be used for display validation of Connect button and Chat
            dispatch(setSalesUserId(String(res?.data?.data?.assignedSMId)));
            dispatch(
              setCheckIsLeadApiInvoked({
                key: "ASSIGN_SM",
                value: true,
              })
            );
          })
          .catch((err: any) => {
            setIsSubmittingToAPI(false);
            console.error("Lead allocation failed:", err);
            return;
          });
      } catch (error) {
        setIsSubmittingToAPI(false);
        console.error("Lead creation flow failed:", error);
        return;
      }
    }

    let leadIdData = "";
    // source
    if (checkIsLeadApiInvoked?.CREATE_LEAD == false && applicationSource == "" || isThirdParty === true) {
      const hasLeadSequenceId =
        !!leadSequenceId && String(leadSequenceId).trim().toLowerCase() !== "null";

      if (!hasLeadSequenceId) {
        try {
          partnerLeadPayload.leadPincode = formData?.pincode;
          partnerLeadPayload.assignedSMId =assignedSMIdValue ? assignedSMIdValue :
            partnerLeadPayload.assignedSMId || "";
          
          await eligibilityCheckServices
            .createPartnerLead(partnerLeadPayload)
            .then(async (resp: any) => {
              leadIdData = resp?.data?.data?.leadSequence.toString();
              dispatch(
                setLeadSequenceId(resp?.data?.data?.leadSequence.toString())
              );
              if (resp?.status == 200) {
                dispatch(
                  setCheckIsLeadApiInvoked({
                    key: "CREATE_LEAD",
                    value: true,
                  })
                );
              }
            })
            .catch(() => {
              setIsSubmittingToAPI(false);
              return;
            });
        } catch (error: any) {
          console.error("Lead to Application Error:", error);
          return;
        }
      } else {
        try {
          if(activeHorizontalIndex<1){
            let leadData:any=  await losServices.getDataByLeadId(trackingId ?? "");
            let dataval=leadData?.data?.data?.configs;
              
            const updateLeadPayload = updateLeadPayloadData(trackingId,dataval)
            const updateLeadResp: any = await losServices.updateLead(updateLeadPayload);
            if (updateLeadResp?.status === 200) {
              leadIdData = String(leadSequenceId);
              dispatch(
                setCheckIsLeadApiInvoked({
                  key: "CREATE_LEAD",
                  value: true,
                })
              );
            }
          }
        } catch (error: any) {
          console.error("Update Lead Error:", error);
          return;
        }
      }
    }
    // lead id
    if (checkIsLeadApiInvoked?.LEAD_TO_APPLICATION == false) {
      try {
        if (leadSequenceId || leadIdData) {
          const leadToAppPayload = {
            leadId: leadSequenceId || leadIdData,
            trackingId: trackingId ?? "",
            // Add any other required fields for lead-to-application
          };

          const leadToAppResp: any = await losServices.leadToApplication(
            leadToAppPayload
          );
          if (leadToAppResp.status == 200) {
            dispatch(
              setCheckIsLeadApiInvoked({
                key: "LEAD_TO_APPLICATION",
                value: true,
              })
            );
            dispatch(
              setApplicationId(leadToAppResp?.data?.data?.applicationId)
            );
            dispatch(setApplicantId(leadToAppResp?.data?.data?.applicantId));

            if (
              activeHorizontalIndex === 1 &&
              (activeVerticalIndex === 0 || activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)
            ) {
              handleRelationMasterApi();
            }

            // Execute API calls based on step conditions
            const executeApiCalls = async () => {
              const promises: Promise<void>[] = [];

              if (activeHorizontalIndex === 0 && (activeVerticalIndex === 0 || activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                promises.push(fetchProducts());
              }

              if (
                activeHorizontalIndex === 0 &&
                (activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)
              ) {
                promises.push(fetchMasterData());
              }

              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                debouncedZipCodeCall(formData.permanentPincode, undefined, "permanent");
                debouncedZipCodeCall(formData.currentPincode, undefined, "current");
              }
              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                debouncedCompanyZipCodeCall(formData.employmentCompanyPincode);
              }

              if (
                (activeHorizontalIndex === 0 && activeVerticalIndex === 1) ||
                (activeHorizontalIndex === 1 &&
                  (activeVerticalIndex === 1 ||
                    activeVerticalIndex === 2 ||
                    activeVerticalIndex === 3 ||
                    activeVerticalIndex === 4 ||
                    activeVerticalIndex === 5)) ||
                (activeHorizontalIndex === 3 && activeVerticalIndex === 0)
              ) {
                promises.push(fetchCountries());
              }

              if (
                activeHorizontalIndex === 1 &&
                (activeVerticalIndex === 0 || activeVerticalIndex === 5 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4)
              ) {
                promises.push(fetchSalutations());
              }

              if (
                (activeHorizontalIndex === 3 && activeVerticalIndex === 0) ||
                (activeHorizontalIndex === 1 && activeVerticalIndex === 5)
              ) {
                promises.push(fetchMaritalStatuses());
              }

              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                promises.push(fetchDesignations());
                handleInvokCompanyZipCode(String(formData.employmentCompanyPincode));
              }

              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                promises.push(getEntranceExamMaster());
                promises.push(fetchSystemValues());
              }

              // Set loading state at the start
              if (promises.length > 0) {
                setIsApiLoading(true);
                try {
                  // Wait for all API calls to complete
                  await Promise.all(promises);
                } finally {
                  setIsApiLoading(false);
                }
              }
            };

            await executeApiCalls();
          }
        }
      } catch (error: any) {
        console.error("Lead to Application Error:", error);
      }
    }
  };
  

  // handleSubmit
  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    setIsSubmittingToAPI(true);
    // window.scrollTo({ top: 0, behavior: "smooth" });
    try {
      dispatch(updateFormData(values));
      // On Form 1 (vertical step 1)
      if (activeHorizontalIndex === 0 && activeVerticalIndex === 0) {
        handleSubmitForm1(values, setSubmitting);
      } else if (activeHorizontalIndex === 0 && activeVerticalIndex == 1) {
        // Call dedupe-check API (mobileNumber encrypted with PII public key, same pattern as PAN verification)
        const courseName =
          values.courseName?.label || values.courseName;
        const mobileNumber =
          values.phone_number ?? formData.phone_number;

        if (!courseName) {
          await handleInvokCreateApi(
            buildCreateLeadPayloadForCurrentStep(values),
            values
          );
        } else {
          try {
            const piiPublicKey = await fetchSanitizedPiiPublicKey();
            if (!piiPublicKey) {
              setIsSubmittingToAPI(false);
              dispatch(
                setStatusPopup({
                  status: "error",
                  message:
                    "Unable to secure your details. Please try again.",
                })
              );
              return;
            }
            trackCustomerJourneyEvent(
              `${handleGAEligibilityStatments}_COURSEDETAILS_PAGE2`,
              decrypt(userProfile?.id) ?? "",
              trackingId,
              {
                label: `${handleGAEligibilityStatments}_COURSEDETAILS_PAGE2`,
                category: `${handleGAEligibilityStatments}_COURSEDETAILS_PAGE2`,
                action: `${handleGAEligibilityStatments}_COURSEDETAILS_PAGE2`,
                page: "EligibiityCheck_Provide Course Details",
              }
            );
            await handleInvokCreateApi(
              buildCreateLeadPayloadForCurrentStep(values),
              values
            );
          } catch (err: any) {
            setIsSubmittingToAPI(false);
            dispatch(
              setStatusPopup({
                status: "error",
                message:
                  err?.response?.data?.message || "Dedupe check failed",
              })
            );
          }
        }
      } else if (activeHorizontalIndex === 0 && activeVerticalIndex === 2) {
        const verticalSteps =
          horizontalSteps[activeHorizontalIndex]?.verticalSteps || [];
        const allFields = [
          ...(verticalSteps[1]?.fields || []),
          ...(verticalSteps[2]?.fields || []),
        ];
        
        if (!assignedSMIdValue) {
          handleLeadCreationFlow(getLeadPayload, leadSequenceId, true);
        }
        const allFormValues = { ...formData, ...values };
        const payload: any = {
          formData: mapFormDataToAPI(allFormValues, allFields),
          submissionTrackingId: trackingId,
        };

        // 1. Capture API
        const captureResp = await eligibilityCheckServices.captureFormData(
          payload
        );
        if (captureResp?.data?.status !== "success") {
          setIsSubmittingToAPI(false);
          dispatch(
            setStatusPopup({
              status: "error",
              message: captureResp?.data?.message || "Capture failed",
            })
          );
          return;
        }
        if (assignedSMIdValue) { 
          callUpdateLeadApi(trackingId);
        }
        

        // 2. BRE API
        const brePayload = {
          applicationId: trackingId,
          provisionalOfferBody: {
            values: {
              input: {
                Unique_Lead_ID: trackingId,
                oApplicant: {
                  oApplName: {
                    sFirstName: allFormValues.firstName || "",
                    sLastName: allFormValues.lastName || "",
                  },
                  aCourseDetails: [
                    {
                      ...(!notInList?.includes("Institute Name") && {
                        institute_code: allFormValues.institute?.value
                          ? dropdownData.institutes.find(
                            (item: any) =>
                              item.value === allFormValues.institute?.value,
                          )?.code
                          : allFormValues.institute_code,
                      }),

                      ...(!notInList?.includes("Course Name") && {
                        course_code: allFormValues.courseName?.value
                          ? dropdownData.courses.find(
                            (item: any) =>
                              item.value === allFormValues.courseName?.value,
                          )?.code
                          : allFormValues.courseCode,
                      }),

                      ...(!notInList?.includes("University Name") && {
                        university_campus_id: allFormValues.university?.code
                          ? allFormValues.university.code
                          : allFormValues.university?.value
                            ? dropdownData.universities.find(
                              (item: any) =>
                                item.value == allFormValues.university?.value
                            )?.code
                            : typeof allFormValues.university === "string"
                              ? allFormValues.universityCampusId
                              : "",
                      }),
                      university_country_id: allFormValues.country?.value ? 
                        allFormValues.country?.value : allFormValues?.universityCountryId ? allFormValues?.universityCountryId : "",
                      category: allFormValues.courseType || "",
                      admission_status: allFormValues.admissionStatus || "",
                      course_category:
                        handleCourseCategoryValue(
                          allFormValues.courseCategory
                        ) || "",
                    },
                  ],
                },
              },
            },
          },
        };

        let breResp: any;
        let fetchUserApplicationRes: any = null;
        if (isAuthenticated) {
          // fetching userapplication data to get isQualified
          const token: any = process.env.REACT_APP_FETCH_TOKEN;
          const res: any = await fetchUserApplicationsFormData(
            token,
            trackingId
          );
          const apps = res.data?.applications || [];
          fetchUserApplicationRes = apps[0];
          let finalSteps = getCombinedApplicationSteps(apps[0]);
          dispatch(setDisplayHorizontalSteps(finalSteps));
          // Store source from API response in Redux
          if (fetchUserApplicationRes?.source) {
            dispatch(setApplicationSource(fetchUserApplicationRes.source));
          }
        }
        if (isPartnerPreEligibilityFlow) {
          setIsSubmittingToAPI(false);
          dispatch(setActiveVerticalIndex(3));
          callUpdateLeadApi(trackingId).catch(() => {});
        } else if (
          (Boolean(partnerSkipEligibilityTrackingId) &&
            String(partnerSkipEligibilityTrackingId) === String(trackingId)) ||
          (fetchUserApplicationRes && fetchUserApplicationRes?.isQualified)
        ) {
          // check-eligibility call, proceed exactly like an already-qualified lead.
          setIsSubmittingToAPI(false);
          dispatch(setActiveHorizontalIndex(1));
          dispatch(setActiveVerticalIndex(0));
        } else if(coAppAddOption === "provisional") {
          dispatch(setActiveHorizontalIndex(2));
          dispatch(setActiveVerticalIndex(0));
        } else {
          setIsCheckingOffer(true);
          try {
            breResp = await eligibilityCheckServices.checkOffer(brePayload);

            if(googleCampKeys && Object.keys(googleCampKeys).length && googleCampKeys.eligilibity_camp) {
              trackGooglePixelEvent(googleCampKeys.eligilibity_camp) 
            }

            trackCustomerJourneyEvent(
              `${handleGAEligibilityStatments}_PROVIDELOANDET_PAGE3`,
              decrypt(userProfile?.id) ?? "",
              trackingId,
              {
                label: `${handleGAEligibilityStatments}_PROVIDELOANDET_PAGE3`,
                category: `${handleGAEligibilityStatments}_PROVIDELOANDET_PAGE3`,
                action: `${handleGAEligibilityStatments}_PROVIDELOANDET_PAGE3`,
                page: "EligibiityCheck_Provide Loan Details",
              }
            );

            if (isAuthenticated) {
              const token: any = process.env.REACT_APP_FETCH_TOKEN;
              const res: any = await fetchUserApplicationsFormData(
                token,
                trackingId
              );
              const apps = res.data?.applications || [];
              fetchUserApplicationRes = apps[0];
              let finalSteps = getCombinedApplicationSteps(apps[0]);
              dispatch(setDisplayHorizontalSteps(finalSteps));
              dispatch(setLeadSequenceId(fetchUserApplicationRes?.leadId));
            }
          } catch (e: any) {
            dispatch(setIsEligible(false));
            // Show server error message in modal popup when API fails
            const apiMessage =
              e?.response?.data?.message ||
              e?.response?.data?.error ||
              e?.message ||
              "Unable to check eligibility. Please try again.";
            setIsSubmittingToAPI(false);
            dispatch(
              setStatusPopup({
                status: "error",
                message: apiMessage,
              })
            );
          } finally {
            setIsCheckingOffer(false);
          }

          dispatch(setBreStatus("FROM_FORM"));
          dispatch(setBreData(breResp?.data?.data));
          dispatch(
            setIsEligible(breResp?.data?.data?.Scheme_Available == "Yes")
          );

          if (breResp?.data?.status !== "success" && (breResp?.data?.message || breResp?.data?.response?.message)) {
            setIsSubmittingToAPI(false);
            dispatch(
              setStatusPopup({
                status: "info",
                message: breResp?.data?.message || breResp?.data?.response?.message,
              })
            );
            return;
          }

          dispatch(nextVerticalStep());
        }

        // 3. Partner Lead API
        // Merge formData and values to ensure all latest keys are included
        const mergedFormData = { ...formData, ...values };
        // Helper to extract value if object, else return as is
        const extractId = (field: any) => {
          const match = field?.match(/^\s*([^-\s]+)\s*(?:-|$)/);
          return match ? match[1] : field?.trim();
        };
        const extractValue = (field: any) =>
          field && typeof field === "object" && "value" in field
            ? field.value
            : field;
        const extractValueCode = (field: any) =>
          field && typeof field === "object" && "code" in field
            ? field.code
            : extractId(field);
        const partnerLeadPayload: {
          applicationId: any;
          leadFirstName: any;
          leadLastName: any;
          leadMobileNo: any;
          leadEmailAddr: any;
          amountRequested: any;
          admissionStatus: any;
          countryOfStudyId: any;
          universityId: string;
          universityNotInList: any;
          otherUniversityName: any;
          instituteId: string;
          instituteNotInList: any;
          otherInstituteName: any;
          courseId: string;
          courseNotInList: any;
          leadCourseTypeName: any;
          stemFlag: boolean;
          otherCourseName: string;
          assignedSMId?: string;
          pincode?: string;
        } = {
          pincode: mergedFormData.pincode || "",
          applicationId: trackingId || "",
          leadFirstName: mergedFormData.firstName || "",
          leadLastName: mergedFormData.lastName || "",
          leadMobileNo: mergedFormData.phone_number,
          leadEmailAddr: mergedFormData.email || "",
          amountRequested: mergedFormData.loanAmount || "",
          admissionStatus: mergedFormData.admissionStatus || "",
          countryOfStudyId: extractValue(mergedFormData.country) || "US",
          universityId: notInList?.includes("University Name")
            ? ""
            : mergedFormData.university != null && mergedFormData.university != "" ? String(extractValueCode(mergedFormData.university)) : "",
          universityNotInList: notInList?.includes("University Name") || false,
          otherUniversityName: notInList?.includes("University Name")
            ? mergedFormData.university
            : "",
          instituteId: notInList?.includes("Institute Name")
            ? ""
            : mergedFormData.institute != null && mergedFormData.institute != "" ? String(extractValueCode(mergedFormData.institute)) : "",
          instituteNotInList: notInList?.includes("Institute Name") || false,
          otherInstituteName: notInList?.includes("Institute Name")
            ? mergedFormData.institute
            : "",
          courseId: notInList?.includes("Course Name")
            ? ""
            : mergedFormData.courseName != null && mergedFormData.courseName != "" ? String(extractValueCode(mergedFormData.courseName)) : "",
          courseNotInList: notInList?.includes("Course Name") || false,
          leadCourseTypeName:
            mergedFormData.leadCourseTypeName || "Post Graduate",
          stemFlag: mergedFormData.courseType == "STEM" ? true : false,
          otherCourseName: notInList?.includes("Course Name")
            ? String(extractValue(mergedFormData.courseName))
            : "",
        };

        if (
          breResp?.data?.data?.Scheme_Available.toLowerCase() === "yes"
        ) {
          // console.log(leadSequenceId, "leadSequenceId")
          handleLeadCreationFlow(partnerLeadPayload, fetchUserApplicationRes?.leadId || leadSequenceId);
        }

        setIsSubmittingToAPI(false);
        dispatch(setBreStatus("FROM_FORM"));
      }
      // For all vertical steps under horizontal step 2
      if (activeHorizontalIndex === 1 || activeHorizontalIndex === 3) {
        if (shouldAutoInvokeLeadFlow) {
          handleLeadCreationFlow(getLeadPayload, leadSequenceId);
        }

        // Build the data array as per required payload
        const data: any[] = [];
        if (activeVerticalIndex === 2) {
          const isEmployed = values.employmentisEmployed;

          // Always include the radio field
          const radioField = fields.find(
            (f) => f.name === "employmentisEmployed"
          );
          if (radioField) {
            data.push({
              formFieldId: radioField.id,
              formFieldKey: radioField.name,
              formFieldValue: isEmployed,
            });
          }

          // Include all other employment fields
          fields
            .filter((f) => f.name !== "employmentisEmployed")
            .forEach((field) => {
              let fieldValue = "";
              if (isEmployed === "Yes") {
                fieldValue = values[field.name] ?? "";
                // Designation is stored as its code; formData carries the full name.
                if (field.name === "employmentDesignation") {
                  fieldValue = getMasterOptionName(fieldValue, dropdownData?.designations);
                }
              } else {
                // If not employed, set employmentType to 'Student', others blank
                if (field.name === "employmentType") {
                  fieldValue = "Student";
                } else {
                  fieldValue = "";
                }
              }
              data.push({
                formFieldId: field.id,
                formFieldKey: field.name,
                formFieldValue: String(fieldValue),
              });
            });
        } else if (activeVerticalIndex === 3) {
          // Merge fields and extraCourses for lookup
          const allCourseFields = fields;

          // Build a map of courseXType values to calculate courseXTypeId
          const courseTypeValues: { [key: string]: string } = {};
          Object.keys(values).forEach((key) => {
            if (/^course\d+Type$/.test(key)) {
              courseTypeValues[key] = values[key];
            }
          });

          // Academic Details: skip core/language fields
          Object.entries(values).forEach(([key, value]: any) => {
            // Skip core/language fields (including indexed)
            if (
              key.startsWith("core") ||
              key.startsWith("language") ||
              key.match(/^core.*_\d+$/) ||
              key.match(/^language.*_\d+$/)
            ) {
              return;
            }

            const fieldDef = allCourseFields.find((f) => f.name === key);
            // Handle courseXType fields - also add corresponding courseXTypeId
            const courseTypeMatch = key.match(/^course(\d+)Type$/);
            
            // Skip courseXTypeId fields since they're added with courseXType above
            const courseTypeIdMatch = key.match(/^course(\d+)TypeID$/);
            if (courseTypeIdMatch) {
              //return; // Skip - already handled above
            }
            if (fieldDef?.id) {
              let fieldValue = value;
              // Special handling for educationGap - pass "0" if blank
              // Fix: Ensure educationGap never becomes "undefined"
              if (key === "educationGap") {
                fieldValue =
                  value !== undefined &&
                    value !== null &&
                    value.toString().trim() !== ""
                    ? value
                    : "0";
              }
              data.push({
                formFieldId: fieldDef.id,
                formFieldKey: key,
                formFieldValue: String(fieldValue),
              });
            } else {
              console.warn(`Field definition not found for key: ${key}, fieldDef:`, fieldDef);
            }
          });

          const eduGapDef = allCourseFields.find(
            (f) => f.name === "educationGap",
          );

          // If educationGap exists in field definitions but was NOT included in the Formik values → push it (to handle untouched field)
          if (
            eduGapDef &&
            !data.some((item) => item.formFieldKey === "educationGap")
          ) {
            data.push({
              formFieldId: eduGapDef.id,
              formFieldKey: "educationGap",
              formFieldValue: "0", // default value
            });
          }
        } else if (activeVerticalIndex === 4) {
          // Core Exam
          const coreRadioField = coreFields.find(
            (f: any) => f.name === "coreExamApplied"
          );
          if (coreRadioField) {
            data.push({
              formFieldId: coreRadioField.id,
              formFieldKey: coreRadioField.name,
              formFieldValue: values[coreRadioField.name] ?? "",
            });

            // Separate base fields and dynamic fields
            const baseCoreFields = coreFields.filter(
              (f: any) => f.name !== "coreExamApplied" && !f.isRemoved
            );
            const dynamicCoreFields = coreFields.filter(
              (f: any) => f.isRemoved
            );

            // Add base fields (exact match only)
            baseCoreFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include coreExamID/coreExamId fields regardless of "Yes" or "No" status
                const isCoreExamID =
                  /^coreExamID(_\d+)?$/.test(field.name) ||
                  /^coreExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isCoreExamID || values[coreRadioField.name] === "Yes"
                      ? String(values[field.name] || "") ?? ""
                      : "",
                });
              }
            });

            // Add dynamic fields with their own IDs
            dynamicCoreFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include coreExamID/coreExamId fields regardless of "Yes" or "No" status
                const isCoreExamID =
                  /^coreExamID(_\d+)?$/.test(field.name) ||
                  /^coreExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isCoreExamID || values[coreRadioField.name] === "Yes"
                      ? String(values[field.name] || "") ?? ""
                      : "",
                });
              }
            });
          }

          // Language Exam
          const languageRadioField = languageFields.find(
            (f: any) => f.name === "languageExamApplied"
          );
          if (languageRadioField) {
            data.push({
              formFieldId: languageRadioField.id,
              formFieldKey: languageRadioField.name,
              formFieldValue: values[languageRadioField.name] ?? "",
            });

            // Separate base fields and dynamic fields
            const baseLanguageFields = languageFields.filter(
              (f: any) => f.name !== "languageExamApplied" && !f.isRemoved
            );
            const dynamicLanguageFields = languageFields.filter(
              (f: any) => f.isRemoved
            );

            // Add base fields (exact match only)
            baseLanguageFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include languageExamID/languageExamId fields regardless of "Yes" or "No" status
                const isLanguageExamID =
                  /^languageExamID(_\d+)?$/.test(field.name) ||
                  /^languageExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isLanguageExamID ||
                      values[languageRadioField.name] === "Yes"
                      ? String(values[field.name] || "") ?? ""
                      : "",
                });
              }
            });

            // Add dynamic fields with their own IDs
            dynamicLanguageFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include languageExamID/languageExamId fields regardless of "Yes" or "No" status
                const isLanguageExamID =
                  /^languageExamID(_\d+)?$/.test(field.name) ||
                  /^languageExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isLanguageExamID ||
                      values[languageRadioField.name] === "Yes"
                      ? String(values[field.name] || "") ?? ""
                      : "",
                });
              }
            });
          }

          // Add any other non-core/language fields if needed
          Object.entries(values).forEach(([key, value]: any) => {
            if (
              !coreFields.some((f: any) => f.name === key) &&
              !languageFields.some((f: any) => f.name === key)
            ) {
              const fieldDef = fields.find((f) => f.name === key);
              if (fieldDef?.id) {
                data.push({
                  formFieldId: fieldDef.id,
                  formFieldKey: key,
                  formFieldValue: String(value),
                });
              }
            }
          });
        } else {
          // Default mapping for other steps
          Object.entries(values).forEach(([key, value]: any) => {
            // if (key === "aadhaar") return; // Do not include aadhaar field
            const fieldDef = fields.find((f) => f.name === key);
            if (fieldDef?.id) {
              let fieldValue = value;
              // Special handling for PAN
              if (key === "pan") {
                fieldValue = hasPan === "no" ? "no" : panNumber;
              }

              data.push({
                formFieldId: fieldDef.id,
                formFieldKey: key,
                formFieldValue: String(fieldValue),
              });
            }
          });
        }

        const isAadhaarSeededPayload =
          aadhaarSeedingStatus === undefined ||
            aadhaarSeedingStatus === null ||
            aadhaarSeedingStatus === ""
            ? false
            : aadhaarSeedingStatus;

        const payloadObject: any = {
          data,
          trackingId: trackingId,
          templateId: templateId,
          formName: horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
          mobileNumber: values?.phone_number || formData?.phone_number,
          isAadhaarSeeded: isAadhaarSeededPayload,

        };

        // Applicant sections before Co-Applicant (vertical 0-4) also send the
        // master-data ids for the backend, tagged with the section saved.
        const applicantSection = APPLICANT_SECTION_BY_VERTICAL_INDEX[activeVerticalIndex];
        if (applicantSection) {
          const idDtosBySection = buildApplicantIdDtosBySection({
            values,
            countryOptions: dropdownData?.countries,
            currentCodeData,
            permanentCodeData,
            companyCodeData,
            entranceExamTypes: dropdownData?.entranceExamTypes,
            languageExamTypes: dropdownData?.languageExamTypes,
            designations: dropdownData?.designations,
          });
          // Only the dto of the screen being saved.
          payloadObject.idDtos = idDtosBySection[applicantSection];
          payloadObject.section = applicantSection;
        }
        try {
          const resp = await applicantDetailsServices.createApplicant(
            payloadObject
          );

          if (
            resp.data?.status === "success"
          ) {
            // Call create-update-applicant-basic-details after successful applicant creation

            try {
              // Set applicationId if available
              if (resp?.data?.data?.applicationId) {
                dispatch(
                  setApplicationId(resp?.data?.data?.applicationId.toString())
                );
              }
              
              // Only proceed with LOS API calls if both IDs are present
              if (resp?.data?.data?.applicantId && resp?.data?.data?.applicationId) {
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 0 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {

                  trackCustomerJourneyEventAndWait(
                    `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                      category: `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                      action: `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                      page: "ProvisionalOff_Student Details",
                    },
                    300
                  );

                  
                  // ==================== APPLICANT DEMOGRAPHIC DETAILS ====================
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 1 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {

                  trackCustomerJourneyEventAndWait(
                    `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                      category: `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                      action: `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                      page: "ProvisionalOff_Address Details",
                    },
                    300
                  );
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {
                  trackCustomerJourneyEventAndWait(
                    `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                      category: `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                      action: `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                      page: "ProvisionalOff_Employment Details",
                    }
                  );
                  
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 3 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {
                  trackCustomerJourneyEventAndWait(
                    `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                      category: `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                      action: `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                      page: "ProvisionalOff_Academic Details",
                    }
                  );
                  
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 4 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {
                  
                  trackCustomerJourneyEventAndWait(
                    `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                      category: `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                      action: `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                      page: "ProvisionalOff_Entrance Exam Details",
                    }
                  );
                  
                }
              }
            } catch (basicDetailsError: any) {
              
            }

            // These dispatches are inside the success if block
            dispatch(setTrackingId(resp.data.data.trackingId));
            setIsSubmittingToAPI(false);
            dispatch(updateFormData(values));
            if(coAppAddOption === "provisional") {
              dispatch(setActiveHorizontalIndex(2));
              dispatch(setActiveVerticalIndex(0));
            } else {
              dispatch(nextVerticalStep());
            }

            if (activeVerticalIndex === 5) {
              dispatch(setActiveHorizontalIndex(2));
            }
            dispatch(setBreStatus("FROM_FORM"));
          }

          // else {
          //   // Error case - resp.data?.status is not "success"
          //   setIsSubmittingToAPI(false);
          //   dispatch(
          //     setStatusPopup({
          //       status: "error",
          //       message: resp.data?.message || "Applicant creation failed",
          //     })
          //   );
          // }
        }
        catch (error: any) {
          // Catch for outer try block (createApplicant API call)
          setIsSubmittingToAPI(false);
          dispatch(
            setStatusPopup({
              status: "error",
              message:
                error?.response?.data?.message || "Applicant creation failed",
            }),
          );
          // }
        }
        //return;
      }
    } catch (error) {
      console.error("Error during form submission:", error);
    } finally {
      setSubmitting(false);
    }
  };

  /**
   * Handles filling current address fields based on a boolean value.
   *
   * When the value is "false", this function copies values from permanent address fields
   * to the corresponding current address fields. When the value is "true" or any other value,
   * it clears all current address fields by setting them to empty strings.
   *
   * This function is typically used in address forms where users can choose to use
   * their permanent address as their current address, or enter a different current address.
   *
   * @param {any} value - A string value that determines the behavior:
   *                      - "false": Copy permanent address values to current address fields
   *                      - Any other value: Clear all current address fields
   *
   * @example
   * // Copy permanent address to current address
   * handleFilledCurrentAddressFields("false");
   *
   * // Clear current address fields
   * handleFilledCurrentAddressFields("true");
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  const handleFilledCurrentAddressFields = (value: any) => {
    if (value === true) {
      // Copy permanent address fields to current address fields
      formikRef?.current?.setFieldValue(
        "currentAddressLine1",
        formikRef?.current?.values?.permanentAddressLine1 || ""
      );
      formikRef?.current?.setFieldValue(
        "currentAddressLine2",
        formikRef?.current?.values?.permanentAddressLine2 || ""
      );
      formikRef?.current?.setFieldValue(
        "currentAddressLine3",
        formikRef?.current?.values?.permanentAddressLine3 || ""
      );
      formikRef?.current?.setFieldValue(
        "currentAddressType",
        formikRef?.current?.values?.permanentAddressType || ""
      );
      formikRef?.current?.setFieldValue(
        "currentCity",
        formikRef?.current?.values?.permanentCity?.value ||
        formikRef?.current?.values?.permanentCity ||
        ""
      );
      formikRef?.current?.setFieldValue(
        "currentCountry",
        formikRef?.current?.values?.permanentCountry || ""
      );
      formikRef?.current?.setFieldValue(
        "currentOwnershipStatus",
        formikRef?.current?.values?.permanentOwnershipStatus || ""
      );
      formikRef?.current?.setFieldValue(
        "currentPincode",
        formikRef?.current?.values?.permanentPincode || ""
      );
      formikRef?.current?.setFieldValue(
        "currentState",
        formikRef?.current?.values?.permanentState || ""
      );
      formikRef?.current?.setFieldValue(
        "currentYearsInCurrentAddress",
        formikRef?.current?.values?.permanentYearsInCurrentAddress || ""
      );
      formikRef?.current?.setFieldValue(
        "currentYearsInCurrentCity",
        formikRef?.current?.values?.permanentYearsInCurrentCity || ""
      );
    } else {

      // Clear current address fields so user can enter new values
      formikRef?.current?.setFieldValue("currentAddressLine1", "");
      formikRef?.current?.setFieldValue("currentAddressLine2", "");
      formikRef?.current?.setFieldValue("currentAddressLine3", "");
      formikRef?.current?.setFieldValue("currentAddressType", "");
      formikRef?.current?.setFieldValue("currentCity", "");
      formikRef?.current?.setFieldValue("currentCountry", "");
      formikRef?.current?.setFieldValue("currentOwnershipStatus", "");
      formikRef?.current?.setFieldValue("currentPincode", "");
      formikRef?.current?.setFieldValue("currentState", "");
      formikRef?.current?.setFieldValue("currentYearsInCurrentAddress", "");
      formikRef?.current?.setFieldValue("currentYearsInCurrentCity", "");
    }
  };

  // Generic handler for co-applicant address copy/clear
  const handleFilledCurrentAddressFieldsCoApplicant = (
    coAppNum: string,
    value: any
  ) => {
    const prefix = `addressCoApplicant${coAppNum}`;
    if (value === true) {
      // Copy permanent address fields to current address fields

      formikRef?.current?.setFieldValue(
        `${prefix}currentAddressLine1`,
        formikRef?.current?.values?.[`${prefix}permanentAddressLine1`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentAddressLine2`,
        formikRef?.current?.values?.[`${prefix}permanentAddressLine2`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentAddressLine3`,
        formikRef?.current?.values?.[`${prefix}permanentAddressLine3`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentCity`,
        formikRef?.current?.values?.[`${prefix}permanentCity`]?.value ||
        formikRef?.current?.values?.[`${prefix}permanentCity`] ||
        ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentCountry`,
        formikRef?.current?.values?.[`${prefix}permanentCountry`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentOwnershipStatus`,
        formikRef?.current?.values?.[`${prefix}permanentOwnershipStatus`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentPincode`,
        formikRef?.current?.values?.[`${prefix}permanentPincode`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentState`,
        formikRef?.current?.values?.[`${prefix}permanentState`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentAddress`,
        formikRef?.current?.values?.[
        `${prefix}permanentYearsInCurrentAddress`
        ] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentCity`,
        formikRef?.current?.values?.[`${prefix}permanentYearsInCurrentCity`] ||
        ""
      );
    } else {
      // Clear current address fields so user can enter new values
      formikRef?.current?.setFieldValue(`${prefix}currentAddressLine1`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentAddressLine2`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentAddressLine3`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentCity`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentCountry`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentOwnershipStatus`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentPincode`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentState`, "");
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentAddress`,
        ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentCity`,
        ""
      );
    }
    // Always set the checkbox value as a boolean in Formik
    formikRef?.current?.setFieldValue(
      `${prefix}currentsameAsPermanent`,
      !!value
    );
  };
  const handleInvokCityApi = async (cityCode: string) => {
    if (!cityCode) return;

    try {
      const resp = await eligibilityCheckServices.getCity(cityCode);
      if (resp.status === 200 && resp.data?.data) {
        const cityLists: any = resp.data.data
          .filter((item: any) => item?.cityName) // Filter out items without cityName
          .map((item: any) => ({
            value: item.cityName || "",
            label: item.cityName || "",
          }));
        setCityList(cityLists);
      }
    } catch (error: any) {
      console.log("error", error);
      setCityList([]); // Reset city list on error
    }
  };

  const handleInvokStatesByCountryApi = async (countryName: string) => {
    const normalizedCountry = String(countryName || "").trim();
    const normalizedCountryLower = normalizedCountry.toLowerCase();

    if (!normalizedCountry) {
      lastBirthCityCountryRef.current = "";
      birthCityInFlightCountryRef.current = "";
      setBirthCityList([]);
      setBirthCityLoading(false);
      return;
    }

    const isSameCountryRequest =
      lastBirthCityCountryRef.current.toLowerCase() === normalizedCountryLower;
    const isSameCountryInFlight =
      birthCityInFlightCountryRef.current.toLowerCase() === normalizedCountryLower;

    if (isSameCountryInFlight || (isSameCountryRequest && birthCityList.length > 0)) {
      return;
    }

    lastBirthCityCountryRef.current = normalizedCountry;
    birthCityInFlightCountryRef.current = normalizedCountry;
    const requestId = ++birthCityRequestIdRef.current;
    setBirthCityLoading(true);

    try {
      const resp = await eligibilityCheckServices.getCitiesByCountryState(
        normalizedCountry,
      );

      if (requestId !== birthCityRequestIdRef.current) {
        return;
      }

      if (resp.status === 200 && resp.data?.data) {
        const rawCities = Array.isArray(resp.data?.data)
          ? resp.data.data
          : typeof resp.data?.data === "object" && resp.data?.data !== null
            ? Object.values(resp.data.data)
            : [];

        const seenCities = new Set<string>();
        const locationOptions = rawCities
          .map((item: any) => {
            if (item && typeof item === "object") {
              const label = String(
                item?.cityName ??
                  item?.cityDesc ??
                  item?.name ??
                  item?.label ??
                  item?.value ??
                  "",
              )
                .trim()
                .replace(/\s+/g, " ");
              // Prefer city/cityCode — never fall back to cityName (full name).
              const value = String(
                item?.city ??
                  item?.cityCode ??
                  item?.value ??
                  item?.code ??
                  "",
              )
                .trim()
                .replace(/\s+/g, " ");

              if (!label && !value) {
                return null;
              }

              return {
                label: label || value,
                value: value || label,
              };
            }

            const normalizedCity = String(item ?? "")
              .trim()
              .replace(/\s+/g, " ");

            if (!normalizedCity) {
              return null;
            }

            return {
              label: normalizedCity,
              value: normalizedCity,
            };
          })
          .filter((city: any) => city?.label || city?.value)
          .filter((city: any) => {
            const key = `${String(city?.value || "").toLowerCase()}::${String(
              city?.label || "",
            ).toLowerCase()}`;
            if (seenCities.has(key)) {
              return false;
            }
            seenCities.add(key);
            return true;
          });

        setBirthCityList(locationOptions);
      } else {
        setBirthCityList([]);
      }
    } catch (error: any) {
      console.log("error", error);
      if (requestId === birthCityRequestIdRef.current) {
        setBirthCityList([]);
      }
    } finally {
      if (requestId === birthCityRequestIdRef.current) {
        birthCityInFlightCountryRef.current = "";
        setBirthCityLoading(false);
      }
    }
  };

  useEffect(() => {
    if (!Array.isArray(fields) || fields.length === 0) return;

    const isBirthCountryFieldMatch = (f: any) => {
      const name = String(f?.name || "").toLowerCase();
      const label = String(f?.label || "").toLowerCase();

      return (
        /country.*birth|birth.*country|countryofbirth/.test(name) ||
        /country.*birth|birth.*country|country of birth/.test(label)
      );
    };

    // Prefer the currently expanded co-applicant's own country-of-birth
    // field whenever a co-applicant accordion is open, since `fields` can
    // contain more than one co-applicant's fields at once and picking the
    // first match regardless of which accordion is open resolves the wrong
    // co-applicant's country (or the wrong step's field entirely — this used
    // to be gated to only (3,0)/(1,5), which silently skipped this on the
    // Co-Applicant Additional Details step (3,1), so changing a co-applicant's
    // Country of Birth there never re-fetched cities for the new country).
    // Not gated by step index, matching how FormEdit.tsx resolves this.
    let birthCountryField: any = null;
    if (loanDetailCoApplicantCollapseValue) {
      const activeCoAppNum = String(
        loanDetailCoApplicantCollapseValue
      ).replace("CoApplicant", "");
      birthCountryField = fields.find(
        (f: any) =>
          f?.name === `basicCoApplicant${activeCoAppNum}CountryOfBirth`
      );
    }

    if (!birthCountryField) {
      birthCountryField = fields.find(isBirthCountryFieldMatch);
    }

    if (!birthCountryField?.name) return;

    const safeFormValues = formValues as Record<string, any>;

    // The country field itself stores an opaque countryId (see
    // `fetchCountries`: value = country.countryId, label = country.countryDesc),
    // while the human-readable country name is kept in a companion
    // `${field.name}Name` field. `getCitiesByCountryState` needs the name,
    // not the id, so prefer the companion field before falling back to the
    // raw field (which may already be a plain name/object in other cases).
    const rawCountry =
      formikRef?.current?.values?.[`${birthCountryField.name}Name`] ??
      safeFormValues?.[`${birthCountryField.name}Name`] ??
      formikRef?.current?.values?.[birthCountryField.name] ??
      safeFormValues?.[birthCountryField.name];

    const resolvedCountry =
      typeof rawCountry === "string"
        ? rawCountry
        : rawCountry && typeof rawCountry === "object"
          ? rawCountry.label || rawCountry.value || ""
          : "";

    const normalizedCountry = String(resolvedCountry || "").trim();
    if (!normalizedCountry) return;

    handleInvokStatesByCountryApi(normalizedCountry);
  }, [
    fields,
    formValues,
    formikRef,
    activeHorizontalIndex,
    activeVerticalIndex,
    loanDetailCoApplicantCollapseValue,
  ]);

  const handleDisablePermanentPincodeBasedFields = (field: any) => {
    const staticFields = [
      "permanentCity",
      "permanentState",
      "permanentCountry",
      "currentCity",
      "currentState",
      "currentCountry",
      "employmentCompanyCity",
      "employmentCompanyState",
      "employmentCompanyCountry",
    ];

    // 1. Static field names
    if (staticFields.includes(field.name)) return true;

    // 2. Dynamic co-applicant fields (1, 2, 3, ...)
    const dynamicPattern =
      /^addressCoApplicant\d+(permanentCity|permanentState|permanentCountry|currentCity|currentState|currentCountry)$/;

    const dynamicCompanyPattern =
      /^employmentCoApplicant\d+(city|state|companyCountry)$/;

    const referenceAddressPattern =
      /^addressReference\d+(City|State|Country)$/;

    // Collateral (property mode) City/State/Country — auto-filled via pincode lookup, read-only.
    const collateralAddressPattern = /^collateral\d*(City|State|Country)$/i;

    return (
      dynamicPattern.test(field.name) ||
      dynamicCompanyPattern.test(field.name) ||
      referenceAddressPattern.test(field.name) ||
      collateralAddressPattern.test(field.name)
    );
  };

  const [permanentCodeData, setPermanentCodeData] = useState<any>(null);
  const [currentCodeData, setCurrentCodeData] = useState<any>(null);
  const [companyCodeData, setCompanyCodeData] = useState<any>(null);
  const [reference1CodeData, setReference1CodeData] = useState<any>(null);
  const [reference2CodeData, setReference2CodeData] = useState<any>(null);
  const [collateralCodeDataByNumber, setCollateralCodeDataByNumber] = useState<
    Record<string, any>
  >({});
  // Ref to store timeout ID for cleanup
  const zipCodeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [isPinCodeLoading, setIsPinCodeLoading] = useState(false);
  // console.log(isCurrentSameAsPermanent, "isCurrentSameAsPermanent")
  const handleInvokPinCodeApi = async (
    zipCode: string,
    stateCode: string,
    fieldType?: string,
    coAppNum?: string
  ) => {
    try {
      const resp = await eligibilityCheckServices.getPinCode(zipCode);
      if (resp.status === 200) {
        // Read fresh values from Redux store to avoid using stale closure values
        const currentState = store.getState();
        const currentActiveHorizontalIndex = currentState.stepper.activeHorizontalIndex;
        const currentActiveVerticalIndex = currentState.stepper.activeVerticalIndex[currentActiveHorizontalIndex] || 0;
        if (
          (currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 5) ||
          (currentActiveHorizontalIndex == 3 && currentActiveVerticalIndex == 1)
        ) {

          // Always read the latest state from Redux store to handle concurrent updates
          // This ensures we always have the most recent state even when API calls happen in quick succession
          const latestState = store.getState();
          const latestZipCodeData =
            latestState.stepper.coApplicantZipCodeData || {};

          // Create a proper copy of the state to avoid mutations
          // Use spread operator for shallow copy, then deep copy nested objects
          var oldPinCodeData: any = {};
          Object.keys(latestZipCodeData).forEach((key) => {
            if (
              latestZipCodeData[key] &&
              typeof latestZipCodeData[key] === "object"
            ) {
              oldPinCodeData[key] = {
                current: latestZipCodeData[key].current && typeof latestZipCodeData[key].current === 'object'
                    ? { ...latestZipCodeData[key].current }
                    : latestZipCodeData[key].current,
                permanent: latestZipCodeData[key].permanent && typeof latestZipCodeData[key].permanent === 'object'
                  ? { ...latestZipCodeData[key].permanent }
                  : latestZipCodeData[key].permanent,
                company: latestZipCodeData[key].company && typeof latestZipCodeData[key].company === 'object'
                  ? { ...latestZipCodeData[key].company }
                  : latestZipCodeData[key].company,
              };
            } else {
              oldPinCodeData[key] = latestZipCodeData[key];
            }
          });

            // Read loanDetailCoApplicantCollapseValue fresh from the store to avoid stale closure.
          // If coAppNum is explicitly passed (always the case from CoApplicantDetailsSection),
          // derive the key from it directly so we never rely on Redux collapse state at all.
          const latestCollapseValue =
            latestState.stepper.loanDetailCoApplicantCollapseValue;
          let coAppKey = coAppNum
            ? `CoApplicant${coAppNum}`
            : latestCollapseValue;

          // Ensure coAppKey exists in the data structure
          if (!oldPinCodeData[coAppKey]) {
            oldPinCodeData[coAppKey] = {
              current: null,
              permanent: null,
              company: null,
            };
          }

          // Get existing data for this co-applicant, preserving both current and permanent
          const existingCoAppData = oldPinCodeData[coAppKey] || {};

          // Preserve existing values - these are already deep copied above
          const preservedCurrent = existingCoAppData.current !== undefined
              ? existingCoAppData.current
              : null;

          const preservedPermanent = existingCoAppData.permanent !== undefined
              ? existingCoAppData.permanent
              : null;

          // Prepare the new data object with API response
          const newPinCodeData = {
            ...resp.data.data?.[0],
            stateCode: stateCode,
          };

          // Derive coAppNumValue from the already-correct coAppKey (not from stale closure).
          const coAppNumValue = coAppKey.split("CoApplicant")[1];
          const currentSameAsPermanent =
            formikRef?.current?.values?.[
              `addressCoApplicant${coAppNumValue}currentsameAsPermanent`
            ];

          if (currentSameAsPermanent && fieldType !== "company") {
            // If same as permanent is checked, update both with same data (not applicable for company address)
            oldPinCodeData[coAppKey] = {
              current: { ...newPinCodeData },
              permanent: { ...newPinCodeData },
              company: existingCoAppData.company !== undefined ? existingCoAppData.company : null,
            };
          } else {
            // Update only the targeted field type, preserving the opposite field
            if (fieldType === "permanent") {
              oldPinCodeData[coAppKey] = {
                current: preservedCurrent, // Preserve existing current data
                permanent: { ...newPinCodeData }, // Update permanent with new data
                company: existingCoAppData.company !== undefined ? existingCoAppData.company : null,
              };
            } else if (fieldType === "current") {
              oldPinCodeData[coAppKey] = {
                current: { ...newPinCodeData }, // Update current with new data
                permanent: preservedPermanent, // Preserve existing permanent data
                company: existingCoAppData.company !== undefined ? existingCoAppData.company : null,
              };
            } else if (fieldType === "company") {
              oldPinCodeData[coAppKey] = {
                current: preservedCurrent, // Preserve existing current data
                permanent: preservedPermanent, // Preserve existing permanent data
                company: { ...newPinCodeData }, // Update company with new data
              };
            } else {
              // If fieldType is not specified, preserve both existing values
              oldPinCodeData[coAppKey] = {
                current: preservedCurrent,
                permanent: preservedPermanent,
                company: existingCoAppData.company !== undefined ? existingCoAppData.company : null,
              };
            }
          }

          // Dispatch the updated state
          dispatch(setCoApplicantZipCodeData(oldPinCodeData));
        }

        if (currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 1) {
          if (isCurrentSameAsPermanent) {
            // console.log("permanentCodeData")
            // Create separate copies for permanent and current to avoid reference sharing
            const permanentData = { ...resp.data.data?.[0], stateCode: stateCode };
            setPermanentCodeData(permanentData);
            setCurrentCodeData(permanentData);
          } else {
            switch (fieldType) {
              case "permanent":
                // Update permanent only, preserve current address with its existing stateCode
                const permanentData = { ...resp.data.data?.[0], stateCode: stateCode };
                setPermanentCodeData(permanentData);
                // currentCodeData remains unchanged - don't touch it
                break;
              case "current":
                // Update current only, preserve permanent address with its existing stateCode
                const currentData = { ...resp.data.data?.[0], stateCode: stateCode };
                setCurrentCodeData(currentData);
                // permanentCodeData remains unchanged - don't touch it
                break;
              default:
                // No action needed for other fieldType values
                break;
            }
          }
        }
        if (currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 2) {
          // Update company address pincode data state
          if (resp.data?.data?.[0]) {
            const companyData = { ...resp.data.data?.[0], stateCode: stateCode };
            setCompanyCodeData(companyData);
          } else {
            // Clear company code data if no data found
            setCompanyCodeData(null);
          }
        }
        if (currentActiveHorizontalIndex == 3 && currentActiveVerticalIndex == 3) {
          const referenceData = resp.data?.data?.[0]
            ? { ...resp.data.data?.[0], stateCode: stateCode }
            : null;
          if (fieldType === "reference1") {
            setReference1CodeData(referenceData);
          } else if (fieldType === "reference2") {
            setReference2CodeData(referenceData);
          }
        }
        // Property collateral: store city / pinCodeId / stateCode like reference
        const collateralMatch = fieldType?.match(/^collateral(\d+)$/i);
        if (collateralMatch) {
          const collateralNum = collateralMatch[1];
          const collateralData = resp.data?.data?.[0]
            ? { ...resp.data.data?.[0], stateCode: stateCode }
            : null;
          setCollateralCodeDataByNumber((prev) => {
            const next = { ...prev };
            if (collateralData) {
              next[collateralNum] = collateralData;
            } else {
              delete next[collateralNum];
            }
            return next;
          });
        }
      }
    } catch (error: any) {
      // Clear company code data on error if we're in company address section
      const currentState = store.getState();
      const currentActiveHorizontalIndex = currentState.stepper.activeHorizontalIndex;
      const currentActiveVerticalIndex = currentState.stepper.activeVerticalIndex[currentActiveHorizontalIndex] || 0;
      if (currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 2) {
        setCompanyCodeData(null);
      }
      if (currentActiveHorizontalIndex == 3 && currentActiveVerticalIndex == 3) {
        if (fieldType === "reference1") {
          setReference1CodeData(null);
        } else if (fieldType === "reference2") {
          setReference2CodeData(null);
        }
      }
      const collateralMatch = fieldType?.match(/^collateral(\d+)$/i);
      if (collateralMatch) {
        const collateralNum = collateralMatch[1];
        setCollateralCodeDataByNumber((prev) => {
          const next = { ...prev };
          delete next[collateralNum];
          return next;
        });
      }
    } finally {
      setZipCodeLoading(false);
    }
  };

  const lastUniversityQueryRef = useRef("");
  const lastInstituteQueryRef = useRef("");
  const lastCourseQueryRef = useRef("");

  // Debounced function to handle zip code API calls
  const debouncedZipCodeCall = useCallback(
    async (pincode: string, coAppNum?: string, fieldType?: string) => {
      if (pincode && String(pincode).length === 6) {
        setZipCodeLoading(true);
        try {
          const resp = await eligibilityCheckServices.getZipCode(pincode);
          if (resp.status === 200) {
            // Each address block below sets City/State/Country back to back.
            // Formik's default (shouldValidate: true) setFieldValue validates
            // against the values snapshot from BEFORE any of these calls run,
            // so e.g. the Country call's validation doesn't yet see the City/
            // State values the earlier calls just set — and whichever
            // validation resolves last overwrites the others' correct,
            // error-free result with phantom "Please select a City/State/
            // Country" errors. shouldValidate is explicitly false here, with
            // the error cleared manually, to avoid that race entirely.
            const setAddressFieldSilently = (fieldName: string, val: any) => {
              formikRef?.current?.setFieldValue(fieldName, val, false);
              formikRef?.current?.setFieldError(fieldName, undefined);
              // Errors are cleared optimistically above; this re-derives them from
              // the schema once every write in this batch has landed.
              scheduleFormRevalidate();
            };

            // Several lookups can be in flight for the applicant address (the
            // load-time one, the Aadhaar prefill, user typing). Drop a response
            // whose pincode no longer matches the form, so a late stale one
            // can't overwrite City/State/Country for the pincode now shown.
            const isStaleApplicantAddressResponse = () => {
              const addressPrefix = coAppNum ? `addressCoApplicant${coAppNum}` : "";
              const pincodeKey =
                fieldType === "permanent" || fieldType === "current"
                  ? addressPrefix
                    ? `${addressPrefix}${fieldType}Pincode`
                    : `${fieldType}Pincode`
                  : "";
              const formPincode = pincodeKey
                ? formikRef?.current?.values?.[pincodeKey]
                : "";
              return !!formPincode && String(formPincode) !== String(pincode);
            };

            if (resp?.data?.data.length > 0) {
              const { cityName, countryName, stateName, stateCode, city }: any =
                resp?.data?.data?.[0];

              if (isStaleApplicantAddressResponse()) return;

              // Awaited so the outer `finally` below (which resets
              // zipCodeLoading) doesn't fire until getPinCode has also
              // settled — previously this ran fire-and-forget, so
              // zipCodeLoading could flip back to false while getPinCode
              // was still in flight.
              await handleInvokPinCodeApi(pincode, stateCode, fieldType, coAppNum);

              if (isStaleApplicantAddressResponse()) return;

              // Determine if this is a permanent address field
              const isPermanentField = fieldType === "permanent";
              const isCurrentField = fieldType === "current";
              const isCompanyField = fieldType === "company";
              const isReference1Field = fieldType === "reference1";
              const isReference2Field = fieldType === "reference2";
              const isCollateralField = /^collateral\d+$/i.test(fieldType || "");
              const collateralNumber =
                fieldType?.match(/^collateral(\d+)$/i)?.[1] || "1";

              // Safety check - if fieldType is not specified, don't update any fields to avoid confusion
              if (!fieldType) {
                console.warn(
                  "handleInvokZipCode called without fieldType, skipping field updates"
                );
                return;
              }

              if (coAppNum) {
                const sameAsKey = `addressCoApplicant${coAppNum}currentsameAsPermanent`;
                const isSameAs = formikRef?.current?.values?.[sameAsKey];

                if (isPermanentField) {
                  // Update permanent fields when permanent pincode is entered
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}permanentCity`,
                    cityName || ""
                  );
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}permanentState`,
                    stateName || ""
                  );
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}permanentCountry`,
                    countryName || ""
                  );
                  // Only update current fields if same as permanent is checked
                  if (isSameAs) {
                    handleInvokCityApi(city);
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}currentCity`,
                      cityName || ""
                    );
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}currentState`,
                      stateName || ""
                    );
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}currentCountry`,
                      countryName || ""
                    );
                  }
                } else if (isCurrentField) {
                  // Update current fields when current pincode is entered
                  handleInvokCityApi(city);
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}currentCity`,
                    cityName || ""
                  );
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}currentState`,
                    stateName || ""
                  );
                  setAddressFieldSilently(
                    `addressCoApplicant${coAppNum}currentCountry`,
                    countryName || ""
                  );
                  // Only update permanent fields if same as current is checked
                  if (isSameAs) {
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}permanentCity`,
                      cityName || ""
                    );
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}permanentState`,
                      stateName || ""
                    );
                    setAddressFieldSilently(
                      `addressCoApplicant${coAppNum}permanentCountry`,
                      countryName || ""
                    );
                  }
                } else if (isCompanyField) {
                  // Update co-applicant company address fields when company pincode is entered
                  setAddressFieldSilently(
                    `employmentCoApplicant${coAppNum}city`,
                    cityName || ""
                  );
                  setAddressFieldSilently(
                    `employmentCoApplicant${coAppNum}state`,
                    stateName || ""
                  );
                  setAddressFieldSilently(
                    `employmentCoApplicant${coAppNum}companyCountry`,
                    countryName || ""
                  );
                }
              } else {
                const isSameAs =
                  formikRef?.current?.values?.currentsameAsPermanent;

                if (isPermanentField) {
                  // Update permanent fields when permanent pincode is entered
                  setAddressFieldSilently("permanentCity", cityName || "");
                  setAddressFieldSilently("permanentState", stateName || "");
                  setAddressFieldSilently(
                    "permanentCountry",
                    countryName || ""
                  );
                  // Only update current fields if same as permanent is checked
                  if (isSameAs) {
                    handleInvokCityApi(stateCode);
                    setAddressFieldSilently("currentCity", cityName || "");
                    setAddressFieldSilently("currentState", stateName || "");
                    setAddressFieldSilently(
                      "currentCountry",
                      countryName || ""
                    );
                  }
                } else if (isCurrentField) {
                  // Update current fields when current pincode is entered
                  handleInvokCityApi(stateCode);
                  setAddressFieldSilently("currentCity", cityName || "");
                  setAddressFieldSilently("currentState", stateName || "");
                  setAddressFieldSilently("currentCountry", countryName || "");
                  // Only update permanent fields if same as current is checked
                  if (isSameAs) {
                    setAddressFieldSilently("permanentCity", cityName || "");
                    setAddressFieldSilently("permanentState", stateName || "");
                    setAddressFieldSilently(
                      "permanentCountry",
                      countryName || ""
                    );
                  }
                } else if (isReference1Field) {
                  setAddressFieldSilently(
                    "addressReference1City",
                    cityName || ""
                  );
                  setAddressFieldSilently(
                    "addressReference1State",
                    stateName || ""
                  );
                  setAddressFieldSilently(
                    "addressReference1Country",
                    countryName || ""
                  );
                } else if (isReference2Field) {
                  setAddressFieldSilently(
                    "addressReference2City",
                    cityName || ""
                  );
                  setAddressFieldSilently(
                    "addressReference2State",
                    stateName || ""
                  );
                  setAddressFieldSilently(
                    "addressReference2Country",
                    countryName || ""
                  );
                } else if (isCollateralField) {
                  applyCollateralAddressFromPincode(formikRef, {
                    fields,
                    collateralNumber,
                    cityName: cityName || "",
                    stateName: stateName || "",
                    countryName: countryName || "",
                    countries: dropdownData?.countries || [],
                    onUpdate: (patch) => dispatch(updateFormData(patch)),
                  });
                }
              }
            } else {
              const isPermanentField = fieldType === "permanent";
              const isCurrentField = fieldType === "current";
              const isCompanyField = fieldType === "company";
              const isReference1Field = fieldType === "reference1";
              const isReference2Field = fieldType === "reference2";
              const isCollateralField = /^collateral\d+$/i.test(fieldType || "");
              const collateralNumber =
                fieldType?.match(/^collateral(\d+)$/i)?.[1] || "1";
              if (coAppNum) {
                if (isPermanentField) {
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}permanentCity`, "");
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}permanentState`, "");
                } else if (isCurrentField) {
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}currentCity`, "");
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}currentState`, "");
                } else if (isCompanyField) {
                  formikRef?.current?.setFieldValue(`employmentCoApplicant${coAppNum}city`, "");
                  formikRef?.current?.setFieldValue(`employmentCoApplicant${coAppNum}state`, "");
                  formikRef?.current?.setFieldValue(`employmentCoApplicant${coAppNum}companyCountry`, "");
                }
              } else {
                if (isPermanentField) {
                  formikRef?.current?.setFieldValue("permanentCity", "");
                  formikRef?.current?.setFieldValue("permanentState", "");
                } else if (isCurrentField) {
                  formikRef?.current?.setFieldValue("currentCity", "");
                  formikRef?.current?.setFieldValue("currentState", "");
                } else if (isReference1Field) {
                  formikRef?.current?.setFieldValue("addressReference1City", "");
                  formikRef?.current?.setFieldValue("addressReference1State", "");
                  formikRef?.current?.setFieldValue("addressReference1Country", "");
                } else if (isReference2Field) {
                  formikRef?.current?.setFieldValue("addressReference2City", "");
                  formikRef?.current?.setFieldValue("addressReference2State", "");
                  formikRef?.current?.setFieldValue("addressReference2Country", "");
                } else if (isCollateralField) {
                  applyCollateralAddressFromPincode(formikRef, {
                    fields,
                    collateralNumber,
                    clear: true,
                    onUpdate: (patch) => dispatch(updateFormData(patch)),
                  });
                  setCollateralCodeDataByNumber((prev) => {
                    const next = { ...prev };
                    delete next[String(collateralNumber)];
                    return next;
                  });
                }
              }

              dispatch(
                setStatusPopup({
                  status: "error",
                  message: "Pincode not found. Please enter a valid pincode.",
                })
              );
            }
          }
        } catch (error: any) {
          console.log("error", error);
        } finally {
          // Without this, an invalid/not-found pincode (or a failed API call)
          // left zipCodeLoading stuck true forever, since handleInvokPinCodeApi
          // (the only other place that cleared it) is never reached on those
          // paths — permanently blocking Continue via isNavigationDisabled.
          setZipCodeLoading(false);
        }
      }
      // }, 500);
    },
    [
      loanDetailCoApplicantCollapseValue,
      coApplicantZipCodeData,
      formData,
      permanentCodeData,
      currentCodeData,
      isCurrentSameAsPermanent,
      activeHorizontalIndex,
      activeVerticalIndex
    ]
  );

  const debouncedCall = useMemo(
    () =>
      debounce((key: string, value: string) => {
        if (key === "university") fetchUniversities(value);
        if (key === "institute") fetchInstitutes(value);
        if (key === "courseName") fetchCourses(value);
      }, 1000),
    [formValues.countryId, formData?.country?.value, formValues.universityId, formValues?.instituteId]
  );

  useEffect(() => {
    if(activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
       dispatch(setIsPreLogin(false));
    }
  }, [activeHorizontalIndex, activeVerticalIndex])

  useEffect(() => {
    (async () => {
      if(trackingId && activeHorizontalIndex === 1 && activeVerticalIndex === 4) {
        const data = await fetchAppData(trackingId);
        const verticalSteps = data[0]?.horizontalSteps[1]?.verticalSteps || [];
        const loanDetails = verticalSteps?.find((f: any) => f.verticalStepName === "Co-Applicant Details")?.verticalStepName;
        if(loanDetails === "Co-Applicant Details") {
          dispatch(setIsCoAppAlreadyExist(true))
        }
      }
    })()
  },[trackingId, activeHorizontalIndex, activeVerticalIndex]);


  const handleInvokZipCode = (
    pincode: string,
    coAppNum?: string,
    fieldType?: string
  ) => {
    // Only call API if pincode is exactly 6 digits
    if (pincode && pincode.length === 6) {
      debouncedZipCodeCall(pincode, coAppNum, fieldType);
    }
  };
  // console.log(permanentCodeData, currentCodeData, isCurrentSameAsPermanent, "permanentCodeData")
  // City/State/Country follow the address's own saved pincode. The Aadhaar
  // pincode is only a fallback for an address that has none yet — once the
  // address was changed (e.g. in the assisted journey), looking up the Aadhaar
  // pincode would overwrite City/State/Country with the old address's values.
  const savedPermanentPincode =
    formikRef?.current?.values?.permanentPincode || formData?.permanentPincode;
  useEffect(() => {
    const permanentPincodeToResolve =
      savedPermanentPincode || aadhaarVerifiedDetails?.pincode;
    if (isCurrentSameAsPermanent == true && activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
      setPermanentCodeData(null);
      setCurrentCodeData(null);
      handleInvokZipCode(
        permanentPincodeToResolve,
        undefined,
        "permanent"
      );
    } else {
      if (aadhaarVerifiedDetails?.pincode &&
        activeHorizontalIndex === 1 &&
        (activeVerticalIndex === 1 ||
          activeVerticalIndex === 2 ||
          activeVerticalIndex === 5)
      ) {
        handleInvokZipCode(
          permanentPincodeToResolve,
          undefined,
          "permanent"
        );
      }
    }
  }, [
    aadhaarVerifiedDetails?.pincode,
    activeHorizontalIndex,
    activeVerticalIndex,
    savedPermanentPincode,
    isCurrentSameAsPermanent
  ]);

  // Ref to track last processed employment pincode
  const lastEmploymentPincodeRef = useRef<string>("");

  useEffect(() => {
    if (
      activeHorizontalIndex == 1 &&
      (activeVerticalIndex == 1 ||
        activeVerticalIndex == 2)
    ) {
      const currentPincode = formikRef?.current?.values?.employmentCompanyPincode;
      if (currentPincode && currentPincode !== lastEmploymentPincodeRef.current) {
        lastEmploymentPincodeRef.current = currentPincode;
        handleInvokZipCode(currentPincode);
      }
    }
  }, [formikRef?.current?.values?.employmentCompanyPincode, activeHorizontalIndex, activeVerticalIndex]);

  // For each co-applicant, if Aadhaar details have pincode, trigger handleInvokZipCode with co-applicant number
  useEffect(() => {
    if (!aadhaarVerifiedDetailsCoApplicant) return;
    Object.entries(aadhaarVerifiedDetailsCoApplicant).forEach(
      ([coAppKey, detailsRaw]) => {
        const match = coAppKey.match(/CoApplicant(\d+)/);
        if (!match) return;
        const num = match[1];
        const details = detailsRaw as any;
        if (details?.pincode) {
          handleInvokZipCode(details.pincode, num, "permanent");
        }
      }
    );
  }, [aadhaarVerifiedDetailsCoApplicant]);

    // When user lands on Reference & Collateral step, restore reference/collateral code data
    // by re-triggering pincode API for any existing reference/collateral pincodes
    useEffect(() => {
      if (activeHorizontalIndex === 3 && activeVerticalIndex === 3) {
        const fv = formikRef?.current?.values || {};
        const ref1Pincode = fv?.addressReference1Pincode;
        const ref2Pincode = fv?.addressReference2Pincode;
        if (ref1Pincode && String(ref1Pincode).length === 6) {
          handleInvokZipCode(String(ref1Pincode), undefined, "reference1");
        }
        if (ref2Pincode && String(ref2Pincode).length === 6) {
          handleInvokZipCode(String(ref2Pincode), undefined, "reference2");
        }
        Object.keys(fv).forEach((key) => {
          if (
            /^collateral/i.test(key) &&
            /pincode/i.test(key) &&
            !/^coOwnerCollateral/i.test(key)
          ) {
            const normalized = String(key)
              .toLowerCase()
              .replace(/[^a-z0-9]/g, "");
            const match = normalized.match(/^collateral(\d+)/);
            const collateralNum = match?.[1] || "1";
            const pin = fv[key];
            const pinStr =
              pin && typeof pin === "object" && "value" in pin
                ? String((pin as any).value ?? "")
                : String(pin ?? "");
            if (pinStr.length === 6) {
              handleInvokZipCode(pinStr, undefined, `collateral${collateralNum}`);
            }
          }
        });
      }
    }, [activeHorizontalIndex, activeVerticalIndex]);

  // Ref to store timeout ID for cleanup
  const companyZipCodeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Debounced function to handle zip code API calls
  const debouncedCompanyZipCodeCall = useCallback((pincode: string) => {
    // Clear existing timeout
    if (companyZipCodeTimeoutRef.current) {
      clearTimeout(companyZipCodeTimeoutRef.current);
    }

    // Clear loading state when user starts typing again
    setZipCodeLoading(false);

    // Set new timeout
    companyZipCodeTimeoutRef.current = setTimeout(async () => {
      if (pincode && pincode.length === 6) {
        setZipCodeLoading(true);

        try {
          const resp = await eligibilityCheckServices.getZipCode(pincode);
          if (resp.status === 200) {
            if (resp?.data?.data.length > 0) {
              const { cityName, countryName, stateName, stateCode }: any =
                resp?.data?.data?.[0];

              // Awaited so the outer `finally` below doesn't reset
              // zipCodeLoading before getPinCode has also settled.
              await handleInvokPinCodeApi(pincode, stateCode);
              // handleInvokStateApi(stateCode);
              handleInvokCityApi(stateCode);
              formikRef?.current?.setFieldValue(
                "employmentCompanyCity",
                cityName || ""
              );
              formikRef?.current?.setFieldValue(
                "employmentCompanyState",
                stateName || ""
              );
              formikRef?.current?.setFieldValue(
                "employmentCompanyCountry",
                countryName || ""
              );
            } else {
              // Clear company code data if pincode not found
              setCompanyCodeData(null);
              formikRef?.current?.setFieldValue("employmentCompanyCity", "");
              formikRef?.current?.setFieldValue("employmentCompanyState", "");
              formikRef?.current?.setFieldValue("employmentCompanyCountry", "");

              dispatch(
                setStatusPopup({
                  status: "error",
                  message: "Pincode not found. Please enter a valid pincode.",
                })
              );
            }
          }
        } catch (error: any) {
          console.log("error", error);
        } finally {
          setZipCodeLoading(false);
        }
      }
    }, 500); // 500ms delay
  }, []);

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (zipCodeTimeoutRef.current) {
        clearTimeout(zipCodeTimeoutRef.current);
      }
      if (companyZipCodeTimeoutRef.current) {
        clearTimeout(companyZipCodeTimeoutRef.current);
      }
    };
  }, []);

  const handleInvokCompanyZipCode = (pincode: string) => {
    // Only call API if pincode is exactly 6 digits
    if (pincode && pincode.length === 6) {
      debouncedCompanyZipCodeCall(pincode);
    }
  };

  const renderField = (field: any) => {
    switch (field.type) {
      case "number":
      case "text":
        if (formikRef?.current?.values?.employmentType !== "Others" && field.name === "employmentYear" ) {
          return (
            <Grid item xs={12} key={field.id} sx={{ mt: 1 }}>
              <Box sx={{ bgcolor: '#00B3B514', p: 2, borderRadius: 2 }}>
                <Box mb={1} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <img src={workExperienceIcon} alt="work-experience" />
                  <Typography style={{ color: '#4B465C', fontSize: '13px', fontWeight: 700 }}>
                    Help us with your work experience <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>

                <Grid container spacing={2}>
                  {/* YEAR FIELD */}
                  <Grid item xs={12} sm={6}>
                    <Field name="employmentYear">
                      {({ field: f, meta, form }: any) => (
                        <InputField
                          {...f}
                          fullWidth
                          type="text"
                          placeholder="Total Years"
                          variant="outlined"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          inputProps={{ min: 0, max: 60, maxLength: 2 }}
                          error={!!meta.touched && !!meta.error}
                          helperText={meta.touched && meta.error ? meta.error : ""}
                          autoComplete="new-password"
                          onKeyDown={(e: any) => {
                            if (["e", "E", "+", "-", "."].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e: any) => {
                            let v = String(e?.target?.value ?? "");
                            v = v.replace(/\D/g, "");
                            if (v.length > 2) v = v.slice(0, 2);

                            if (v === "") {
                              form.setFieldError("employmentYear", "");
                              form.setFieldValue("employmentYear", ""); // Use setFieldValue for consistency
                              handleFilledFieldsCount("employmentYear", "");
                              return;
                            }

                            const n = parseInt(v, 10);
                            if (!Number.isNaN(n) && n > 60) {
                              const prev = !f.value ? "60" : String(f.value);
                              form.setFieldTouched("employmentYear", true, false);
                              form.setFieldError("employmentYear", "Year cannot be greater than 60");
                              form.setFieldValue("employmentYear", prev, false);
                              handleFilledFieldsCount("employmentYear", prev);
                              return;
                            }

                            if (meta.error === "Year cannot be greater than 60") {
                              form.setFieldError("employmentYear", "");
                            }

                            // NEW LOGIC: If years set to 60, force month to 0
                            if (n === 60) {
                              form.setFieldValue("employmentMonth", "0", false);
                              handleFilledFieldsCount("employmentMonth", "0");
                            }

                            form.setFieldValue("employmentYear", v, false);
                            handleFilledFieldsCount("employmentYear", v);
                          }}
                        />
                      )}
                    </Field>
                  </Grid>

                  {/* MONTH FIELD */}
                  <Grid item xs={12} sm={6}>
                    <Field name="employmentMonth">
                      {({ field: f, meta, form }: any) => (
                        <InputField
                          {...f}
                          fullWidth
                          type="text"
                          placeholder="Total Months"
                          variant="outlined"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          inputProps={{ min: 0, max: 12, maxLength: 2 }}
                          error={!!meta.touched && !!meta.error}
                          helperText={meta.touched && meta.error ? meta.error : ""}
                          autoComplete="new-password"
                          onKeyDown={(e: any) => {
                            if (["e", "E", "+", "-", "."].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e: any) => {
                            let v = String(e?.target?.value ?? "");
                            v = v.replace(/\D/g, "");
                            if (v.length > 2) v = v.slice(0, 2);

                            const currentYear = parseInt(form.values.employmentYear, 10);

                            if (v === "") {
                              form.setFieldError("employmentMonth", "");
                              form.setFieldValue("employmentMonth", "", false);
                              handleFilledFieldsCount("employmentMonth", "");
                              return;
                            }

                            const n = parseInt(v, 10);

                            // LOGIC: If years are 60, force month to 0 and show error if they try to change it
                            if (currentYear === 60 && n > 0) {
                              form.setFieldTouched("employmentMonth", true, false);
                              form.setFieldError("employmentMonth", "Month must be 0 if Year is 60");
                              form.setFieldValue("employmentMonth", "0", false);
                              return;
                            }

                            if (!Number.isNaN(n) && n > 12) {
                              const prev = !f.value ? "12" : String(f.value);
                              form.setFieldTouched("employmentMonth", true, false);
                              form.setFieldError("employmentMonth", "Month cannot be greater than 12");
                              form.setFieldValue("employmentMonth", prev, false);
                              return;
                            }

                            if (meta.error === "Month cannot be greater than 12" || meta.error === "Month must be 0 if Year is 60") {
                              form.setFieldError("employmentMonth", "");
                            }

                            form.setFieldValue("employmentMonth", v, false);
                            handleFilledFieldsCount("employmentMonth", v);
                          }}
                        />
                      )}
                    </Field>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );
        }
        if (field.name.match(/^employmentCoApplicant\d+employmentYear$/)) {
          const coApplicantPrefix = field.name.replace(/employmentYear$/, "");
          const coApplicantMonthFieldName = `${coApplicantPrefix}employmentMonth`;

          return (
            <Grid item xs={12} key={field.id} sx={{ mt: 1 }}>
              <Box sx={{ bgcolor: '#00B3B514', p: 2, borderRadius: 2 }}>
                <Box mb={1} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <img src={workExperienceIcon} alt="work-experience" />
                  <Typography style={{ color: '#4B465C', fontSize: '13px', fontWeight: 700 }}>
                    Help us with your work experience <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>

                <Grid container spacing={2}>
                  {/* YEAR FIELD */}
                  <Grid item xs={12} sm={6}>
                    <Field name={field.name}>
                      {({ field: f, meta, form }: any) => (
                        <InputField
                          {...f}
                          fullWidth
                          type="text"
                          placeholder="Total Years"
                          variant="outlined"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          inputProps={{ min: 0, max: 60, maxLength: 2 }}
                          error={!!meta.touched && !!meta.error}
                          helperText={meta.touched && meta.error ? meta.error : ""}
                          autoComplete="new-password"
                          onKeyDown={(e: any) => {
                            if (["e", "E", "+", "-", "."].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e: any) => {
                            let v = String(e?.target?.value ?? "");
                            v = v.replace(/\D/g, "");
                            if (v.length > 2) v = v.slice(0, 2);

                            if (v === "") {
                              form.setFieldError(field.name, "");
                              form.setFieldValue(field.name, "", false);
                              handleFilledFieldsCount(field.name, "");
                              return;
                            }

                            const n = parseInt(v, 10);
                            if (!Number.isNaN(n) && n > 60) {
                              const prev = !f.value ? "60" : String(f.value);
                              form.setFieldTouched(field.name, true, false);
                              form.setFieldError(field.name, "Year cannot be greater than 60");
                              form.setFieldValue(field.name, prev, false);
                              handleFilledFieldsCount(field.name, prev);
                              return;
                            }

                            if (meta.error === "Year cannot be greater than 60") {
                              form.setFieldError(field.name, "");
                            }

                            // NEW LOGIC: If years set to 60, force corresponding co-applicant month to 0
                            if (n === 60) {
                              form.setFieldValue(coApplicantMonthFieldName, "0", false);
                              handleFilledFieldsCount(coApplicantMonthFieldName, "0");
                            }

                            form.setFieldValue(field.name, v, false);
                            handleFilledFieldsCount(field.name, v);
                          }}
                        />
                      )}
                    </Field>
                  </Grid>

                  {/* MONTH FIELD */}
                  <Grid item xs={12} sm={6}>
                    <Field name={coApplicantMonthFieldName}>
                      {({ field: f, meta, form }: any) => {
                        const currentYear = parseInt(form.values[field.name.replace(/employmentMonth$/, "employmentYear")] ?? "", 10);
                        return (
                          <InputField
                            {...f}
                            fullWidth
                            type="text"
                            placeholder="Total Months"
                            variant="outlined"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            inputProps={{ min: 0, max: 12, maxLength: 2 }}
                            error={!!meta.touched && !!meta.error}
                            helperText={meta.touched && meta.error ? meta.error : ""}
                            autoComplete="new-password"
                            onKeyDown={(e: any) => {
                              if (["e", "E", "+", "-", "."].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e: any) => {
                              let v = String(e?.target?.value ?? "");
                              v = v.replace(/\D/g, "");
                              if (v.length > 2) v = v.slice(0, 2);

                              if (v === "") {
                                form.setFieldError(coApplicantMonthFieldName, "");
                                form.setFieldValue(coApplicantMonthFieldName, "", false);
                                handleFilledFieldsCount(coApplicantMonthFieldName, "");
                                return;
                              }

                              const n = parseInt(v, 10);

                              if (currentYear === 60 && n > 0) {
                                form.setFieldTouched(coApplicantMonthFieldName, true, false);
                                form.setFieldError(coApplicantMonthFieldName, "Month must be 0 if Year is 60");
                                form.setFieldValue(coApplicantMonthFieldName, "0", false);
                                return;
                              }

                              if (!Number.isNaN(n) && n > 12) {
                                const prev = !f.value ? "12" : String(f.value);
                                form.setFieldTouched(coApplicantMonthFieldName, true, false);
                                form.setFieldError(coApplicantMonthFieldName, "Month cannot be greater than 12");
                                form.setFieldValue(coApplicantMonthFieldName, prev, false);
                                return;
                              }

                              if (meta.error === "Month cannot be greater than 12" || meta.error === "Month must be 0 if Year is 60") {
                                form.setFieldError(coApplicantMonthFieldName, "");
                              }

                              form.setFieldValue(coApplicantMonthFieldName, v, false);
                              handleFilledFieldsCount(coApplicantMonthFieldName, v);
                            }}
                          />
                        );
                      }}
                    </Field>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );
        }
        // return null for employmentMonth so it doesn't render a second time
        if (field.name === "employmentMonth" || field.name.match(/^employmentCoApplicant\d+employmentMonth$/)) {
          return null;
        }
        // Handle main applicant First/Last Name only if value exists and as per bugs in sheet have not change anything in api
        if (
          field.name === "studentDetailsFirstName" ||
          field.name === "studentDetailsLastName" ||
          field.name === "firstName" ||
          field.name === "lastName"
        ) {
          let valueExists = false;
          let valueExistsone = false;
          if (field.name === "studentDetailsFirstName" || field.name === "studentDetailsLastName") {
            valueExists =
              formikRef.current?.values?.[field.name] ||
              formData?.[field.name];
          }
          if (field.name === "firstName" || field.name === "lastName") {
            valueExistsone =
              formikRef.current?.values?.[field.name] ||
              formData?.[field.name];
          }
          if (valueExists || valueExistsone) {
            return (
              <Grid item xs={12} sm={6} key={field.id}>
                <Box>
                  <label className="text-lable" style={{ display: "block" }}>
                    {field.label}{" "}
                    {field.required && <span style={{ color: "red" }}>*</span>}
                  </label>
                  <Field name={field.name}>
                    {({ field: f, meta }: any) => (
                      <InputField
                        {...f}
                        fullWidth
                        placeholder={field.placeholder || `Enter ${field.label}`}
                        variant="outlined"
                        inputmode="text"
                        disabled={isApiLoading || Boolean(valueExists) || (Boolean(valueExistsone) && isAuthenticated)}
                        error={!!meta.touched && !!meta.error}
                        helperText={meta.touched && meta.error ? meta.error : ""}
                        autoComplete="new-password"
                        inputProps={{ autoComplete: "new-password" }}
                        onInput={(e: any) => {
                          if (valueExists) return;
                          e.target.value = e.target.value;
                          handleFilledFieldsCount(field.name, e.target.value);

                          if (
                            activeHorizontalIndex === 1 &&
                            activeVerticalIndex === 5 &&
                            formikRef?.current?.values
                          ) {
                            dispatch(
                              updateFormData({
                                [field.name]: e.target.value,
                              })
                            );
                          }
                        }}
                        onBlur={(e: any) => {
                          let value = e.target.value || "";
                          value = value.trim().replace(/\s{2,}/g, " ");
                          e.target.value = value;

                          if (formikRef?.current) {
                            formikRef.current.setFieldValue(field.name, value, true);
                          }

                          handleFilledFieldsCount(field.name, value);

                          if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
                            dispatch(
                              updateFormData({
                                [field.name]: value,
                              })
                            );
                          }
                        }}
                      />
                    )}
                  </Field>
                </Box>
              </Grid>
            );
          }
        }
        // PAN field logic for co-applicants
        if (field.name.match(/^basicCoApplicant\d+PanNumber$/)) {
          const coApplicantPanMatch = field.name.match(
            /^basicCoApplicant(\d+)PanNumber$/
          );
          const idx = coApplicantPanMatch
            ? String(Number(coApplicantPanMatch[1]) - 1)
            : null;

          // Verified logic (check both Redux and Formik)
          let isPanVerified = false;
          let lastVerifiedPan = "";
          if (idx !== null) {
            const formikPanVerified =
              formikRef.current?.values[
              `basicCoApplicant${Number(idx) + 1}IsPanVerified`
              ];
            const reduxPanVerified = coApplicantVerification[idx]?.panVerified;
            const lastPan =
              coApplicantVerification[idx]?.lastPanNumber ||
              formikRef.current?.values[field.name];
            isPanVerified =
              (formikPanVerified || reduxPanVerified) &&
              formikRef.current?.values[field.name] === lastPan;
            lastVerifiedPan = lastPan;
          }

          // Duplicate PAN validation (include main applicant PAN)
          const allPanFields = Object.keys(
            formikRef.current?.values || {}
          ).filter((key) => key.match(/^basicCoApplicant\d+PanNumber$/));
          const currentPanValue = formikRef.current?.values[field.name];
          // Get main applicant PAN from Redux formData, formik, and panNumber
          let mainApplicantPan = formData?.pan;
          if (
            !mainApplicantPan ||
            mainApplicantPan === "" ||
            mainApplicantPan === "yes" ||
            mainApplicantPan === "no"
          ) {
            // fallback to Formik value if Redux is blank or not a PAN
            const formikPan = formikRef.current?.values?.pan;
            if (
              formikPan &&
              formikPan !== "" &&
              formikPan !== "yes" &&
              formikPan !== "no"
            ) {
              mainApplicantPan = formikPan;
            } else if (
              panNumber &&
              panNumber !== "" &&
              /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panNumber)
            ) {
              // fallback to panNumber from Redux if it's a valid PAN
              mainApplicantPan = panNumber;
            } else {
              mainApplicantPan = undefined;
            }
          }
          const duplicatePan =
            allPanFields
              .filter((key) => key !== field.name)
              .map((key) => formikRef.current?.values[key])
              .includes(currentPanValue) ||
            (mainApplicantPan &&
              currentPanValue &&
              mainApplicantPan?.toUpperCase() ===
              currentPanValue?.toUpperCase());
          return (
            <Grid
              item
              xs={12}
              sm={
                activeHorizontalIndex === 1 && activeVerticalIndex === 3
                  ? 4
                  : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                    ? 12
                    : 6
              }
              key={field.id}
            >
              <Box>
                <label className="text-lable" style={{ display: "block" }}>
                  {field.label}{" "}
                  {field.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <Field name={field.name}>
                  {({ field: f, meta, form }: any) => (
                    <InputField
                      {...f}
                      fullWidth
                      placeholder={field.placeholder || "Enter PAN Number"}
                      variant="outlined"
                      inputmode="text"
                      // disabled={isApiLoading || isPanVerified}
                      autoComplete="new-password"
                      onKeyDown={(e) => {
                        // Block leading space: allow spaces only after first character
                        if (e.key === " ") {
                          const target = e.target as HTMLInputElement;
                          const start = target.selectionStart ?? 0;
                          if (start === 0) {
                            e.preventDefault();
                          }
                        }
                      }}
                      error={
                        !!coApplicantPanVerifyError[field.name] ||
                        (!!meta.touched && !!meta.error) ||
                        (duplicatePan && !!currentPanValue)
                      }
                      helperText={
                        coApplicantPanVerifyError[field.name]
                          ? coApplicantPanVerifyError[field.name]
                          : meta.touched && meta.error
                            ? meta.error
                            : duplicatePan && !!currentPanValue
                              ? "This PAN is already used in another field."
                              : ""
                      }
                      onChange={(e) => {
                        let inputValue = e.target.value?.toUpperCase();
                        if (inputValue.length > 10) {
                          inputValue = inputValue.slice(0, 10);
                        }
                        form.setFieldValue(field.name, inputValue);
                        setCoApplicantPanVerifyError((prev) => ({
                          ...prev,
                          [field.name]: "",
                        }));
                        // Reset verification if value changes
                        if (inputValue !== lastVerifiedPan) {
                          if (idx !== null) {
                            dispatch(
                              setCoApplicantVerification({
                                index: idx,
                                data: {
                                  panVerified: false,
                                },
                              })
                            );
                          }
                        } else {
                          if (idx !== null) {
                            dispatch(
                              setCoApplicantVerification({
                                index: idx,
                                data: {
                                  panVerified: true,
                                },
                              })
                            );
                          }
                        }
                      }}
                      onInput={(e: any) => {
                        // Trim leading spaces from pasted/typed input but allow internal spaces
                        if (
                          typeof e.target.value === "string" &&
                          /^\s/.test(e.target.value)
                        ) {
                          e.target.value = e.target.value.replace(/^\s+/, "");
                        }
                        let panval = e.target.value?.toUpperCase();
                        handleFilledFieldsCount(field.name, panval);
                        if (
                          activeHorizontalIndex === 1 &&
                          activeVerticalIndex === 5
                        ) {
                          // Persist all form values to Redux for refresh survival
                          if (formikRef?.current?.values) {
                            // dispatch(
                            //   updateFormData({
                            //     ...formikRef.current.values,
                            //     [field.name]: e.target.value,
                            //   })
                            // );
                            dispatch(
                              updateFormData({
                                [field.name]: panval,
                              })
                            );
                          }
                        }
                      }}
                      inputProps={{
                        ...(coApplicantPanMatch ? { maxLength: 10 } : {}),
                      }}
                      InputProps={{
                        readOnly: isApiLoading || isPanVerified,
                        style: { textTransform: "uppercase" },
                        endAdornment: (
                          <Button
                            sx={{
                              backgroundColor: isPanVerified && !duplicatePan ? "transparent" : "#FEC10D",
                              color: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                              "&:hover": {
                                backgroundColor: isPanVerified && !duplicatePan ? "transparent" : "#FEC10D",
                                color: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                              },
                              "&.Mui-disabled": {
                                backgroundColor: isPanVerified && !duplicatePan ? "transparent" : "#FEC10D",
                                color: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                                WebkitTextFillColor: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                                opacity: 1
                              },
                              "& img": {
                                opacity: 1,
                                filter: "brightness(1)",
                              },
                              textTransform: "none",
                              fontSize: isPanVerified && !duplicatePan ? "16px" : "10px",
                              fontWeight: isPanVerified && !duplicatePan ? 400 : 700,
                              px: "15px",
                              borderRadius: "4px",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              boxShadow: "none",
                              height: '100%',
                              mr: 0.5,
                            }}
                            onClick={isApiLoading || isPanVerified ? undefined : async () => {
                              if (isPanVerified || duplicatePan) return;
                              setCoApplicantPanLoading((prev) => ({
                                ...prev,
                                [field.name]: true,
                              }));

                              try {
                                const panNumber = form.values[field.name];
                                const firstName =
                                  form.values[
                                  `basicCoApplicant${Number(idx) + 1
                                  }FirstName`
                                  ] || "";
                                const lastName =
                                  form.values[
                                  `basicCoApplicant${Number(idx) + 1}LastName`
                                  ] || "";
                                const name = `${firstName} ${lastName}`.trim();
                                const dob =
                                  form.values[
                                  `basicCoApplicant${Number(idx) + 1}dob`
                                  ] || "";
                                // Check one scenario at a time so only one message shows under the PAN field
                                const panVerifyError = !dob
                                  ? "Please enter your Date of Birth before verifying your PAN."
                                  : !String(panNumber || "").trim()
                                    ? "Please enter your PAN to proceed with verification."
                                    : !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(String(panNumber).trim().toUpperCase())
                                      ? "Please enter a valid 10-digit PAN number."
                                      : "";
                                setCoApplicantPanVerifyError((prev) => ({
                                  ...prev,
                                  [field.name]: panVerifyError,
                                }));
                                if (panVerifyError) return;
                                const piiPublicKey =
                                  await fetchSanitizedPiiPublicKey();
                                if (!piiPublicKey) return;

                                const payload = await encryptData(
                                  {
                                    panNumber,
                                    fullName: name.trim(),
                                    dob: dob
                                      ? new Date(dob).toLocaleDateString(
                                        "en-GB"
                                      )
                                      : "",
                                    trackingId: trackingId,
                                    applicantType: `Co-Applicant ${Number(idx) + 1}`,
                                  },
                                  ["panNumber"],
                                  piiPublicKey
                                );
                                const resp =
                                  await applicantDetailsServices.verifyPan(payload);
                                if (resp.status === 200) {

                                  trackCustomerJourneyEvent(
                                    `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                    decrypt(userProfile?.id) ?? "",
                                    trackingId,
                                    {
                                      label: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                      category: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                      action: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                      page: `ProvisionalOff_Loan Details_COAPP(${Number(idx) + 1}) PAN Verification`,
                                    }
                                  );


                                  // Check for invalid date of birth in PAN API response
                                  if (
                                    resp.data?.data?.dateOfBirth === "invalid" && dob // only if dob is provided
                                  ) {
                                    setCoApplicantPanVerifyError((prev) => ({
                                      ...prev,
                                      [field.name]: "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them.",
                                    }));
                                  } else {
                                    const isAadhaarSeeded =
                                      String(
                                        resp?.data?.data?.aadhaarSeedingStatus || ""
                                      ).toLowerCase() === "y";
                                    if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
                                      callSaveCoApplicantApi(formData, fields, String(Number(idx) + 1), trackingId, resp?.data?.data?.aadhaarSeedingStatus === "y" ? true : false, "PAN", {})
                                    }

                                    dispatch(
                                      setCoApplicantVerification({
                                        index: idx ?? "",
                                        data: {
                                          panVerified: true,
                                          lastPanNumber: panNumber,
                                          aadhaarSeedingStatus: isAadhaarSeeded,
                                        },
                                      })
                                    );
                                    formikRef.current?.setFieldValue(
                                      field.name,
                                      panNumber
                                    );
                                    formikRef.current?.setFieldValue(
                                      `basicCoApplicant${Number(idx) + 1}IsPanVerified`,
                                      true,
                                      false
                                    );
                                    dispatch(
                                      updateFormData({
                                        [`basicCoApplicant${Number(idx) + 1}IsPanVerified`]: true
                                      })
                                    );
                                    formikRef.current?.setFieldError(
                                      field.name,
                                      undefined
                                    );
                                    scheduleFormRevalidate();
                                    setSnackbar({
                                      open: true,
                                      message:
                                        "Yay! The co-applicant's PAN has been successfully verified.",
                                      severity: "success",
                                    });
                                  }
                                } else if (resp.status === 400) {
                                  setSnackbar({
                                    open: true,
                                    message:
                                      "Uh-oh! We are experiencing some technical issues fetching the co-applicant’s PAN details. Please try again later.",
                                    severity: "error",
                                  });
                                } else {
                                  setCoApplicantPanVerifyError((prev) => ({
                                    ...prev,
                                    [field.name]: "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them.",
                                  }));
                                }
                              } catch (err: any) {
                                setSnackbar({
                                  open: true,
                                  message: "Uh-oh! PAN verification failed. Please check the details and try again.",
                                  severity: "error",
                                });
                              } finally {
                                setCoApplicantPanLoading((prev) => ({
                                  ...prev,
                                  [field.name]: false,
                                }));
                              }
                            }}
                            disabled={
                              isPanVerified ||
                              duplicatePan ||
                              coApplicantPanLoading[field.name]
                            }
                          >
                            {coApplicantPanLoading[field.name] ? (
                              <CircularProgress size={16} color="inherit" />
                            ) : (
                              <>
                                {isPanVerified && !duplicatePan ? (
                                  <>
                                    <img
                                      src={greenCheckVerified}
                                      alt="Verified"
                                      style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                    <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                                  </>
                                ) : (
                                  <>
                                    <Typography variant="inherit">Verify</Typography>
                                    <img
                                      src={arrowRightVerify}
                                      alt="Verified"
                                      style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </Button>
                        ),
                      }}
                    />
                  )}
                </Field>
              </Box>
            </Grid>
          );
        }
        // Name fields: block numbers for First Name, Last Name, Co-applicant First/Last Name
        const isReferenceNameField = /^basicReference\d+(FirstName|LastName)$/.test(field.name);
        // FD Holder Name ("...FdHolderName") and Savings Holder Name ("...HolderName") —
        // both end in "HolderName", so this single regex covers both.
        const isCollateralHolderNameField = /^collateral\d*(Fd)?HolderName$/i.test(field.name);
        const isNameField =
          field.name === "firstName" ||
          field.name === "lastName" ||
          field.name === "fatherFirstName" ||
          field.name === "fatherLastName" ||
          field.name === "motherFirstName" ||
          field.name === "motherLastName" ||
          /^basicCoApplicant\d+FirstName$/.test(field.name) ||
          /^basicCoApplicant\d+LastName$/.test(field.name) ||
          /^(basicCoApplicant|coApplicant)\d+OtherRelationWithStudent$/.test(field.name) ||
          isReferenceNameField ||
          isCollateralHolderNameField;
        const isTwentySixCharNameField =
          field.name === "firstName" ||
          field.name === "lastName" ||
          field.name === "fatherFirstName" ||
          field.name === "fatherLastName" ||
          field.name === "motherFirstName" ||
          field.name === "motherLastName" ||
          /^basicCoApplicant\d+FirstName$/.test(field.name) ||
          /^basicCoApplicant\d+LastName$/.test(field.name);

        if (isNameField) {
          return (
            <Grid
              item
              xs={12}
              sm={
                activeHorizontalIndex === 1 && activeVerticalIndex === 3
                  ? 4
                  : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                    ? 12
                    : activeHorizontalIndex === 3 && activeVerticalIndex === 1
                      ? 12
                      : 6
              }
              key={field.id}
            >
              <Box>
                <label className="text-lable" style={{ display: "block" }}>
                  {field.label}{" "}
                  {field.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <Field name={field.name}>
                  {({ field: f, meta }: any) => (
                    <InputField
                      {...f}
                      fullWidth
                      placeholder={field.placeholder || `Enter ${field.label}`}
                      variant="outlined"
                      inputmode="text"
                      disabled={
                        isApiLoading ||
                        isCoApplicantFieldLockedByCoOwner(fetchedApplicationVals, field.name)
                      }
                      //disabled={isApiLoading || Boolean(field?.disabled)}
                      error={!!meta.touched && !!meta.error}
                      helperText={meta.touched && meta.error ? meta.error : ""}
                      autoComplete="new-password"
                      inputProps={{
                        maxLength: isReferenceNameField
                          ? 25
                          : isCollateralHolderNameField
                            ? 50
                            : /^(basicCoApplicant|coApplicant)\d+OtherRelationWithStudent$/.test(field.name)
                              ? 50
                              : isTwentySixCharNameField
                                ? 26
                                : undefined,
                      }}
                      onCopy={isReferenceNameField ? (e) => e.preventDefault() : undefined}
                      onPaste={isReferenceNameField ? (e) => e.preventDefault() : undefined}
                      onKeyDown={(e) => {
                        // Block leading space: allow spaces only after first character
                        if (e.key === " ") {
                          const target = e.target as HTMLInputElement;
                          const start = target.selectionStart ?? 0;
                          if (start === 0) {
                            e.preventDefault();
                          }
                        }
                      }}
                      onInput={(e: any) => {
                        // Trim leading spaces from pasted/typed input but allow internal spaces
                        if (
                          typeof e.target.value === "string" &&
                          /^\s/.test(e.target.value)
                        ) {
                          e.target.value = e.target.value.replace(/^\s+/, "");
                        }
                        // Only allow alphabets and spaces
                        e.target.value = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          ""
                        );
                        if (isReferenceNameField || isCollateralHolderNameField) {
                          // Auto Title Case as the user types
                          e.target.value = e.target.value.replace(
                            /\w\S*/g,
                            (word: string) =>
                              word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                          );
                        }
                        if (
                          field.name === "fatherFirstName" ||
                          field.name === "motherFirstName" ||
                          field.name === "fatherLastName" ||
                          field.name === "motherLastName"
                        ) {
                          dispatch(
                            setVerificationMessage({
                              index: "",
                              applicantType: "",
                              field: "",
                              status: "",
                              message: "",
                            })
                          );
                        }
                        handleFilledFieldsCount(field.name, e.target.value);
                        if (
                          activeHorizontalIndex === 1 &&
                          activeVerticalIndex === 5
                        ) {
                          if (formikRef?.current?.values) {
                            dispatch(
                              updateFormData({
                                [field.name]: e.target.value,
                              })
                            );
                          }
                        }
                      }}
                      onBlur={(e: any) => {
                        let value = e.target.value || "";
                        value = value.trim().replace(/\s{2,}/g, " ");
                        e.target.value = value;

                        if (formikRef?.current) {
                          formikRef.current.setFieldValue(field.name, value, true);
                        }

                        handleFilledFieldsCount(field.name, value);

                        if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
                          dispatch(
                            updateFormData({
                              [field.name]: value,
                            })
                          );
                        }
                      }}
                    />
                  )}
                </Field>
              </Box>
            </Grid>
          );
        }

        // logic for comma separated values
        const isCurrencyFieldName = (fieldName: string): boolean => {
          const keywords = [
            "amount",
            "price",
            "fees",
            "cost",
            "loan",
            "charge",
            "balance",
            "total",
            "expense",
            "expenses",
            "obligation",
            "income",
            "fund",
          ];
          return keywords.some((keyword) =>
            fieldName.toLowerCase().includes(keyword)
          );
        };
        // Collateral Value (e.g. fdCollateralValue/savingCollateralValue/collateral{n}Value)
        // isn't caught by isCurrencyFieldName's keyword list, but still needs Indian comma formatting.
        const isCollateralValueField = /^collateral\d*value$/i.test(field.name);
        // Fund/Expense fields (Course Duration Funds): explicit match since a
        // couple of names (expenseVasExpense, fundOwnSources) don't contain any
        // of isCurrencyFieldName's generic keywords.
        const isFundExpenseCurrencyField = FUND_EXPENSE_CURRENCY_FIELDS.includes(field.name);
        const isFundExpenseConditionalField =
          field.name === FUND_EXPENSE_LOAN_AMOUNT_FIELD ||
          FUND_EXPENSE_CONDITIONAL_FIELDS.includes(field.name);
        const isFundExpenseRequiredNow =
          isFundExpenseConditionalField &&
          isAdmissionStatusConfirmed(formikRef?.current?.values || {});
        if (isCurrencyFieldName(field.name) || isCollateralValueField || isFundExpenseCurrencyField) {
          const formatNumberIndian = (value: string | number) => {
            if (value) {
              const num = Number(value?.toString().replace(/,/g, ""));
              if (isNaN(num)) return value?.toString();

              return new Intl.NumberFormat("en-IN", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              }).format(num);
            }
          };

          const unformatNumber = (formattedValue: string): string => {
            // Allows decimal points but removes all commas
            return formattedValue.replace(/,/g, "");
          };

          const fieldLabel = field.label || field.name;

          return (
            <Grid
              item
              xs={12}
              sm={
                activeHorizontalIndex === 0 && activeVerticalIndex === 2
                  ? 6
                  : activeHorizontalIndex === 1 && activeVerticalIndex === 2
                    ? 6
                    : activeHorizontalIndex === 3 && activeVerticalIndex === 0
                    ? 6
                    : 12
              }
              sx={{ mt: (activeHorizontalIndex === 1 && activeVerticalIndex === 4) && !isXsOrSm ? '2px' : '0px' }}
              key={field.id}
            >
              <Box>
                {/* Label (Standard Form Label) */}
                <label className="text-lable" style={{ display: "block" }}>
                  {fieldLabel}{" "}
                  {(field.required || isFundExpenseRequiredNow) && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                  {field.labelHint && (
                    <span style={{ color: "#6b7280", fontSize: "12px" }}> {field.labelHint}</span>
                  )}
                </label>

                {/* Input Field with Currency Formatting Logic */}
                <Field name={field.name}>
                  {({ field: f, meta }: any) => (
                    <InputField
                      {...f}
                      type="text" // Set the input type to 'text' to allow comma characters to be displayed
                      inputmode="numeric"
                      pattern="[0-9]*"
                      // disabled={isApiLoading}
                      autoComplete="new-password"
                      // Ensure cleared values render as empty string for currency fields
                      value={formatNumberIndian(f.value) ?? ""}
                      onKeyDown={(e) => {
                        // Block leading space: allow spaces only after first character
                        if (e.key === " ") {
                          const target = e.target as HTMLInputElement;
                          const start = target.selectionStart ?? 0;
                          if (start === 0) {
                            e.preventDefault();
                          }
                        }
                      }}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\D/g, "");
                        let displayValue = e.target.value;
                        let storeValue = unformatNumber(displayValue);

                        // only allow numbers (and single decimal point)
                        if (
                          storeValue === "" ||
                          /^\d*(\.\d*)?$/.test(storeValue)
                        ) {
                          // Enforce max 15 digits before decimal
                          const [intPart, decPart] = storeValue.split(".");
                          let limitedInt = f?.name === "employmentMonthlyObligation" ? intPart.slice(0, 14) : intPart.slice(0, 15);
                          let limitedValue =
                            decPart !== undefined
                              ? `${limitedInt}.${decPart}`
                              : limitedInt;
                          f.onChange({
                            target: {
                              name: f.name,
                              value: limitedValue,
                            },
                          } as React.ChangeEvent<HTMLInputElement>);
                          handleFilledFieldsCount(field.name, limitedValue);
                        }
                      }}
                      fullWidth
                      placeholder={`Enter ${fieldLabel}`}
                      variant="outlined"
                      error={!!meta.touched && !!meta.error}
                      helperText={meta.touched && meta.error}
                      InputProps={{
                        maxLength: isFundExpenseCurrencyField ? 255 : 18, // allow for commas and decimal
                      }}
                      disabled={
                        isApiLoading ||
                        field.name.startsWith("coreTotalMarks") ||
                        field.name.startsWith("languageTotalMarks") ||
                        Boolean(field?.disabled)
                      }
                    />
                  )}
                </Field>
              </Box>
            </Grid>
          );
        }

        let isEmployeeRequiredField = field.name === "employmentCompanyName"
          || field.name === "employmentCompanyAddress1"
          || field.name === "employmentCompanyAddress2"
          || field.name === "employmentCompanyAddress3"
          || field.name === "employmentLandmark"
          || field.name === "employmentCompanyPincode"
          || field.name === "employmentCompanyCity"
          || field.name === "employmentCompanyState"
          || field.name === "employmentCompanyCountry";

        return (
          <Grid
            item
            xs={12}
            sm={
              (activeHorizontalIndex === 1 && activeVerticalIndex === 5) ||
                (activeHorizontalIndex === 1 && activeVerticalIndex === 4) ||
                (activeHorizontalIndex === 1 && activeVerticalIndex === 3) ||
                (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
                ? 12
                : 6
            }
            sx={{ mt: (activeHorizontalIndex === 1 && activeVerticalIndex === 4) && !isXsOrSm ? '2px' : '0px' }}
            key={field.id}
          >
            <Box>
              <label className="text-lable" style={{ display: "block" }}>
                {field.label}{" "}
                {(field.required || isEmployeeRequiredField) && (
                  <span style={{ color: "red" }}>*</span>
                )}
                {field.labelHint && (
                  <span style={{ color: "#6b7280", fontSize: "12px" }}> {field.labelHint}</span>
                )}
              </label>
              <Field name={field.name}>
                {({ field: f, meta }: any) => (
                  <InputField
                    {...f}
                    fullWidth
                    type={
                      field?.name.match(/^course\d+Percentage$/) ||
                        field?.name.match(/^coreExamScore(_\d+)?$/) ||
                        field?.name.match(/^languageExamScore(_\d+)?$/)
                        ? "text"
                        : field.type
                    }
                    inputmode="numeric"
                    pattern="[0-9]*"
                    disabled={isApiLoading || handleDisablePermanentPincodeBasedFields(field) || Boolean(field?.disabled)}
                    autoComplete="new-password"
                    inputProps={{
                      min: 0,
                      maxLength: /^addressReference\d+(AddressLine1|AddressLine2|Locality|Landmark|Area)$/.test(field.name)
                        ? 50
                        : /^collateral\d*(AddressLine1|AddressLine2|Landmark)$/i.test(field.name)
                          ? 50
                          : /^collateral\d*Area$/i.test(field.name)
                            ? 255
                            : undefined,
                    }}
                    onWheel={(e: any) => {
                      // Prevent mouse wheel from changing number input values
                      if (field.type === "number") {
                        e.target.blur();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (
                        field.type === "number" &&
                        ["e", "E", "+", "-"].includes(e.key)
                      ) {
                        e.preventDefault(); // Block scientific notation and sign keys
                      }
                      // Disallow leading space: only allow space after first character
                      if (e.key === " ") {
                        const target = e.target as HTMLInputElement;
                        if (
                          !target.value ||
                          (target.selectionStart === 0 &&
                            target.selectionEnd === 0)
                        ) {
                          e.preventDefault();
                        }
                      }
                    }}
                    placeholder={
                      field.name.includes('YearsInCurrentAddress')
                        ? "How long have you been living here (in years)"
                        : field.name.includes('YearsInCurrentCity')
                          ? "How long have you lived in this city (in years)"
                          : field.name === 'pincode'
                            ? 'Enter Area Pincode'
                            : field.placeholder || `Enter ${field.label}`
                    }
                    variant="outlined"
                    error={!!meta.touched && !!meta.error}
                    helperText={
                      (field.name === "permanentPincode" ||
                        field.name === "employmentCompanyPincode" ||
                        /^addressCoApplicant\d+permanentPincode$/.test(
                          field.name
                        ) ||
                        /^addressCoApplicant\d+currentPincode$/.test(
                          field.name
                        ) ||
                        /^collateral\d*.*pincode$/i.test(field.name)
                        ) &&
                        zipCodeLoading
                        ? "Validating pincode..."
                        : meta.touched && meta.error
                    }
                    onInput={(e: any) => {
                      if (field?.disabled) return;
                      if (field.name === "totalCost") {
                        // Use setTimeout to ensure Formik has the latest value of totalCost before validating the dependent field
                        setTimeout(() => {
                          formikRef.current?.validateField("loanAmount");
                        }, 0);
                      }

                      // Trim leading spaces from pasted/typed input but allow internal spaces
                      if (
                        typeof e.target.value === "string" &&
                        /^\s/.test(e.target.value)
                      ) {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                      }

                      // Reference address lines: strip characters outside the allowed whitelist
                      if (/^addressReference\d+(AddressLine1|AddressLine2|Locality|Landmark|Area)$/.test(field.name)) {
                        e.target.value = e.target.value.replace(/[^a-zA-Z0-9.><,\/!@#$%&()\[\]{} -]/g, "");
                      }

                      // Collateral (property mode) address lines: same whitelist filter
                      if (/^collateral\d*(AddressLine1|AddressLine2|Landmark|Area)$/i.test(field.name)) {
                        e.target.value = e.target.value.replace(/[^a-zA-Z0-9.><,\/!@#$%&()\[\]{} -]/g, "");
                      }

                      // FD Number: integers only
                      if (/^collateral\d*FdNumber$/i.test(field.name)) {
                        e.target.value = e.target.value.replace(/\D/g, "");
                      }

                      // No of Units: standard numbers only
                      if (/^collateral\d*NoOfUnits$/i.test(field.name)) {
                        e.target.value = e.target.value.replace(/\D/g, "");
                      }

                      // Account Number: strip commas/formatting characters, digits only
                      if (/^collateral\d*AccountNumber$/i.test(field.name)) {
                        e.target.value = e.target.value.replace(/\D/g, "");
                      }

                      if (field.type === "number") {
                        const sanitized = e.target.value.replace(
                          /[eE+\-]/g,
                          ""
                        );
                        if (sanitized !== e.target.value) {
                          e.target.value = sanitized; // Strip unsupported characters from pasted input
                        }
                      }
                      // Only enforce 6-digit numeric for fields containing 'pincode'
                      if (field.name.toLowerCase().includes("pincode")) {
                        e.target.value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 6);
                      }

                      // Restrict employmentMonth to numeric input only and max 2 digits
                      if (
                        field.name.toLowerCase().includes("employmentmonth")
                      ) {
                        let monthValue = e.target.value.replace(/\D/g, "");
                        // Limit to 2 digits
                        e.target.value = monthValue.slice(0, 2);
                      }

                      let value = e.target.value;

                      if (
                        field.name.match(/^course\d+Percentage$/) ||
                        field.name.match(/^coreExamScore(_\d+)?$/) ||
                        field?.name.match(/^languageExamScore(_\d+)?$/)
                      ) {
                        let v = e.target.value;
                        v = v.replace(/^0/, "");
                        // remove + - e E
                        v = v.replace(/[eE+\-]/g, "");
                        v = v.replace(/[^0-9.]/g, "");
                        // remove commas
                        v = v.replace(/,/g, "");

                        // split by dot
                        const parts = v.split(".");

                        if (parts.length === 1) {
                          // only integers, no dot
                          v = parts[0];
                        } else if (parts.length === 2) {
                          const [i, d] = parts;

                          // ✔ allow trailing dot (like "99.")
                          if (d === "") {
                            v = i + ".";
                          } else {
                            // ✔ allow max 2 decimals
                            v = i + "." + d.slice(0, 2);
                          }
                        } else {
                          // more than one dot → keep only first two parts
                          v = parts[0] + "." + parts[1].slice(0, 2);
                        }

                        e.target.value = v;
                      }

                      // If user tries to enter more than 6 digits, do not call any API handlers
                      if (field.name.toLowerCase().includes("pincode")) {
                        if (value.length > 6) {
                          return;
                        }
                      }

                      // For main applicant permanent pincode
                      if (field.name === "permanentPincode") {
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, undefined, "permanent");
                        }
                      }
                      // For main applicant current pincode
                      else if (field.name === "currentPincode") {
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, undefined, "current");
                        }
                        // Do not update permanentPincode when currentPincode changes
                      }
                      // For co-applicant permanent pincode
                      else if (
                        /^addressCoApplicant\d+permanentPincode$/.test(
                          field.name
                        )
                      ) {
                        const match = field.name.match(
                          /^addressCoApplicant(\d+)permanentPincode$/
                        );
                        const coAppNum = match ? match[1] : undefined;
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, coAppNum, "permanent");
                        }
                      }
                      // For co-applicant current pincode
                      else if (
                        /^addressCoApplicant\d+currentPincode$/.test(field.name)
                      ) {
                        const match = field.name.match(
                          /^addressCoApplicant(\d+)currentPincode$/
                        );
                        const coAppNum = match ? match[1] : undefined;
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, coAppNum, "current");
                        }
                      }
                      // For co-applicant employment/company pincode
                      else if (
                        /^employmentCoApplicant\d+pincode$/.test(field.name)
                      ) {
                        const match = field.name.match(
                          /^employmentCoApplicant(\d+)pincode$/
                        );
                        const coAppNum = match ? match[1] : undefined;
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, coAppNum, "company");
                        }
                        
                      }
                      // For reference address pincodes
                      else if (/^addressReference1Pincode$/.test(field.name)) {
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, undefined, "reference1");
                        }
                      }
                      // For collateral property pincodes
                      else if (
                        /^collateral/i.test(field.name) &&
                        /pincode/i.test(field.name) &&
                        !/^coOwnerCollateral/i.test(field.name)
                      ) {
                        const normalized = String(field.name || "")
                          .toLowerCase()
                          .replace(/[^a-z0-9]/g, "");
                        const match = normalized.match(/^collateral(\d+)/);
                        const collateralNum = match?.[1] || "1";
                        if (value && value.length === 6) {
                          handleInvokZipCode(
                            value,
                            undefined,
                            `collateral${collateralNum}`,
                          );
                        }
                      } else if (/^addressReference2Pincode$/.test(field.name)) {
                        if (value && value.length === 6) {
                          handleInvokZipCode(value, undefined, "reference2");
                        }
                      }
                      if (field.name === "employmentCompanyPincode") {
                        handleInvokCompanyZipCode(value);
                      }
                      handleFilledFieldsCount(field.name, value);

                      // Check and uncheck address checkbox if address fields change
                      if (
                        /^(permanent|current)(AddressLine1|AddressLine2|AddressLine3|Pincode|City|State|Country|OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity)$/.test(field.name) ||
                        /^addressCoApplicant\d+(permanent|current)(AddressLine1|AddressLine2|AddressLine3|Pincode|City|State|Country|OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity)$/.test(field.name)
                      ) {
                        // Use setTimeout to ensure the value is set in formik before checking
                        setTimeout(() => {
                          checkAndUncheckAddressCheckbox();
                        }, 0);
                      }

                      if (
                        activeHorizontalIndex === 1 &&
                        activeVerticalIndex === 5
                      ) {
                        // Persist all form values to Redux for refresh survival
                        if (formikRef?.current?.values) {
                          dispatch(
                            updateFormData({
                              [field.name]: value,
                            })
                          );
                        }
                      }
                      // setting empty data on input changes
                      if (field.name === "fatherFirstName" || field.name === "motherFirstName" || field.name === "fatherLastName" || field.name === "motherLastName") {
                        dispatch(
                          setVerificationMessage({
                            index: "",
                            applicantType: "",
                            field: "",
                            status: "",
                            message: "",
                          })
                        );
                      }
                    }}
                    InputProps={{
                      endAdornment:
                        (field.name === "permanentPincode" ||
                          field.name === "employmentCompanyPincode" ||
                          /^addressCoApplicant\d+permanentPincode$/.test(
                            field.name
                          ) ||
                          /^addressCoApplicant\d+currentPincode$/.test(
                            field.name
                          ) ||
                          /^collateral\d*.*pincode$/i.test(field.name)
                          ) &&
                          zipCodeLoading ? (
                          <CircularProgress size={20} />
                        ) : undefined,
                    }}
                  />
                )}
              </Field>
            </Box>
          </Grid>
        );
      case "phone":
        const isReferencePhoneField = /^(refBasic\d+|basicReference\d+)(Mobile|PhoneNumber)$/i.test(
          field.name,
        );
        // Reject fraud-pattern numbers (all-repeated-digit) and require first digit 6-9.
        const REFERENCE_MOBILE_FRAUD_REGEX = /^(?!.*^(.)\1+$)[6-9]\d{9}$/;
        const referenceMobileValueForCheck = String(
          formikRef.current?.values[field.name] || "",
        );
        const isReferenceMobileInvalid =
          isReferencePhoneField &&
          referenceMobileValueForCheck.length === 10 &&
          !REFERENCE_MOBILE_FRAUD_REGEX.test(referenceMobileValueForCheck);
        const isCollateralPhoneField = /^(coOwnerCollateral[\d_]*PhoneNumber|collateral\d*PhoneNumber)$/i.test(
          field.name,
        );
        // Co-applicant phone field check
        const coApplicantPhoneMatch = field.name.match(
          /^basicCoApplicant(\d+)PhoneNumber$/
        );
        const adCoApplicantPhoneMatch = field.name.match(
          /^adBasicCoApplicant(\d+)PhoneNumber$/
        );
        let isMobileVerifiedField = false;
        let lastVerifiedMobile = "";
        if (coApplicantPhoneMatch) {
          const idx = String(Number(coApplicantPhoneMatch[1]) - 1); // 0-based index
          const formikMobileVerified =
            formikRef.current?.values[
            `basicCoApplicant${Number(idx) + 1}IsMobileVerified`
            ];
          const reduxMobileVerified =
            coApplicantVerification[idx]?.mobileVerified;
          const lastMobile =
            coApplicantVerification[idx]?.lastVerifiedMobileNumber ||
            formikRef.current?.values[field.name];
          isMobileVerifiedField =
            (formikMobileVerified || reduxMobileVerified) &&
            formikRef.current?.values[field.name] === lastMobile;
          lastVerifiedMobile = lastMobile;
        } else {
          isMobileVerifiedField =
            isMobileVerified &&
            formikRef.current?.values[field.name] === lastVerifiedPhoneNumber;
          lastVerifiedMobile = lastVerifiedPhoneNumber;
        }

        // Get all phone field names
        const allPhoneFields = Object.keys(
          formikRef.current?.values || {}
        ).filter(
          (key) =>
            key === "phone_number" ||
            key.match(/^basicCoApplicant\d+PhoneNumber$/)
        );
        // Check for duplicate phone
        const currentPhoneValue = formikRef.current?.values[field.name];
        // Allow main applicant and student details to match
        const allowedPhonePairs = [
          ["phone_number", "studentDetailsPhone_number"],
          ["studentDetailsPhone_number", "phone_number"],
        ];
        const duplicatePhone = allPhoneFields
          // 1. Don't compare a field with itself
          .filter((key) => key !== field.name) 
          // 2. Filter out allowed skips and exceptions
          .filter((key) => {
            // Check if either the current field OR the comparison field belongs to Collateral
            // (co-owner or base collateral phone fields)
            const isComparisonFieldCollateral = /^(coOwnerCollateral[\d_]*PhoneNumber|collateral\d*PhoneNumber)$/i.test(key);

            // ✅ RULE 1: If either field belongs to Collateral, skip the duplicate check entirely
            if (isCollateralPhoneField || isComparisonFieldCollateral) {
              return false;
            }

            // RULE 2: "phone_number" and "studentDetailsPhone_number" are allowed to match each other
            const isMainAndStudentMatch = 
              (field.name === "phone_number" && key === "studentDetailsPhone_number") ||
              (field.name === "studentDetailsPhone_number" && key === "phone_number");

            if (isMainAndStudentMatch) {
              return false; 
            }

            return true; // Run the duplicate check for any remaining fields (e.g., basicCoApplicants)
          })
          // 3. Extract values and check if the current value matches any remaining field value
          .map((key) => formikRef.current?.values[key])
          .includes(currentPhoneValue);

        return (
          <Grid
            item
            xs={12}
            sm={
              activeHorizontalIndex === 1 && activeVerticalIndex === 3
                ? 4
                : activeHorizontalIndex === 1 && activeVerticalIndex === 5 ||
                 (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
                  ? 12
                  : 6
            }
            key={field.id}
          >
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <label className="text-lable" style={{ display: "block" }}>
                  {field.label}{" "}
                  {field.required && <span style={{ color: "red" }}>*</span>}
                </label>
              </Box>
              <Field name={field.name}>
                {({ field: f, meta, form }: any) => (
                  <InputField
                    {...f}
                    fullWidth
                    // type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder={
                      isReferencePhoneField
                        ? "Enter Mobile Number"
                        : isCollateralPhoneField
                          ? "Enter Phone Number"
                        : field.placeholder ||
                          (isXsOrSm
                            ? "Enter Aadhaar Linked Mobile Number..."
                            : "Enter Aadhaar Linked Mobile Number and Verify")
                    }
                    variant="outlined"
                    error={
                      (!!meta.touched && !!meta.error) ||
                      (duplicatePhone && !!currentPhoneValue) ||
                      isReferenceMobileInvalid
                    }
                    helperText={
                      meta.touched && meta.error
                        ? meta.error
                        : 
                        duplicatePhone && !!currentPhoneValue
                          ? isReferencePhoneField
                            ? "This mobile number has already been used in this application. Please enter a different mobile number for this reference."
                            : "This mobile number is already used in another field."
                          :
                          isReferenceMobileInvalid
                            ? "Enter a valid 10-digit mobile number."
                            : ""
                    }
                    autoComplete="new-password"
                    // Co-owner phone is auto-filled from the selected co-owner name.
                    disabled={/^coOwnerCollateral[\d_]*PhoneNumber$/i.test(field.name) ||
                      isCoApplicantFieldLockedByCoOwner(fetchedApplicationVals, field.name) ||
                       (!!coApplicantPhoneMatch && isMobileVerifiedField)
                    }
                    // disabled={
                    //   isApiLoading ||
                    //   (isAuthenticated &&
                    //     ((activeHorizontalIndex === 1 &&
                    //       activeVerticalIndex === 0) ||
                    //       (activeHorizontalIndex === 0 &&
                    //         activeVerticalIndex === 0 &&
                    //         !!f.value &&
                    //         (formData?.isMobileVerified ||
                    //           formikRef?.current?.values?.isMobileVerified))))
                    // }
                    onKeyDown={(e) => {
                      // Block leading space: allow spaces only after first character
                      if (e.key === " ") {
                        const target = e.target as HTMLInputElement;
                        const start = target.selectionStart ?? 0;
                        if (start === 0) {
                          e.preventDefault();
                        }
                      }
                    }}
                    onChange={(e) => {
                      f.onChange(e);

                      const rawValue = e.target.value;
                      const numericValue = rawValue.replace(/\D/g, "");

                      const isValidMobile = numericValue.length === 10;

                      // Always reset verification if not a valid 10-digit number
                      if (
                        !isValidMobile ||
                        numericValue !== lastVerifiedMobile
                      ) {
                        if (coApplicantPhoneMatch) {
                          const idx = String(
                            Number(coApplicantPhoneMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: { mobileVerified: false },
                            })
                          );
                        } else {
                          dispatch(setIsMobileVerified(false));
                        }
                      }

                      // Only set verified = true when it exactly matches last verified number
                      if (
                        isValidMobile &&
                        numericValue === lastVerifiedMobile
                      ) {
                        if (coApplicantPhoneMatch) {
                          const idx = String(
                            Number(coApplicantPhoneMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: { mobileVerified: true },
                            })
                          );
                        } else {
                          dispatch(setIsMobileVerified(true));
                        }
                      }
                    }}
                    onInput={(e: any) => {
                      // Trim leading spaces from pasted/typed input but allow internal spaces
                      if (
                        typeof e.target.value === "string" &&
                        /^\s/.test(e.target.value)
                      ) {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                      }
                      e.target.value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);
                      handleFilledFieldsCount(field.name, e.target.value);
                      if (
                        activeHorizontalIndex === 1 &&
                        activeVerticalIndex === 5
                      ) {
                        // Persist all form values to Redux for refresh survival
                        if (formikRef?.current?.values) {
                          // dispatch(
                          //   updateFormData({
                          //     ...formikRef.current.values,
                          //     [field.name]: e.target.value,
                          //   })
                          // );
                          dispatch(
                            updateFormData({
                              [field.name]: e.target.value,
                            })
                          );
                        }
                      }
                    }}
                    inputProps={{ maxLength: 10 }}
                    InputProps={{
                      readOnly: isApiLoading || (
                        isAuthenticated && (
                          (activeHorizontalIndex === 1 && activeVerticalIndex === 0) ||
                          (activeHorizontalIndex === 0 && activeVerticalIndex === 0 && !!f.value && (formData?.isMobileVerified || formikRef?.current?.values?.isMobileVerified)
                          )
                        )
                      ),
                      autoComplete: "off",
                      endAdornment:
                        coApplicantPhoneMatch ||
                        adCoApplicantPhoneMatch ||
                        isReferencePhoneField ||
                        isCollateralPhoneField
                          ? undefined
                          : (
                        <Button
                          onClick={isApiLoading || (
                            isAuthenticated && (
                              (activeHorizontalIndex === 1 && activeVerticalIndex === 0 && ((formData?.isMobileVerified === "true" || formData?.isMobileVerified === true) || (formikRef?.current?.values?.isMobileVerified === "true" || formikRef?.current?.values?.isMobileVerified === true))) ||
                              (activeHorizontalIndex === 0 && activeVerticalIndex === 0 && !!f.value && ((formData?.isMobileVerified === "true" || formData?.isMobileVerified === true) || (formikRef?.current?.values?.isMobileVerified === "true" || formikRef?.current?.values?.isMobileVerified === true))
                              )
                            )
                          ) ? undefined : async () => {
                            if (
                              isMobileVerifiedField ||
                              duplicatePhone ||
                              !currentPhoneValue
                            )
                              return;
                            try {
                              let name = `${form?.values?.studentDetailsFirstName || form?.values?.firstName || ""} ${form?.values?.studentDetailsLastName || form?.values?.lastName || ""}`.trim();
                              // applicant name
                              const mobileNumber = form.values[field.name];
                              setOtpMobileNumber(mobileNumber);
                              setOtpMobileFieldName(field.name);

                              const coApplicantPhoneMatch = field.name.match(
                                /^basicCoApplicant(\d+)PhoneNumber$/
                              );
                              if (coApplicantPhoneMatch) {
                                dispatch(
                                  setCurrentCoApplicantIdx(
                                    String(Number(coApplicantPhoneMatch[1]) - 1)
                                  )
                                );

                                // this will only work for coapplicant
                                const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantPhoneMatch[1]))}FirstName`;
                                if (form.values[dynamicNameKey]) {
                                  name = form.values[dynamicNameKey];   // co-applicant name
                                }
                              } else {
                                dispatch(setCurrentCoApplicantIdx(null));
                              }

                              const resp =
                                await eligibilityCheckServices.sendOtp({
                                  name,
                                  mobileNumber,
                                });

                              if (resp?.data?.status === "fail") {
                                dispatch(
                                  setStatusPopup({
                                    status: "error",
                                    message: resp.data.message,
                                  })
                                );
                                return;
                              }
                              setOtpKey(resp.data.data.value);
                              setOtpTime(resp.data.data.otpTime);
                              setOpenOtpModal(true);
                            } catch (err: any) {
                              const apiMsg =
                                err?.response?.data?.errors?.[0]?.constraints
                                  ?.matches;
                              dispatch(
                                setStatusPopup({
                                  status: "info",
                                  message: apiMsg,
                                })
                              );
                            }
                          }}
                          disabled={duplicatePhone || !currentPhoneValue}
                          sx={{
                            backgroundColor: isMobileVerifiedField ? "transparent" : "#FEC10D",
                            color: isMobileVerifiedField ? "#28C76F" : "#000000",
                            "&:hover": {
                              backgroundColor: isMobileVerifiedField ? "transparent" : "#FEC10D",
                              color: isMobileVerifiedField ? "#28C76F" : "#000000",
                            },
                            "&.Mui-disabled": {
                              backgroundColor: isMobileVerifiedField ? "transparent" : "#FEC10D",
                              color: isMobileVerifiedField ? "#28C76F" : "#000000",
                              WebkitTextFillColor: isMobileVerifiedField ? "#28C76F" : "#000000",
                              opacity: 1,
                            },
                            "& img": {
                              opacity: 1,
                              filter: "brightness(1)",
                            },
                            textTransform: "none",
                            fontSize: isMobileVerifiedField ? "16px" : "10px",
                            fontWeight: isMobileVerifiedField ? 400 : 700,
                            px: "15px",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            boxShadow: "none",
                            height: '100%',
                            mr: 0.5,
                          }}
                        >
                          {isMobileVerifiedField ? (
                            <>
                              <img
                                src={greenCheckVerified}
                                alt="Verified"
                                style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                              />
                              <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                            </>
                          ) : (
                            <>
                              <Typography variant="inherit">Verify</Typography>
                              <img
                                src={arrowRightVerify}
                                alt="Verified"
                                style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                              />
                            </>
                          )}
                        </Button>
                        ),
                    }}
                  />
                )}
              </Field>
            </Box>
          </Grid>
        );
      case "email":
        const isReferenceEmailField = /^(refBasic\d+|basicReference\d+)(EmailID|Email)$/i.test(
          field.name,
        );
        // Co-applicant email field check
        const coApplicantEmailMatch = field.name.match(
          /^basicCoApplicant(\d+)Email$/
        );
        const adCoApplicantEmailMatch = field.name.match(
          /^adBasicCoApplicant(\d+)Email$/
        );
        const applicantEmailVerifiedFlag =
          isEmailVerified === true ||
          isEmailVerified === "true" ||
          formData?.isEmailVerified === true ||
          formData?.isEmailVerified === "true" ||
          formikRef.current?.values?.isEmailVerified === true ||
          formikRef.current?.values?.isEmailVerified === "true";
        let isVerified = false;
        let lastVerified = "";
        if (coApplicantEmailMatch) {
          const idx = String(Number(coApplicantEmailMatch[1]) - 1); // 0-based index
          const formikEmailVerified =
            formikRef.current?.values[
            `basicCoApplicant${Number(idx) + 1}IsEmailVerified`
            ];
          const reduxEmailVerified =
            coApplicantVerification[idx]?.emailVerified;
          const lastEmail = coApplicantVerification[idx]?.lastVerifiedEmail || "";
          isVerified =
            !!lastEmail &&
            (formikEmailVerified || reduxEmailVerified) &&
            String(formikRef.current?.values[field.name] || "").trim().toLowerCase() ===
            String(lastEmail || "").trim().toLowerCase();
          lastVerified = lastEmail;
        } else {
          isVerified = applicantEmailVerifiedFlag;
          lastVerified = lastVerifiedEmail || "";
        }

        // Check duplicate email only between applicant and co-applicant 1
        const currentEmailValue = formikRef.current?.values[field.name];
        // No OTP for an invalid email (e.g. containing + or -)
        const isCurrentEmailInvalid = !isValidJourneyEmail(currentEmailValue);
        const normalizedCurrentEmail = String(currentEmailValue || "")
          .trim()
          .toLowerCase();
        const normalizeEmail = (value: any) =>
          String(value || "")
            .trim()
            .toLowerCase();
        const applicantEmail = normalizeEmail(formikRef.current?.values?.email);
        const coApplicant1Email = normalizeEmail(
          formikRef.current?.values?.basicCoApplicant1Email
        );
        const isApplicantOrCoApplicant1 =
          field.name === "email" || field.name === "basicCoApplicant1Email";
        const isCoApplicant2Onward = /^basicCoApplicant([2-9]\d*)Email$/.test(
          field.name
        );

        let duplicateEmail = false;
        if (!!normalizedCurrentEmail) {
          if (isApplicantOrCoApplicant1) {
            duplicateEmail =
              normalizedCurrentEmail ===
              normalizeEmail(
                formikRef.current?.values[
                field.name === "email" ? "basicCoApplicant1Email" : "email"
                ]
              );
          } else if (isCoApplicant2Onward) {
            duplicateEmail =
              normalizedCurrentEmail === applicantEmail ||
              normalizedCurrentEmail === coApplicant1Email;
          }
        }

        return (
          <Grid
            item
            xs={12}
            sm={
              activeHorizontalIndex === 1 && activeVerticalIndex === 3
                ? 4
                : activeHorizontalIndex === 1 && activeVerticalIndex === 5 ||
                 (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
                  ? 12
                  : 6
            }
            key={field.id}
          >
            <Box>
              <label className="text-lable" style={{ display: "block" }}>
                {field.label}{" "}
                {field.required  && (
                  <span style={{ color: "red" }}>*</span>
                )}
              </label>
              <Field name={field.name}>
                {({ field: f, meta, form }: any) => (
                  <InputField
                    {...f}
                    fullWidth
                    placeholder={
                      isReferenceEmailField
                        ? "Enter Email ID"
                        : field.placeholder || "Enter Email ID and verify"
                    }
                    variant="outlined"
                    inputmode="text"
                    error={
                      ((!!meta.touched) && !!meta.error) ||
                      (duplicateEmail && !!currentEmailValue)
                    }
                    helperText={
                      meta.touched && meta.error
                        ? meta.error
                        : duplicateEmail && !!currentEmailValue
                          ? "This email is already used in another field."
                          : ""
                    }
                    autoComplete="new-password"
                    onKeyDown={(e) => {
                      // Block leading space: allow spaces only after first character
                      if (e.key === " ") {
                        const target = e.target as HTMLInputElement;
                        const start = target.selectionStart ?? 0;
                        if (start === 0) {
                          e.preventDefault();
                        }
                      }
                    }}
                    onChange={(e) => {
                      const inputValue = e.target.value;

                      // Keep Formik values in sync between applicant email fields
                      if (field.name === "email" || field.name === "studentDetailEmail") {
                        form.setFieldValue("email", inputValue, false);
                        form.setFieldValue("studentDetailEmail", inputValue, false);
                      } else {
                        f.onChange(e);
                      }

                      // Keep Redux formData in sync with latest typed email
                      if (field.name === "email" || field.name === "studentDetailEmail") {
                        dispatch(
                          updateFormData({
                            email: inputValue,
                            studentDetailEmail: inputValue,
                          })
                        );
                      } else {
                        dispatch(
                          updateFormData({
                            [field.name]: inputValue,
                          })
                        );
                      }

                      // Reset verification if value changes (an empty value is never verified)
                      if (inputValue !== lastVerified || !String(inputValue || "").trim()) {
                        if (coApplicantEmailMatch) {
                          const idx = String(
                            Number(coApplicantEmailMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: {
                                emailVerified: false,
                              },
                            })
                          );
                        } else {
                          dispatch(setIsEmailVerified(false));
                        }
                      } else {
                        if (coApplicantEmailMatch) {
                          const idx = String(
                            Number(coApplicantEmailMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: {
                                emailVerified: true,
                              },
                            })
                          );
                        } else {
                          dispatch(setIsEmailVerified(inputValue === lastVerified && inputValue !== "" && isEmailVerified == true));
                        }
                      }
                    }}
                    onInput={(e: any) => {
                      // Trim leading spaces from pasted/typed input but allow internal spaces
                      if (
                        typeof e.target.value === "string" &&
                        /^\s/.test(e.target.value)
                      ) {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                      }
                      if (field.name === "email" || field.name === "studentDetailEmail") {
                        dispatch(
                          updateFormData({
                            email: e.target.value,
                            studentDetailEmail: e.target.value,
                          })
                        );
                      }
                      handleFilledFieldsCount(field.name, e.target.value);
                      if (
                        activeHorizontalIndex === 1 &&
                        activeVerticalIndex === 5
                      ) {
                        // Persist all form values to Redux for refresh survival
                        if (formikRef?.current?.values) {
                          // dispatch(
                          //   updateFormData({
                          //     ...formikRef.current.values,
                          //     [field.name]: e.target.value,
                          //   })
                          // );
                          dispatch(
                            updateFormData({
                              [field.name]: e.target.value,
                            })
                          );
                        }
                      }
                    }}
                    disabled={(() => {
                      if (!coApplicantEmailMatch) return false;
                      // An empty email can never be verified — keep it editable
                      if (!String(formikRef.current?.values?.[field.name] || "").trim()) {
                        return false;
                      }
                      const idx = Number(coApplicantEmailMatch[1]) - 1;
                      const isTruthy = (v: any) =>
                        v === true || v === "true" || v === 1 || v === "1";
                      const emailVerifiedFlag =
                        isTruthy(
                          formikRef.current?.values?.[
                            `basicCoApplicant${idx + 1}IsEmailVerified`
                          ]
                        ) || Boolean(coApplicantVerification[idx]?.emailVerified);
                      if (!emailVerifiedFlag) return false;
                      const lastEmail =
                        coApplicantVerification[idx]?.lastVerifiedEmail ||
                        formikRef.current?.values?.[field.name] ||
                        "";
                      return (
                        String(formikRef.current?.values?.[field.name] || "")
                          .trim()
                          .toLowerCase() ===
                        String(lastEmail || "").trim().toLowerCase()
                      );
                    })()}
                    inputProps={{ autoComplete: "off", maxLength: 40 }}
                    InputProps={{
                      readOnly:
                        isApiLoading ||
                        ((field.name === "email" || field.name === "studentDetailEmail") && applicantEmailVerifiedFlag),
                      endAdornment: (
                        (coApplicantEmailMatch || adCoApplicantEmailMatch || isReferenceEmailField)
                          ? null
                          : (
                            <Button
                              sx={{
                                backgroundColor: isVerified ? "transparent" : "#FEC10D",
                                color: isVerified ? "#28C76F" : "#000000",
                                "&:hover": {
                                  backgroundColor: isVerified ? "transparent" : "#FEC10D",
                                  color: isVerified ? "#28C76F" : "#000000",
                                },
                                "&.Mui-disabled": {
                                  backgroundColor: isVerified ? "transparent" : "#FEC10D",
                                  color: isVerified ? "#28C76F" : "#000000",
                                  WebkitTextFillColor: isVerified ? "#28C76F" : "#000000",
                                  opacity: 1,
                                },
                                "& img": {
                                  opacity: 1,
                                  filter: "brightness(1)",
                                },
                                textTransform: "none",
                                fontSize: isVerified ? "16px" : "10px",
                                fontWeight: isVerified ? 400 : 700,
                                px: "15px",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                boxShadow: "none",
                                height: '100%',
                                mr: 0.5,
                              }}
                              onClick={isApiLoading ? undefined : async () => {
                                if (
                                  isVerified ||
                                  duplicateEmail ||
                                  !currentEmailValue ||
                                  isCurrentEmailInvalid
                                )
                                  return;
                                try {
                                  let name = `${form?.values?.studentDetailsFirstName || form?.values?.firstName || ""} ${form?.values?.studentDetailsLastName || form?.values?.lastName || ""}`.trim();

                                  const email = form.values[field.name];
                                  setOtpEmail(email);
                                  setOtpEmailFieldName(field.name);

                                  const coApplicantEmailMatch = field.name.match(
                                    /^basicCoApplicant(\d+)Email$/
                                  );
                                  if (coApplicantEmailMatch) {
                                    dispatch(
                                      setCurrentCoApplicantIdx(
                                        String(Number(coApplicantEmailMatch[1]) - 1)
                                      )
                                    );

                                    // this will only work for coapplicant
                                    const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantEmailMatch[1]))}FirstName`;
                                    if (form.values[dynamicNameKey]) {
                                      name = form.values[dynamicNameKey];   // co-applicant name
                                    }
                                  } else {
                                    dispatch(setCurrentCoApplicantIdx(null));
                                  }

                                  const resp =
                                    await eligibilityCheckServices.sendOtp({
                                      name,
                                      email: email.toLowerCase(),
                                    });
                                  if (resp?.data?.status === "fail") {
                                    dispatch(
                                      setStatusPopup({
                                        status: "error",
                                        message: resp.data.message,
                                      })
                                    );
                                    return;
                                  }
                                  setOtpEmailKey(resp.data.data.value);
                                  setOtpEmailTime(resp.data.data.otpTime);
                                  setOpenEmailOtp(true);
                                } catch (err: any) {
                                  const apiMsg =
                                    err?.response?.data?.errors?.[0]?.constraints
                                      ?.isEmail;
                                  dispatch(
                                    setStatusPopup({
                                      status: "error",
                                      message: apiMsg,
                                    })
                                  );
                                }
                              }}
                              disabled={isVerified || duplicateEmail || !currentEmailValue || isCurrentEmailInvalid}
                            >
                              {isVerified ? (
                                <>
                                  <img
                                    src={greenCheckVerified}
                                    alt="Verified"
                                    style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                  />
                                  <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                                </>
                              ) : (
                                <>
                                  <Typography variant="inherit">Verify</Typography>
                                  <img
                                    src={arrowRightVerify}
                                    alt="Verified"
                                    style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                  />
                                </>
                              )}
                            </Button>
                          )
                      ),
                    }}
                  />
                )}
              </Field>
            </Box>
          </Grid>
        );
      case "dropdown":
        if (field.name === "product") {
          return (
            <Grid
              item
              xs={12}
              sm={activeHorizontalIndex === 1 && activeVerticalIndex === 3 ? 4 : 6}
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    useEffect(() => {
                      if (!f.value && productOptions.length > 0 && !loadingProducts) {
                        const defaultValue = productOptions[0].value;
                        form.setFieldValue(field.name, defaultValue);
                        dispatch(setSelectedProduct(defaultValue));
                        handleFilledFieldsCount(field.name, defaultValue);
                      }
                    }, [productOptions, loadingProducts, f.value]);

                    return (
                      <SelectOptions
                        label={field.label}
                        value={f.value}
                        onChange={(value: any) => {
                          form.setFieldValue(field.name, value);
                          dispatch(setSelectedProduct(value));
                          handleFilledFieldsCount(field.name, value);
                        }}
                        options={productOptions}
                        placeholder={field.label}
                        isMandatory={field.required || false}
                        disabled={loadingProducts}
                        error={Boolean(form.touched[field.name] && form.errors[field.name])}
                        helperText={form.touched[field.name] && form.errors[field.name] ? String(form.errors[field.name]) : ""}
                      />
                    );
                  }}
                </Field>
              </Box>
            </Grid>
          );
        }

        if (field.name === "courseCategory") {
          return (
            <Grid
              item
              xs={12}
              sm={activeHorizontalIndex === 1 && activeVerticalIndex === 3 ? 4 : 6}
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    const options = getDropdownOptions(field);

                    useEffect(() => {
                      // Only set default if value is empty and options are available
                      if (!f.value && options.length > 0 && !loadingProducts) {
                        const defaultValue = options[0].value;
                        form.setFieldValue(field.name, defaultValue);

                        // Ensure Redux and trackers are updated on initial mount
                        dispatch(updateFormData({ [field.name]: defaultValue }));
                        handleFilledFieldsCount(field.name, defaultValue);
                      }
                    }, [options, loadingProducts, f.value]);

                    // Normalize value: extract .value if it's an object, otherwise use as-is
                    const normalizedValue =
                      (typeof f.value === "object" && f.value !== null && "value" in f.value)
                        ? f.value.value
                        : f.value;

                    return (
                      <SelectOptions
                        label={field.label}
                        value={normalizedValue}
                        onChange={(value: any) => {
                          // Normalize incoming value for storage
                          const valToStore = (typeof value === "object" && value !== null && "value" in value)
                            ? value.value
                            : value;

                          form.setFieldValue(field.name, valToStore);

                          // Standard handlers
                          handleDropdownChange(field.name, value, form);
                          handleFilledFieldsCount(field.name, valToStore);

                          // Persist to Redux for refresh survival
                          dispatch(
                            updateFormData({
                              [field.name]: valToStore,
                            })
                          );
                        }}
                        options={options}
                        placeholder={`Select ${field.label}`}
                        isMandatory={field.required || false}
                        disabled={loadingProducts}
                        error={Boolean(form.touched[field.name] && form.errors[field.name])}
                        helperText={form.touched[field.name] && form.errors[field.name] ? String(form.errors[field.name]) : ""}
                      />
                    );
                  }}
                </Field>
              </Box>
            </Grid>
          );
        }

        return (
          <>
            <Grid
              item
              xs={12}
              sm={
                (activeHorizontalIndex === 1 && activeVerticalIndex === 5) ||
                  (activeHorizontalIndex === 1 && activeVerticalIndex === 4) ||
                  (activeHorizontalIndex === 1 && activeVerticalIndex === 3) ||
                  (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
                  ? 12
                  : 6
              }
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    let options = getDropdownOptions(field);

                    // Restrict duplicate course types
                    const keyItem: any = field.name.match(
                      /^basicCoApplicant(\d+)RelationWithStudent$/
                    );

                    if (field.name.includes(keyItem?.[0])) {
                      options = relationshipOptions;
                    }

                    // Populate applicant + co-applicant names for coOwnerCollateral Name fields
                    if (isCoOwnerCollateralNameField(field.name)) {
                      options = getCoOwnerNameAutocompleteOptions(
                        form.values || {},
                        field.name,
                        f.value,
                      );
                    }

                    // Filter out "Student" option from employmentType
                    if (field.name === "employmentType") {
                      options = options.filter(
                        (opt: any) => opt.value !== "Student"
                      );
                    }

                    if (
                      field.name.includes("course") &&
                      field.name.includes("Type")
                    ) {
                      // Derive selectedCourseTypes from form.values
                      const selectedCourseTypes = Object.keys(form.values)
                        .filter(
                          (key) => key.includes("course") && key.includes("Type")
                        )
                        .map((key) => form.values[key]?.value || form.values[key])
                        .filter(Boolean);

                      options = options.filter(
                        (opt: any) =>
                          !selectedCourseTypes.includes(opt.value) ||
                          opt.value === f.value?.value ||
                          opt.value === f.value
                      );

                      // 12th / Diploma / Graduation are not offered for Qualification 1 (10th)
                      // (kept only if already saved, so the existing value still shows)
                      if (field.name === "course1Type") {
                        const currentCourseType = f.value?.value || f.value;
                        options = options.filter(
                          (opt: any) =>
                            !["12th", "Diploma", "Graduation"].includes(opt.value) ||
                            opt.value === currentCourseType
                        );
                      }
                    }

                    // Restrict duplicate exam names for core and language exams (including suffixed fields)
                    if (
                      /^coreExamName(_\d+)?$/.test(field?.name ?? "") ||
                      /^languageExamName(_\d+)?$/.test(field?.name ?? "")
                    ) {
                      // Type for exam name value
                      type ExamNameValue = string;
                      // Collect all selected core/language exam names (including suffixed)
                      const selectedExamNames: ExamNameValue[] = Object.keys(
                        form?.values ?? {}
                      )
                        .filter(
                          (key) =>
                            /^coreExamName(_\d+)?$/.test(key) ||
                            /^languageExamName(_\d+)?$/.test(key)
                        )
                        .map((key) => form?.values?.[key])
                        .filter(Boolean);

                      options = options.filter(
                        (opt: any) =>
                          !selectedExamNames.includes(opt?.value) ||
                          opt?.value === f?.value
                      );
                    }

                    if (
                      (field.name === "permanentAddressType" ||
                        /^addressCoApplicant\d+permanentAddressType$/.test(
                          field.name
                        )) &&
                      !f.value
                    ) {
                      form.setFieldValue(field.name, "Permanent Address", false);
                    }

                    if (
                      field.name === "currentAddressType" ||
                      /^addressCoApplicant\d+currentAddressType$/.test(field.name)
                    ) {
                      if (f.value !== "Current address") {
                        form.setFieldValue(field.name, "Current address", false);
                      }
                    }

                    // Default course type values are now handled in useEffect to ensure proper Redux storage

                    // Normalize value for simple dropdowns (like employmentType)
                    let normalizedValue = f.value;
                    if(field.name==="collateral1Type" && !f.value){
                      normalizedValue = formikRef?.current?.values?.collateralType || "";
                    }
                    if (
                      field.name === "employmentType" &&
                      typeof f.value === "object" &&
                      f.value !== null &&
                      "value" in f.value
                    ) {
                      normalizedValue = f.value.value;
                    }

                    // Special handling for salutation fields
                    if (field.name.toLowerCase().includes("salutation")) {
                      // For salutation, f.value should contain the salutation code (value)
                      // If it's an object, extract the value, otherwise use as-is
                      if (
                        typeof f.value === "object" &&
                        f.value !== null &&
                        "value" in f.value
                      ) {
                        normalizedValue = f.value.value;
                      } else {
                        normalizedValue = f.value;
                      }
                    }

                    // Special handling for designation fields
                    if (field.name.toLowerCase().includes("designation")) {
                      // For designation, f.value should contain the designation code (value)
                      // If it's an object, extract the value, otherwise use as-is
                      if (
                        typeof f.value === "object" &&
                        f.value !== null &&
                        "value" in f.value
                      ) {
                        normalizedValue = f.value.value;
                      } else {
                        normalizedValue = f.value;
                      }
                    }

                    return (
                      <SelectOptions
                        label={field.label}
                        value={normalizedValue}
                        onChange={(value: any) => {
                          let storedValue = value;

                          // Several branches below never reach handleDropdownChange
                          // (designation, employmentType, collateral type, ...), so
                          // schedule the revalidation here too.
                          scheduleFormRevalidate();

                          // For employmentCompanyCountry, set value with validation, then clear error and validate
                          if (field.name === "employmentCompanyCountry") {
                            form.setFieldValue(field.name, value, true); // validate = true
                            handleFilledFieldsCount(field.name, value);
                            form.setFieldTouched(field.name, true, false);
                            form.setFieldError(field.name, undefined);
                            form.validateField(field.name);
                          } else if (field.name === "employmentType") {
                            // Always store as string for employmentType
                            const normalizedEmploymentType =
                              typeof value === "object" &&
                                value !== null &&
                                "value" in value
                                ? (value as any).value
                                : value;

                            storedValue = normalizedEmploymentType;
                            form.setFieldValue(field.name, normalizedEmploymentType);
                            handleFilledFieldsCount(field.name, normalizedEmploymentType);

                            // If employmentType is Others, clear other employment-related fields
                            // But preserve monthlyIncome and monthlyObligation
                            if (normalizedEmploymentType === "Others") {
                              const employmentFieldNamesToClear = fields
                                .filter(
                                  (f: any) =>
                                    (f.name?.toLowerCase().startsWith("employment") ||
                                      f.name?.toLowerCase().startsWith("employmentcompany")) &&
                                    f.name !== "employmentType" &&
                                    f.name !== "employmentisEmployed" &&
                                    f.name !== "employmentMonthlyIncome" &&
                                    f.name !== "employmentMonthlyObligation"
                                )
                                .map((f: any) => f.name);
                              employmentFieldNamesToClear.forEach((fname: string) => {
                                form.setFieldValue(fname, "", false);
                                form.setFieldTouched(fname, false, false);
                                form.setFieldError(fname, undefined);
                                handleFilledFieldsCount(fname, "");
                              });
                            }
                          } else if (
                            field.name.startsWith("coreExamName") ||
                            field.name.startsWith("languageExamName")
                          ) {
                            storedValue = value;
                            handleExamDropdownChange(
                              field.name,
                              value,
                              form.setFieldValue
                            );
                            handleFilledFieldsCount(field.name, value);
                          } else {
                            

                            if (field.name.toLowerCase().includes("salutation")) {
                              // For salutation fields, find the full option object to get both code and description
                              const selectedOption = options.find(
                                (opt: any) => opt.value === value
                              );
                              if (selectedOption) {
                                // Set the form value to the salutation code (value)
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                );
                                // Pass full option to handleDropdownChange to store both code and description
                                handleDropdownChange(
                                  field.name,
                                  selectedOption,
                                  form
                                );
                                storedValue = selectedOption.value;
                              } else {
                                form.setFieldValue(field.name, value);
                                handleDropdownChange(field.name, value, form);
                                storedValue = value;
                              }
                            } else if (
                              /^basicCoApplicant\d+MaritalStatus$/i.test(field.name)
                            ) {
                              const selectedOption = options.find(
                                (opt: any) => String(opt.value) === String(value)
                              );
                              const maritalStatusLabel = String(
                                selectedOption?.label ?? value ?? ""
                              );

                              form.setFieldValue(field.name, maritalStatusLabel);
                              handleDropdownChange(field.name, maritalStatusLabel, form);
                              storedValue = maritalStatusLabel;
                              handleFilledFieldsCount(field.name, maritalStatusLabel);
                            } else if (
                              field.name.toLowerCase().includes("designation")
                            ) {
                              // For designation fields, store only the value (code) but display label
                              // The value passed here is already the code from the selected option
                              form.setFieldValue(field.name, value);
                              handleFilledFieldsCount(field.name, value);
                              storedValue = value;
                            } else if (isCoOwnerCollateralNameField(field.name)) {
                              handleCoOwnerNameSelection(
                                field.name,
                                value,
                                form,
                                handleFilledFieldsCount,
                                handleDropdownChange,
                              );
                              storedValue = value;
                            } else if (/^collateral\d*type$/i.test(field.name)) {
                              const collateralNumber =
                                getCollateralNumberFromFieldName(field.name) || 1;
fields
                                .filter(
                                  (otherField: any) =>
                                    otherField.name !== field.name &&
                                    fieldBelongsToCollateralNumber(
                                      otherField.name,
                                      collateralNumber
                                    )
                                )
                                .forEach((otherField: any) => {
                                  form.setFieldValue(otherField.name, "", false);
                                  form.setFieldTouched(otherField.name, false, false);
                                  handleFilledFieldsCount(otherField.name, "");
                                });

                              form.setFieldValue(field.name, value);
                              handleDropdownChange(field.name, value, form);
                              storedValue = value;
                            } else {
                              form.setFieldValue(field.name, value);
                              handleDropdownChange(field.name, value, form);
                              storedValue = value;
                            }
                            if (!/^basicCoApplicant\d+MaritalStatus$/i.test(field.name)) {
                              handleFilledFieldsCount(field.name, value);
                            }
                          }

                          if (
                            activeHorizontalIndex === 1 &&
                            activeVerticalIndex === 5
                          ) {
                            // Persist all form values to Redux for refresh survival
                            if (formikRef?.current?.values) {
                              
                              dispatch(
                                updateFormData({
                                  [field.name]: storedValue,
                                })
                              );
                            }
                          }

                          // Check and uncheck address checkbox if address fields change
                          if (
                            /^(permanent|current)(OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity|State|Country|City)$/.test(field.name) ||
                            /^addressCoApplicant\d+(permanent|current)(OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity|State|Country|City)$/.test(field.name)
                          ) {
                            setTimeout(() => {
                              checkAndUncheckAddressCheckbox();
                            }, 0);
                          }

                          if (field.name == "salutation") {
                            const fatherFirstName = form?.values?.fatherFirstName;
                            const motherFirstName = form?.values?.motherFirstName;
                            const fatherLastName = form?.values?.fatherLastName;
                            const motherLastName = form?.values?.motherLastName;
                            const gender = form?.values?.gender;
                            const aadhaar = form?.values?.aadhaar;
                            const dob = form?.values?.dob;
                            const firstName =
                              form?.values?.firstName ||
                              form?.values?.studentDetailsFirstName;
                            const lastName =
                              form?.values?.lastName ||
                              form?.values?.studentDetailsLastName;
                            const phone_number =
                              form?.values?.phone_number ||
                              form?.values?.studentDetailsPhone_number;
                            const email =
                              form?.values?.email ||
                              form?.values?.studentDetailEmail;
                            const isAadhaarVerified = form?.values?.isAadhaarVerified;
                            const isEmailVerified = form?.values?.isEmailVerified;
                            const isMobileVerified = form?.values?.isMobileVerified;
                            const isPanVerified = form?.values?.isPanVerified;
                            dispatch(
                              updateFormData({
                                [field?.name]: value,
                                fatherFirstName,
                                motherFirstName,
                                fatherLastName,
                                motherLastName,
                                gender,
                                aadhaar,
                                dob,
                                firstName: formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || "",
                                lastName: formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || "",
                                phone_number,
                                email,
                                isAadhaarVerified,
                                isEmailVerified,
                                isMobileVerified,
                                isPanVerified,
                              })
                            );
                          }
                        }}
                        options={options}
                        placeholder={
                          field.name?.includes("salutation")
                            ? 'Select Salutation'
                            : field.name === "coreScoreReceived" || field.name === "languageScoreReceived"
                              ? 'Select Status'
                              : `Select ${field.label}`
                        }
                        isMandatory={
                          /^collateral\d*type$/i.test(field.name)
                            ? Boolean(field.required) &&
                              (formikRef?.current?.values?.collateral === "Yes" ||
                                Boolean(f.value))
                            : field.required || false
                        }
                        error={Boolean(form.touched[field.name] && form.errors[field.name])}
                        helperText={form.touched[field.name] && form.errors[field.name] ? String(form.errors[field.name]) : ""}
                        isApplicant={field.name === "employmentType" ? true : false}
                        disabled={field?.disabled || false}
                     />
                    );
                  }}
                </Field>
              </Box>
            </Grid>

            {/* This renders the whitespace (empty box) only next to Employment Type */}
            {field.name === 'employmentType' && !isXsOrSm && (
              <Grid item xs={12} sm={6} />
            )}
          </>
        );
      case "radio":
        return (
          <Grid item xs={12} key={field.id}>
            <Box>
              <Field name={field.name}>
                {({ field: f, form, meta }: any) => {
                  const errorMessage = meta?.error || form.errors[field.name];
                  const showError = Boolean(
                    (meta?.touched || form.touched[field.name]) &&
                      errorMessage
                  );
                  const helperText = showError
                    ? String(errorMessage)
                    : null;

                  return (
                    <CustomRadioGroup
                      hasBg={
                        activeHorizontalIndex === 0 && activeVerticalIndex === 0
                      }
                      isRequired={true}
                      label={field.label}
                      options={(field.options?.options || []).map(
                        (opt: string) => ({
                          value:
                            activeHorizontalIndex === 0 &&
                              activeVerticalIndex === 0
                              ? opt?.toLowerCase()
                              : opt,
                          label: opt,
                        })
                      )}
                      value={
                        field?.disabled && field?.value !== undefined
                          ? field.value
                          : f.value
                      }
                      error={showError}
                      helperText={helperText}
                      disabled={Boolean(field?.disabled)}
                      onChange={(value) => {
                        scheduleFormRevalidate();
                        handleFilledFieldsCount(field.name, value);
                        handleRadioChange(field.name, value, form);
                        form.setFieldValue(field.name, value, true);
                        form.setFieldTouched(field.name, true, false);
                        if (
                          activeHorizontalIndex === 1 &&
                          activeVerticalIndex === 5
                        ) {
                          if (formikRef?.current?.values) {
                            dispatch(
                              updateFormData({
                                [field.name]: value,
                              })
                            );
                          }
                        }
                      }}
                    />
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      case "checkbox":
        return (
          <Grid item xs={12} sm={12} key={field.id} sx={{ mb: 0, mt: 0, p: 0 }}>
            <Box sx={{ m: 0, p: 0 }}>
              <Field name={field.name}>
                {({ field: f, form, meta }: any) => {
                  const safeLabel = DOMPurify.sanitize(field?.label); // sanitize before rendering
                  const hasPurposesAnchor = hasSpecificPurposesAnchor(
                    field?.label
                  );

                  const showError = Boolean(form?.touched?.[field.name] && form?.errors?.[field.name]);
                  return (
                    <div className="checkbox-wrapper" style={{ margin: 0, padding: 0 }}>
                      <FormControl error={showError} component="fieldset" sx={{ width: "100%" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!f.value}
                              {...f}
                              onChange={(event: any) => {
                                let checked = event.target.checked;
                                // "Same as permanent" copies a whole address block
                                // in one tick, so the individual writes all validate
                                // stale values — revalidate once after they settle.
                                scheduleFormRevalidate();
                                if (field.name === "currentsameAsPermanent") {
                                  setIsCurrentSameAsPermanent(checked);
                                  handleFilledCurrentAddressFields(checked);
                                }
                                const match = field.name.match(
                                  /^addressCoApplicant(\d+)currentsameAsPermanent$/
                                );
                                if (match) {
                                  if (checked) {
                                    handleInvokZipCode(
                                      String(formikRef?.current?.values?.[`addressCoApplicant${match[1]}permanentPincode`]),
                                      undefined,
                                      "current"
                                    )
                                  }
                                  handleFilledCurrentAddressFieldsCoApplicant(
                                    match[1],
                                    checked
                                  );
                                }
                                handleFilledFieldsCount(field.name, event);
                                f.onChange(event); // ensure Formik state is updated
                              }}
                              color={showError ? "error" : undefined}
                              sx={{
                                p: 0.5,
                                "&.Mui-checked": {
                                  color: "#33C2C4",
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              component="span"
                              onClick={
                                hasPurposesAnchor
                                  ? handlePurposesClick
                                  : undefined
                              }
                              sx={{
                                fontFamily: "Jost, sans-serif",
                                fontWeight: 400,
                                fontSize: isXsOrSm ? "12px" : "15px",
                                lineHeight: "22px",
                                textAlign: "left",
                                color: "#4B465C",
                                display: "inline-block",
                                borderRadius: "4px",
                                padding: "2px 0px",
                                cursor: hasPurposesAnchor ? "pointer" : "default",
                                "& a": {
                                  color: "#33C2C4",
                                  textDecoration: "underline",
                                  transition: "color 0.2s ease-in-out",
                                  "&:hover": {
                                    color: "#33C2C4",
                                  },
                                },
                              }}
                              dangerouslySetInnerHTML={{ __html: safeLabel }} // sanitized HTML
                            />
                          }
                          sx={{ m: 0, alignItems: "flex-start !important" }}
                        />
                        {showError && (
                          <FormHelperText sx={{ color: "#d32f2f", ml: 0 }}>{String(form?.errors?.[field.name])}</FormHelperText>
                        )}
                      </FormControl>
                    </div>
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      case "autocomplete":
        // Restrict duplicate course types
        const keyItem: any = field.name.match(
          /^basicCoApplicant(\d+)RelationWithStudent$/
        ) ||  field.name.match(
          /^adBasicCoApplicant(\d+)RelationWithStudent$/
        );
        const isBirthCityDropdownField =
          /^basicCoApplicant\d+CityOfBirth$/i.test(String(field?.name || "")) ||
          String(field?.name || "").toLowerCase() === "applicantcitybirth" ||
          /city.*birth|birth.*city/i.test(String(field?.name || "")) ||
          /city.*birth|birth.*city/i.test(String(field?.label || ""));
        return (
          <Grid
            item
            xs={12}
            sm={
              activeHorizontalIndex === 1 && activeVerticalIndex === 3
                ? 4
                : activeHorizontalIndex === 1 && activeVerticalIndex === 5 || 
                 (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
                  ? 12
                  : 6
            }
            key={field.id}
          >
            <Box>
              <Field name={field.name}>
                {({ field: f, form, meta }: any) => {
                  // For RelationWithStudent, convert stored value to option object for display
                  let displayValue = f.value || null;
                  if (
                    field.name.match(/^basicCoApplicant\d+RelationWithStudent$/)
                  ) {
                    const options = relationshipOptions;
                    // Find the option that matches the stored value
                    const matchedOption = options.find(
                      (opt: any) => opt.value === f.value
                    );
                    displayValue = matchedOption || null;
                  }

                  // For designation fields (applicant and co-applicant), convert stored value to option object for display
                 
                  if (field.name.toLowerCase().includes("designation")) {
                    const options = getDropdownOptions(field);
                    // Match the stored code, or the full name once saved data reloads
                    const matchedOption = options.find(
                      (opt: any) => opt.value === f.value || opt.label === f.value
                    );

                    displayValue = matchedOption || null;
                  }

                  if (
                    /MaritalStatus$/i.test(String(field?.name || "")) &&
                    f.value !== "" && f.value !== null && f.value !== undefined
                  ) {
                    const maritalOpts = getDropdownOptions(field) || [];
                    const searchVal =
                      typeof f.value === "object"
                        ? String(
                            (f.value as any)?.label ??
                              (f.value as any)?.value ??
                              "",
                          ).toLowerCase()
                        : String(f.value ?? "").toLowerCase();

                    if (searchVal) {
                      const matched = maritalOpts.find(
                        (opt: any) =>
                          String(opt?.label ?? "").toLowerCase() === searchVal ||
                          String(opt?.value ?? "").toLowerCase() === searchVal,
                      );
                      displayValue =
                        matched ||
                        (typeof f.value === "object"
                          ? f.label
                          : {
                              value: String(f.value),
                              label: String(f.label),
                            });
                    }
                  }

                  // For nationality autocomplete fields, resolve stored string/object to
                  // the matching option so the autocomplete displays the correct label.
                  if (
                    (/nationality/i.test(String(field?.name || "")) ||
                      /naionality/i.test(String(field?.name || ""))) &&
                    f.value !== "" && f.value !== null && f.value !== undefined
                  ) {
                    const nationalityOpts = (getDropdownOptions(field) || []);
                    const searchVal = typeof f.value === "object"
                      ? String((f.value as any)?.label ?? (f.value as any)?.value ?? "").toLowerCase()
                      : String(f.value ?? "").toLowerCase();
                    if (searchVal) {
                      const matched = nationalityOpts.find((opt: any) =>
                        String(opt?.label ?? "").toLowerCase() === searchVal ||
                        String(opt?.value ?? "").toLowerCase() === searchVal
                      );
                      displayValue = matched || (typeof f.value === "object" ? f.value : { value: String(f.value), label: String(f.value) });
                    }
                  }

                  // For country autocomplete fields (e.g. Country of Birth), resolve stored
                  // string (name or code) to the matching { value, label } option object so
                  // the autocomplete displays the correct label when the form is pre-filled.
                  if (
                    (field.name.toLowerCase().includes("country") ||
                      field.label?.toLowerCase().includes("country")) &&
                    typeof f.value === "string" &&
                    f.value !== ""
                  ) {
                    const countryOpts = dropdownData?.countries || [];
                    const matched =
                      countryOpts.find(
                        (opt: any) =>
                          opt.label?.toLowerCase() === f.value.toLowerCase() ||
                          opt.value?.toLowerCase() === f.value.toLowerCase(),
                      );
                    displayValue =
                      matched || { value: String(f.value), label: String(f.value) };
                  }

                  const isBirthCityField =
                    /birth.*city|city.*birth/i.test(String(field?.name || "")) ||
                    /birth.*city|city.*birth/i.test(String(field?.label || "")) ||
                    String(field?.name || "").toLowerCase() === "applicantcitybirth"
                    ||  (field.name.toLowerCase().includes("cityofbirth"));

                  if (isBirthCityField && f.value) {
                    const cityOptions = getDropdownOptions(field) || [];
                    if (typeof f.value === "object") {
                      displayValue =
                        normalizeBirthCityOption(f.value, cityOptions) || f.value;
                    } else if (typeof f.value === "string" && f.value !== "") {
                      const matchedCity = cityOptions.find(
                        (opt: any) => {
                          if (typeof opt === "string") {
                            return opt.toLowerCase() === String(f.value || "").toLowerCase();
                          }

                          return (
                            String(opt?.label || "").toLowerCase() ===
                              String(f.value || "").toLowerCase() ||
                            String(opt?.value || "").toLowerCase() ===
                              String(f.value || "").toLowerCase()
                          );
                        },
                      );

                      displayValue =
                        matchedCity ||
                        normalizeBirthCityOption(f.value, cityOptions) ||
                        String(f.value);
                    }
                  }
                  
                  const coOwnerNameOptions = isCoOwnerCollateralNameField(field.name)
                    ? getCoOwnerNameAutocompleteOptions(form.values || {}, field.name, f.value)
                    : null;

                  const syncAutocompleteSelection = (
                    fieldName: string,
                    selectedValue: any,
                    formikBag: any,
                    shouldTouch = true
                  ) => {
                    const normalizedSelectionValue =
                      typeof selectedValue === "object" && selectedValue !== null
                        ? selectedValue?.value ?? selectedValue?.label ?? selectedValue
                        : selectedValue;

                    formikBag.setFieldValue(fieldName, normalizedSelectionValue, false);
                    formikBag.setFieldTouched(fieldName, shouldTouch, false);
                    formikBag.setFieldError(fieldName, undefined);

                    if (formikRef?.current) {
                      formikRef.current.setFieldValue(fieldName, normalizedSelectionValue, false);
                      formikRef.current.setFieldTouched(fieldName, shouldTouch, false);
                      formikRef.current.setFieldError(fieldName, undefined);
                      if (formikRef.current.values) {
                        formikRef.current.values[fieldName] = normalizedSelectionValue;
                      }
                    }

                    // The setFieldError above clears the message optimistically;
                    // this re-derives it from the schema so a selection that is
                    // still invalid keeps reporting, and a valid one stays clear
                    // instead of waiting on the next unrelated change.
                    scheduleFormRevalidate();

                    return normalizedSelectionValue;
                  };

                  return (
                    <AutoCompleteOptions
                      isNotList={
                        field.name.toLowerCase() == "university" ||
                        field.name.toLowerCase() == "institute" ||
                        field.name.toLowerCase() == "coursename"
                      }
                      formikRef={formikRef}
                      label={field.label}
                      fieldProps={{ ...f }}
                      options={
                        coOwnerNameOptions ??
                        (field.name.includes(keyItem?.[0])
                          ? relationshipOptions
                          : getDropdownOptions(field))
                      }
                      value={displayValue}
                      form={form}
                      onChange={(value: any, reason?: string) => {
                        if (isCoOwnerCollateralNameField(field.name)) {
                          handleCoOwnerNameSelection(
                            field.name,
                            value,
                            form,
                            handleFilledFieldsCount,
                            handleDropdownChange,
                          );
                          return;
                        }
                        const isApplicantCityCountryField =
                          String(field?.name || "").toLowerCase() ===
                          "applicantcitycountry";
                        const isApplicantCityBirthField =
                          !/^basicCoApplicant\d+CityOfBirth$/i.test(
                            String(field?.name || ""),
                          ) &&
                          (String(field?.name || "").toLowerCase() ===
                            "applicantcitybirth" ||
                            /city.*birth|birth.*city/i.test(
                              String(field?.name || ""),
                            ));
                        const isBirthCountryUiField =
                          /birth.*country|country.*birth/i.test(
                            String(field?.name || "")
                          ) && !isApplicantCityCountryField;
                        const isCoApplicantNationalityField =
                          /^basicCoApplicant\d+Nationality$/i.test(
                            String(field?.name || "")
                          ) ||
                          /naionality/i.test(String(field?.name || ""));
                        const isCoApplicantCityOfBirthField =
                          /^basicCoApplicant\d+CityOfBirth$/i.test(
                            String(field?.name || "")
                        );
                        const isCoApplicantMaritalStatusAutocompleteField =
                          /^basicCoApplicant\d+MaritalStatus$/i.test(
                            String(field?.name || "")
                          );
                        syncAutocompleteSelection(field.name, value, form, true);
                        if (
                          isBirthCountryUiField &&
                          (reason === "selectOption" || (reason === undefined && value))
                        ) {
                          const normalizedBirthCountryValue =
                            typeof value === "string"
                              ? value
                              : String(value?.label || value?.value || "");

                          const countryOfBirthValue = value?.value || value;
                          const countryOfBirthLabel = value?.label || value;
                          

                          // Set the field value to only the value
                          form.setFieldValue(field.name, countryOfBirthValue);
                          form.setFieldValue(
                            `${field.name}Name`,
                            countryOfBirthLabel
                          );

                          // Update Redux with RelationWithStudent value and name
                          const currentFormData = { ...formData };
                          currentFormData[field.name] = countryOfBirthValue;
                          currentFormData[`${field.name}Name`] = countryOfBirthLabel;
                          dispatch(updateFormData(currentFormData));

                          handleFilledFieldsCount(field.name, countryOfBirthValue);
                          handleDropdownChange(
                            field.name,
                            normalizedBirthCountryValue,
                            form,
                            "selectOption"
                          );
                          return;
                        }

                        if (
                          isBirthCountryUiField &&
                          reason === "blur" &&
                          (value === null || value === undefined || value === "")
                        ) {
                          return;
                        }

                        if (
                          (
                            isApplicantCityBirthField ||
                            (isApplicantCityCountryField && birthCityList.length > 0)
                          ) &&
                          (reason === "selectOption" || (reason === undefined && value))
                        ) {
                          const normalizedCityOption = normalizeBirthCityOption(
                            value,
                            birthCityList,
                          );

                          form.setFieldValue(field.name, normalizedCityOption, false);
                          form.setFieldError(field.name, undefined);
                          form.setFieldTouched(field.name, true, false);
                          handleFilledFieldsCount(
                            field.name,
                            normalizedCityOption,
                          );
                          return;
                        }

                        if (
                          (isApplicantCityCountryField || isApplicantCityBirthField) &&
                          reason === "clear"
                        ) {
                          form.setFieldValue(field.name, "", false);
                          form.setFieldError(field.name, undefined);
                          form.setFieldTouched(field.name, true, false);
                          handleFilledFieldsCount(field.name, "");
                          return;
                        }
                        if (
                          isApplicantCityCountryField &&
                          reason &&
                          reason !== "selectOption" &&
                          reason !== "clear"
                        ) {
                          return;
                        }

                        // Keep selected value intact on outside-click blur.
                        if (
                          isApplicantCityCountryField &&
                          (reason === "blur" ||
                            value === null ||
                            value === undefined ||
                            value === "")
                        ) {
                          return;
                        }
                        if (
                          field.name.match(
                            /^basicCoApplicant\d+RelationWithStudent$/
                          )
                        ) {
                          const relationValue = value?.value || value;
                          const relationLabel = value?.label || value;
                          const relationValueFields = [
                            field.name.replace(
                              /RelationWithStudent$/,
                              "OtherRelationWithStudent"
                            ),
                            field.name.replace(
                              /RelationWithStudent$/,
                              "RelationValue"
                            ),
                          ];

                          form.setFieldValue(field.name, relationValue, false);
                          form.setFieldValue(
                            `${field.name}Name`,
                            relationLabel,
                            false
                          );
                          if (relationValue !== "OTHERS") {
                            relationValueFields.forEach((relationValueField) => {
                              form.setFieldValue(relationValueField, "", false);
                            });
                          }
                          if (relationValue) {
                            form.setFieldError(field.name, undefined);
                            form.setFieldTouched(field.name, true, false);
                          }

                          // Update Redux with RelationWithStudent value and name
                          const currentFormData = { ...formData };
                          currentFormData[field.name] = relationValue;
                          currentFormData[`${field.name}Name`] = relationLabel;
                          if (relationValue !== "OTHERS") {
                            relationValueFields.forEach((relationValueField) => {
                              currentFormData[relationValueField] = "";
                            });
                          }
                          dispatch(updateFormData(currentFormData));

                          handleFilledFieldsCount(field.name, relationValue);
                        }else if (
                          field.name.match(
                            /^basicCoApplicant\d+MaritalStatus$/
                          )
                        ) {
                          const maritalValue = value?.value || value;
                          const maritalLabel = value?.label || value;


                          // Set the field value to only the value. See the
                          // RelationWithStudent branch above for why
                          // shouldValidate is explicitly false here.
                          form.setFieldValue(field.name, maritalLabel, false);
                          form.setFieldValue(
                            `${field.name}Name`,
                            maritalLabel,
                            false
                          );
                          if (maritalLabel) {
                            form.setFieldError(field.name, undefined);
                            form.setFieldTouched(field.name, true, false);
                          }

                          // Update Redux with RelationWithStudent value and name
                          const currentFormData = { ...formData };
                          currentFormData[field.name] = maritalValue;
                          currentFormData[`${field.name}Name`] = maritalLabel;
                          dispatch(updateFormData(currentFormData));

                          handleFilledFieldsCount(field.name, maritalValue);
                        } else if (
                          field.name.match(
                            /^basicCoApplicant\d+Nationality$/
                          )
                        ) {
                          const nationalityValue = value?.value || value;
                          const nationalityLabel = value?.label || value;


                          // Set the field value to only the value. See the
                          // RelationWithStudent branch above for why
                          // shouldValidate is explicitly false here.
                          form.setFieldValue(field.name, nationalityLabel, false);
                          form.setFieldValue(
                            `${field.name}Name`,
                            nationalityLabel,
                            false
                          );
                          if (nationalityLabel) {
                            form.setFieldError(field.name, undefined);
                            form.setFieldTouched(field.name, true, false);
                          }

                          // Update Redux with RelationWithStudent value and name
                          const currentFormData = { ...formData };
                          currentFormData[field.name] = nationalityValue;
                          currentFormData[`${field.name}Name`] = nationalityLabel;
                          dispatch(updateFormData(currentFormData));

                          handleFilledFieldsCount(field.name, nationalityValue);
                        }else if (
                          field.name.match(
                            /^basicCoApplicant\d+CountryOfBirth$/
                          )
                        ) {
                          const countryOfBirthValue = value?.value || value;
                          const countryOfBirthLabel = value?.label || value;

                          form.setFieldValue(field.name, countryOfBirthValue, false);
                          form.setFieldValue(
                            `${field.name}Name`,
                            countryOfBirthLabel,
                            false
                          );
                          if (countryOfBirthValue) {
                            form.setFieldError(field.name, undefined);
                            form.setFieldTouched(field.name, true, false);
                          }

                          // Update Redux with RelationWithStudent value and name
                          const currentFormData = { ...formData };
                          currentFormData[field.name] = countryOfBirthValue;
                          currentFormData[`${field.name}Name`] = countryOfBirthLabel;
                          dispatch(updateFormData(currentFormData));

                          handleFilledFieldsCount(field.name, countryOfBirthValue);
                        }
                        else if (
                          field.name.match(
                            /^basicCoApplicant\d+CityOfBirth$/
                          )
                        ) {
                          const cityOfBirthValue = value?.value || value;
                          const cityOfBirthLabel = value?.label || value;

                          form.setFieldValue(field.name, cityOfBirthLabel, false);
                          form.setFieldValue(
                            `${field.name}Name`,
                            cityOfBirthLabel,
                            false
                          );
                          if (cityOfBirthLabel) {
                            form.setFieldError(field.name, undefined);
                            form.setFieldTouched(field.name, true, false);
                          }

                          // Update Redux with RelationWithStudent value and name
                          const currentFormData = { ...formData };
                          currentFormData[field.name] = cityOfBirthValue;
                          currentFormData[`${field.name}Name`] = cityOfBirthLabel;
                          dispatch(updateFormData(currentFormData));

                          handleFilledFieldsCount(field.name, cityOfBirthValue);
                        }
                        else if (field.name.toLowerCase().includes("designation")) {
                          // Extract value (code) from the selected option
                          const designationValue = value?.value || value;

                          // Set the field value to only the designation code
                          form.setFieldValue(field.name, designationValue);
                          handleFilledFieldsCount(field.name, designationValue);
                        } else {
                          form.setFieldTouched(field.name, true, false);
                          handleFilledFieldsCount(field.name, value);
                          handleDropdownChange(field.name, value, form, reason);
                          handleFilledFieldsCount(field.name, value);
                          form.validateField(field.name);
                        }

                        // Check and uncheck address checkbox if address fields change
                        if (
                          /^(permanent|current)(OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity|State|Country|City)$/.test(field.name) ||
                          /^addressCoApplicant\d+(permanent|current)(OwnershipStatus|YearsInCurrentAddress|YearsInCurrentCity|State|Country|City)$/.test(field.name)
                        ) {
                          setTimeout(() => {
                            checkAndUncheckAddressCheckbox();
                          }, 0);
                        }
                        if (value && Object.keys(value).length > 0) {
                          if (field.name === "country") {
                            form.setFieldValue("university", "");
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              universities: [],
                              institutes: [],
                              courses: [],
                            }));
                          }

                          if (field.name === "university") {
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              institutes: [],
                              courses: [],
                            }));
                          }

                          if (field.name === "institute") {
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              courses: [],
                            }));
                          }
                        }

                        // Clear dropdown options if value is cleared (cross button)
                        if (!value || value == null) {
                          if (
                            field.name === "courseCategory" ||
                            field.name.toLowerCase().includes("study") ||
                            field.name.toLowerCase().includes("admissionstatus")
                          ) {
                            form.setFieldValue("country", "");
                            form.setFieldValue("university", "");
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              countries: [],
                              universities: [],
                              institutes: [],
                              courses: [],
                            }));
                          } else if (field.name === "country") {
                            form.setFieldValue("university", "");
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              universities: [],
                              institutes: [],
                              courses: [],
                            }));
                          } else if (field.name === "university") {
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              institutes: [],
                              courses: [],
                            }));
                          } else if (field.name === "institute") {
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              courses: [],
                            }));
                          } else if (
                            field.name === "courseName" ||
                            field.name === "course"
                          ) {
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              courses: [],
                            }));
                          } else if (
                            field.name.match(
                              /^basicCoApplicant(\d+)RelationWithStudent$/
                            )
                          ) {
                            // Clear RelationWithStudent name field
                            form.setFieldValue(`${field.name}Name`, "");
                            const relationValueFields = [
                              field.name.replace(
                                /RelationWithStudent$/,
                                "OtherRelationWithStudent"
                              ),
                              field.name.replace(
                                /RelationWithStudent$/,
                                "RelationValue"
                              ),
                            ];
                            relationValueFields.forEach((relationValueField) => {
                              form.setFieldValue(relationValueField, "");
                            });
                            const currentFormData = { ...formData };
                            relationValueFields.forEach((relationValueField) => {
                              currentFormData[relationValueField] = "";
                            });
                            currentFormData[field.name] = "";
                            currentFormData[`${field.name}Name`] = "";
                            dispatch(updateFormData(currentFormData));
                          }
                        }
                      }}
                      onInputChange={(e: any, inputValue: any, reason: any) => {
                        // Call API when typing, but not on selection (reset) or if value already in options
                        if (
                          field.name === "university" &&
                          inputValue?.length >= 3 &&
                          reason !== "reset"
                        ) {
                          // Check if inputValue matches any existing option (means it's a selection)
                          const isExistingOption = dropdownData.universities?.some(
                            (opt: any) => opt.label === inputValue
                          );

                          if (!isExistingOption) {
                            setFormValues((prev) => ({
                              ...prev,
                              universityName: inputValue,
                            }));
                            // Prevent duplicate calls for same value
                            if (lastUniversityQueryRef.current !== inputValue) {
                              lastUniversityQueryRef.current = inputValue;
                              debouncedCall(field.name, inputValue);
                            }
                          }
                        } else if (
                          field.name === "institute" &&
                          inputValue?.length >= 3 &&
                          reason !== "reset"
                        ) {
                          // Check if inputValue matches any existing option (means it's a selection)
                          const isExistingOption = dropdownData.institutes?.some(
                            (opt: any) => opt.label === inputValue
                          );

                          if (!isExistingOption) {
                            setFormValues((prev) => ({
                              ...prev,
                              instituteName: inputValue,
                            }));
                            if (lastInstituteQueryRef.current !== inputValue) {
                              lastInstituteQueryRef.current = inputValue;
                              debouncedCall(field.name, inputValue);
                            }
                          }
                        } else if (
                          field.name === "courseName" &&
                          inputValue?.length >= 3 &&
                          reason !== "reset"
                        ) {
                          // Check if inputValue matches any existing option (means it's a selection)
                          const isExistingOption = dropdownData.courses?.some(
                            (opt: any) => opt.label === inputValue
                          );

                          if (!isExistingOption) {
                            setFormValues((prev) => ({
                              ...prev,
                              courseName: inputValue,
                            }));
                            if (lastCourseQueryRef.current !== inputValue) {
                              lastCourseQueryRef.current = inputValue;
                              debouncedCall(field.name, inputValue);
                            }
                          }
                        } else if (field.name === "salutation") {
                          setFormValues((prev) => ({
                            ...prev,
                            salutation: inputValue,
                          }));
                        } else if (
                          field.name === "currentPincode" &&
                          inputValue?.length == 6
                        ) {
                          setFormValues((prev) => ({
                            ...prev,
                            salutation: inputValue.label,
                          }));
                        }
                      }}
                      // isMandatory: non-mandatory on (0,1) when admissionStatus is Undecided for University/Institute/Course
                      isMandatory={
                        (() => {
                          const nameLower = field.name.toLowerCase();
                          const applyAdmissionUndecided =
                            activeHorizontalIndex === 0 &&
                            activeVerticalIndex === 1 &&
                            form?.values?.admissionStatus === "Undecided";
                          const isTargetField =
                            nameLower === "university" ||
                            nameLower === "institute" ||
                            nameLower === "coursename";
                          return field.required && !(applyAdmissionUndecided && isTargetField);
                        })()
                      }
                      loading={isBirthCityDropdownField ? birthCityLoading : isDropdownLoading(field)}
                      placeholder={
                        field.name.toLowerCase() === "university"
                          ? "Type 3 Letters of University Name"
                          : field.name.toLowerCase() === "institute"
                            ? "Type 3 Letters of Institute Name"
                            : field.name.toLowerCase() === "coursename"
                              ? "Type 3 Letters of Course Name"
                              : `Select ${field.label}`
                      }
                      noOptionText={
                        field.name.toLowerCase() === "university"
                          ? "Select Not In List and Enter the University Name"
                          : field.name.toLowerCase() === "institute"
                            ? "Select Not In List and Enter the Institute Name"
                            : field.name.toLowerCase() === "coursename"
                              ? "Select Not In List and Enter the Course Name"
                              : "No Options"
                      }
                      error={!!meta?.touched && !!meta?.error}
                      helperText={meta?.touched && meta?.error}
                      disabled={handleDisablePermanentPincodeBasedFields(field)}
                    />
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      case "date": {
        const isScoreExpectedField = /scoreExpectedOn/i.test(field.name);
        return (
          <Grid
            item
            xs={12}
            sm={
              (activeHorizontalIndex === 1 && activeVerticalIndex === 3) || (activeHorizontalIndex === 1 && activeVerticalIndex === 5) ||
               (activeHorizontalIndex === 3 && activeVerticalIndex === 1)
                ? 12
                : 6
            }
            key={field.id}
          >
            <Box>
              <Field name={field.name}>
                {({ field: f, meta, form }: any) => {
                  // Disable DOB for a co-applicant if their PAN is verified
                  let disableDate = false;
                  const coApplicantDobMatch = field.name.match(/^basicCoApplicant(\d+)dob$/);
                  if (coApplicantDobMatch) {
                    const idx = String(Number(coApplicantDobMatch[1]) - 1);
                    const reduxPanVerified = coApplicantVerification[idx]?.panVerified;
                    const lastPan = coApplicantVerification[idx]?.lastPanNumber;
                    const currentPanFieldName = `basicCoApplicant${Number(idx) + 1}PanNumber`;
                    const currentPanValue = formikRef.current?.values?.[currentPanFieldName];
                    const isPanCoVerified = formikRef.current?.values?.[`basicCoApplicant${Number(idx) + 1}IsPanVerified`];
                    // Ensure PAN is verified and matches the last verified PAN (if available)
                    const isPanVerifiedForCurrentPan = !!reduxPanVerified && (!lastPan || (currentPanValue && currentPanValue.toUpperCase() === lastPan.toUpperCase()));
                    disableDate = isPanCoVerified;
                  }

                  // Disable main applicant DOB if main PAN is verified
                  if (field.name === "dob" && isPanVerified) {
                    disableDate = true;
                  }

                  // Date range constraints
                  const isDisbursementDate = field.name === "loanDateOfDisbursement";
                  const dateMin = isDisbursementDate ? dayjs().add(1, "day").startOf("day") :isScoreExpectedField ? dayjs().startOf("day") : dayjs("1900-01-01");
                  const dateMax = isDisbursementDate ? undefined :isScoreExpectedField ? dayjs("9999-12-31") : dayjs();
 
                  const dateValue = useMemo(
                    () => (f.value ? dayjs(f.value) : null),
                    [f.value]
                  );
                  return (
                    <BasicDatePicker
                      label={field.label === "Language Score Expected On" ? "Score Expected On" : field.label}
                      required={field.required}
                      value={dateValue}
                      onChange={(date) => {
                        const formattedDate = date
                          ? dayjs(date).format("YYYY-MM-DD")
                          : "";

                        if (
                          isDisbursementDate &&
                          formattedDate &&
                          dayjs(formattedDate).isBefore(dayjs(), "day")
                        ) {
                          form.setFieldTouched(field.name, true, false);
                          form.setFieldError(
                            field.name,
                            "Past date is not allowed",
                          );
                          return;
                        }

                        if (
                          isDisbursementDate &&
                          form.errors?.[field.name] === "Past date is not allowed"
                        ) {
                          form.setFieldError(field.name, undefined);
                        }

                        handleFilledFieldsCount(field.name, formattedDate);

                        // prevent validation on each change
                        form.setFieldValue(field.name, formattedDate, false);
                        // Re-derive this field's error now rather than on the next
                        // unrelated change. Disbursement dates are skipped: their
                        // "Past date is not allowed"/invalid-date messages are set
                        // imperatively (here and in onError, which MUI fires after
                        // onChange) and aren't in the schema, so a revalidation
                        // pass would wipe them.
                        if (!isDisbursementDate) {
                          scheduleFormRevalidate();
                        }
                        // Clear stale required/type errors when a date is picked, so
                        // Continue doesn't stay disabled until an unrelated field blurs.
                        if (formattedDate) {
                          form.setFieldError(field.name, undefined);
                        }
                        const value = form.values[field.name];
                        dispatch(updateFormData({ [field.name]: formattedDate }));
                      }}
                      onBlur={() => {
                        // dispatch only once on blur (much faster)
                        const value = form.values[field.name];
                        dispatch(updateFormData({ [field.name]: value }));
                      }}
                      onError={(reason) => {
                        if (!isDisbursementDate) return;

                        if (reason === "minDate") {
                          form.setFieldTouched(field.name, true, false);
                          form.setFieldError(
                            field.name,
                            "Past date is not allowed",
                          );
                          return;
                        }

                        if (reason === "invalidDate") {
                          form.setFieldTouched(field.name, true, false);
                          form.setFieldError(
                            field.name,
                            "Enter a valid date",
                          );
                          return;
                        }

                        if (
                          !reason &&
                          [
                            "Past date is not allowed",
                            "Enter a valid date",
                          ].includes(String(form.errors?.[field.name] || ""))
                        ) {
                          form.setFieldError(field.name, undefined);
                        }
                      }}
                      error={!!meta.touched && !!meta.error}
                      helperText={meta.touched && meta.error}
                      width="100%"
                      minDate={dateMin}
                      maxDate={dateMax}
                      readOnly={isScoreExpectedField}
                      disabled={disableDate}
                    />
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      }
      case "hidden":
        return (
          <Field name={field.name}>
            {({ field: f }: any) => (
              <input
                type="hidden"
                name={f.name}
                autoComplete="new-password"
                value={f.value || ""}
                onChange={f.onChange}
                onBlur={f.onBlur}
              />
            )}
          </Field>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (formData.pan) {
      if (formData.pan == "yes" || formData.pan == "no") {
        dispatch(setHasPan(formData?.pan));
        if (formData.pan == "no") {
          setPanNumberValue("");
          dispatch(setPanNumber(""));
          dispatch(setLastPanNumber(""));
          dispatch(setIsPanVerified(false));
        }
      } else if (/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData?.pan?.toUpperCase())) {
        dispatch(setHasPan("yes"));
        dispatch(setPanNumber(formData?.pan?.toUpperCase()));
        dispatch(setAadhaarMandatory(formData?.isPanVerified));
      }
    } else if (/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.pan?.toUpperCase())) {
      // If PAN is a valid PAN number, treat as 'yes' and set PAN number
      dispatch(setHasPan("yes"));
      dispatch(setPanNumber(formData.pan?.toUpperCase()));
      setPanNumberValue(formData.pan?.toUpperCase());
      dispatch(setIsPanVerified(isLoadTesting ? true : formData.isPanVerified));
      dispatch(setShowAadhaar(formData.isAadhaarVerified));
      dispatch(setAadhaarMandatory(formData.isAadhaarVerified));

      if (formData.aadhaar) {
        formikRef?.current?.setFieldValue("aadhaar", formData.aadhaar);
        dispatch(setAadhaarApplicationNo(formData.aadhaar));
      }
      // Handle per-coapplicant Aadhaar application numbers if present in formData
      Object.keys(formData).forEach((key) => {
        const aadhaarMatch = key.match(/^basicCoApplicant(\d+)AadhaarNumber$/);
        if (aadhaarMatch && formData[key]) {
          const coAppKey = aadhaarMatch[1];
          dispatch(
            setAadhaarApplicationNoCoApplicant({
              coAppKey,
              applicationNo: formData[key],
            })
          );
        }
        // Handle per-coapplicant isDocumentVerifiedCoApplicant if present in formData
        const verifiedMatch = key.match(
          /^basicCoApplicant(\d+)AadhaarVerified$/
        );
        if (verifiedMatch && formData[key] !== undefined) {
          const coAppKey = verifiedMatch[1];
          dispatch(
            setIsDocumentVerifiedCoApplicant({
              coAppKey,
              isVerified: isLoadTesting ? true : Boolean(formData[key]),
            })
          );
        }
      });
    }

    // aadhaar key is removed from getdata api so using isAadhaarVerified to check aadhaar verification
    if (formData.aadhaar===true || formData.isAadhaarVerified===true || formData.aadhaar==="true" || formData.isAadhaarVerified==="true") {
      dispatch(setIsDocumentVerified(true));
    }
    if (hasPan === "no") {
      dispatch(setAadhaarMandatory(true));
    }
  }, [formData, hasPan]);

  const [panNumberValue, setPanNumberValue] = useState("");
  const [isPanLoading, setIsPanLoading] = useState(false);

  useEffect(() => {
    const getApplicationNo = async () => {
      // For main applicant
      const applicationNo = localStorage.getItem("applicationNo");
      if (applicationNo) {
        dispatch(setAadhaarApplicationNo(applicationNo));
      }

      // For co-applicants: look for keys like "applicationNo_CoApplicant1", "applicationNo_CoApplicant2", etc.
      Object.keys(localStorage).forEach((key) => {
        const match = key.match(/^applicationNo_CoApplicant(\d+)$/);
        if (match) {
          const coAppKey = match[1];
          const coAppApplicationNo = localStorage.getItem(key);
          if (coAppApplicationNo) {
            dispatch(
              setAadhaarApplicationNoCoApplicant({
                coAppKey,
                applicationNo: coAppApplicationNo,
              })
            );
          }
        }
      });
    };
    getApplicationNo();
  }, [formikRef]);

  useEffect(() => {
    if (panNumber) {
      setPanNumberValue(panNumber);
    }
  }, [panNumber]);

  const isReinitStep =
    activeHorizontalIndex === 1 &&
    (activeVerticalIndex === 0 || activeVerticalIndex === 1);
  const preservedTouchedRef = useRef<Record<string, any>>({});

  useEffect(() => {
    const currentTouched = formikRef.current?.touched;
    if (currentTouched && Object.keys(currentTouched).length > 0) {
      preservedTouchedRef.current = currentTouched;
    }
  });

  useEffect(() => {
    if (!isReinitStep) return;

    const restoreTimer = setTimeout(() => {
      const formik = formikRef.current;
      const preserved = preservedTouchedRef.current;
      if (!formik || Object.keys(preserved).length === 0) return;
      // Anything left in `touched` means no reset happened — nothing to restore.
      if (Object.keys(formik.touched || {}).length > 0) return;
      formik.setTouched(preserved, false);
      formik.validateForm(formik.values);
    }, 0);
    return () => clearTimeout(restoreTimer);
  }, [formData, isReinitStep]);

  useEffect(() => {
    // Drop the snapshot too, otherwise the restore above would put back exactly
    // the flags this clear is meant to remove.
    preservedTouchedRef.current = {};
    formikRef.current?.setTouched({}, false);
  }, [activeHorizontalIndex, activeVerticalIndex]);

  const getFieldErrorMessage = (
    fieldName: string,
    touched?: Record<string, any>,
    errors?: Record<string, any>
  ): string | undefined =>
    touched?.[fieldName] && typeof errors?.[fieldName] === "string"
      ? errors[fieldName]
      : undefined;

  // PAN and Aadhaar related fields
  const renderPanAadhaarFields = (
    values: any,
    shouldDisableFields: boolean,
    setFieldValue: any,
    touched?: Record<string, any>,
    errors?: Record<string, any>
  ) => (
    <>
      <Grid container className="inner-form-box" ml={2} mt={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
            <img src={idIcon} alt="icon" style={{ width: 20, height: 20 }} />

            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                color: "#4B465C",
              }}
            >
              Verify your PAN now to speed up the process
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          {!isXsOrSm ? (
            <label className="text-lable">Do you have PAN? <span style={{ color: "red" }}>*</span></label>
          ) : (
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                color: "#4B465C",
                mt: 2,
              }}
            >
              Do you have PAN? <span style={{ color: "red" }}>*</span>
            </Typography>
          )}

          <RadioGroup
            row
            name="has_pan"
            value={hasPan}
            onChange={(e) => {
              // Preserve dob value in Redux formData when toggling PAN radio
              const dobValue = values?.dob;
              const motherFirstName = values?.motherFirstName;
              const fatherFirstName = values?.fatherFirstName;
              const motherLastName = values?.motherLastName;
              const fatherLastName = values?.fatherLastName;
              const gender = values?.gender;
              const aadhaar = values?.aadhaar;
              const firstName = values?.firstName;
              const lastName = values?.lastName;

              dispatch(setHasPan(e.target.value));
              dispatch(
                updateFormData({
                  pan: e.target.value,
                  dob: dobValue,
                  motherFirstName,
                  fatherFirstName,
                  motherLastName,
                  fatherLastName,
                  gender,
                  aadhaar,
                  firstName,
                  lastName,
                })
              );
              if (e.target.value === "no") {
                dispatch(setLastPanNumber(panNumber)); // Save current PAN
                setPanNumberValue("");
                dispatch(setPanNumber(""));
                dispatch(setIsPanVerified(false));
                setFieldValue?.("pan", "");
                setFieldValue?.("isPanVerified", false);
                dispatch(updateFormData({ pan: "no", isPanVerified: false }));
                dispatch(setAadhaarMandatory(true));
                dispatch(setShowAadhaar(true));
              } else {
                setPanNumberValue("");
                dispatch(setPanNumber(""));
                dispatch(setLastPanNumber(""));
                dispatch(setIsPanVerified(false));
                setFieldValue?.("pan", "");
                setFieldValue?.("isPanVerified", false);
                dispatch(updateFormData({ pan: "yes", isPanVerified: false }));

                // TODO: Need to replace this urlParams with actual verification from backend
                if (!urlParams.get("document_verified")) {
                  dispatch(setAadhaarMandatory(false));
                  dispatch(setShowAadhaar(false));
                }
              }

              // setting empty data on radio button changes
              dispatch(
                setVerificationMessage({
                  index: "",
                  applicantType: "",
                  field: "",
                  status: "",
                  message: "",
                })
              );
            }}
            sx={{ flexDirection: "row" }}
          >
            <FormControlLabel
              value="yes"
              control={<RadioButton />}
              label="Yes"
              classes={{ label: "text-lable" }}
            // disabled={true}
            />
            <FormControlLabel
              value="no"
              control={<RadioButton />}
              label="No"
              classes={{ label: "text-lable" }}
              disabled={isPanVerified}
            />
          </RadioGroup>
        </Grid>

        {hasPan === "yes" && (
          <>
            <Grid item xs={12} sm={8} md={8}>
              <FormGrid
                fields={[
                  {
                    label: "PAN Number",
                    component: (
                      <InputField
                        fullWidth
                        placeholder=""
                        value={panNumberValue?.toUpperCase()}
                        // disabled={isApiLoading || isPanVerified}
                        inputProps={{ maxLength: 10 }}
                        autoComplete="new-password"
                        onKeyDown={(e) => {
                          // Block leading space: allow spaces only after first character
                          if (e.key === " ") {
                            const target = e.target as HTMLInputElement;
                            const start = target.selectionStart ?? 0;
                            if (start === 0) {
                              e.preventDefault();
                            }
                          }
                        }}
                        onChange={(e) => {
                          let newPan = e.target.value?.toUpperCase();
                          // Preserve dob value in Redux formData when toggling PAN radio
                          const dobValue = values?.dob;
                          if (newPan.length > 10) {
                            newPan = newPan.slice(0, 10);
                          }
                          setPanNumberValue(newPan);
                          dispatch(setPanNumber(newPan));
                          setFieldValue && setFieldValue("pan", newPan);
                          // Mark as touched and force validation on every change for immediate error display
                          if (formikRef.current?.setFieldTouched) {
                            formikRef.current.setFieldTouched(
                              "pan",
                              true,
                              false
                            );
                          }
                          // Use setTimeout to ensure Formik state is updated before validation
                          if (formikRef.current?.validateField) {
                            setTimeout(() => {
                              formikRef.current?.validateField("pan");
                            }, 0);
                          }
                          // Always run filled fields/verification logic for any 10-char input
                          handleFilledFieldsCount("pan", newPan);
                          if (newPan === "") {
                            dispatch(setIsPanVerified(false));
                          } else {
                            if (newPan === reduxLastPanNumber) {
                              dispatch(setIsPanVerified(true));
                            } else {
                              dispatch(setIsPanVerified(false));
                            }
                          }

                          // setting empty data on input value changes
                          dispatch(
                            setVerificationMessage({
                              index: "",
                              applicantType: "",
                              field: "",
                              status: "",
                              message: "",
                            })
                          );
                        }}
                        error={
                          (verificationMessage?.field === "pan" &&
                            verificationMessage?.status === "error" &&
                            !!verificationMessage?.message) ||
                          !!getFieldErrorMessage("pan", touched, errors)
                        }
                        variant="outlined"
                        InputProps={{
                          readOnly: isApiLoading || isPanVerified,
                          style: { textTransform: "uppercase" },
                          endAdornment: (
                            <Button
                              sx={{
                                backgroundColor: isPanVerified ? "transparent" : "#FEC10D",
                                color: isPanVerified ? "#28C76F" : "#000000",
                                "&:hover": {
                                  backgroundColor: isPanVerified ? "transparent" : "#FEC10D",
                                  color: isPanVerified ? "#28C76F" : "#000000",
                                },
                                "&.Mui-disabled": {
                                  backgroundColor: isPanVerified ? "transparent" : "#FEC10D",
                                  color: isPanVerified ? "#28C76F" : "#000000",
                                  WebkitTextFillColor: isPanVerified ? "#28C76F" : "#000000",
                                  opacity: 1,
                                },
                                "& img": {
                                  opacity: 1,
                                  filter: "brightness(1)",
                                },
                                textTransform: "none",
                                fontSize: isPanVerified ? "16px" : "10px",
                                fontWeight: isPanVerified ? 400 : 700,
                                px: "15px",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                boxShadow: "none",
                                height: '100%',
                                mr: 0.5,
                              }}
                              onClick={isApiLoading || isPanVerified ? undefined : async () => {
                                try {
                                  setIsPanLoading(true);
                                  if (!values.dob) {
                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "Please enter your Date of Birth before verifying your PAN.",
                                      })
                                    );
                                    return;
                                  }
                                  if (!String(panNumberValue || "").trim()) {
                                    dispatch(
                                      setVerificationMessage({
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "Please enter your PAN to proceed with verification.",
                                      })
                                    );
                                    return;
                                  }
                                  if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(String(panNumberValue).trim().toUpperCase())) {
                                    dispatch(
                                      setVerificationMessage({
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "Please enter a valid 10-digit PAN number.",
                                      })
                                    );
                                    return;
                                  }


                                  const piiPublicKey =
                                    await fetchSanitizedPiiPublicKey();
                                  if (!piiPublicKey) return;

                                  const payload = await encryptData(
                                    {
                                      panNumber: panNumberValue,
                                      fullName: `${values.firstName || ""} ${values.lastName || ""
                                        }`.trim(),
                                      dob: values.dob
                                        ? new Date(
                                          values.dob
                                        ).toLocaleDateString("en-GB")
                                        : "",
                                      trackingId: trackingId,
                                      applicantType: "Applicant",
                                    },
                                    ["panNumber"],
                                    piiPublicKey
                                  );

                                  const resp =
                                    await applicantDetailsServices.verifyPan(payload);
                                  if (
                                    resp.status === 200 &&
                                    resp.data?.data?.dateOfBirth === "invalid" &&
                                    values.dob
                                  ) {

                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them.",
                                      })
                                    );
                                  } else if (
                                    resp.status === 200 &&
                                    resp.data?.data?.dateOfBirth.toLowerCase() === "invalid" &&
                                    resp.data?.data?.panStatus.toLowerCase() === "invalid"
                                  ) {
                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them.",
                                      })
                                    );
                                  } else if (resp.status === 200) {
                                    const isAadhaarSeeded =
                                      String(
                                        resp?.data?.data
                                          ?.aadhaarSeedingStatus || ""
                                      ).toLowerCase() === "y";
                                    dispatch(
                                      updateFormData({
                                        pan: panNumber,
                                        dob: values.dob,
                                      })
                                    );
                                    dispatch(
                                      setAadhaarSeedingStatus(isAadhaarSeeded)
                                    );
                                    setPanNumberValue(panNumber);
                                    setFieldValue("pan", panNumberValue);
                                    setFieldValue("isPanVerified", true, false);
                                    formikRef.current?.setFieldError(
                                      "pan",
                                      undefined
                                    );
                                    scheduleFormRevalidate();
                                    dispatch(setPanNumber(panNumberValue));
                                    dispatch(setIsPanVerified(true));
                                    dispatch(setLastPanNumber(panNumberValue));
                                    dispatch(
                                      setAadhaarMandatory(
                                        resp.data.data.adharMandatory
                                      )
                                    );
                                    dispatch(
                                      setShowAadhaar(
                                        resp.data.data.adharMandatory
                                      )
                                    );

                                    trackCustomerJourneyEvent(
                                      `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                      decrypt(userProfile?.id) ?? "",
                                      trackingId,
                                      {
                                        label: `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                        category: `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                        action: `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                        page: "ProvisionalOff_Student Details_PAN Verification",
                                      }
                                    );

                                    if(activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
                                      const obj = {...formData,...values };
                                      if(formData?.pan?.length < 10) {
                                        obj.pan = panNumberValue;
                                      }
                                      callCreateApi(obj, fields, trackingId, templateId, isAadhaarSeeded || false, {}, "PAN")
                                    }

                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "success",
                                        message:
                                          "Yay! Your PAN has been verified successfully.",
                                      })
                                    );

                                    // Add this line:
                                    handleFilledFieldsCount("pan", panNumber);
                                  } else if (resp.status === 400) {
                                    dispatch(
                                      setVerificationMessage({
                                        index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message:
                                          "Uh-oh! We are experiencing some technical issues fetching PAN details. Please try again later.",
                                      })
                                    );
                                  } else {
                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message:
                                          "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them.",
                                      })
                                    );
                                  }
                                } catch (err: any) {
                                  dispatch(
                                    setVerificationMessage({
                                      // index: "",
                                      applicantType: "applicant",
                                      field: "pan",
                                      status: "error",
                                      message: err?.response?.data?.errors?.[0]?.property === "dob" ?
                                        "We couldn't verify your PAN with the provided Date of Birth. Please verify your details and re-enter them."
                                        : err?.response?.data?.message,
                                    })
                                  );
                                } finally {
                                  setIsPanLoading(false);
                                }
                              }}
                              disabled={isPanLoading || isPanVerified}
                            >
                              {isPanLoading
                                ? <CircularProgress size={16} />
                                : isPanVerified ? (
                                  <>
                                    <img
                                      src={greenCheckVerified}
                                      alt="Verified"
                                      style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                    <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                                  </>
                                ) : (
                                  <>
                                    <Typography variant="inherit">Verify</Typography>
                                    <img
                                      src={arrowRightVerify}
                                      alt="Verified"
                                      style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                  </>
                                )
                              }
                            </Button>
                          ),
                        }}
                      />
                    ),
                  },
                ]}
              />
            </Grid>

            {/* displaying PAN activity related messages */}
            <Grid item xs={12} mt={1}>
              {verificationMessage?.message &&
                verificationMessage?.field === "pan" && (
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color:
                        verificationMessage?.status === "success"
                          ? "success.main"
                          : "error.main",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    {verificationMessage?.message}
                  </Typography>
                )}
            </Grid>
          </>
        )}
        {(() => {
          let panError = getFieldErrorMessage("pan", touched, errors);
          // A PAN verify message is already shown above; avoid stacking a second message
          if (
            verificationMessage?.field === "pan" &&
            verificationMessage?.message
          ) {
            return null;
          }
          // "Yes" is selected but PAN is blank: the schema can't see the radio, so remap its message
          if (
            hasPan === "yes" &&
            panError === "Please select whether you have a PAN card."
          ) {
            panError = "Please enter your PAN to proceed with verification.";
          }
          return panError ? (
            <Grid item xs={12} mt={1}>
              <FormHelperText
                error
                sx={{ ml: 0, fontSize: "12px", fontWeight: 500 }}
              >
                {panError}
              </FormHelperText>
            </Grid>
          ) : null;
        })()}
      </Grid>

      {/* Aadhaar Section */}
      {(adharMandatory || showAadhaar) && (
        <Grid container className="inner-form-box" ml={2} mt={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <img src={idIcon} alt="icon" style={{ width: 20, height: 20 }} />

              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#4B465C",
                }}
              >
                Verify Aadhaar Number
              </Typography>
            </Box>

            <label className="text-lable" style={{ marginBottom: "10px" }}>
              Verify your Aadhaar through Digilocker to keep your application
              going smoothly
            </label>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            {isAadharLoading ? (
              <Skeleton
                variant="rectangular"
                width={120}
                height={40}
                sx={{ borderRadius: 2, mb: 1 }}
              />
            ) : (
              <IconButton
                sx={{
                  backgroundColor: isDocumentVerified ? "#33c2c4" : undefined,
                  color: isDocumentVerified ? "#33c2c4" : "#000",
                  border: isDocumentVerified ? "1px solid #33c2c4" : "",
                  "&.Mui-disabled": {
                    backgroundColor: "white !important",
                    color: isDocumentVerified ? "#33c2c4" : "#000",
                  },
                }}
                onClick={async () => {

                
                  setIsEaadhaarOnVerifyNow(true);
                  setIsAadharLoading(true);
                  // setting empty data on button click
                  dispatch(
                    setVerificationMessage({
                      index: "",
                      applicantType: "",
                      field: "",
                      status: "",
                      message: "",
                    })
                  );
                  try {

                    const aadhaarPayload: any = {
                      applicantEmail: values.email,
                      applicantName: `${values.firstName || ""} ${values.lastName || ""
                        }`.trim(),
                      applicantMobile: values.phone_number,
                      redirectUrl: `${window.location.origin}/application/apply-now`,
                      landingPageNotRequired: true,
                      trackingId: trackingId,
                      typeOfApplicant: "Applicant",
                    };
                    if (hasPan === "yes") {
                      aadhaarPayload.applicantPan = panNumber;
                      // aadhaarPayload.uiStream = "DIGILOCKER_AADHAAR_PAN";
                    }
                    // if (hasPan === "no") {
                    //   aadhaarPayload.uiStream = "DIGILOCKER_AADHAAR";
                    // }

                    const resp =
                      await applicantDetailsServices.aadhaarApplication(
                        aadhaarPayload
                      );
                    if (
                      resp.data?.status === "success" &&
                      resp.data.data?.link
                    ) {



                      let link = resp.data.data.link;
                      const applicationNo = resp.data.data.applicationNo;
                      localStorage.setItem("applicationNo", applicationNo);
                      dispatch(setAadhaarApplicationNo(applicationNo));
                      dispatch(
                        setLastVerifiedPhoneNumber(lastVerifiedPhoneNumber)
                      );
                      dispatch(setLastVerifiedEmail(lastVerifiedEmail));
                      if (!/^https?:\/\//i.test(link)) {
                        link = "https://" + link;
                      }

                      await trackCustomerJourneyEventAndWait(
                        `${handleGAProvisionalOfferStatments}_STDUENTDET_AADHAARVERIF_PAGE5`,
                        decrypt(userProfile?.id) ?? "",
                        trackingId,
                        {
                          label: `${handleGAProvisionalOfferStatments}_STDUENTDET_AADHAARVERIF_PAGE5`,
                          category: `${handleGAProvisionalOfferStatments}_STDUENTDET_AADHAARVERIF_PAGE5`,
                          action: `${handleGAProvisionalOfferStatments}_STDUENTDET_AADHAARVERIF_PAGE5`,
                          page: "ProvisionalOff_Student Details_Aadhaar Verification",
                        },
                        500
                      );

                      window.location.replace(link);
                    } else {
                      dispatch(
                        setStatusPopup({
                          status: "info",
                          message: resp.data?.message,
                        })
                      );
                    }
                  } catch (err: any) {
                    dispatch(
                      setStatusPopup({
                        status: "error",
                        message: err?.response?.data?.message,
                      })
                    );
                  } finally {
                    setIsAadharLoading(false);
                  }
                }}
                disabled={isDocumentVerified}
              >
                {isDocumentVerified && (
                  <img src={VerifiedIcon} alt="arrow-narrow-right" />
                )}
                {`${isDocumentVerified ? "Verified" : "Verify Via Digilocker"}`}

                {!isDocumentVerified && (
                  <img src={RightBlackArrow} alt="right-arrow" />
                )}
              </IconButton>
            )}
          </Grid>

          {/* displaying Aadhar activity related messages */}
          <Grid item xs={12} mt={1}>
            {verificationMessage?.message &&
              verificationMessage?.field === "aadhar" && (
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 500,
                    color:
                      verificationMessage?.status === "success"
                        ? "success.main"
                        : "error.main",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  {verificationMessage?.message}
                </Typography>
              )}
          </Grid>

          {getFieldErrorMessage("aadhaar", touched, errors) && (
            <Grid item xs={12} sm={12} md={12}>
              <FormHelperText error sx={{ ml: 0, mt: 1 }}>
                {getFieldErrorMessage("aadhaar", touched, errors)}
              </FormHelperText>
            </Grid>
          )}
        </Grid>
      )}
    </>
  );

  // Current Address fields
  const currFields = fields.filter(
    (f) => f.required && f.name?.toLowerCase().startsWith("current")
  );
  // Employment Address fields
  const employmentFields = fields.filter(
    (f) =>
      f.required &&
      f.name?.toLowerCase().includes("employment") &&
      !f.name?.toLowerCase().includes("employmentcompany")
  );

  // Company Address fields
  const companyFields = fields.filter(
    (f) =>
      f.required &&
      f.name?.toLowerCase().includes("employmentcompany") &&
      f.name !== "employmentCompanyName"
  );

  // Core and Language fields from Entrance Exam
  const coreFields = fields.filter((f) => f.name.startsWith("core"));
  const languageFields = fields.filter((f) => f.name.startsWith("language"));

  const otherFields = fields.filter(
    (f) =>
      f.required &&
      !f.name?.toLowerCase().startsWith("current") &&
      !f.name?.toLowerCase().includes("employmentcompany") &&
      f.name !== "employmentCompanyName"
  );

  const getFilledCount = (fieldSubset: any[], values: any) => {
    if (!Array.isArray(fieldSubset)) return 0;
    return fieldSubset.filter((field: any) => {
      if (!field?.name) return false;

      // Exclude checkboxes for step 1, form 1
      if (
        field.type === "checkbox" &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 0
      ) {
        return false;
      }

      const val = values?.[field.name];

      // Handle checkboxes separately
      if (field.type === "checkbox") {
        // Accept both boolean true and string 'true' as checked
        return val === true || val === "true";
      }

      // For arrays (like multi-select), check length
      if (Array.isArray(val)) {
        return val.length > 0;
      }

      // For normal text/number fields
      return val !== undefined && val !== null && val !== "";
    }).length;
  };

  const getFilledCountWithPanAadhaar = (fieldSubset: any[], values: any) => {
    let count = getFilledCount(fieldSubset, values);
    return count;
  };
  const fatherFullName=aadhaarVerifiedDetails?.careOf && aadhaarVerifiedDetails?.careOf?.split(" ");
  const fatherFirstName = fatherFullName ? fatherFullName[0] : formikRef?.current?.values?.fatherFirstName;
  const fatherLastName = fatherFullName ? fatherFullName[1] : formikRef?.current?.values?.fatherLastName;

  // Function to check and uncheck address checkbox
  const checkAndUncheckAddressCheckbox = useCallback(() => {
    const values = formikRef?.current?.values;
    if (!values) return;

    

    // Helper function to compare addresses
    const areAddressesDifferent = (prefix = '') => {
      const hasPermanentData = hasAddressData(prefix, 'permanent', values);
      const hasCurrentData = hasAddressData(prefix, 'current', values);
      if (!hasPermanentData || !hasCurrentData) {
        return false;
      }
      const permanentOwnershipStatus = normalizeValue(values[`${prefix}permanentOwnershipStatus`]);
      const permanentYearsInCurrentAddress = normalizeValue(values[`${prefix}permanentYearsInCurrentAddress`]);
      const permanentYearsInCurrentCity = normalizeValue(values[`${prefix}permanentYearsInCurrentCity`]);
      const permanentAddressLine1 = normalizeValue(values[`${prefix}permanentAddressLine1`]);
      const permanentAddressLine2 = normalizeValue(values[`${prefix}permanentAddressLine2`]);
      const permanentAddressLine3 = normalizeValue(values[`${prefix}permanentAddressLine3`]);
      const permanentPincode = normalizeValue(values[`${prefix}permanentPincode`]);
      const permanentCity = normalizeValue(values[`${prefix}permanentCity`]);
      const permanentState = normalizeValue(values[`${prefix}permanentState`]);
      const permanentCountry = normalizeValue(values[`${prefix}permanentCountry`]);

      const currentOwnershipStatus = normalizeValue(values[`${prefix}currentOwnershipStatus`]);
      const currentYearsInCurrentAddress = normalizeValue(values[`${prefix}currentYearsInCurrentAddress`]);
      const currentYearsInCurrentCity = normalizeValue(values[`${prefix}currentYearsInCurrentCity`]);
      const currentAddressLine1 = normalizeValue(values[`${prefix}currentAddressLine1`]);
      const currentAddressLine2 = normalizeValue(values[`${prefix}currentAddressLine2`]);
      const currentAddressLine3 = normalizeValue(values[`${prefix}currentAddressLine3`]);
      const currentPincode = normalizeValue(values[`${prefix}currentPincode`]);
      const currentCity = normalizeValue(values[`${prefix}currentCity`]);
      const currentState = normalizeValue(values[`${prefix}currentState`]);
      const currentCountry = normalizeValue(values[`${prefix}currentCountry`]);

      return (
        permanentOwnershipStatus !== currentOwnershipStatus ||
        permanentYearsInCurrentAddress !== currentYearsInCurrentAddress ||
        permanentYearsInCurrentCity !== currentYearsInCurrentCity ||
        permanentAddressLine1 !== currentAddressLine1 ||
        permanentAddressLine2 !== currentAddressLine2 ||
        permanentAddressLine3 !== currentAddressLine3 ||
        permanentPincode !== currentPincode ||
        permanentCity !== currentCity ||
        permanentState !== currentState ||
        permanentCountry !== currentCountry
      );
    };

    // Check for main applicant
    if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
      if (values.currentsameAsPermanent && areAddressesDifferent('')) {
        formikRef?.current?.setFieldValue('currentsameAsPermanent', false);
        setIsCurrentSameAsPermanent(false);
      }
      if (!areAddressesDifferent('')) {
        formikRef?.current?.setFieldValue('currentsameAsPermanent', true);
        setIsCurrentSameAsPermanent(true);
      }
    }

    // Check for co-applicants
    if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
      Object.keys(values).forEach((key) => {
        const coAppMatch = key.match(/^addressCoApplicant(\d+)currentsameAsPermanent$/);
        if (coAppMatch) {
          const coAppNum = coAppMatch[1];
          const prefix = `addressCoApplicant${coAppNum}`;
          const currentAddressKeys = Object.keys(values).filter(
            (addressKey) =>
              addressKey.startsWith(`${prefix}current`) &&
              !addressKey.endsWith("currentsameAsPermanent"),
          );
          const isCurrentAddressBlank = currentAddressKeys.every((addressKey) => {
            const currentValue = values[addressKey];
            return (
              currentValue === undefined ||
              currentValue === null ||
              currentValue === ""
            );
          });

          if (values[key] && areAddressesDifferent(prefix)) {
            if (isCurrentAddressBlank) {
              copyCoApplicantPermanentToCurrent(coAppNum);
            } else {
              formikRef?.current?.setFieldValue(key, false);
            }
          }
        }
      });
    }
  }, [activeHorizontalIndex, activeVerticalIndex]);

  useEffect(() => {
    if (
      activeHorizontalIndex === 1 &&
      (activeVerticalIndex === 0 || activeVerticalIndex === 1)
    ) {
      formikRef?.current?.setFieldValue(
        "permanentCountry",
        formikRef?.current?.values?.permanentCountry ||
        aadhaarVerifiedDetails?.country
      );
      formikRef?.current?.setFieldValue(
        "permanentPincode",
        formikRef?.current?.values?.permanentPincode ||
        aadhaarVerifiedDetails?.pincode
      );
      formikRef?.current?.setFieldValue(
        "permanentState",
        formikRef?.current?.values?.permanentState ||
        aadhaarVerifiedDetails?.state
      );

      const conCatAddress: string = [
        handleUnwanted(aadhaarVerifiedDetails?.house),
        handleUnwanted(aadhaarVerifiedDetails?.street),
        handleUnwanted(aadhaarVerifiedDetails?.landmark),
        handleUnwanted(aadhaarVerifiedDetails?.locality),
        //aadhaarVerifiedDetails?.vtc,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();

      let chunkSize: boolean = conCatAddress.length > 50; // Condition applied here

      // Check if user has manually entered any address data (from formik values OR from formData/Redux)
      const hasManualPermanentAddress = (
        (formikRef?.current?.values?.permanentAddressLine1 && formikRef?.current?.values?.permanentAddressLine1.trim() !== "") ||
        (formikRef?.current?.values?.permanentAddressLine2 && formikRef?.current?.values?.permanentAddressLine2.trim() !== "") ||
        (formikRef?.current?.values?.permanentAddressLine3 && formikRef?.current?.values?.permanentAddressLine3.trim() !== "") ||
        (formData?.permanentAddressLine1 && formData?.permanentAddressLine1.trim() !== "") ||
        (formData?.permanentAddressLine2 && formData?.permanentAddressLine2.trim() !== "") ||
        (formData?.permanentAddressLine3 && formData?.permanentAddressLine3.trim() !== "")
      );

      if (hasManualPermanentAddress) {
        // User has entered data, preserve it
        // Don't overwrite with Aadhaar data
      } else if (chunkSize) {
        const addressLines = splitAddressByWords(conCatAddress);
        const addr1: string = addressLines[0] || "";
        const addr2: string = addressLines[1] || "";
        const addr3: string = addressLines[2] || "";
        formikRef?.current?.setFieldValue("permanentAddressLine1", addr1);
        formikRef?.current?.setFieldValue("permanentAddressLine2", addr2);
        formikRef?.current?.setFieldValue("permanentAddressLine3", addr3);
      } else {

        formikRef?.current?.setFieldValue(
          "permanentAddressLine1",
          aadhaarVerifiedDetails?.house || ""
        );
        formikRef?.current?.setFieldValue(
          "permanentAddressLine2",
          `${aadhaarVerifiedDetails?.street || ""} ${aadhaarVerifiedDetails?.landmark || ""
            }`.trim()
        );
        formikRef?.current?.setFieldValue(
          "permanentAddressLine3",
          `${aadhaarVerifiedDetails?.locality || ""}`.trim()
        );
      }

      formikRef?.current?.setFieldValue(
        "permanentCity",
        formikRef?.current?.values?.permanentCity ||
        aadhaarVerifiedDetails?.district
      );

      formikRef?.current?.setFieldValue(
        "currentCountry",
        formikRef?.current?.values?.currentCountry ||
        aadhaarVerifiedDetails?.country
      );
      formikRef?.current?.setFieldValue(
        "currentPincode",
        formikRef?.current?.values?.currentPincode ||
        aadhaarVerifiedDetails?.pincode
      );
      formikRef?.current?.setFieldValue(
        "currentState",
        formikRef?.current?.values?.currentState ||
        aadhaarVerifiedDetails?.state
      );

      const conCatCurrentAddress: string = [
        handleUnwanted(aadhaarVerifiedDetails?.house),
        handleUnwanted(aadhaarVerifiedDetails?.street),
        handleUnwanted(aadhaarVerifiedDetails?.landmark),
        handleUnwanted(aadhaarVerifiedDetails?.locality),
        //aadhaarVerifiedDetails?.vtc,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();

      let chunkSize2: boolean = conCatCurrentAddress.length > 50; // Condition applied here

      // Check if user has manually entered any address data (from formik values OR from formData/Redux)
      const hasManualCurrentAddress = (
        (formikRef?.current?.values?.currentAddressLine1 && formikRef?.current?.values?.currentAddressLine1.trim() !== "") ||
        (formikRef?.current?.values?.currentAddressLine2 && formikRef?.current?.values?.currentAddressLine2.trim() !== "") ||
        (formikRef?.current?.values?.currentAddressLine3 && formikRef?.current?.values?.currentAddressLine3.trim() !== "") ||
        (formData?.currentAddressLine1 && formData?.currentAddressLine1.trim() !== "") ||
        (formData?.currentAddressLine2 && formData?.currentAddressLine2.trim() !== "") ||
        (formData?.currentAddressLine3 && formData?.currentAddressLine3.trim() !== "")
      );

      if (hasManualCurrentAddress) {
        // User has entered data, preserve it
        // Don't overwrite with Aadhaar data
      } else if (chunkSize2) {
        // const currentAddr1: string = conCatCurrentAddress.slice(0, 50);
        // const currentAddr2: string = conCatCurrentAddress.slice(50, 100);
        // const currentAddr3: string = conCatCurrentAddress.slice(100, 150);
        const addressLines = splitAddressByWords(conCatCurrentAddress);
        const currentAddr1: string = addressLines[0] || "";
        const currentAddr2: string = addressLines[1] || "";
        const currentAddr3: string = addressLines[2] || "";
        formikRef?.current?.setFieldValue(
          "currentAddressLine1",
          currentAddr1 || ""
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine2",
          currentAddr2 || ""
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine3",
          currentAddr3 || ""
        );
      } else {
        formikRef?.current?.setFieldValue(
          "currentAddressLine1",
          aadhaarVerifiedDetails?.house || ""
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine2",
          `${aadhaarVerifiedDetails?.street || ""} ${aadhaarVerifiedDetails?.landmark || ""
            }`.trim()
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine3",
          `${aadhaarVerifiedDetails?.locality || ""}`.trim()
        );
      }

      formikRef?.current?.setFieldValue(
        "currentCity",
        formikRef?.current?.values?.currentCity ||
        aadhaarVerifiedDetails?.district
      );

      const dobValue =
        formikRef?.current?.values?.dob ||
        (aadhaarVerifiedDetails?.dob
          ? aadhaarVerifiedDetails.dob.split("-")?.reverse()?.join("-")
          : "");

      formikRef?.current?.setFieldValue("dob", dobValue);
      const genderValue =
        formikRef?.current?.values?.gender ||
        (aadhaarVerifiedDetails?.gender === "M"
          ? "male"
          : aadhaarVerifiedDetails?.gender === "F"
            ? "female"
            : "");

      formikRef?.current?.setFieldValue("gender", genderValue);
      formikRef?.current?.setFieldValue("fatherFirstName", formikRef?.current?.values?.fatherFirstName || fatherFirstName);
      formikRef?.current?.setFieldValue("fatherLastName", formikRef?.current?.values?.fatherLastName || fatherLastName);
    }
  }, [
    formikRef,
    aadhaarVerifiedDetails,
    fatherFirstName,
    fatherLastName,
    activeHorizontalIndex,
    activeVerticalIndex,
    formikRef?.current?.values?.currentPincode
  ]);

  // Per-co-applicant: prepopulate address and personal fields from Aadhaar verification details
  useEffect(() => {
    if (!aadhaarVerifiedDetailsCoApplicant) return;
    Object.entries(aadhaarVerifiedDetailsCoApplicant).forEach(
      ([coAppKey, detailsRaw]) => {
        // coAppKey is like 'CoApplicant1', extract number
        const match = coAppKey.match(/CoApplicant(\d+)/);
        if (!match) return;
        const num = match[1];
        const details = detailsRaw as any;
        if (!details) return;
        // Address fields

        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentCountry`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentCountry`
          ] || details?.country
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentPincode`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentPincode`
          ] || details?.pincode
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentState`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentState`
          ] || details?.state
        );

        const conCatPermanentAddress: string = [
          handleUnwanted(details?.house),
          handleUnwanted(details?.street),
          handleUnwanted(details?.landmark),
          handleUnwanted(details?.locality),
          //details?.vtc,
        ]
          .filter(Boolean)
          .join(" ")
          .trim();

        let chunkSize: boolean = conCatPermanentAddress.length > 50; // Condition applied here
        if (chunkSize) {
           const addressLines = splitAddressByWords(conCatPermanentAddress);
          const permanentAddr1: string = addressLines[0] || "";
          const permanentAddr2: string = addressLines[1] || "";
          const permanentAddr3: string = addressLines[2] || "";
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine1`,
            permanentAddr1 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine2`,
            permanentAddr2 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine3`,
            permanentAddr3 || ""
          );
        } else {
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine1`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}permanentAddressLine1`
            ] || details?.house
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine2`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}permanentAddressLine2`
            ] || `${details?.street} ${details?.landmark}`
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine3`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}permanentAddressLine3`
            ] || `${details?.locality}`
          );
        }

        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentCity`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentCity`
          ] || details?.district
        );

        // Current address fields
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentCountry`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}currentCountry`
          ] || details?.country
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentPincode`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}currentPincode`
          ] || details?.pincode
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentState`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}currentState`
          ] || details?.state
        );

        const conCatCurrentAddress: string = [
          handleUnwanted(details?.house),
          handleUnwanted(details?.street),
          handleUnwanted(details?.landmark),
          handleUnwanted(details?.locality),
          //details?.vtc,
        ]
          .filter(Boolean)
          .join(" ")
          .trim();

        let chunkSize2: boolean = conCatCurrentAddress.length > 50; // Condition applied here

        if (chunkSize2) {
          const addressLines = splitAddressByWords(conCatCurrentAddress);
          const currentAddr1: string = addressLines[0] || "";
          const currentAddr2: string = addressLines[1] || "";
          const currentAddr3: string = addressLines[2] || "";
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine1`,
            currentAddr1 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine2`,
            currentAddr2 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine3`,
            currentAddr3 || ""
          );
        } else {
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine1`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}currentAddressLine1`
            ] || details?.house
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine2`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}currentAddressLine2`
            ] || `${details?.street} ${details?.landmark}`
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine3`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}currentAddressLine3`
            ] || `${details?.locality}`
          );
        }

        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentCity`,
          formikRef?.current?.values?.[`addressCoApplicant${num}currentCity`] ||
          details?.district
        );

        // DOB and gender
        const dobValue =
          formikRef?.current?.values?.[`basicCoApplicant${num}dob`] ||
          (details?.dob ? details.dob.split("-").reverse().join("-") : "");
        formikRef?.current?.setFieldValue(
          `basicCoApplicant${num}dob`,
          dobValue
        );
        const genderValue =
          formikRef?.current?.values?.[`basicCoApplicant${num}Gender`] ||
          formData?.[`basicCoApplicant${num}Gender`] ||
          (details?.gender === "M"
            ? "male"
            : details?.gender === "F"
              ? "female"
              : "");
        formikRef?.current?.setFieldValue(
          `basicCoApplicant${num}Gender`,
          genderValue
        );
        formikRef?.current?.setFieldValue(
          `basicCoApplicant${num}fatherName`,
          formikRef?.current?.values?.[`basicCoApplicant${num}fatherName`] ||
          removeSalutation(details?.careOf)
        );

        [
          "FirstName",
          "LastName",
          "PhoneNumber",
          "Email",
          "salutation",
          "MaritalStatus",
        ].forEach((suffix) => {
          const fieldName = `basicCoApplicant${num}${suffix}`;
          const existingValue = formikRef?.current?.values?.[fieldName];
          if (existingValue === undefined || existingValue === null || existingValue === "") {
            const restoredValue = formData?.[fieldName];
            if (restoredValue !== undefined && restoredValue !== null && restoredValue !== "") {
              formikRef?.current?.setFieldValue(fieldName, restoredValue);
            }
          }
        });
      }
    );
  }, [aadhaarVerifiedDetailsCoApplicant]);

  function getCoApplicantGroups(fields: any) {
    // Find all unique co-applicant prefixes (e.g. coApplicant1, coApplicant2, ...)
    const coApplicantRegex = /^coApplicant(\d+)/;
    const groups: any = {};

    fields.forEach((field: any) => {
      const match: any = field.name.match(coApplicantRegex);
      if (match) {
        const idx = match[1];
        if (!groups[idx]) groups[idx] = [];
        groups[idx].push(field);
      }
    });

    // Sort by index
    return Object.keys(groups)
      .sort((a, b) => Number(a) - Number(b))
      .map((idx) => ({
        label: `Co-Applicant ${idx}`,
        fields: groups[idx],
      }));
  }

  function areAllCoApplicantsVerified(values: any) {
    const groups = getCoApplicantGroups(fields);

    return groups.every((group) => {
      const coIdx: any = group.label.split(" ").pop();
      const reduxIdx = String(Number(coIdx) - 1); // zero-based index as string
      const verification = coApplicantVerification[reduxIdx];

      // Only check if co-applicant has a name (i.e., is filled)
      const nameField: any = group.fields.find((fld: any) =>
        fld.name.toLowerCase().endsWith("name")
      );
      const hasName = nameField && values[nameField.name];
      if (!hasName) return true; // skip empty co-applicant
      return (
        verification?.panVerified &&
        // verification?.emailVerified &&
        verification?.mobileVerified
      );
    });
  }

  const isEntranceExamContinueDisabled = (
    values: any,
    stepErrors: Record<string, any> = {}
  ) => {
    const coreExam = values.coreExamApplied;
    const languageExam = values.languageExamApplied;

    // If any scoreReceived is "No" and its corresponding scoreExpectedOn is empty, disable Continue
    const allScoreReceivedFields = fields.filter(
      (f) => /^(core|language)ScoreReceived(_\d+)?$/.test(f.name)
    );
    const hasMissingExpectedDate = allScoreReceivedFields.some((f) => {
      if (values[f.name] !== "No") return false;
      const suffix = f.name.match(/(_\d+)$/)?.[1] ?? "";
      const expectedOnField = f.name.startsWith("core")
        ? `coreScoreExpectedOn${suffix}`
        : `languageScoreExpectedOn${suffix}`;
      return !values[expectedOnField];
    });
    if (hasMissingExpectedDate) return true;

    if (!coreExam || !languageExam) {
      return true;
    }

    // Both "No"
    if (coreExam === "No" && languageExam === "No") {
      return !coreExam || !languageExam;
    }
    const filteredOtherFields = otherFields.filter((f) => {
      if (f.name.startsWith("core") && f.name !== "coreExamApplied") {
        if (coreExam !== "Yes") {
          return false;
        }
      }

      if (f.name.startsWith("language") && f.name !== "languageExamApplied") {
        if (languageExam !== "Yes") {
          return false;
        }
      }

      // For core
      if (
        /^coreExamScore(_\d+)?$/.test(f.name) ||
        /^coreTotalMarks(_\d+)?$/.test(f.name)
      ) {
        // Find corresponding coreScoreReceived field (dynamic)
        const match = f.name.match(
          /^coreExamScore_(\d+)$|^coreTotalMarks_(\d+)$/
        );
        let scoreReceivedKey = "coreScoreReceived";
        if (match) {
          const idx = match[1] || match[2];
          scoreReceivedKey = `coreScoreReceived_${idx}`;
        }
        if (values[scoreReceivedKey] === "No") {
          return false;
        }
        if (
          /^coreExamID(_\d+)?$/.test(f.name) ||
          /^coreExamId(_\d+)?$/.test(f.name)
        ) {
          return false;
        }
      }
      // For language
      if (
        /^languageExamScore(_\d+)?$/.test(f.name) ||
        /^languageTotalMarks(_\d+)?$/.test(f.name)
      ) {
        // Find corresponding languageScoreReceived field (dynamic)
        const match = f.name.match(
          /^languageExamScore_(\d+)$|^languageTotalMarks_(\d+)$/
        );
        let scoreReceivedKey = "languageScoreReceived";
        if (match) {
          const idx = match[1] || match[2];
          scoreReceivedKey = `languageScoreReceived_${idx}`;
        }
        if (values[scoreReceivedKey] === "No") {
          return false;
        }
        if (
          /^languageExamID(_\d+)?$/.test(f.name) ||
          /^languageExamId(_\d+)?$/.test(f.name)
        ) {
          return false;
        }
      }
      return true;
    });
    const relevantFieldNames = new Set<string>([
      "coreExamApplied",
      "languageExamApplied",
      ...filteredOtherFields.map((f) => f.name),
    ]);

    const hasRelevantErrors = Object.keys(stepErrors).some((fieldName) =>
      relevantFieldNames.has(fieldName)
    );
    if (hasRelevantErrors) {
      return true;
    }

    return (
      getFilledCountWithPanAadhaar(filteredOtherFields, values) !==
      filteredOtherFields.length
    );
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      const inputs =
        document.querySelectorAll<HTMLInputElement>("input");

      inputs.forEach((el) => {
        const name = el.getAttribute("name");

        if (!name) return;

        // disable browser autofill
        el.autocomplete = "off";

        el.setAttribute("autocomplete", "new-password");
        el.setAttribute("autocorrect", "off");
        el.setAttribute("autocapitalize", "off");
        el.setAttribute("spellcheck", "false");

        // readonly trick
        el.readOnly = true;

        const removeReadonly = () => {
          el.readOnly = false;
        };

        el.addEventListener("focus", removeReadonly, {
          once: true,
        });
      });
    }, 300);

    return () => clearTimeout(timeout);
  }, [
    activeHorizontalIndex,
    activeVerticalIndex,
  ]);
  
  return (
    <Box sx={{ width: "100%" }}>
      {activeVerticalIndex === 3 && activeHorizontalIndex == 0 ? (
        isPartnerPreEligibilityFlow ? (
          <StaticEligibilitySuccess
            firstName={formData.firstName}
            onNext={() => dispatch(setActiveHorizontalIndex(1))}
          />
        ) : !isCheckingOffer ? (
          <EligibilityConfirmation
            firstName={formData.firstName}
            provisionalOffer={breData}
            onNext={() => dispatch(nextVerticalStep())}
          />
        ) : null
      ) : (
        <>
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            validate={(vals) =>
              activeHorizontalIndex === 3 && activeVerticalIndex === 3
                ? getReferenceCollateralValidationErrors(fields, vals)
                : {}
            }
            onSubmit={handleSubmit}
            enableReinitialize={
              activeHorizontalIndex === 1 &&
              (activeVerticalIndex === 0 || activeVerticalIndex === 1)
            }
            validateOnChange={true}
            validateOnBlur={true}
          >
            {({
              isSubmitting,
              errors,
              touched,
              values,
              setFieldValue,
              validateForm,
              submitForm,
              ...otherFormikProps
            }) => {
              // Log Formik errors for debugging
              if (Object.keys(errors).length > 0) {
                console.error("[Formik Errors]", errors);
              }
              const employmentAndCompanyFields = fields
                .filter(
                  (f) =>
                    f.required &&
                    (f.name?.toLowerCase().startsWith("employment") ||
                      f.name?.toLowerCase().startsWith("employmentcompany")) &&
                    f.name !== "employmentisEmployed"
                )
                .map((f) => f.name);

              const isExcludedField = (name: string) => {
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  values.employmentisEmployed === "No" &&
                  employmentAndCompanyFields.includes(name)
                ) {
                  return true;
                }
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  values.employmentisEmployed === "Yes" &&
                  !getAutocompleteOptionValue(values?.employmentType) &&
                  name !== "employmentType" &&
                  (name?.toLowerCase().startsWith("employment") ||
                    name?.toLowerCase().startsWith("employmentcompany"))
                ) {
                  return true;
                }
                // When employmentType is Others, skip validation for employmentYear
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  values?.employmentType === "Others" &&
                  (name === "employmentYear" || name === "employmentMonth")
                ) {
                  return true;
                }
                // Co-applicant employment: if a co-applicant selected "No", exclude all their
                // employment sub-fields (everything except the isEmployed radio itself)
                if (activeHorizontalIndex === 3 && activeVerticalIndex === 1) {
                  const coAppEmpMatch = name.match(/^employmentCoApplicant(\d+)(.+)$/);
                  if (coAppEmpMatch) {
                    const coNum = coAppEmpMatch[1];
                    const suffix = coAppEmpMatch[2];
                    // Keep the isEmployed radio itself — never exclude it
                    if (suffix === "employmentisEmployed" || suffix === "isEmployed") {
                      return false;
                    }
                    const isEmployedKey =
                      fields.find((f: any) =>
                        new RegExp(`^employmentCoApplicant${coNum}(employmentisEmployed|isEmployed)$`).test(String(f?.name || ""))
                      )?.name || `employmentCoApplicant${coNum}employmentisEmployed`;
                    if (values?.[isEmployedKey] === "No") return true;
                  }
                }
                // Exclude University/Institute/Course validation errors on step (0,1) when admissionStatus is Undecided only if NOT in notInList (when "not in list" is selected, value is required)
                if (activeHorizontalIndex === 0 && activeVerticalIndex === 1) {
                  const applyAdmissionUndecided = values?.admissionStatus === "Undecided";
                  const uniExcluded = (name === "university") && applyAdmissionUndecided && !notInList?.includes("University Name");
                  const instExcluded = (name === "institute") && applyAdmissionUndecided && !notInList?.includes("Institute Name");
                  const courseExcluded = (name === "courseName") && applyAdmissionUndecided && !notInList?.includes("Course Name");
                  if (uniExcluded || instExcluded || courseExcluded) {
                    return true;
                  }
                }
                if (activeHorizontalIndex === 1 && activeVerticalIndex === 2) {
                  return ["coreExamApplied", "languageExamApplied"].includes(
                    name
                  );
                }
                // On the Entrance Exam step (1,4), the "Have you appeared..."
                // questions ARE required, so they must NOT be excluded there —
                // otherwise their validation errors never block Continue.
                if (activeHorizontalIndex === 1 && activeVerticalIndex === 4) {
                  return ["employmentisEmployed"].includes(name);
                }
                return [
                  "employmentisEmployed",
                  "coreExamApplied",
                  "languageExamApplied",
                ].includes(name);
              };

              const currentStepFieldNames = fields.map((f) => f.name);
              const currentStepErrors = Object.keys(errors).filter(
                (key) =>
                  currentStepFieldNames.includes(key) && !isExcludedField(key)
              );
              const coApplicantEvaluationFields =
                coApplicantEvaluationFieldsForEmploymentCheck;
              const coApplicantNums = coApplicantNumsForEmploymentCheck;
              const additionalCoApplicantCount = coApplicantNums.size;
              
              const areAllCoApplicantsSaved =
                additionalCoApplicantCount > 0 &&
                Array.from(coApplicantNums).every(
                  (num) => savedBasicCoApplicants?.[`CoApplicant${num}`] === true
                );
              const employmentFillStatusByCoApplicant =
                activeHorizontalIndex === 3 && activeVerticalIndex === 1
                  ? computeEmploymentFillStatusForCoApplicants(
                      values,
                      coApplicantEvaluationFields,
                      coApplicantNums,
                    )
                  : [];

              const areAllCoApplicantsEmploymentComplete =
                activeHorizontalIndex === 3 && activeVerticalIndex === 1
                  ? employmentFillStatusByCoApplicant.every(
                      ({ coAppKey, isEmploymentFilled }) =>
                        isEmploymentFilled &&
                        savedEmploymentCoApplicants?.[coAppKey] === true,
                    )
                  : true;
                 
              const applicantAdditionalRequiredFields = fields.filter(
                (f: any) => f?.required !== false,
              );
              const isApplicantAdditionalDetailsComplete =
                activeHorizontalIndex === 3 && activeVerticalIndex === 0
                  ? getFilledCountWithPanAadhaar(
                      applicantAdditionalRequiredFields,
                      values,
                    ) === applicantAdditionalRequiredFields.length &&
                    currentStepErrors.length === 0
                  : true;
              const referenceCollateralRequiredFields = fields.filter(
                (f: any) => f?.required !== false,
              );
              const isReferenceCollateralDetailsComplete =
                activeHorizontalIndex === 3 && activeVerticalIndex === 3
                  ? getFilledCountWithPanAadhaar(
                      referenceCollateralRequiredFields,
                      values,
                    ) === referenceCollateralRequiredFields.length &&
                    currentStepErrors.length === 0
                  : true;
              const isAdditionalSummaryComplete =
                activeHorizontalIndex === 3 && activeVerticalIndex === 4
                  ? tabsState.additionalSummaryDocumentsComplete &&
                    (tabsState.additionalSummaryActiveTab === 0 ||
                      tabsState.additionalSummaryConsentComplete)
                  : true;
              
              // ── Fund vs Expense balance check (step 3-2) ─────────────────
              const _feNorm = (name: any) =>
                String(name || "").toLowerCase().replace(/[^a-z0-9]/g, "");
              const _feStartsWith = (name: any, prefixes: string[]) => {
                const n = _feNorm(name);
                return prefixes.some((p) => n.startsWith(p) || n.startsWith(`ad${p}`));
              };
              const _feIncludes = (value: any, keywords: string[]) => {
                const n = _feNorm(value);
                return keywords.some((k) => n.includes(k));
              };
              const _feSortedFields = Array.isArray(fields) ? [...fields] : [];
              const _feExpenseFields = _feSortedFields.filter((f: any) => {
                const byPrefix = _feStartsWith(f?.name, ["expense", "expenses"]);
                const byText =
                  _feIncludes(f?.name, ["totalexpense", "expense"]) ||
                  _feIncludes(f?.label, ["totalexpense", "expense"]);
                return byPrefix || byText;
              });
              const _feFundFields = _feSortedFields.filter((f: any) =>
                _feStartsWith(f?.name, ["fund", "fundrequest", "funds"]),
              );
              const _feToNum = (raw: any): number => {
                if (raw === null || raw === undefined || raw === "") return 0;
                if (typeof raw === "number") return isNaN(raw) ? 0 : raw;
                const candidate =
                  typeof raw === "object" && raw !== null && "value" in raw
                    ? (raw as any).value
                    : raw;
                const normalized = String(candidate)
                  .replace(/,/g, "")
                  .replace(/[^0-9.-]/g, "")
                  .trim();
                if (!normalized) return 0;
                const parsed = parseFloat(normalized);
                return isNaN(parsed) ? 0 : parsed;
              };
              const _feComputeTotal = (sectionFields: any[], keywords: string[]): number => {
                const isExact = (val: any, kws: string[]) => {
                  const n = _feNorm(val);
                  return kws.some((k) => n === k || n.endsWith(k) || n.startsWith(k));
                };
                const directField = sectionFields.find(
                  (f: any) => isExact(f?.name, keywords) || isExact(f?.label, keywords),
                );
                const keys = sectionFields
                  .map((f: any) => f?.name)
                  .filter((n: string) => !!n && n !== directField?.name);
                const sum = keys.reduce((acc: number, key: string) => acc + _feToNum(values?.[key]), 0);
                if (sum > 0) return sum;
                if (directField?.name) {
                  const dv = _feToNum(values?.[directField.name]);
                  if (dv > 0) return dv;
                }
                return sum;
              };
             
              const _feTotalExpense = _feComputeTotal(_feExpenseFields, ["totalexpense", "expensetotal"]);
              const _feTotalFund = _feComputeTotal(_feFundFields, ["totalfund", "fundtotal"]);
               
              const isFundExpenseBalanced =
                activeHorizontalIndex === 3 && activeVerticalIndex === 2
                  ? _feTotalExpense === _feTotalFund
                  : true;
              // Remove errors for employment/company fields from Formik errors if "No" is selected
              if (
                activeHorizontalIndex === 1 &&
                activeVerticalIndex === 2 &&
                values.employmentisEmployed === "No"
              ) {
                employmentAndCompanyFields.forEach((field) => {
                  if (errors[field]) {
                    delete errors[field];
                  }
                });
              }
              
                                    
              // Remove errors for University/Institute/Course on step (0,1) when admissionStatus is Undecided only if NOT in notInList (when "not in list" is selected, show required value error)
              if (activeHorizontalIndex === 0 && activeVerticalIndex === 1) {
                // console.log(errors, values?.admissionStatus)
                const applyAdmissionUndecided = values?.admissionStatus === "Undecided";
                if (applyAdmissionUndecided) {
                  // if (errors["country"]) delete errors["country"];
                  if (!notInList?.includes("University Name") && errors["university"]) delete errors["university"];
                  if (!notInList?.includes("Institute Name") && errors["institute"]) delete errors["institute"];
                  if (!notInList?.includes("Course Name") && errors["courseName"]) delete errors["courseName"];
                }
              }
              return (
                <Form autoComplete="off">
                  {activeHorizontalIndex < 3 &&
                  <Box sx={{ mb: 2, mt: 2 }}>
                    <SectionHeader
                      icon={
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 40,
                            height: 40,
                            borderRadius: "8px",
                            bgcolor: "#e5feffff",
                          }}
                        >
                          <img
                            src={
                              activeHorizontalIndex === 0 // activeHorizontalIndex === 0
                                ? activeVerticalIndex === 0
                                  ? idIcon
                                  : activeVerticalIndex === 1
                                    ? booksIcon
                                    : loanIcon
                                : activeVerticalIndex === 0 // activeHorizontalIndex === 1
                                  ? idIcon
                                  : activeVerticalIndex === 1
                                    ? locationIcon
                                    : activeVerticalIndex === 2
                                      ? idIcon
                                      : academicIcon
                            }
                            alt="icon"
                            style={{
                              width: 28,
                              height: 28,
                            }}
                          />
                        </Box>
                      }
                      title={
                        horizontalSteps?.[activeHorizontalIndex]?.verticalSteps?.[
                          activeVerticalIndex
                        ]?.verticalStepName || horizontalSteps?.[activeHorizontalIndex]?.verticalSteps?.[
                          activeVerticalIndex
                        ]?.stepLabel ||  "Details"
                      }
                      subtitle="Please fill all required details"
                      completion={`${(() => {
                        const filteredOtherFields = otherFields.filter((f) => {
                          const isUniversity = f.name === "university";
                          const isInstitute = f.name === "institute";
                          const isCourseName = f.name === "courseName";
                          const applyAdmissionUndecided =
                            activeHorizontalIndex === 0 &&
                            activeVerticalIndex === 1 &&
                            values?.admissionStatus === "Undecided";
                          const exclude =
                            applyAdmissionUndecided &&
                            (isUniversity || isInstitute || isCourseName);
                          return !exclude;
                        });
                        return `${getFilledCountWithPanAadhaar(
                          filteredOtherFields,
                          values,
                        )} / ${filteredOtherFields.length}`;
                      })()}`
                      }
                    />
                  </Box>
                  }

                  {/* Form Fields */}
                  <Grid container spacing={2}>
                    {activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 2 ? (
                      <>
                        {/* Always render the "Are you employed?" radio field */}
                        {fields
                          .filter((f) => f.name === "employmentisEmployed")
                          .sort((a, b) => {
                            // Example: sort by order field
                            return a.order - b.order;
                          })
                          .map((field) => renderField(field))}

                        {/* If "Yes" is selected, render the rest of the employment fields */}
                        {values.employmentisEmployed === "Yes" &&
                          (() => {
                            let hasInsertedCompanyHeader = false;
                            // When employmentType is "Others", show only required fields in this section
                            const allEmploymentFields = fields.filter(
                              (f) => f.name !== "employmentisEmployed"
                            );
                            const selectedEmploymentType = getAutocompleteOptionValue(
                              values?.employmentType,
                            );
                            const shouldShowOnlyRequired =
                              selectedEmploymentType === "Others";
                            const fieldsToRender = !selectedEmploymentType
                              ? allEmploymentFields.filter(
                                (f) => f.name === "employmentType"
                              )
                              : shouldShowOnlyRequired
                              ? allEmploymentFields.filter(
                                (f) =>
                                  f.required &&
                                  f.name !== "employmentYear" &&
                                  f.name !== "employmentDesignation"
                              )
                              : allEmploymentFields;

                            return fieldsToRender.map((field) => {
                              const elements: React.ReactNode[] = [];

                              // Insert header before the *first* company field
                              if (
                                !hasInsertedCompanyHeader &&
                                field.name
                                  ?.toLowerCase()
                                  .includes("employmentcompany") &&
                                field.name !== "employmentCompanyName"
                              ) {
                                elements.push(
                                  <Grid
                                    item
                                    xs={12}
                                    key="company-section-header"
                                  >
                                    <Box sx={{ mt: 3, mb: 1 }}>
                                      <SectionHeader
                                        icon={
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              width: 40,
                                              height: 40,
                                              borderRadius: "8px",
                                              bgcolor: "#e5feffff",
                                            }}
                                          >
                                            <img
                                              src={locationIcon}
                                              alt="icon"
                                              style={{
                                                width: 28,
                                                height: 28,
                                              }}
                                            />
                                          </Box>
                                        }
                                        title="Company Address"
                                        subtitle="Company Address Related Details"
                                        completion={`${companyFields.length > 0
                                          ? `${getFilledCount(
                                            companyFields,
                                            values
                                          )} / ${companyFields.length}`
                                          : ""
                                          }`}
                                      />
                                    </Box>
                                  </Grid>
                                );
                                hasInsertedCompanyHeader = true;
                              }

                              elements.push(renderField(field));
                              return elements;
                            });
                          })()}
                      </>
                    ) : activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 4 ? (
                      <>
                        {/* Entrance Exam Details Sections */}
                        <Grid container ml={2} mt={2}>
                          {/* Render Core Entrance Exam Section */}
                          <EntranceExamDetailsSection
                            fields={fields.filter((f: any) =>
                              f.name.startsWith("core")
                            )}
                            allFields={fields}
                            sectionPrefix="core"
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            renderField={renderField}
                            horizontalSteps={horizontalSteps}
                            activeHorizontalIndex={activeHorizontalIndex}
                            activeVerticalIndex={activeVerticalIndex}
                            formikRef={formikRef}
                            dropdownData={dropdownData}
                          />

                          {/* Render Language Entrance Exam Section */}
                          <EntranceExamDetailsSection
                            fields={fields.filter((f: any) =>
                              f.name.startsWith("language")
                            )}
                            sectionPrefix="language"
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            renderField={renderField}
                            horizontalSteps={horizontalSteps}
                            activeHorizontalIndex={activeHorizontalIndex}
                            activeVerticalIndex={activeVerticalIndex}
                            formikRef={formikRef}
                            dropdownData={dropdownData}
                          />
                        </Grid>
                      </>
                    ) : activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 3 ? (
                      (() => {
                        return (
                          <>
                            {/* Render Course Details Section */}
                            <CourseDetailsSection
                              fields={fields}
                              horizontalSteps={horizontalSteps}
                              activeHorizontalIndex={activeHorizontalIndex}
                              activeVerticalIndex={activeVerticalIndex}
                              renderField={renderField}
                              values={values}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              touched={touched}
                              handleChange={otherFormikProps.handleChange}
                              formikRef={formikRef}
                              pageType={"FORM"}
                            />
                          </>
                        );
                      })()
                    ) : activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 5 ? (
                      <>
                        {/* Render CoApplicant Details Section */}
                        <CoApplicantDetailsSection
                          fields={fields}
                          horizontalSteps={horizontalSteps}
                          activeHorizontalIndex={activeHorizontalIndex}
                          activeVerticalIndex={activeVerticalIndex}
                          getCoApplicantGroups={getCoApplicantGroups}
                          renderField={renderField}
                          values={values}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          handleChange={otherFormikProps.handleChange}
                          formikRef={formikRef}
                          pinCodeData={{ permanent: permanentCodeData, current: currentCodeData }}
                          dropdownData={dropdownData}
                          handleInvokZipCode={handleInvokZipCode}
                          relationshipOptionsList={relationshipOptions}
                          salutationOptionsList={
                            dropdownData?.salutations || []
                          }
                          tabIndex={tabIndex}
                          setTabIndex={setTabIndex}
                          zipCodeLoading={zipCodeLoading}
                          checkIsLeadApiInvoked={checkIsLeadApiInvoked}
                          handleLeadCreationFlow={handleLeadCreationFlow}
                          getLeadPayload={getLeadPayload}
                        />
                      </>
                    ) : activeHorizontalIndex === 3 &&
                      activeVerticalIndex === 0 ? (
                      (() => {
                        return (
                          <>
                            {/* Render Applicant Details Section */}
                            <ApplicantAdditionalDetails
                              fields={fields}
                              horizontalSteps={horizontalSteps}
                              activeHorizontalIndex={activeHorizontalIndex}
                              activeVerticalIndex={activeVerticalIndex}
                              renderField={renderField}
                              values={values}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              touched={touched}
                              handleChange={otherFormikProps.handleChange}
                              formikRef={formikRef}
                              nationalityOptions={applicantNationalityOptions}
                              birthCityOptions={birthCityList}
                              dropdownData={dropdownData}
                               pageType={"FORM"}
                              isDIYJourney={isDIYJourney}
                            />
                          </>
                        );
                      })()
                    ) : activeHorizontalIndex === 3 &&
                      activeVerticalIndex === 3 ? (
                      (() => {
                        return (
                          <>
                            {/* Render Reference & Collateral Details Section */}
                            <ReferenceCollateralDetails
                              fields={fields}
                              renderField={renderField}
                              formikRef={formikRef}
                              values={values}
                              errors={errors}
                              touched={touched}
                              isSaving={isSubmittingToAPI}
                              activeTab={activeTab}
                              setActiveTab={setActiveTab}
                              isDIYJourney={isDIYJourney}
                              lastSavedCollateralSnapshotByGroupRef={lastSavedCollateralSnapshotByGroupRef}
                              onReferenceSaveAndNext={async (selectedReferenceNumber: number) => {
                                setIsSubmittingToAPI(true);
                                try {
                                  const currentValues =
                                    formikRef?.current?.values || values || {};
                                   
                                  const referenceNumber = selectedReferenceNumber || 1;
                                  const shouldCallCreateApi = referenceNumber === 2;
                                  
                                  const referenceData: any[] = (fields || [])
                                  .filter((field: any) => {
                                    if (!field?.id) return false;
                                    const normalizedName = String(field?.name || "")
                                      .toLowerCase()
                                      .replace(/[^a-z0-9]/g, "");
                                    return (
                                      normalizedName.startsWith(`basicreference${referenceNumber}`) ||
                                      normalizedName.startsWith(`addressreference${referenceNumber}`)
                                    );
                                  })
                                  .flatMap((field: any) => {
                                    const rawValue = currentValues?.[field.name];
                                    const normalizedValue =
                                      rawValue && typeof rawValue === "object"
                                        ? "value" in rawValue
                                          ? rawValue.value
                                          : "label" in rawValue
                                            ? rawValue.label
                                            : rawValue
                                        : rawValue;

                                    return [{
                                      formFieldId: field.id,
                                      formFieldKey: field.name,
                                      formFieldValue:normalizedValue!=undefined? String(normalizedValue):"",
                                    }];
                                  });

                                  const isAadhaarSeededPayload =
                                    aadhaarSeedingStatus === undefined ||
                                    aadhaarSeedingStatus === null ||
                                    aadhaarSeedingStatus === ""
                                      ? false
                                      : aadhaarSeedingStatus;

                                  const referencePayload = {
                                    data: referenceData,
                                    trackingId: trackingId,
                                    templateId: templateId,
                                    formName:
                                      horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
                                    mobileNumber:
                                      currentValues?.phone_number || formData?.phone_number,
                                    isAadhaarSeeded: isAadhaarSeededPayload,
                                  };

                                  // let referenceResp: any = null;
                                  // if (shouldCallCreateApi) {
                                    let referenceResp: any =
                                      await applicantDetailsServices.createApplicant(
                                        referencePayload,
                                      );
                                  //}

                                  if (
                                    shouldCallCreateApi &&
                                    referenceResp?.data?.status !== "success"
                                  ) {
                                    throw new Error(
                                      referenceResp?.data?.message ||
                                        "Unable to save Reference and Collateral details.",
                                    );
                                  }

                                  if (referenceResp?.data?.data?.trackingId) {
                                    dispatch(
                                      setTrackingId(referenceResp?.data?.data?.trackingId),
                                    );
                                  }
                                  if (referenceResp?.data?.data?.applicationId) {
                                    dispatch(
                                      setApplicationId(
                                        String(referenceResp?.data?.data?.applicationId),
                                      ),
                                    );
                                  }
                                  if (referenceResp?.data?.data?.applicantId) {
                                    dispatch(
                                      setApplicantId(referenceResp?.data?.data?.applicantId),
                                    );
                                  }

                                  const toValue = (val: any) => {
                                    if (val && typeof val === "object" && "value" in val) {
                                      return val.value;
                                    }
                                    return val;
                                  };

                                  
                                  const resolvedTrackingId =
                                    referenceResp?.data?.data?.trackingId || trackingId || "";
                                  const resolvedApplicationId =
                                    referenceResp?.data?.data?.applicationId ||
                                    applicationIdApp ||
                                    "";

                                  // Fetch any existing Reference One/Two IDs before saving, so an
                                  // already-saved reference is updated instead of duplicated.
                                  let fetchedReferenceOneId: any = null;
                                  let fetchedReferenceTwoId: any = null;
                                  if (resolvedTrackingId) {
                                    try {
                                      const referenceIdsResp = await losServices.getReferenceIds(
                                        resolvedTrackingId,
                                      );
                                      fetchedReferenceOneId =
                                        referenceIdsResp?.data?.data?.referenceOneId || null;
                                      fetchedReferenceTwoId =
                                        referenceIdsResp?.data?.data?.referenceTwoId || null;
                                      if (fetchedReferenceOneId) {
                                        dispatch(setreferenceOneId(fetchedReferenceOneId));
                                      }
                                      if (fetchedReferenceTwoId) {
                                        dispatch(setreferenceTwoId(fetchedReferenceTwoId));
                                      }
                                    } catch (error) {
                                      console.log(error, "getReferenceIds error");
                                    }
                                  }

                                  const resolvedReferenceId =referenceNumber === 2?
                                    (fetchedReferenceTwoId || referenceTwoId):
                                    (fetchedReferenceOneId || referenceOneId);

                                  const selectedReferenceCodeData =
                                    referenceNumber === 2
                                      ? reference2CodeData
                                      : reference1CodeData;

                                  const saveReferencePayload:any = {
                                    trackingId: resolvedTrackingId,
                                    eventName: `APPLICANT_APPLICATION_REFERENCE_${selectedReferenceNumber===1?"ONE":"TWO"}_DETAILS`,
                                    applicantType: "Applicant",
                                    applicationId: Number(resolvedApplicationId) || 0,
                                    emailAddress:currentValues?.[`basicReference${referenceNumber}Email`],
                                    firstName:currentValues?.[`basicReference${referenceNumber}FirstName`],
                                    lastName:currentValues?.[`basicReference${referenceNumber}LastName`],
                                    fullName:`${currentValues?.[`basicReference${referenceNumber}FirstName`]} ${currentValues?.[`basicReference${referenceNumber}LastName`]}`.trim(),
                                    active: true,
                                    referenceType : selectedReferenceNumber===1?"one":"two",
                                    mobileNo: Number(currentValues?.[`basicReference${referenceNumber}PhoneNumber`]),
                                    referenceAddress: {
                                      addressTypeDescription: "RESI ALTERNATE ADDRESS",
                                      addressLine2: currentValues?.[`addressReference${referenceNumber}AddressLine2`] || "",
                                      area: currentValues?.[`addressReference${referenceNumber}Area`] || "",
                                      locality: currentValues?.[`addressReference${referenceNumber}Locality`] || "",
                                      addressTypeId: "ALTRESI",
                                      landmark: currentValues?.[`addressReference${referenceNumber}Landmark`] || "",
                                      addressLine1: currentValues?.[`addressReference${referenceNumber}AddressLine1`] || "",
                                      cityId:selectedReferenceCodeData?.city ||
                                        "",
                                      cityName: currentValues?.[`addressReference${referenceNumber}City`] || "",
                                      countryId:dropdownData?.countries.find(
                                          (country: any) =>
                                            country.label ===
                                            (typeof values?.currentCountry === "object"
                                              ? values.currentCountry.label
                                              : currentValues?.[`addressReference${referenceNumber}Country`]),
                                        )?.value ||
                                        "IN",
                                      countryName: currentValues?.[`addressReference${referenceNumber}Country`] || "",
                                      pincodeId:selectedReferenceCodeData?.pinCodeId? Number(selectedReferenceCodeData?.pinCodeId) : "",
                                      pincode: String(currentValues?.[`addressReference${referenceNumber}Pincode`]) || "",
                                    },
                                  };
                                  if(resolvedReferenceId){
                                    saveReferencePayload.referenceId= Number(resolvedReferenceId) || resolvedReferenceId;
                                    await losServices.updateReference(saveReferencePayload);
                                  }else{
                                    await losServices.saveReference(saveReferencePayload);
                                  }
                                  // Continue is gated on Collateral's own Save & Next (or
                                  // the already-saved re-derivation above) — saving
                                  // Reference alone must not enable it.
                                  // Move to Collateral only once both references are saved
                                  // (in any order); otherwise stay on the Reference tab.
                                  const isOtherReferenceSaved =
                                    referenceNumber === 2
                                      ? Boolean(fetchedReferenceOneId || referenceOneId)
                                      : Boolean(fetchedReferenceTwoId || referenceTwoId);
                                  if (isOtherReferenceSaved) {
                                    setActiveTab(1);
                                  } else if (shouldCallCreateApi) {
                                    setSnackbar({
                                      open: true,
                                      message:
                                        "Please save Reference 1 details before moving to Collateral Details.",
                                      severity: "error",
                                    });
                                  }
                                  dispatch(updateFormData(currentValues));

                                  trackCustomerJourneyEvent(
                                    `${extendedJourneyPrefix}_REFERENCEDETAILS_CONTINUE_PAGE14`,
                                    decrypt(userProfile?.id) ?? "",
                                    trackingId,
                                    {
                                      label: `${extendedJourneyPrefix}_REFERENCEDETAILS_CONTINUE_PAGE14`,
                                      category: `${extendedJourneyPrefix}_REFERENCEDETAILS_CONTINUE_PAGE14`,
                                      action: `${extendedJourneyPrefix}_REFERENCEDETAILS_CONTINUE_PAGE14`,
                                      page: "Extended Journey_Reference details",
                                    }
                                  );
                                  return true;
                                } catch (error: any) {
                                  dispatch(
                                    setStatusPopup({
                                      status: "error",
                                      message:
                                        error?.response?.data?.message ||
                                        (error as any)?.message ||
                                        "Unable to save Reference and Collateral details.",
                                    }),
                                  );
                                  // keep the current reference open so the user can retry
                                  return false;
                                } finally {
                                  setIsSubmittingToAPI(false);
                                }
                              }}
                              onCollateralSaveAndNext={async (selectedCollateralNumber: number) => {
                                setIsSubmittingToAPI(true);
                                try {
                                  const currentValues =
                                    formikRef?.current?.values || values || {};
                                  const horizontalStepLabel =
                                    horizontalSteps?.[activeHorizontalIndex]?.stepLabel;
                                  const mergedFields = getMergedCollateralFieldDefinitions(
                                    horizontalSteps,
                                    fields,
                                    horizontalStepLabel,
                                  );
                                  const hasCollateralAnswer = (() => {
                                    const raw = currentValues?.hasCollateral;
                                    const val =
                                      raw && typeof raw === "object"
                                        ? (raw as any).value ?? (raw as any).label
                                        : raw;
                                    return String(val ?? "").trim();
                                  })();
                                  const hasNoRealCollateralFields =
                                    !mergedFields.some((f: any) => {
                                      if (/^coOwnerCollateral/i.test(String(f?.name || ""))) return false;
                                      if (!fieldBelongsToCollateralNumber(f?.name, selectedCollateralNumber)) return false;
                                      const raw = currentValues?.[f?.name];
                                      if (raw === null || raw === undefined) return false;
                                      if (typeof raw === "object") {
                                        const v = (raw as any)?.value ?? (raw as any)?.label;
                                        return String(v ?? "").trim() !== "";
                                      }
                                      return String(raw).trim() !== "";
                                    });
                                  const isNoCollateralSave =
                                    selectedCollateralNumber === 1 &&
                                    hasNoRealCollateralFields &&
                                    hasCollateralAnswer.toLowerCase() === "no";
                                  const collateralNumbersToSave = isNoCollateralSave
                                    ? [selectedCollateralNumber]
                                    : isCollateralSectionComplete(
                                        mergedFields,
                                        currentValues,
                                        selectedCollateralNumber,
                                      )
                                      ? [selectedCollateralNumber]
                                      : [];
                                  if (collateralNumbersToSave.length === 0) {
                                    throw new Error(
                                      "Please complete all required Collateral fields before saving.",
                                    );
                                  }

                                  for (const collateralNumber of collateralNumbersToSave) {
                                    if (
                                      hasDuplicateCoOwnerNamesForCollateral(
                                        currentValues,
                                        collateralNumber,
                                      )
                                    ) {
                                      throw new Error(
                                        `Duplicate co-owner names are not allowed within Collateral ${collateralNumber}.`,
                                      );
                                    }
                                  }

                                  const toValue = (val: any) => {
                                    if (val && typeof val === "object" && "value" in val) {
                                      return val.value;
                                    }
                                    return val;
                                  };

                                  const toLabel = (val: any) => {
                                    if (val && typeof val === "object" && "label" in val) {
                                      return val.label;
                                    }
                                    return val;
                                  };

                                  let resolvedTrackingId = trackingId || "";
                                  let resolvedApplicationId = applicationIdApp || "";
                                  let resolvedApplicantId = applicantIdApp || "";

                                  for (const collateralNumber of collateralNumbersToSave) {
                                    const collateralData = buildCollateralFormDataEntries(
                                      mergedFields,
                                      currentValues,
                                      collateralNumber,
                                      isFirstCollateralWithData(mergedFields, currentValues, collateralNumber),
                                    );

                                    const collateralPayload = {
                                      formData: collateralData,
                                      trackingId: resolvedTrackingId,
                                      collateralSequenceType: `COLLATERAL_${
                                        numberToWord[collateralNumber] || numberToWord[1]
                                      }`,
                                    };

                                    const collateralResp: any =
                                      await losServices.createCollateral(collateralPayload);

                                    if (collateralResp?.data?.status !== "success") {
                                      throw new Error(
                                        collateralResp?.data?.message ||
                                          `Unable to save Collateral ${collateralNumber} details.`,
                                      );
                                    }

                                    if (collateralResp?.data?.data?.trackingId) {
                                      resolvedTrackingId =
                                        collateralResp?.data?.data?.trackingId;
                                      dispatch(setTrackingId(resolvedTrackingId));
                                    }
                                    if (collateralResp?.data?.data?.applicationId) {
                                      resolvedApplicationId =
                                        collateralResp?.data?.data?.applicationId;
                                      dispatch(
                                        setApplicationId(String(resolvedApplicationId)),
                                      );
                                    }
                                    if (collateralResp?.data?.data?.applicantId) {
                                      resolvedApplicantId =
                                        collateralResp?.data?.data?.applicantId;
                                      dispatch(setApplicantId(resolvedApplicantId));
                                    }
                                    let collaterIdData=await eligibilityCheckServices.getCollateralIds(collateralResp?.data?.data?.trackingId);
                                    
                                    
                                    const collateralTypeRaw = getCollateralFormValue(
                                      currentValues,
                                      collateralNumber,
                                      "Type",
                                    );
                                    const countryRaw = getCollateralFormValue(
                                      currentValues,
                                      collateralNumber,
                                      "country",
                                    );
                                    const pincodeRaw = getCollateralFormValue(
                                      currentValues,
                                      collateralNumber,
                                      "pincode",
                                    );

                                    let resolvedCollateralId = null;
                                    let resolvedCollateralOwnerId=null;
                                    let resolvedOwnerAddressId=null;
                                    let resolvedOwnerCreatedBy=null;
                                    let resolvedCollateralRecord:any=null;
                                      if(collaterIdData?.data?.data){
                                        let sequenceType=`COLLATERAL_${
                                          numberToWord[collateralNumber] || numberToWord[1]
                                        }`;
                                        let val=collaterIdData?.data?.data.findLast((item:any) => item.collateralSequenceType === sequenceType)
                                        resolvedCollateralId=val?.collateralId ? Number(val?.collateralId):null;
                                        resolvedCollateralOwnerId=val?.collateralOwnerDetailsId? Number(val?.collateralOwnerDetailsId):null;
                                        resolvedOwnerAddressId=val?.ownerAddressId ?? null;
                                        resolvedOwnerCreatedBy=val?.createdBy ?? null;
                                        resolvedCollateralRecord=val ?? null;
                                      }
                                      
                                    const collateralType = String(
                                      toLabel(collateralTypeRaw) || "",
                                    );
                                    const collateralTypeId =
                                      Number(toValue(collateralTypeRaw)) || 0;
                                    const isPropertyCollateral =
                                      collateralTypeId === 308 ||
                                      collateralType.toLowerCase().includes("property");
                                    let selectedCollateralCodeData =
                                      collateralCodeDataByNumber[
                                        String(collateralNumber)
                                      ] || null;
                                    if (
                                      isPropertyCollateral &&
                                      !selectedCollateralCodeData?.city
                                    ) {
                                      const pin = String(toValue(pincodeRaw) || "");
                                      if (pin.length === 6) {
                                        try {
                                          const zipResp =
                                            await eligibilityCheckServices.getZipCode(
                                              pin,
                                            );
                                          const stateCodeFromZip =
                                            zipResp?.data?.data?.[0]?.stateCode;
                                          const pinResp =
                                            await eligibilityCheckServices.getPinCode(
                                              pin,
                                            );
                                          if (pinResp?.data?.data?.[0]) {
                                            selectedCollateralCodeData = {
                                              ...pinResp.data.data[0],
                                              stateCode: stateCodeFromZip,
                                            };
                                            setCollateralCodeDataByNumber((prev) => ({
                                              ...prev,
                                              [String(collateralNumber)]:
                                                selectedCollateralCodeData,
                                            }));
                                          }
                                        } catch {
                                          // keep null; payload will send empty ids
                                        }
                                      }
                                    }
                                    const countryLabel = String(
                                      toLabel(countryRaw) || toValue(countryRaw) || "",
                                    );
                                    const resolvedCountryId =
                                      dropdownData?.countries?.find(
                                        (country: any) =>
                                          country.label === countryLabel ||
                                          String(country.value) ===
                                            String(toValue(countryRaw)) || 
                                            String(country.label) === String(toValue(countryRaw))
                                      )?.value || "IN";
                                    const propertyTypeRaw = currentValues[`collateral${collateralNumber}propertypeName`];
                                    const collateralValue=currentValues[`collateral${collateralNumber}Value`];
                                    const propertySubTypeRaw = getCollateralFormValue(
                                      currentValues,
                                      collateralNumber,
                                      "PropertySubTypeName",
                                    );
                                    const selectedPropertyTypeCode = String(
                                      toValue(propertyTypeRaw) || "",
                                    );
                                    const selectedPropertySubTypeCode = String(
                                      toValue(propertySubTypeRaw) || "",
                                    );
                                    let resolvedPropertyTypeId: any = toValue(propertyTypeRaw);
                                    let resolvedPropertySubTypeId: any = toValue(propertySubTypeRaw);
                                    const addressTypeRaw = getCollateralFormValue(
                                      currentValues,
                                      collateralNumber,
                                      "AddressType",
                                    );
                                    const selectedAddressTypeCode = String(
                                      toValue(addressTypeRaw) || "",
                                    );
                                    let resolvedAddressTypeDescription: any = toLabel(addressTypeRaw);
                                    if (isPropertyCollateral) {
                                      try {
                                        if (selectedPropertyTypeCode) {
                                          const propertyTypeMaster =
                                            await dropdownService.getPropertyTypes();
                                          resolvedPropertyTypeId =
                                            propertyTypeMaster.find(
                                              (opt: any) =>
                                                String(opt.value) === selectedPropertyTypeCode,
                                            )?.serialId ?? resolvedPropertyTypeId;
                                        }
                                        if (selectedPropertySubTypeCode) {
                                          const propertySubTypeMaster =
                                            await dropdownService.getPropertySubTypes(
                                              selectedPropertyTypeCode,
                                            );
                                          resolvedPropertySubTypeId =
                                            propertySubTypeMaster.find(
                                              (opt: any) =>
                                                String(opt.value) === selectedPropertySubTypeCode,
                                            )?.serialId ?? resolvedPropertySubTypeId;
                                            
                                        }
                                        if (selectedAddressTypeCode) {
                                          const addressTypeMaster =
                                            await dropdownService.getAddressTypes();
                                          resolvedAddressTypeDescription =
                                            addressTypeMaster.find(
                                              (opt: any) =>
                                                String(opt.value) === selectedAddressTypeCode,
                                            )?.label ?? resolvedAddressTypeDescription;
                                        }
                                      } catch {
                                        // keep raw code/label value; payload will fall back to it
                                      }
                                    }

                                    const coOwnerApplicantIdByPrefix =
                                      await resolveCoOwnerApplicantIdMap(
                                        mergedFields,
                                        currentValues,
                                        collateralNumber,
                                        resolvedApplicantId,
                                        async (coApplicantType: string) => {
                                          try {
                                            const coOwnerApplicantResp: any =
                                              await losServices.getCoApplicantDetails({
                                                trackingId: resolvedTrackingId,
                                                coApplicantType,
                                              });
                                            return coOwnerApplicantResp?.data?.data?.applicantId;
                                          } catch {
                                            return 0;
                                          }
                                        },
                                      );

                                    const saveCollateralPayload = buildSaveCollateralPayload({
                                      currentValues,
                                      mergedFields,
                                      collateralNumber,
                                      applicationId: resolvedApplicationId ? resolvedApplicationId:0,
                                      applicantId: resolvedApplicantId,
                                      resolvedCollateralId,
                                      resolvedCollateralOwnerId,
                                      ownerAddressId: resolvedOwnerAddressId,
                                      createdBy: resolvedOwnerCreatedBy,
                                      selectedCollateralCodeData,
                                      resolvedCountryId,
                                      propertyTypeId: resolvedPropertyTypeId,
                                      propertySubTypeId: resolvedPropertySubTypeId,
                                      addressTypeDescription: resolvedAddressTypeDescription,
                                      coOwnerApplicantIdByPrefix,
                                      fetchedCollateral: resolvedCollateralRecord,
                                    });
                                    
                                    let payloadColl={
                                      ...saveCollateralPayload,
                                      trackingId: resolvedTrackingId,
                                      eventName:
                                        `APPLICANT_APPLICATION_COLLATERAL_${
                                        numberToWord[collateralNumber] || numberToWord[1]
                                      }_OWNERSHIP_DETAILS`,
                                      applicantType: "Applicant",
                                      "collateralSequenceType":`COLLATERAL_${
                                        numberToWord[collateralNumber] || numberToWord[1]
                                      }`,
                                      collateralValue:Number(collateralValue),
                                      //"applicantId": resolvedApplicantId,

                                    }
                                    // No real collateral fields for this group (the
                                    // applicant answered No) — there's no ownership/
                                    // property detail to sync, so skip save-collateral;
                                    // create-collateral above already persisted the
                                    // hasCollateral answer.
                                    if (!isNoCollateralSave) {
                                      await losServices.saveCollateral(payloadColl);
                                      window.dispatchEvent(
                                        new CustomEvent("collateral:saved", {
                                          detail: { collateralNumber },
                                        })
                                      );
                                    }
                                  }

                                  setenableContinue(true);
                                  dispatch(setIsRefColBtnEnable(true));
                                  dispatch(updateFormData(currentValues));
                                  // Keep the fetched snapshot in sync with the saved
                                  // co-owners so the co-applicant Name/Mobile lock
                                  // applies without a reload.
                                  if (!isNoCollateralSave) {
                                    dispatch(
                                      setFetchUserApplicationData(
                                        mergeSavedCoOwnersIntoFetchedData(
                                          fetchUserApplicationData,
                                          currentValues,
                                          collateralNumbersToSave,
                                        ),
                                      ),
                                    );
                                  }
                                  collateralNumbersToSave.forEach((n: number) => {
                                    lastSavedCollateralSnapshotByGroupRef.current[n] =
                                      buildCollateralGroupSnapshot(n);
                                  });

                                  trackCustomerJourneyEvent(
                                    `${extendedJourneyPrefix}_COLLATERALDETAILS_CONTINUE_PAGE15`,
                                    decrypt(userProfile?.id) ?? "",
                                    trackingId,
                                    {
                                      label: `${extendedJourneyPrefix}_COLLATERALDETAILS_CONTINUE_PAGE15`,
                                      category: `${extendedJourneyPrefix}_COLLATERALDETAILS_CONTINUE_PAGE15`,
                                      action: `${extendedJourneyPrefix}_COLLATERALDETAILS_CONTINUE_PAGE15`,
                                      page: "Extended Journey_Collateral detaiils ",
                                    }
                                  );
                                } catch (error: any) {
                                  dispatch(
                                    setStatusPopup({
                                      status: "error",
                                      message: getCollateralSaveErrorMessage(error),
                                    }),
                                  );
                                  // CollateralDetails only stays on this collateral when the
                                  // result is exactly false.
                                  return false;
                                } finally {
                                  setIsSubmittingToAPI(false);
                                }
                              }}
                              pageType={"FORM"}
                            />
                          </>
                        );
                      })()
                    ) : activeHorizontalIndex === 3 &&
                      activeVerticalIndex === 4 ? (
                      (() => {
                        return (
                          <>
                            <AdditionalSummaryDetail 
                              dropdownData={dropdownData}
                             activeHorizontalIndex = {3}
                             activeVerticalIndex = {4}   />
                          </>
                        );
                      })()
                    ) : activeHorizontalIndex === 3 &&
                      activeVerticalIndex === 2 ? (
                      (() => {
                        return (
                          <>
                            {/* Render Fund & Expense Details Section */}
                            <FundExpenseDetails
                              fields={fields}
                              renderField={renderField}
                              formikRef={formikRef}
                              values={values}
                              pageType={"FORM"}
                            />
                          </>
                        );
                      })()
                    ) : activeHorizontalIndex === 3 &&
                      activeVerticalIndex === 1 ? (
                      (() => {
                        return (
                          <>
                            {/* Render Academic Details Section */}
                            <CoApplicantAdditionalDetails
                              fields={fields}
                              horizontalSteps={horizontalSteps}
                              activeHorizontalIndex={activeHorizontalIndex}
                              activeVerticalIndex={activeVerticalIndex}
                              renderField={renderField}
                              values={values}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              touched={touched}
                              handleChange={otherFormikProps.handleChange}
                              formikRef={formikRef}
                              dropdownData={dropdownData}
                              handleInvokZipCode={handleInvokZipCode}
                              relationshipOptionsList={relationshipOptions}
                              salutationOptionsList={
                                dropdownData?.salutations || []
                              }
                              zipCodeLoading={zipCodeLoading}
                              tabIndex={tabIndex}
                              setTabIndex={setTabIndex}
                              checkIsLeadApiInvoked={checkIsLeadApiInvoked}
                              handleLeadCreationFlow={handleLeadCreationFlow}
                              getLeadPayload={getLeadPayload}
                              pageType={"FORM"}
                            />
                          </>
                        );
                      })()
                    ) : (
                      <>
                        {(() => {
                          // Fields excluding pan and aadhaar
                          const filteredFields = fields.filter(
                            (field) =>
                              field.name !== "pan" && field.name !== "aadhaar"
                          ).sort(
                            (a, b) =>
                              Number(a.fieldOrder) - Number(b.fieldOrder));

                          // Find index of first dob-related field
                          const dobIndex = filteredFields.findIndex(
                            (field) =>
                              field.name?.toLowerCase().includes("dob") ||
                              field.label?.toLowerCase().includes("dob")
                          );

                          if (dobIndex === -1) {
                            let hasInsertedCurrHeader = false; // <-- track insertion

                            return filteredFields.map((field) => {
                              const elements: React.ReactNode[] = [];

                              // Insert header before the *first* field with prefix "current"
                              if (
                                !hasInsertedCurrHeader &&
                                field.name?.toLowerCase().startsWith("current")
                              ) {
                                elements.push(
                                  <Grid
                                    item
                                    xs={12}
                                    key="current-section-header"
                                  >
                                    <Box
                                      sx={{ mt: 3, mb: 1 }}
                                      key="current-section-header"
                                    >
                                      <SectionHeader
                                        icon={
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              width: 40,
                                              height: 40,
                                              borderRadius: "8px",
                                              bgcolor: "#e5feffff",
                                            }}
                                          >
                                            <img
                                              src={locationIcon}
                                              alt="icon"
                                              style={{
                                                width: 28,
                                                height: 28,
                                              }}
                                            />
                                          </Box>
                                        }
                                        title="Current Address"
                                        subtitle="Student Current Address Related Details "
                                        completion={`${getFilledCount(
                                          currFields,
                                          values
                                        )} / ${currFields.length}`}
                                      />
                                    </Box>
                                  </Grid>
                                );
                                hasInsertedCurrHeader = true;
                              }

                              elements.push(renderField(field));
                              return elements;
                            });
                          }

                          // Before dob fields
                          const beforeDob = filteredFields.slice(
                            0,
                            dobIndex + 1
                          );

                          // After dob fields
                          const afterDob = filteredFields.slice(dobIndex + 1);
                          
                          let hasInsertedCurrHeader = false;

                          return (
                            <>
                              {/* Fields before dob */}
                              {beforeDob.map((field) => {
                                const elements: React.ReactNode[] = [];

                                if (
                                  !hasInsertedCurrHeader &&
                                  field.name
                                    ?.toLowerCase()
                                    .startsWith("current")
                                ) {
                                  elements.push(
                                    <Grid
                                      item
                                      xs={12}
                                      key="current-section-header"
                                    >
                                      <Box
                                        sx={{ mt: 3, mb: 1 }}
                                        key="current-section-header"
                                      >
                                        <SectionHeader
                                          icon={
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 40,
                                                height: 40,
                                                borderRadius: "8px",
                                                bgcolor: "#e5feffff",
                                              }}
                                            >
                                              <img
                                                src={locationIcon}
                                                alt="icon"
                                                style={{
                                                  width: 28,
                                                  height: 28,
                                                }}
                                              />
                                            </Box>
                                          }
                                          title="Current Address"
                                          subtitle="Student Current Address Related Details "
                                          completion={`${getFilledCount(
                                            currFields,
                                            values
                                          )} / ${currFields.length}`}
                                        />
                                      </Box>
                                    </Grid>
                                  );
                                  hasInsertedCurrHeader = true;
                                }

                                elements.push(renderField(field));
                                return elements;
                              })}
                              {/* For Pan and Aadhaar Section */}
                              {isPanStep &&
                                renderPanAadhaarFields(
                                  values,
                                  shouldDisableFields,
                                  setFieldValue,
                                  touched,
                                  errors
                                )}
                              {/* Fields after dob */}
                              {afterDob.map((field) => {
                                const elements: React.ReactNode[] = [];

                                // Insert header before the *first* field with prefix "current"
                                if (
                                  !hasInsertedCurrHeader &&
                                  field.name
                                    ?.toLowerCase()
                                    .startsWith("current")
                                ) {
                                  elements.push(
                                    <Box
                                      sx={{ mt: 3, mb: 1 }}
                                      key="current-section-header"
                                    >
                                      <SectionHeader
                                        icon={
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              width: 40,
                                              height: 40,
                                              borderRadius: "8px",
                                              bgcolor: "#e5feffff",
                                            }}
                                          >
                                            <img
                                              src={locationIcon}
                                              alt="icon"
                                              style={{
                                                width: 28,
                                                height: 28,
                                              }}
                                            />
                                          </Box>
                                        }
                                        title="Current Address"
                                        subtitle="Student Current Address Related Details "
                                        completion={`${getFilledCount(
                                          currFields,
                                          values
                                        )} / ${currFields.length}`}
                                      />
                                    </Box>
                                  );
                                  hasInsertedCurrHeader = true;
                                }

                                elements.push(renderField(field));
                                return elements;
                              })}
                            </>
                          );
                        })()}
                      </>
                    )}
                  </Grid>

                  {/* Actions Back & Continue */}
                  <Box mt={3} pr={{ xs: 1, sm: 2 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        width: "100%",
                        gap: 2,
                      }}
                    >
                      {/* Show Back button only if not on first form and not on step 3 */}
                      {((activeHorizontalIndex === 0 &&
                        activeVerticalIndex > 0 &&
                        activeVerticalIndex < 3) ||
                        (activeHorizontalIndex === 1 &&
                          activeVerticalIndex > 0) ||
                        (activeHorizontalIndex === 3 &&
                          activeVerticalIndex > 0 ) ||activeHorizontalIndex === 4
                        ) && isPreviousButton === true && !isXsOrSm ? (
                        <Box sx={{ width: { xs: "100%", sm: 134 } }}>
                          <OutlinedPrimaryButton
                            width={isXsOrSm ? "100%" : "134px"}
                            type="button"
                            fullWidth
                            variant="outlined"
                            onClick={() => {
                              if (activeHorizontalIndex === 3) {
                                if (activeVerticalIndex === 4) {
                                  // Leaving the Additional Summary step via Previous — clear its
                                  // persisted Documents/Consent tab choice so a later fresh
                                  // re-entry starts on the default (Documents) tab.
                                  if (trackingId) {
                                    localStorage.removeItem(`additionalSummaryActiveTab:${trackingId}`);
                                  }
                                  dispatch(setActiveVerticalIndex(3));
                                  window.scrollTo({ top: 0, behavior: "smooth" });
                                  return;
                                }
                                if (activeVerticalIndex === 3) {
                                  dispatch(setActiveVerticalIndex(2));
                                  window.scrollTo({ top: 0, behavior: "smooth" });
                                  return;
                                }
                                if (activeVerticalIndex === 2) {
                                  dispatch(setActiveVerticalIndex(1));
                                  window.scrollTo({ top: 0, behavior: "smooth" });
                                  return;
                                }
                                if (activeVerticalIndex === 1) {
                                  dispatch(setActiveVerticalIndex(0));
                                  window.scrollTo({ top: 0, behavior: "smooth" });
                                  return;
                                }
                              }
                              dispatch(prevVerticalStep());
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                            disabled={isSubmitting || isSubmittingToAPI}
                          >
                            <ArrowBackIcon sx={{ mr: !isXsOrSm ? 1 : 0 }} />

                            {"Previous"}
                          </OutlinedPrimaryButton>
                        </Box>
                      ) : null}
                      {/* Continue Button */}
                      {(activeHorizontalIndex !== 1 ||
                        activeVerticalIndex !== 5) && (
                          <>
                            <Box sx={{ width: { xs: "100%", sm: 220 } }}>
                              <PrimaryButton
                                type="button"
                                fullWidth
                                onClick={
                                  activeHorizontalIndex < 3 ?async () => {
                                  const shouldOpenSkipCoAppModal =
                                    activeHorizontalIndex === 1 &&
                                    activeVerticalIndex === 4 &&
                                    !coAppAddOption &&
                                    !isCoAppAlreadyExist;
                                  const errs = await validateForm();
                                  const currentStepFieldNames = fields.map((f) => f.name);
                                  if (isPanStep) {
                                    ["pan", "aadhaar"].forEach((panFieldName) => {
                                      if (!currentStepFieldNames.includes(panFieldName)) {
                                        currentStepFieldNames.push(panFieldName);
                                      }
                                    });
                                  }

                                  const extraErrors: Record<string, string> = {};

                                  if (activeHorizontalIndex === 0 && activeVerticalIndex === 0) {
                                    const applicantType = formikRef.current?.values?.applicantType;
                                    if (!applicantType) {
                                      extraErrors["applicantType"] =
                                        "Please select whether you are applying as a Student or a Co-applicant.";
                                  }
                                    const phoneVal = formikRef.current?.values?.phone_number;
                                    if (phoneVal && !isMobileVerified) {
                                      extraErrors["phone_number"] =
                                        "Mobile number verification is pending. Please enter the OTP to verify.";
                                    }
                                    const emailVal = formikRef.current?.values?.email;
                                    if (emailVal && !isEmailVerified) {
                                      extraErrors["email"] =
                                        "Email verification is pending. Please enter the OTP to verify.";
                                    }
                                  }

                                  const yupErrors = await validateForm();
                                  const mergedErrs = { ...yupErrors, ...extraErrors };

                                  const stepErrors = Object.keys(mergedErrs).filter(
                                    (key) => currentStepFieldNames.includes(key) && !isExcludedField(key)
                                  );

                                  if (Object.keys(extraErrors).length > 0) {
                                    Object.entries(extraErrors).forEach(([k, v]) =>
                                      formikRef.current?.setFieldError(k, v)
                                    );
                                  }

                                  if (stepErrors.length > 0) {
                                    const touchedObj: any = {};
                                    stepErrors.forEach((k) => (touchedObj[k] = true));
                                    formikRef.current?.setTouched({ ...formikRef.current?.touched, ...touchedObj }, false);

                                    const firstField = stepErrors[0];
                                    setTimeout(() => {
                                      const el = document.querySelector(`[name="${firstField}"]`) as HTMLElement | null;
                                      if (el && typeof el.scrollIntoView === "function") {
                                        el.scrollIntoView({ behavior: "smooth", block: "center" });
                                        try { el.focus(); } catch (e) {}
                                      } else {
                                        window.scrollTo({ top: 0, behavior: "smooth" });
                                      }
                                    }, 50);

                                    
                                  } else if (shouldOpenSkipCoAppModal) {
                                    // Step is valid — open the skip co-applicant
                                    // modal; it will submit the form on proceed.
                                    setIsSkipCoAppModal(true);
                                  } else {
                                    submitForm();
                                  }
                                } : async () => {
                                  // Post provisional offer: assign SM / create lead if not done yet
                                  if (activeHorizontalIndex === 3 && !assignedSMIdValue) {
                                    handleLeadCreationFlow(getLeadPayload, leadSequenceId, true);
                                  }
                                  if (activeHorizontalIndex === 3) {
                                    let valuesToValidate: Record<string, any> =
                                      formikRef?.current?.values || values || {};

                                    if (
                                      activeVerticalIndex === 2 &&
                                      String(
                                        valuesToValidate?.admissionStatus ?? ""
                                      )
                                        .trim()
                                        .toLowerCase() === "undecided"
                                    ) {
                                      setZeroForFundAndExpenses(
                                        setFieldValue,
                                        valuesToValidate
                                      );
                                      const zeroPatch: Record<string, any> = {};
                                      FUND_EXPENSE_AMOUNT_FIELDS.forEach((key) => {
                                        zeroPatch[key] =
                                          valuesToValidate?.[key] || "0";
                                      });
                                      valuesToValidate = {
                                        ...valuesToValidate,
                                        ...zeroPatch,
                                      };
                                    }

                                    const freshErrors =
                                      (await validateForm(valuesToValidate)) || {};

                                    const blockReason =
                                      getAdditionalDetailsBlockReason({
                                        activeVerticalIndex,
                                        values,
                                        errors: freshErrors,
                                        statusFlags: {
                                          isApplicantAdditionalDetailsComplete,
                                          additionalCoApplicantCount,
                                          areAllCoApplicantsSaved,
                                          areAllCoApplicantsEmploymentComplete,
                                          isFundExpenseBalanced,
                                          enableContinue,
                                          isAdditionalSummaryComplete,
                                        },
                                        lastSavedCollateralSnapshotByGroup:
                                          lastSavedCollateralSnapshotByGroupRef.current,
                                        fetchUserApplicationData,
                                        collateralHorizontalSteps: horizontalSteps,
                                      });

                                    if (blockReason) {
                                      if (
                                        activeVerticalIndex === 0 ||
                                        activeVerticalIndex === 2
                                      ) {
                                        const touchedPatch: Record<string, boolean> =
                                          {};
                                        Object.keys(freshErrors).forEach((key) => {
                                          if (
                                            fields.some((f: any) => f?.name === key)
                                          ) {
                                            touchedPatch[key] = true;
                                          }
                                        });
                                        if (Object.keys(touchedPatch).length > 0) {
                                          formikRef.current?.setTouched(
                                            {
                                              ...(formikRef.current?.touched || {}),
                                              ...touchedPatch,
                                            },
                                            false
                                          );
                                        }
                                      }
                                      if (activeVerticalIndex === 0) {
                                        const firstErrorField = fields.find(
                                          (f: any) => f?.name && freshErrors[f.name]
                                        )?.name;
                                        const el = firstErrorField
                                          ? (document.querySelector(
                                              `[name="${firstErrorField}"]`
                                            ) as HTMLElement | null)
                                          : null;
                                        if (el && typeof el.scrollIntoView === "function") {
                                          el.scrollIntoView({ behavior: "smooth", block: "center" });
                                        } else {
                                          window.scrollTo({ top: 0, behavior: "smooth" });
                                        }
                                        return;
                                      }
                                      setSnackbar({
                                        open: true,
                                        message: blockReason,
                                        severity: "error",
                                      });
                                      window.scrollTo({
                                        top: 0,
                                        behavior: "smooth",
                                      });
                                      return;
                                    }
                                  }

                                  // Keep additional-details flow deterministic:
                                  // Applicant Additional -> Co-Applicant Additional -> Fund & Expense -> Reference & Collateral
                                  if (activeHorizontalIndex === 3 && activeVerticalIndex === 0) {
                                    setIsSubmittingToAPI(true);
                                    try {
                                      const currentValues =
                                        formikRef?.current?.values || values || {};

                                      const isAadhaarSeededPayload =
                                        aadhaarSeedingStatus === undefined ||
                                        aadhaarSeedingStatus === null ||
                                        aadhaarSeedingStatus === ""
                                          ? false
                                          : aadhaarSeedingStatus;

                                      const applicantPayloadObject = {
                                        data: buildApplicantAdditionalFormData(
                                          fields,
                                          currentValues,
                                          resolveApplicantNationalityOption,
                                        ),
                                        trackingId: trackingId,
                                        templateId: templateId,
                                        formName:
                                          horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
                                        mobileNumber:
                                          currentValues?.phone_number || formData?.phone_number,
                                        isAadhaarSeeded: isAadhaarSeededPayload,
                                      };

                                      const createApplicantResp: any =
                                        await applicantDetailsServices.createApplicant(
                                          applicantPayloadObject,
                                        );

                                      if (createApplicantResp?.data?.status !== "success") {
                                        throw new Error(
                                          createApplicantResp?.data?.message ||
                                            "Applicant creation failed",
                                        );
                                      }

                                      trackCustomerJourneyEvent(
                                        `${extendedJourneyPrefix}_APPADDDETAILS_CONTINUE_PAGE11`,
                                        decrypt(userProfile?.id) ?? "",
                                        trackingId,
                                        {
                                          label: `${extendedJourneyPrefix}_APPADDDETAILS_CONTINUE_PAGE11`,
                                          category: `${extendedJourneyPrefix}_APPADDDETAILS_CONTINUE_PAGE11`,
                                          action: `${extendedJourneyPrefix}_APPADDDETAILS_CONTINUE_PAGE11`,
                                          page: "Extended Journey_Applicant Additional Details",
                                        }
                                      );

                                      const resolvedTrackingId =
                                        createApplicantResp?.data?.data?.trackingId || trackingId;

                                      if (createApplicantResp?.data?.data?.trackingId) {
                                        dispatch(
                                          setTrackingId(
                                            createApplicantResp?.data?.data?.trackingId,
                                          ),
                                        );
                                      }
                                      if (createApplicantResp?.data?.data?.applicationId) {
                                        dispatch(
                                          setApplicationId(
                                            String(
                                              createApplicantResp?.data?.data?.applicationId,
                                            ),
                                          ),
                                        );
                                      }
                                      if (createApplicantResp?.data?.data?.applicantId) {
                                        dispatch(
                                          setApplicantId(
                                            createApplicantResp?.data?.data?.applicantId,
                                          ),
                                        );
                                      }

                                      const resolvedApplicantId =
                                        Number(
                                          createApplicantResp?.data?.data?.applicantId ||
                                            applicantIdApp,
                                        ) || 0;
                                      const resolvedApplicationId =
                                        Number(
                                          createApplicantResp?.data?.data?.applicationId ||
                                            applicationIdApp,
                                        ) || 0;

                                      const additionalBasicDetailsPayload = buildAdditionalBasicDetailsPayload({
                                        fields,
                                        currentValues,
                                        formData,
                                        dropdownData,
                                        birthCityList,
                                        resolveApplicantNationalityOption,
                                        applicantId: resolvedApplicantId,
                                        applicationId: resolvedApplicationId,
                                        trackingId: resolvedTrackingId,
                                      });

                                      const saveLoanRequirementPayload = buildSaveLoanRequirementPayload({
                                        fields,
                                        currentValues,
                                        formData,
                                        dropdownData,
                                        isDIYJourney,
                                        applicationId: resolvedApplicationId,
                                        trackingId: resolvedTrackingId,
                                      });

                                      dispatch(updateFormData(currentValues));
                                      dispatch(setActiveVerticalIndex(1));

                                      // Continue navigation should not wait for LOS/processio APIs.
                                      void (async () => {
                                        try {
                                          await losServices.createUpdateApplicantBasicDetails(
                                            additionalBasicDetailsPayload,
                                          );
                                          // await losServices.updateLead(
                                          //   buildApplicantAdditionalUpdateLeadPayload(fields, currentValues, resolvedTrackingId),
                                          // );
                                          await losServices.saveLoanRequirement(
                                            saveLoanRequirementPayload,
                                          );
                                        } catch (bgError: any) {
                                          console.error(
                                            "Background Applicant Additional save failed:",
                                            bgError,
                                          );
                                        }
                                      })();
                                    } catch (error: any) {
                                      dispatch(
                                        setStatusPopup({
                                          status: "error",
                                          message:
                                            error?.response?.data?.message ||
                                            error?.message ||
                                            "Applicant creation failed",
                                        }),
                                      );
                                    } finally {
                                      setIsSubmittingToAPI(false);
                                    }
                                    return;
                                  }
                                  if (activeHorizontalIndex === 3 && activeVerticalIndex === 1) {
                                    try {
                                      await postsServices.addPost(
                                        "api/v1/progressive-journey/upsert-page",
                                        {
                                          trackingId:trackingId,
                                        },
                                      );
                                    } catch (upsertPageError) {
                                      console.error(
                                        "Upsert Progressive Journey Page Error:",
                                        upsertPageError,
                                      );
                                    }
                                    dispatch(setActiveVerticalIndex(2));
                                    return;
                                  }
                                  if (activeHorizontalIndex === 3 && activeVerticalIndex === 2) {
                                    const currentValues =
                                      formikRef?.current?.values || values || {};

                                    // ── Fund/Expense conditional-required validation ─────────────
                                    // When admissionStatus is CONFIRMED, either every fund/expense
                                    // field must be filled, or ONLY the Requested Loan Amount is
                                    // provided (everything else left blank).
                                    const _fundExpenseState = getFundExpenseValidationState(currentValues);
                                    if (!_fundExpenseState.isValid) {
                                      dispatch(
                                        setStatusPopup({
                                          status: "error",
                                          message: _fundExpenseState.isLoanAmountFilled
                                            ? "Please fill all Fund and Expense fields, or provide only the Requested Loan Amount and leave the rest blank."
                                            : "In case of confirmed please fill all the filled.",
                                        }),
                                      );
                                      return;
                                    }
                                    if (_fundExpenseState.isOnlyLoanAmountProvided) {
                                      // Only the loan amount was provided — the create/save-expense
                                      // APIs (and any downstream processio call) are intentionally
                                      // skipped for this step; just persist locally and move on.
                                      dispatch(updateFormData(currentValues));
                                      dispatch(setActiveVerticalIndex(3));
                                      return;
                                    }

                                    // ── Fund vs Expense balance validation ──────────────────────
                                    const { totalExpense, totalFund } = getFundExpenseTotals(
                                      fields,
                                      currentValues,
                                    );
                                    if (totalExpense !== totalFund) {
                                      dispatch(
                                        setStatusPopup({
                                          status: "error",
                                          message: `Total Fund (₹${totalFund.toLocaleString("en-IN")}) and Total Expenses (₹${totalExpense.toLocaleString("en-IN")}) must be equal before you can continue.`,
                                        }),
                                      );
                                      return;
                                    }
                                    // ── end validation ───────────────────────────────────────────

                                    setIsSubmittingToAPI(true);
                                    try {
                                      if (isAdmissionStatusUndecided(currentValues)) {
                                        setZeroForFundAndExpenses(setFieldValue, currentValues);
                                      }

                                      const isAadhaarSeededPayload =
                                        aadhaarSeedingStatus === undefined ||
                                        aadhaarSeedingStatus === null ||
                                        aadhaarSeedingStatus === ""
                                          ? false
                                          : aadhaarSeedingStatus;

                                      const fundExpensePayload = {
                                        data: buildFundExpenseFormData(fields, currentValues),
                                        trackingId: trackingId,
                                        templateId: templateId,
                                        formName:
                                          horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
                                        mobileNumber:
                                          currentValues?.phone_number || formData?.phone_number,
                                        isAadhaarSeeded: isAadhaarSeededPayload,
                                      };

                                      const createApplicantResp: any =
                                        await applicantDetailsServices.createApplicant(
                                          fundExpensePayload,
                                        );

                                      if (createApplicantResp?.data?.status !== "success") {
                                        throw new Error(
                                          createApplicantResp?.data?.message ||
                                            "Unable to save Fund and Expense details.",
                                        );
                                      }

                                      trackCustomerJourneyEvent(
                                        `${extendedJourneyPrefix}_FUNDS&EXPENSEDETAILS_CONTINUE_PAGE13`,
                                        decrypt(userProfile?.id) ?? "",
                                        trackingId,
                                        {
                                          label: `${extendedJourneyPrefix}_FUNDS&EXPENSEDETAILS_CONTINUE_PAGE13`,
                                          category: `${extendedJourneyPrefix}_FUNDS&EXPENSEDETAILS_CONTINUE_PAGE13`,
                                          action: `${extendedJourneyPrefix}_FUNDS&EXPENSEDETAILS_CONTINUE_PAGE13`,
                                          page: "Extended Journey_Funds & Expense details",
                                        }
                                      );

                                      if (createApplicantResp?.data?.data?.trackingId) {
                                        dispatch(
                                          setTrackingId(
                                            createApplicantResp?.data?.data?.trackingId,
                                          ),
                                        );
                                      }
                                      if (createApplicantResp?.data?.data?.applicationId) {
                                        dispatch(
                                          setApplicationId(
                                            String(
                                              createApplicantResp?.data?.data?.applicationId,
                                            ),
                                          ),
                                        );
                                      }
                                      if (createApplicantResp?.data?.data?.applicantId) {
                                        dispatch(
                                          setApplicantId(
                                            createApplicantResp?.data?.data?.applicantId,
                                          ),
                                        );
                                      }

                                      const saveExpensePayload = buildSaveExpensePayload({
                                        fields,
                                        currentValues,
                                        totalExpense,
                                        totalFund,
                                        trackingId:
                                          createApplicantResp?.data?.data?.trackingId ||
                                          trackingId ||
                                          "",
                                        applicationId:
                                          String(
                                            createApplicantResp?.data?.data?.applicationId ||
                                              applicationIdApp ||
                                              "0",
                                          ) || "0",
                                      });

                                      dispatch(updateFormData(currentValues));
                                      dispatch(setActiveVerticalIndex(3));

                                      await losServices.saveExpense(saveExpensePayload);
                                    } catch (error: any) {
                                      dispatch(
                                        setStatusPopup({
                                          status: "error",
                                          message:
                                            error?.response?.data?.message ||
                                            error?.message ||
                                            "Unable to save Fund and Expense details.",
                                        }),
                                      );
                                    } finally {
                                      setIsSubmittingToAPI(false);
                                    }
                                    return;
                                  }
                                  if (activeHorizontalIndex === 3 && activeVerticalIndex === 3) {
                                    // Reference & Collateral is one step split across two tabs
                                    // (0 = Reference, 1 = Collateral). Continue from the
                                    // Reference tab should land on the Collateral tab next,
                                    // not skip straight past it to Documents — only once the
                                    // Collateral tab is already active does Continue fall
                                    // through to the validation/navigation below.
                                    if (activeTab !== 1) {
                                      setActiveTab(1);
                                      return;
                                    }
                                    const currentValues = formikRef?.current?.values || values || {};
                                    const rawHasCollateral = currentValues?.hasCollateral;
                                    const hasCollateralAnswer = String(
                                      rawHasCollateral && typeof rawHasCollateral === "object"
                                        ? (rawHasCollateral as any).value ?? (rawHasCollateral as any).label
                                        : rawHasCollateral ?? "",
                                    ).trim().toLowerCase();

                                    // "Has Collateral?" = No has no dedicated Save & Next —
                                    // this Continue click is what persists it, since
                                    // isNavigationDisabled leaves Continue enabled for "No"
                                    // even before enableContinue has latched true.
                                    if (hasCollateralAnswer === "no") {
                                      const saved = await saveNoCollateralAnswer();
                                        trackCustomerJourneyEvent(
                                          `${extendedJourneyPrefix}_COLLATERALDETAILS_CONTINUE_PAGE15`,
                                          decrypt(userProfile?.id) ?? "",
                                          trackingId,
                                          {
                                            label: `${extendedJourneyPrefix}_COLLATERALDETAILS_CONTINUE_PAGE15`,
                                            category: `${extendedJourneyPrefix}_COLLATERALDETAILS_CONTINUE_PAGE15`,
                                            action: `${extendedJourneyPrefix}_COLLATERALDETAILS_CONTINUE_PAGE15`,
                                            page: "Extended Journey_Collateral detaiils ",
                                          }
                                        );
                                      if (!saved) return;
                                    } else if (hasCollateralAnswer === "yes") {
                                      // "Yes" must have an actually-confirmed collateral
                                      // before Continue is allowed through — enableContinue
                                      // covers "saved earlier this session", and
                                      // isCollateralStepAlreadySaved covers "already saved,
                                      // confirmed by the fetched application data" (e.g. on
                                      // a revisit). If neither holds, nothing has genuinely
                                      // been added yet — block navigation with a clear error
                                      // instead of silently doing nothing. (This used to be
                                      // `!enableContinue || isCollateralStepAlreadySaved(...)`,
                                      // which blocked whenever the step WAS already saved —
                                      // the exact opposite of what the comment describes.)
                                      if (!enableContinue && !isCollateralStepAlreadySaved(fetchUserApplicationData,hasCollateralAnswer,activeCollateralStatusByGroup)) {
                                        dispatch(
                                          setStatusPopup({
                                            status: "error",
                                            message: "Please add and save Collateral details before continuing.",
                                          }),
                                        );
                                        return;
                                      }
                                    }
                                    // Landing on the Additional Summary step fresh via Continue — clear any
                                    // tab choice persisted from a previous visit so it doesn't override the
                                    // Documents-tab reset below (see AdditionalSummaryDetail.tsx's restore effect).
                                    if (trackingId) {
                                      localStorage.removeItem(`additionalSummaryActiveTab:${trackingId}`);
                                    }
                                    dispatch(setAdditionalSummaryActiveTab(0));
                                    dispatch(setActiveVerticalIndex(4));
                                    return;
                                  }
                                  if (activeHorizontalIndex === 3 && activeVerticalIndex === 4) {
                                    const tabState = store.getState().tabs.additionalSummaryActiveTab;
                                    trackCustomerJourneyEvent(
                                        `${extendedJourneyPrefix}_UPLOADDOC_PAGE16`,
                                        decrypt(userProfile?.id) ?? "",
                                        trackingId,
                                        {
                                          label: `${extendedJourneyPrefix}_UPLOADDOC_PAGE16`,
                                          category: `${extendedJourneyPrefix}_UPLOADDOC_PAGE16`,
                                          action: `${extendedJourneyPrefix}_UPLOADDOC_PAGE16`,
                                          page: "Extended Journey_Upload Documents",
                                        }
                                      );
                                    if (tabState === 0) {
                                      dispatch(setAdditionalSummaryActiveTab(1));
                                    } else {
                                      dispatch(setAdditionalSummaryActiveTab(0));
                                     navigate(ROUTES.Application.loanSummary.locationPath);
                                    }
                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                    return;
                                  }
                                  
                                  dispatch(nextVerticalStep());
                                }
                              }
                            >
                              {isSubmittingToAPI ? (
                                <CircularProgress size={16} />
                              ) : isXsOrSm ? (
                                "Save & Continue"
                              ) : (
                                "Continue"
                              )}
                            </PrimaryButton>
                            </Box>
                          </>
                        )}
                      {((activeHorizontalIndex === 0 &&
                        activeVerticalIndex > 0 &&
                        activeVerticalIndex < 3) ||
                        (activeHorizontalIndex === 1 &&
                          activeVerticalIndex > 0) ||
                        (activeHorizontalIndex === 3 &&
                          activeVerticalIndex > 0 &&
                          activeVerticalIndex !== 5)) && isXsOrSm && isPreviousButton === true ? (
                        <Box sx={{ width: { xs: "100%", sm: 134 }, mb: isXsOrSm ? 2 : "0", mr: !isXsOrSm ? 2 : "0", mt: 2 }}>
                          <OutlinedPrimaryButton
                            width={isXsOrSm ? "100%" : "134px"}
                            type="button"
                            fullWidth
                            variant="outlined"
                            onClick={() => {
                              if (activeHorizontalIndex === 3) {
                                if (activeVerticalIndex === 4) {
                                  dispatch(setActiveVerticalIndex(3));
                                  return;
                                }
                                if (activeVerticalIndex === 3) {
                                  dispatch(setActiveVerticalIndex(2));
                                  return;
                                }
                                if (activeVerticalIndex === 2) {
                                  dispatch(setActiveVerticalIndex(1));
                                  return;
                                }
                                if (activeVerticalIndex === 1) {
                                  dispatch(setActiveVerticalIndex(0));
                                  return;
                                }
                              }
                              dispatch(prevVerticalStep());
                            }}
                            disabled={isSubmitting || isSubmittingToAPI}
                          >
                            <ArrowBackIcon sx={{ mr: !isXsOrSm ? 1 : 0 }} />

                            {"Previous"}
                          </OutlinedPrimaryButton>
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                </Form>
              );
            }}
          </Formik>
        </>
      )}

      <LoaderBackdrop
        open={
          isAadharLoading ||
          Object.values(isAadharCoApplicantLoading).some(Boolean)
        }
      />

      {/* Mobile OTP Modal */}
      <ModalPopup
        isOpen={openOtpModal}
        onClose={() => {
          setOpenOtpModal(false);
          setErrorMsg("");
        }}
        title=""
        isOtpModal={true}
        style={{ maxWidth: isAuthenticated && (otpMobileFieldName.match(/^basicCoApplicant(\d+)PhoneNumber$/) ? true : !isEmailVerified) ? "600px" : "450px" }}
      >
        <OtpInputForm
          mobileMasked={otpMobileNumber.replace(/.(?=.{4})/g, "x")}
          onOtpSubmit={async (otp) => {
            try {
              const coApplicantPhoneMatch = otpMobileFieldName.match(/^basicCoApplicant(\d+)PhoneNumber$/);

              // Determine the userType string
              let currentUserType = "Applicant"; // Default
              if (coApplicantPhoneMatch) {
                const coAppIndex = coApplicantPhoneMatch[1]; // This is '1', '2', etc.
                currentUserType = `Co-Applicant ${coAppIndex}`;
              }

              const verifyResp = await eligibilityCheckServices.verifyOtp({
                type: "mobile",
                mobileNumber: otpMobileNumber,
                key: otpKey,
                mobileOtp: otp,
                mobileOtpCrtdAt: otpTime,
                userType: currentUserType,
                ...(isAuthenticated && {
                  trackingId: trackingId,
                }),
              });
              if (verifyResp?.data?.status === "success") {

                if (activeHorizontalIndex === 0) {

                  trackCustomerJourneyEvent(
                    `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                      category: `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                      action: `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                      page: "EligibiityCheck_Verify Yourself and Provide Consent_Mobile",
                    }
                  );

                } else if (activeHorizontalIndex === 1) {
                  const coApplicantPhoneMatchForOtp = otpMobileFieldName.match(
                    /^basicCoApplicant(\d+)PhoneNumber$/
                  );
                  const coAppNum = coApplicantPhoneMatchForOtp
                    ? String(Number(coApplicantPhoneMatchForOtp[1]))
                    : "0";
                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                      category: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                      action: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                      page: `ProvisionalOff_Loan Details_COAPP(${coAppNum}) Mobile Verification`,
                    }
                  );
                }
                setSnackbar({
                  open: true,
                  message: verifyResp?.data?.message,
                  severity: "success",
                });
                setOpenOtpModal(false);

                // Check which field is being verified
                const coApplicantPhoneMatch = otpMobileFieldName.match(
                  /^basicCoApplicant(\d+)PhoneNumber$/
                );
                if (coApplicantPhoneMatch) {
                  const idx = String(Number(coApplicantPhoneMatch[1]) - 1);
                  dispatch(
                    setCoApplicantVerification({
                      index: idx,
                      data: {
                        mobileVerified: true,
                        lastVerifiedMobileNumber: otpMobileNumber,
                      },
                    })
                  );
                  // Map value to Formik field
                  if (formikRef.current) {
                    formikRef.current.setFieldValue(
                      otpMobileFieldName,
                      otpMobileNumber
                    );
                  }
                } else {
                  dispatch(setIsMobileVerified(true));
                  dispatch(setLastVerifiedPhoneNumber(otpMobileNumber));
                  if (formikRef.current) {
                    formikRef.current.setFieldValue(
                      "phone_number",
                      otpMobileNumber
                    );
                  }
                }
              } else {
                dispatch(
                  setStatusPopup({
                    status: "error",
                    message: verifyResp?.data?.message,
                  })
                );
              }
            } catch (err: any) {
              setErrorMsg(
                // err?.response?.data?.message ||
                'Oops! Looks like you have entered the wrong OTP. Please try again or click "Resend OTP" to get a new one.'
              );
            }
          }}
          errorMessage={errorMsg}
          setErrorMsg={setErrorMsg}
          onResendOtp={async () => {
            let name = `${formikRef?.current?.values?.studentDetailsFirstName || ""} ${formikRef?.current?.values?.studentDetailsLastName || ""}`.trim();
            const coApplicantPhoneMatch = otpMobileFieldName.match(
              /^basicCoApplicant(\d+)PhoneNumber$/
            );
            if (coApplicantPhoneMatch) {
              // this will only work for coapplicant
              const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantPhoneMatch[1]))}FirstName`;
              name = formData[dynamicNameKey];   // co-applicant name
            }

            const resp = await eligibilityCheckServices.sendOtp({
              name: name,
              mobileNumber: otpMobileNumber,
            });
            setOtpKey(resp.data.data.value);
            setOtpTime(resp.data.data.otpTime);
            setErrorMsg(
              "A new OTP has been sent to your registered mobile number."
            );
          }}
          showConsentMessage={
            isAuthenticated ?
              otpMobileFieldName.match(/^basicCoApplicant(\d+)PhoneNumber$/)
                ? true // Always true for Co-applicants on Mobile
                : !customerConsentTime// For Applicant: only true if consent not yet given AND email not yet verified
              : false
          }
        />
      </ModalPopup>

      {/* Email OTP Modal */}
      <ModalPopup
        isOpen={openEmailOtp}
        onClose={() => {
          setOpenEmailOtp(false);
          setErrorMsg("");
        }}
        title=""
        isOtpModal={true}
        style={{ maxWidth: isAuthenticated && (otpEmailFieldName.match(/^basicCoApplicant(\d+)Email$/) ? false : !isMobileVerified) ? "600px" : "450px" }}
      >
        <OtpInputForm
          emailMasked={
            otpEmail.length > 3
              ? otpEmail.slice(0, 3) +
              otpEmail.slice(3).replace(/.(?=.{4})/g, "x")
              : otpEmail.replace(/.(?=.{4})/g, "x")
          }
          onOtpSubmit={async (otp) => {
            try {
              const coApplicantEmailMatch = otpEmailFieldName.match(/^basicCoApplicant(\d+)Email$/);

              // Determine the userType string
              let currentUserType = "Applicant"; // Default
              if (coApplicantEmailMatch) {
                const coAppIndex = coApplicantEmailMatch[1]; // This is '1', '2', etc.
                currentUserType = `Co-Applicant ${coAppIndex}`;
              }
              const verifyResp = await eligibilityCheckServices.verifyOtp({
                type: "email",
                email: otpEmail,
                key: otpEmailKey,
                emailOtp: otp,
                emailOtpCrtdAt: otpEmailTime,
                userType: currentUserType,
                ...(isAuthenticated && {
                  trackingId: trackingId,
                }),
              });

              if (verifyResp?.data?.status === "success") {
                const isProvisionalStudentDetailsEmail =
                  activeHorizontalIndex === 1 && activeVerticalIndex === 0;
                const emailVerifyGaPrefix = isProvisionalStudentDetailsEmail
                  ? handleGAProvisionalOfferStatments
                  : handleGAEligibilityStatments;
                const emailVerifyGaEvent = isProvisionalStudentDetailsEmail
                  ? `${emailVerifyGaPrefix}_STDUENTDET_EMAIL_PAGE5`
                  : `${emailVerifyGaPrefix}_VERIFYYOURSELF_EMAIL_PAGE1`;
                const emailVerifyGaPage = isProvisionalStudentDetailsEmail
                  ? "ProvisionalOff_Student Details_Email"
                  : "EligibiityCheck_Verify Yourself and Provide Consent_Email";

                trackCustomerJourneyEvent(
                  emailVerifyGaEvent,
                  decrypt(userProfile?.id) ?? "",
                  trackingId,
                  {
                    label: emailVerifyGaEvent,
                    category: emailVerifyGaEvent,
                    action: emailVerifyGaEvent,
                    page: emailVerifyGaPage,
                  }
                );


                setSnackbar({
                  open: true,
                  message: verifyResp?.data?.message,
                  severity: "success",
                });
                setOpenEmailOtp(false);

                // Check which field is being verified
                const coApplicantEmailMatch = otpEmailFieldName.match(
                  /^basicCoApplicant(\d+)Email$/
                );
                if (coApplicantEmailMatch) {
                  const idx = String(Number(coApplicantEmailMatch[1]) - 1);
                  dispatch(
                    setCoApplicantVerification({
                      index: idx,
                      data: {
                        emailVerified: true,
                        lastVerifiedEmail: otpEmail,
                      },
                    })
                  );
                  if (formikRef.current) {
                    formikRef.current.setFieldValue(
                      otpEmailFieldName,
                      otpEmail
                    );
                  }
                } else {
                  dispatch(setIsEmailVerified(true));
                  dispatch(setLastVerifiedEmail(otpEmail));
                  if (formikRef.current) {
                    formikRef.current.setFieldValue("email", otpEmail);
                    formikRef.current.setFieldValue("studentDetailEmail", otpEmail);
                  }
                  dispatch(
                    updateFormData({
                      email: otpEmail,
                      studentDetailEmail: otpEmail,
                    })
                  );
                }
              } else {
                dispatch(
                  setStatusPopup({
                    status: "error",
                    message: verifyResp?.data?.message,
                  })
                );
              }
            } catch (err: any) {
              setErrorMsg(
                // err?.response?.data?.message ||
                'Oops! Looks like you have entered the wrong OTP. Please try again or click "Resend OTP" to get a new one.'
              );
            }
          }}
          errorMessage={errorMsg}
          setErrorMsg={setErrorMsg}
          onResendOtp={async () => {
            let name = `${formikRef?.current?.values?.studentDetailsFirstName || ""} ${formikRef?.current?.values?.studentDetailsLastName || ""}`.trim();

            const coApplicantEmailMatch = otpEmailFieldName.match(
              /^basicCoApplicant(\d+)Email$/
            );
            if (coApplicantEmailMatch) {
              // this will only work for coapplicant
              const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantEmailMatch[1]))}FirstName`;
              name = formData[dynamicNameKey];   // co-applicant name
            }

            const resp = await eligibilityCheckServices.sendOtp({
              name: name,
              email: otpEmail.toLowerCase(),
            });
            setOtpEmailKey(resp.data.data.value);
            setOtpEmailTime(resp.data.data.otpTime);
            setErrorMsg("A new OTP has been sent to your registered email ID.");
          }}
          showConsentMessage={
            isAuthenticated
              ? otpEmailFieldName.match(/^basicCoApplicant(\d+)Email$/)
                ? false // Always false for Co-applicants on Email
                : !customerConsentTime// For Applicant: only true if consent not yet given AND mobile not yet verified
              : false
          }
        />
      </ModalPopup>

      {/* Co-Applicant Modal */}
      <ModalPopup
        isOpen={openCoApplicantModal}
        onClose={() => setOpenCoApplicantModal(false)}
        title="Co-Applicant Selected"
      >
        <Typography sx={{ mt: 2 }}>
          Please enter the applicant's details.
        </Typography>
      </ModalPopup>

      {/* Purposes Anchor Modal */}
      <ModalPopup
        isOpen={openAnchorModal}
        onClose={() => setOpenAnchorModal(false)}
        title=""
      >
        {purposeItems.length > 0 ? (
          <Box component="ul" sx={{ pl: 3, mt: 1, mb: 0 }}>
            {purposeItems.map((item, idx) => (
              <Box component="li" key={idx} sx={{ mb: 1.25 }}>
                <Typography sx={{ m: 0 }}>{item}</Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography sx={{ mt: 2, whiteSpace: "pre-line" }}>
            {anchorModalContent}
          </Typography>
        )}
      </ModalPopup>

      {isSkipCoAppModal && <SkipCoApplicantOption 
        open={isSkipCoAppModal}
        onClose={() => setIsSkipCoAppModal(false)}
        onProceed={(val: string) => {
          formikRef.current?.submitForm();
          setIsSkipCoAppModal(false);
        }}
        setSnackbar={setSnackbar}
        selectedVal={selectedVal as ContinueOption | null}
        setSelectedVal={setSelectedVal}
        applicationSource={applicationSource}
        userProfile={userProfile}
      />}

      {/* Alert  */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      {/* Loader Backdrop for BRE checkOffer API */}
      <OfferCheckLoader
        open={isCheckingOffer}
        content="We are checking your eligibility"
      />
    </Box>
  );
};

export default React.memo(DynamicForm);